'use strict';

var lit = require('lit');
var decorators_js = require('lit/decorators.js');
var styleMap_js = require('lit/directives/style-map.js');
var uikitResources = require('@cometchat/uikit-resources');
var chatSdkJavascript = require('@cometchat/chat-sdk-javascript');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

exports.CometChatAvatar = class CometChatAvatar extends lit.LitElement {
    constructor() {
        super();
        this.name = "";
        this.avatarStyle = {
            borderRadius: "16px",
            width: "28px",
            height: "28px",
            border: "1px solid rgb(238 238 238)",
            backgroundColor: "lightgrey",
            nameTextColor: "rgb(20,20,20)",
            backgroundSize: "cover",
            nameTextFont: "500 16px Inter",
            outerViewBorderWidth: "",
            outerViewBorderSpacing: "",
            outerViewBorderRadius: "",
            outerViewBorderColor: ""
        };
        this.avatar = "";
        this.generateAvatar = (data) => {
            var _a, _b, _c;
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = 200;
            canvas.height = 200;
            //Draw background
            context.fillStyle = (_a = this.avatarStyle) === null || _a === void 0 ? void 0 : _a.backgroundColor;
            context.fillRect(0, 0, canvas.width, canvas.height);
            //Draw text
            context.font = this.getCanvasFontSize((_b = this.avatarStyle) === null || _b === void 0 ? void 0 : _b.nameTextFont);
            context.fillStyle = (_c = this.avatarStyle) === null || _c === void 0 ? void 0 : _c.nameTextColor;
            context.strokeStyle = "rgba(20, 20, 20, 8%)";
            context.textAlign = "center";
            context.textBaseline = "middle";
            context.fillText(data, canvas.width / 2, canvas.height / 2);
            return canvas.toDataURL("image/svg");
        };
        // this object contains dynamic stylings for this component
        this.getImageStyle = () => {
            var _a, _b, _c;
            return {
                backgroundSize: (_a = this.avatarStyle) === null || _a === void 0 ? void 0 : _a.backgroundSize,
                backgroundImage: `url(${this.avatar})`,
                border: `${(_b = this.avatarStyle) === null || _b === void 0 ? void 0 : _b.border} `,
                borderRadius: (_c = this.avatarStyle) === null || _c === void 0 ? void 0 : _c.borderRadius,
            };
        };
        this.getContainerStyle = () => {
            var _a, _b, _c;
            return {
                height: (_a = this.avatarStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.avatarStyle) === null || _b === void 0 ? void 0 : _b.width,
                borderRadius: (_c = this.avatarStyle) === null || _c === void 0 ? void 0 : _c.borderRadius,
            };
        };
        this.getOuterViewStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                height: (_a = this.avatarStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.avatarStyle) === null || _b === void 0 ? void 0 : _b.width,
                borderRadius: (_c = this.avatarStyle) === null || _c === void 0 ? void 0 : _c.outerViewBorderRadius,
                boxShadow: `0 0 0 ${(_d = this.avatarStyle) === null || _d === void 0 ? void 0 : _d.outerViewBorderWidth} ${(_e = this.avatarStyle) === null || _e === void 0 ? void 0 : _e.outerViewBorderColor}`,
                padding: (_f = this.avatarStyle) === null || _f === void 0 ? void 0 : _f.outerViewBorderSpacing
            };
        };
        this.updateAvatar();
    }
    update(changedProperties) {
        this.updateAvatar();
        super.update(changedProperties);
    }
    updateAvatar() {
        if (this.image && this.image.trim().length) {
            this.avatar = this.image;
        }
        else if (this.name && Object.keys(this.name).length) {
            let splitName = this.name.split(" ");
            const char = (splitName.length && splitName.length > 1) ? splitName[0].substring(0, 1).toUpperCase() + splitName[1].substring(0, 1).toUpperCase() : this.name.substring(0, 2).toUpperCase();
            this.avatar = this.generateAvatar(char);
        }
        this.render();
    }
    getCanvasFontSize(font) {
        var _a;
        let fontStyle = (font === null || font === void 0 ? void 0 : font.split(" ")) || "500 15px Inter";
        let fontSize = Number((_a = fontStyle[1]) === null || _a === void 0 ? void 0 : _a.replace("px", ""));
        let fontInPixel = fontSize * 5.5 + "px";
        return `${fontStyle[0]} ${fontInPixel} ${fontStyle[2]}`;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return lit.html `<div style=${styleMap_js.styleMap(this.getOuterViewStyle())} class="cc__avatar__outerview">
      <span style=${styleMap_js.styleMap(this.getContainerStyle())} class="cc__avatar">
        <span style=${styleMap_js.styleMap(this.getImageStyle())} class="cc__avatar__image"></span>
      </span>
    </div>`;
    }
};
exports.CometChatAvatar.styles = [
    lit.css `
    :host {
      display: block;
    }
    .cc__avatar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      background-color: #ffffff;
      box-sizing: content-box;
      cursor: inherit;
      outline: none;
      position: static;
      padding: 0;
    }
    .cc__avatar__image{
      display: flex;
      width: 100%;
      height: 100%;
      flex: 1 1 100%;
      background-color: transparent;
      background-position: center;
    }
    .cc__avatar__outerview{
      margin:2px
    }
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatAvatar.prototype, "image", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAvatar.prototype, "name", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatAvatar.prototype, "avatarStyle", void 0);
exports.CometChatAvatar = __decorate([
    decorators_js.customElement('cometchat-avatar')
], exports.CometChatAvatar);

/**
 * AvatarStyle
 *
 * @property {string} height - The height of the avatar.
 * @property {string} width - The width of the avatar.
 * @property {string} border - The border of the avatar.
 * @property {string} borderRadius - The border radius of the avatar.
 * @property {string} backgroundColor - The background color of the avatar.
 * @property {string} nameTextColor - The color of the name text.
 * @property {string} backgroundSize - The size of the background.
 * @property {string} nameTextFont - The font of the name text.
 * @property {string} outerViewBorder - The border of the outer view.
 * @property {string} outerViewBorderSpacing - The border spacing of the outer view.
 * @property {string} outerViewBorderRadius - The border radius of the outer view.
 */
class AvatarStyle {
    constructor(props) {
        this.borderRadius = "24px";
        this.width = "36px";
        this.height = "36px";
        this.border = "none";
        this.nameTextColor = "white";
        this.backgroundSize = "cover";
        this.nameTextFont = "500 16px Inter";
        this.outerViewBorderWidth = "";
        this.outerViewBorderSpacing = "";
        this.outerViewBorderRadius = "";
        this.outerViewBorderColor = "";
        this.backgroundColor = "";
        Object.assign(this, props);
    }
}

exports.CometChatBadge = class CometChatBadge extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.count = 0;
        this.badgeStyle = {
            height: "28px",
            width: "28px",
            borderRadius: "16px",
            background: "",
            border: "",
            textFont: "",
            textColor: ""
        };
        this.getStyle = () => {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
                border: `${(_a = this.badgeStyle) === null || _a === void 0 ? void 0 : _a.border}`,
                borderRadius: (_b = this.badgeStyle) === null || _b === void 0 ? void 0 : _b.borderRadius,
                background: (_c = this.badgeStyle) === null || _c === void 0 ? void 0 : _c.background,
                color: (_d = this.badgeStyle) === null || _d === void 0 ? void 0 : _d.textColor,
                font: (_e = this.badgeStyle) === null || _e === void 0 ? void 0 : _e.textFont,
                width: (_f = this.badgeStyle) === null || _f === void 0 ? void 0 : _f.width,
                height: (_g = this.badgeStyle) === null || _g === void 0 ? void 0 : _g.height,
            };
        };
    }
    render() {
        if (Number(this.count) > 0) {
            return lit.html `<div style=${styleMap_js.styleMap(this.getStyle())} class="cc__badge"> ${Number(this.count) > 999 ? "999+" : this.count} </div>`;
        }
    }
};
exports.CometChatBadge.styles = [
    lit.css `
    .cc__badge{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px;
      min-width:26px;
      min-height:16px;
    }
    `
];
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatBadge.prototype, "count", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatBadge.prototype, "badgeStyle", void 0);
exports.CometChatBadge = __decorate([
    decorators_js.customElement('cometchat-badge')
], exports.CometChatBadge);

/**
 * BaseStyle
 *
 * @property {string} height - The height of the component.
 * @property {string} width - The width of the component.
 * @property {string} border - The border of the component.
 * @property {string} borderRadius - The border radius of the component.
 * @property {string} background - The background color of the component.
 */
class BaseStyle {
    constructor(props) {
        this.height = "100%";
        this.width = "100%";
        this.border = "none";
        this.borderRadius = "0";
        this.background = "white";
        Object.assign(this, props);
    }
}

/**
 * BadgeStyle
 *
 * @extends BaseStyle
 *
 * @property {string} textFont - The font of the text.
 * @property {string} textColor - The color of the text.
 */
class BadgeStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "400 13px Inter, sans-serif";
        this.textColor = "RGB(51, 153, 255)";
        Object.assign(this, props);
    }
}

var waitIcon = "data:image/svg+xml,%3Csvg%20width%3D%2225%22%20height%3D%2224%22%20viewBox%3D%220%200%2025%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8.01057%208.04728C8.34753%209.99213%209.53177%2011.3242%2011.6239%2012C13.716%2011.3242%2014.9002%209.99213%2015.2372%208.04728C15.2572%207.91731%2015.2488%207.78455%2015.2125%207.65816C15.1762%207.53177%2015.1129%207.41476%2015.027%207.3152C14.9411%207.21564%2014.8346%207.1359%2014.7149%207.08149C14.5952%207.02707%2014.4651%206.99928%2014.3336%207.00001H8.9142C8.7827%206.99928%208.65261%207.02707%208.5329%207.08149C8.41319%207.1359%208.30671%207.21564%208.2208%207.3152C8.1349%207.41476%208.07161%207.53177%208.03532%207.65816C7.99902%207.78455%207.99058%207.91731%208.01057%208.04728Z%22%20fill%3D%22%23808080%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.91423%2017C8.78279%2017.0007%208.65276%2016.9729%208.5331%2016.9185C8.41343%2016.8642%208.30699%2016.7845%208.22109%2016.685C8.1352%2016.5855%208.0719%2016.4686%208.03556%2016.3423C7.99922%2016.2159%207.9907%2016.0832%208.01059%2015.9533C8.34756%2014.0085%209.5318%2012.6764%2011.6239%2012C13.716%2012.6764%2014.9003%2014.0085%2015.2372%2015.9533C15.2571%2016.0832%2015.2486%2016.2159%2015.2123%2016.3423C15.1759%2016.4686%2015.1126%2016.5855%2015.0267%2016.685C14.9408%2016.7845%2014.8344%2016.8642%2014.7147%2016.9185C14.5951%2016.9729%2014.465%2017.0007%2014.3336%2017H8.91423Z%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var sentIcon = "data:image/svg+xml,%3Csvg%20width%3D%2211%22%20height%3D%2212%22%20viewBox%3D%220%200%2011%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_538_3503%29%22%3E%3Cpath%20d%3D%22M2.29175%206.00065L4.58341%208.29232L9.16675%203.70898%22%20stroke%3D%22%23A6A6A6%22%20stroke-width%3D%220.8%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_538_3503%22%3E%3Crect%20width%3D%2211%22%20height%3D%2211%22%20fill%3D%22white%22%20transform%3D%22translate%280%200.5%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var deliveredIcon = "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2212%22%20viewBox%3D%220%200%2014%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20opacity%3D%220.8%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.15147%203.15262C9.32528%202.93804%209.29224%202.62319%209.07766%202.44938C8.86308%202.27557%208.54822%202.30861%208.37441%202.52319L3.61414%208.39998L1.626%206.42494C1.4301%206.23032%201.11352%206.23137%200.918901%206.42727C0.724285%206.62318%200.725331%206.93976%200.921238%207.13438L3.30197%209.49942C3.40229%209.59908%203.54012%209.6516%203.68131%209.64398C3.82251%209.63635%203.95388%209.5693%204.04289%209.45942L9.15147%203.15262ZM13.0814%203.16663C13.263%202.95855%2013.2415%202.6427%2013.0334%202.46115C12.8253%202.27961%2012.5095%202.30111%2012.3279%202.50919L7.17358%208.41667L6.74794%207.99934C6.55077%207.80601%206.2342%207.80912%206.04087%208.0063C5.84754%208.20348%205.85066%208.52004%206.04783%208.71337L6.85187%209.50172C6.95016%209.59809%207.08383%209.64968%207.22138%209.64433C7.35892%209.63897%207.48818%209.57715%207.57868%209.47343L13.0814%203.16663Z%22%20fill%3D%22%239C9CA3%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var readIcon = "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2212%22%20viewBox%3D%220%200%2014%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20opacity%3D%220.8%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.15147%203.15262C9.32528%202.93804%209.29224%202.62319%209.07766%202.44938C8.86308%202.27557%208.54822%202.30861%208.37441%202.52319L3.61414%208.39998L1.626%206.42494C1.4301%206.23032%201.11352%206.23137%200.918901%206.42727C0.724285%206.62318%200.725331%206.93976%200.921238%207.13438L3.30197%209.49942C3.40229%209.59908%203.54012%209.6516%203.68131%209.64398C3.82251%209.63635%203.95388%209.5693%204.04289%209.45942L9.15147%203.15262ZM13.0814%203.16663C13.263%202.95855%2013.2415%202.6427%2013.0334%202.46115C12.8253%202.27961%2012.5095%202.30111%2012.3279%202.50919L7.17358%208.41667L6.74794%207.99934C6.55077%207.80601%206.2342%207.80912%206.04087%208.0063C5.84754%208.20348%205.85066%208.52004%206.04783%208.71337L6.85187%209.50172C6.95016%209.59809%207.08383%209.64968%207.22138%209.64433C7.35892%209.63897%207.48818%209.57715%207.57868%209.47343L13.0814%203.16663Z%22%20fill%3D%22%239C9CA3%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var warningIcon = "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2217%22%20viewBox%3D%220%200%2018%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8.99992%2011C8.96695%2011%208.93473%2011.0098%208.90732%2011.0281C8.87992%2011.0464%208.85855%2011.0724%208.84594%2011.1029C8.83332%2011.1333%208.83002%2011.1669%208.83645%2011.1992C8.84289%2011.2315%208.85876%2011.2612%208.88207%2011.2845C8.90538%2011.3078%208.93507%2011.3237%208.9674%2011.3301C8.99973%2011.3366%209.03324%2011.3333%209.0637%2011.3206C9.09415%2011.308%209.12018%2011.2867%209.1385%2011.2593C9.15681%2011.2319%209.16659%2011.1996%209.16659%2011.1667C9.16659%2011.1225%209.14903%2011.0801%209.11777%2011.0488C9.08651%2011.0176%209.04412%2011%208.99992%2011Z%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%209.66667V6%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4%209C4%2010.3261%204.52678%2011.5979%205.46447%2012.5355C6.40215%2013.4732%207.67392%2014%209%2014C10.3261%2014%2011.5979%2013.4732%2012.5355%2012.5355C13.4732%2011.5979%2014%2010.3261%2014%209C14%207.67392%2013.4732%206.40215%2012.5355%205.46447C11.5979%204.52678%2010.3261%204%209%204C7.67392%204%206.40215%204.52678%205.46447%205.46447C4.52678%206.40215%204%207.67392%204%209V9Z%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%2F%3E%3C%2Fsvg%3E";

exports.CometChatReceipt = class CometChatReceipt extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.waitIcon = waitIcon;
        this.sentIcon = sentIcon;
        this.deliveredIcon = deliveredIcon;
        this.readIcon = readIcon;
        this.errorIcon = warningIcon;
        this.receipt = receipts.wait;
        this.receiptStyle = {
            waitIconTint: "rgba(20, 20, 20, 0.33)",
            sentIconTint: "rgba(20, 20, 20, 0.33)",
            deliveredIconTint: "rgba(20, 20, 20, 0.33)",
            readIconTint: "rgba(51, 153, 255)",
            errorIconTint: "rgba(255, 59, 48)",
        };
        this.iconStyle = {
            height: "24px",
            width: "24px",
            iconTint: ""
        };
        this.icon = '';
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.iconStyle = {
            height: ((_a = this.receiptStyle) === null || _a === void 0 ? void 0 : _a.height) ? (_b = this.receiptStyle) === null || _b === void 0 ? void 0 : _b.height : "16px",
            width: ((_c = this.receiptStyle) === null || _c === void 0 ? void 0 : _c.width) ? (_d = this.receiptStyle) === null || _d === void 0 ? void 0 : _d.width : "16px",
        };
        if (this.receipt == receipts.error) {
            this.icon = this.errorIcon;
            this.iconStyle.iconTint = (_e = this.receiptStyle) === null || _e === void 0 ? void 0 : _e.errorIconTint;
        }
        else if (this.receipt == receipts.sent) {
            this.icon = this.sentIcon;
            this.iconStyle.iconTint = (_f = this.receiptStyle) === null || _f === void 0 ? void 0 : _f.sentIconTint;
        }
        else if (this.receipt == receipts.delivered) {
            this.icon = this.deliveredIcon;
            this.iconStyle.iconTint = (_g = this.receiptStyle) === null || _g === void 0 ? void 0 : _g.deliveredIconTint;
        }
        else if (this.receipt == receipts.read) {
            this.icon = this.readIcon;
            this.iconStyle.iconTint = (_h = this.receiptStyle) === null || _h === void 0 ? void 0 : _h.readIconTint;
        }
        else if (this.receipt == receipts.wait) {
            this.icon = this.waitIcon;
            this.iconStyle.iconTint = (_j = this.receiptStyle) === null || _j === void 0 ? void 0 : _j.waitIconTint;
        }
        if (this.icon) {
            return lit.html `<cometchat-icon .URL=${this.icon} .iconStyle=${this.iconStyle}></cometchat-icon>`;
        }
    }
};
exports.CometChatReceipt.styles = [
    lit.css `
      `
];
__decorate([
    decorators_js.property()
], exports.CometChatReceipt.prototype, "waitIcon", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatReceipt.prototype, "sentIcon", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatReceipt.prototype, "deliveredIcon", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatReceipt.prototype, "readIcon", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatReceipt.prototype, "errorIcon", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatReceipt.prototype, "receipt", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatReceipt.prototype, "receiptStyle", void 0);
exports.CometChatReceipt = __decorate([
    decorators_js.customElement('cometchat-receipt')
], exports.CometChatReceipt);
var receipts;
(function (receipts) {
    receipts[receipts["wait"] = 0] = "wait";
    receipts[receipts["sent"] = 1] = "sent";
    receipts[receipts["delivered"] = 2] = "delivered";
    receipts[receipts["read"] = 3] = "read";
    receipts[receipts["error"] = 4] = "error";
})(receipts || (receipts = {}));

/**
 * ReceiptStyle class represents the styles for receipts.
 *
 * @property {string} waitIconTint - Tint color for wait icon.
 * @property {string} sentIconTint - Tint color for sent icon.
 * @property {string} deliveredIconTint - Tint color for delivered icon.
 * @property {string} readIconTint - Tint color for read icon.
 * @property {string} errorIconTint - Tint color for error icon.
 */
class ReceiptStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.waitIconTint = "RGBA(20, 20, 20, 0.58)";
        this.sentIconTint = "RGBA(20, 20, 20, 0.58)";
        this.deliveredIconTint = "RGBA(20, 20, 20, 0.58)";
        this.readIconTint = "rgba(51, 153, 255)";
        this.errorIconTint = "RGB(255, 59, 48)";
        Object.assign(this, props);
    }
}

exports.CometChatStatusIndicator = class CometChatStatusIndicator extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.backgroundColor = "orange";
        this.backgroundImage = "";
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            border: "none",
            borderRadius: "16px",
        }; //Custom styling
        this.background = "";
        this.getStyle = () => {
            var _a, _b, _c, _d;
            this.background = "";
            if (this.backgroundImage) {
                this.background = `${this.backgroundColor} url(${this.backgroundImage}) no-repeat  center`;
            }
            else if (this.backgroundColor && !this.backgroundImage) {
                this.background = this.backgroundColor;
            }
            return {
                border: (_a = this.statusIndicatorStyle) === null || _a === void 0 ? void 0 : _a.border,
                borderRadius: (_b = this.statusIndicatorStyle) === null || _b === void 0 ? void 0 : _b.borderRadius,
                height: (_c = this.statusIndicatorStyle) === null || _c === void 0 ? void 0 : _c.height,
                width: (_d = this.statusIndicatorStyle) === null || _d === void 0 ? void 0 : _d.width,
                background: this.background,
                ...this.statusIndicatorStyle
            };
        };
    }
    render() {
        return lit.html `<span style= ${styleMap_js.styleMap(this.getStyle())} class="cc__statusindicator"> </span>`;
    }
};
exports.CometChatStatusIndicator.styles = [
    lit.css `
  .cc__statusindicator{
    display: block;
    overflow:overlay;
    position: absolute;
    bottom: 0;
    right: 0;
}
  `
];
__decorate([
    decorators_js.property()
], exports.CometChatStatusIndicator.prototype, "backgroundColor", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatStatusIndicator.prototype, "backgroundImage", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatStatusIndicator.prototype, "statusIndicatorStyle", void 0);
exports.CometChatStatusIndicator = __decorate([
    decorators_js.customElement('cometchat-status-indicator')
], exports.CometChatStatusIndicator);

exports.CometChatDate = class CometChatDate extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.dateStyle = {
            textFont: "400 13px Inter",
            textColor: "rgba(20, 20, 20, 0.58)",
            background: "none",
            height: "",
            width: "",
            border: "",
            borderRadius: "",
            padding: "0",
            display: "inline"
        };
        this.pattern = uikitResources.DatePatterns.time;
        this.customDateString = null;
        this.monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        this.weekNames = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        this.date = new Date(this.timestamp * 1000);
        this.getWeekOfDay = () => {
            let weekDay = this.date.getDay();
            let week = this.weekNames[weekDay];
            return week.substring(0, 3);
        };
        this.getMonthOfDay = () => {
            let month = this.date.getMonth();
            let mnth = this.monthNames[month];
            return mnth.substring(0, 3);
        };
        this.getDateFormat = () => {
            if (this.pattern === uikitResources.DatePatterns.DayDate) {
                return this.date.getDate() + " " + this.getMonthOfDay() + ", " + this.date.getFullYear();
            }
            let dt = this.date.getDate();
            if (dt < 10) {
                dt = "0" + dt;
            }
            return dt + "/" + (this.date.getMonth() + 1) + "/" + this.date.getFullYear();
        };
        this.getMinute = (date) => {
            if (date.getMinutes() < 10) {
                return `0${date.getMinutes()}`;
            }
            else {
                return date.getMinutes();
            }
        };
        this.getTimeFormat = () => {
            let timeString = this.date.getHours();
            let postString = "AM";
            if (timeString > 11) {
                postString = "PM";
                timeString = timeString !== 12 ? timeString % 12 : timeString;
            }
            if (timeString < 10) {
                timeString = `0${timeString}`;
            }
            return timeString + ":" + this.getMinute(this.date) + " " + postString;
        };
        this.getDateTimeFormat = () => {
            let timeString = this.date.getHours();
            let postString = "AM";
            if (timeString > 11) {
                postString = "PM";
                timeString = timeString !== 12 ? timeString % 12 : timeString;
            }
            if (timeString < 10) {
                timeString = `0${timeString}`;
            }
            let date = this.date.getDate() + " " + this.getMonthOfDay();
            return date + ", " + timeString + ":" + this.getMinute(this.date) + " " + postString;
        };
        this.getDate = () => {
            const today = new Date();
            if (today.getMonth() === this.date.getMonth() &&
                today.getFullYear() === this.date.getFullYear()) {
                let diff = today.getDate() - this.date.getDate();
                if (diff === 0) {
                    if (this.pattern === uikitResources.DatePatterns.DayDateTime) {
                        return this.getTimeFormat();
                    }
                    return uikitResources.localize("TODAY");
                }
                else if (diff === 1) {
                    return uikitResources.localize("YESTERDAY");
                }
                else if (diff < 7) {
                    return this.getWeekOfDay();
                }
                else {
                    return this.getDateFormat();
                }
            }
            else {
                return this.getDateFormat();
            }
        };
        this.getFormattedDate = () => {
            if (this.customDateString) {
                return this.customDateString;
            }
            else if (this.pattern != null) {
                let formattedDate = "";
                switch (this.pattern) {
                    case uikitResources.DatePatterns.time:
                        formattedDate = this.getTimeFormat();
                        break;
                    case uikitResources.DatePatterns.DayDate:
                    case uikitResources.DatePatterns.DayDateTime:
                        formattedDate = this.getDate();
                        break;
                    case uikitResources.DatePatterns.DateTime:
                        formattedDate = this.getDateTimeFormat();
                        break;
                }
                return formattedDate;
            }
            return null;
        };
        //   styles
        this.DateStyles = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return {
                font: (_a = this.dateStyle) === null || _a === void 0 ? void 0 : _a.textFont,
                color: (_b = this.dateStyle) === null || _b === void 0 ? void 0 : _b.textColor,
                background: (_c = this.dateStyle) === null || _c === void 0 ? void 0 : _c.background,
                height: (_d = this.dateStyle) === null || _d === void 0 ? void 0 : _d.height,
                width: (_e = this.dateStyle) === null || _e === void 0 ? void 0 : _e.width,
                border: (_f = this.dateStyle) === null || _f === void 0 ? void 0 : _f.border,
                borderRadius: (_g = this.dateStyle) === null || _g === void 0 ? void 0 : _g.borderRadius,
                textAlign: 'center',
                padding: ((_h = this.dateStyle) === null || _h === void 0 ? void 0 : _h.padding) || "3px 10px",
                display: ((_j = this.dateStyle) === null || _j === void 0 ? void 0 : _j.display) || "inline"
            };
        };
    }
    render() {
        this.date = new Date(this.timestamp * 1000);
        return lit.html `<span class="cc__date" style=${styleMap_js.styleMap(this.DateStyles())}>${this.getFormattedDate()}</span>`;
    }
};
exports.CometChatDate.styles = [
    lit.css `
    .cc__date{
      display: inline;
    }
      `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatDate.prototype, "dateStyle", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatDate.prototype, "timestamp", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatDate.prototype, "pattern", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatDate.prototype, "customDateString", void 0);
exports.CometChatDate = __decorate([
    decorators_js.customElement('cometchat-date')
], exports.CometChatDate);

/**
 * DateStyle class defines the style properties for date.
 *
 * @property {string} textFont - The font style for the text.
 * @property {string} textColor - The text color for the text.
 *
 * @extends {BaseStyle}
 */
class DateStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "400 13px Inter, sans-serif";
        this.textColor = "RGBA(20, 20, 20, 0.6)";
        this.padding = "4px";
        this.display = "inline";
        Object.assign(this, props);
    }
}

exports.CometChatIcon = class CometChatIcon extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.name = "";
        this.URL = "";
        this.iconStyle = {
            height: "24px",
            width: "24px",
            iconTint: "grey"
        };
    }
    render() {
        if (this.URL) {
            return lit.html ` <div class="cc__icon" style=${styleMap_js.styleMap(this.iconStyles())} title=${this.name}></div>`;
        }
    }
    iconStyles() {
        var _a, _b, _c;
        return {
            WebkitMask: `url(${this.URL})  center center no-repeat`,
            background: (_a = this.iconStyle) === null || _a === void 0 ? void 0 : _a.iconTint,
            height: (_b = this.iconStyle) === null || _b === void 0 ? void 0 : _b.height,
            width: (_c = this.iconStyle) === null || _c === void 0 ? void 0 : _c.width,
            // WebkitMaskRepeat:"no-repeat"
            WebkitMaskSize: "100%"
        };
    }
};
exports.CometChatIcon.styles = [
    lit.css `
    .cc__icon{
      -webkit-mask-repeat: no-repeat;
      mask-repeat:no-repeat;
      -webkit-mask-size: 100%;
    }
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatIcon.prototype, "name", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatIcon.prototype, "URL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatIcon.prototype, "iconStyle", void 0);
exports.CometChatIcon = __decorate([
    decorators_js.customElement('cometchat-icon')
], exports.CometChatIcon);

/**
 * IconStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class IconStyle {
    constructor(props) {
        this.iconTint = "grey";
        this.height = "24px";
        this.width = "24px";
        Object.assign(this, props);
    }
}

exports.CometChatBackdrop = class CometChatBackdrop extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.isOpen = true; //If `true`, the component is shown
        this.backdropStyle = {
            background: "rgba(0, 0, 0, 0.5)",
            position: "absolute"
        }; //Styles applied to the backdrop element
        this.dispatchClickEvent = (event) => {
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
            event === null || event === void 0 ? void 0 : event.preventDefault();
            this.dispatchEvent(new CustomEvent('cc-backdrop-clicked', {
                bubbles: true,
                composed: true,
                detail: { event: event }
            }));
        };
    }
    render() {
        if (this.isOpen) {
            return lit.html `<div class="cc__backdrop" style= ${styleMap_js.styleMap(this.backDropStyle())}  @click= ${this.dispatchClickEvent}>
    <div class="cc__backdrop__slot">
       <slot></slot>
    </div>
</div>`;
        }
    }
    backDropStyle() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            height: (_a = this.backdropStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.backdropStyle) === null || _b === void 0 ? void 0 : _b.width,
            border: (_c = this.backdropStyle) === null || _c === void 0 ? void 0 : _c.border,
            borderRadius: (_d = this.backdropStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
            background: ((_e = this.backdropStyle) === null || _e === void 0 ? void 0 : _e.background) ? (_f = this.backdropStyle) === null || _f === void 0 ? void 0 : _f.background : 'rgba(0, 0, 0, 0.5)',
            position: (_h = (_g = this.backdropStyle) === null || _g === void 0 ? void 0 : _g.position) !== null && _h !== void 0 ? _h : "fixed"
        };
    }
};
exports.CometChatBackdrop.styles = [
    lit.css `
    .cc__backdrop {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    }
    .cc__backdrop__slot {
      height: fit-content;
      width: fit-content;
      z-index: 100;
    }
    `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatBackdrop.prototype, "isOpen", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatBackdrop.prototype, "backdropStyle", void 0);
exports.CometChatBackdrop = __decorate([
    decorators_js.customElement('cometchat-backdrop')
], exports.CometChatBackdrop);

exports.CometChatButton = class CometChatButton extends lit.LitElement {
    constructor() {
        super();
        this.disabled = false;
        this.text = "";
        this.iconURL = "";
        this.hoverText = "";
        this.buttonStyle = {
            height: "fit-content",
            width: "fit-content",
            buttonTextFont: "",
            buttonTextColor: "",
            borderRadius: "8px",
            border: "1px solid #eeeeee",
            buttonIconTint: "",
            background: "",
        };
        this.iconStyle = {};
        this.dispatchClickEvent = (event) => {
            this.dispatchEvent(new CustomEvent('cc-button-clicked', {
                bubbles: true,
                composed: true,
                detail: { event: event }
            }));
        };
    }
    render() {
        var _a, _b, _c, _d, _e;
        this.iconStyle = Object.assign({}, {
            height: ((_a = this.buttonStyle) === null || _a === void 0 ? void 0 : _a.iconHeight) ? (_b = this.buttonStyle) === null || _b === void 0 ? void 0 : _b.iconHeight : "24px",
            width: ((_c = this.buttonStyle) === null || _c === void 0 ? void 0 : _c.iconWidth) ? (_d = this.buttonStyle) === null || _d === void 0 ? void 0 : _d.iconWidth : "24px",
            iconTint: (_e = this.buttonStyle) === null || _e === void 0 ? void 0 : _e.buttonIconTint
        });
        return lit.html `<button @mouseup=${(event) => event === null || event === void 0 ? void 0 : event.stopPropagation()} @mousedown=${(event) => event === null || event === void 0 ? void 0 : event.stopPropagation()}  class="cc__button" title=${this.hoverText} @click=${this.dispatchClickEvent} style= ${styleMap_js.styleMap(this.buttonStyles())}  ?disabled=${this.disabled} >${lit.html `<cometchat-icon  .URL=${this.iconURL} .name=${this.hoverText} .iconStyle=${this.iconStyle}></cometchat-icon>`} ${this.text}</button>`;
    }
    buttonStyles() {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            ...this.buttonStyle,
            font: (_a = this.buttonStyle) === null || _a === void 0 ? void 0 : _a.buttonTextFont,
            height: (_b = this.buttonStyle) === null || _b === void 0 ? void 0 : _b.height,
            width: (_c = this.buttonStyle) === null || _c === void 0 ? void 0 : _c.width,
            border: (_d = this.buttonStyle) === null || _d === void 0 ? void 0 : _d.border,
            borderRadius: (_e = this.buttonStyle) === null || _e === void 0 ? void 0 : _e.borderRadius,
            color: (_f = this.buttonStyle) === null || _f === void 0 ? void 0 : _f.buttonTextColor,
            background: (_g = this.buttonStyle) === null || _g === void 0 ? void 0 : _g.background,
            opacity: this.disabled ? 0.6 : 1,
            cursor: this.disabled ? "default" : 'pointer',
        };
    }
};
exports.CometChatButton.styles = [
    lit.css `
    .cc__button {
      display:flex;
      flex-direction:row;
      justify-content: flex-start;
      align-items: center;
      padding: 0;
      text-align: left;
    }
    `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatButton.prototype, "disabled", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatButton.prototype, "text", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatButton.prototype, "iconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatButton.prototype, "hoverText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatButton.prototype, "buttonStyle", void 0);
exports.CometChatButton = __decorate([
    decorators_js.customElement('cometchat-button')
], exports.CometChatButton);

/**
 * Sanitizes an HTML string by removing any tags that do not match the provided whitelist regular expressions.
 * If the input is not a string or the whitelist is not an array, the input string is returned as is.
 *
 * @param htmlString - The HTML string to sanitize.
 * @param whitelistRegExes - An array of regular expressions representing the whitelist of allowed tags.
 * @returns The sanitized HTML string.
 */
function sanitizeHtml(htmlString, whitelistRegExes) {
    if (!htmlString) {
        return "";
    }
    if (!Array.isArray(whitelistRegExes)) {
        return htmlString;
    }
    let returnString = htmlString;
    try {
        returnString = htmlString.replace(/<[^>]+>?/g, function (match) {
            const combinedRegex = new RegExp("(" + whitelistRegExes.map((regex) => regex.source).join("|") + ")");
            return combinedRegex.test(match)
                ? match
                : match.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        });
    }
    catch (error) {
        console.log(error);
    }
    return returnString;
}
/**
 * Debounces a function, ensuring it is only executed after a specified wait time has passed since the last invocation.
 * @param func The function to debounce.
 * @param wait The wait time in milliseconds.
 * @returns A debounced version of the function.
 */
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
/**
 * Checks if an element is scrollable.
 * @param ele - The HTML element to check.
 * @returns True if the element is scrollable, false otherwise.
 */
function isScrollable(ele) {
    const hasScrollableContent = ele.scrollHeight > ele.clientHeight || ele.scrollWidth > ele.clientWidth;
    // Check for overflow styles and handle potential edge cases
    const overflowYStyle = window.getComputedStyle(ele).overflowY;
    const overflowXStyle = window.getComputedStyle(ele).overflowX;
    const isOverflowHidden = overflowYStyle.indexOf("hidden") !== -1 ||
        overflowXStyle.indexOf("hidden") !== -1;
    const isOverflowAuto = (overflowYStyle === "auto" || overflowXStyle === "auto") &&
        hasScrollableContent;
    // Consider potential non-standard overflow values and nested overflow
    const isNonStandardOverflow = (overflowYStyle !== "visible" &&
        overflowYStyle !== "hidden" &&
        overflowYStyle !== "scroll") ||
        (overflowXStyle !== "visible" &&
            overflowXStyle !== "hidden" &&
            overflowXStyle !== "scroll");
    // Return true if scrollable content exists and overflow is not primarily hidden
    return ((hasScrollableContent && !isOverflowHidden) ||
        isOverflowAuto ||
        isNonStandardOverflow);
}
/**
 * Returns the closest scrollable ancestor of the given element.
 * If no scrollable ancestor is found, the document element is returned as the default fallback.
 * @param ele - The element for which to find the closest scrollable ancestor.
 * @returns The closest scrollable ancestor element or the document element if none is found.
 */
function getClosestScrollableAncestor(ele) {
    while (ele) {
        // Get the root node of the current element
        const rootNode = ele.getRootNode();
        // Check if the root node is a shadow root
        if (rootNode instanceof ShadowRoot) {
            // If the root node is a shadow root, traverse to its host
            ele = rootNode.host;
        }
        else {
            // If not in shadow DOM, move to the parent element
            ele = ele.parentElement;
        }
        // Check if the current element is scrollable
        if (ele && isScrollable(ele)) {
            return ele; // Return the scrollable element
        }
    }
    // No scrollable ancestor found, return document as default fallback
    return document.documentElement;
}
/**
 * Checks if an element is visible within its scrollable ancestor.
 *
 * @param element - The element to check visibility for.
 * @returns A boolean indicating whether the element is visible.
 */
function isElementVisibleWithScrollableAncestor(element) {
    // Get closest scrollable ancestor
    const scrollableAncestor = getClosestScrollableAncestor(element);
    const elemRect = element.getBoundingClientRect();
    const contRect = scrollableAncestor.getBoundingClientRect();
    // Check visibility within the scrollable ancestor, considering potential edge cases
    const isVisible = elemRect.top >= contRect.top && // Top within scrollable area
        elemRect.left >= contRect.left && // Left within scrollable area
        elemRect.bottom <= contRect.bottom && // Bottom within scrollable area
        elemRect.right <= contRect.right && // Right within scrollable area
        elemRect.bottom > contRect.top && // Some element height within view
        elemRect.right > contRect.left; // Some element width within view
    return isVisible;
}
/**
* Detects if the device is mobile.
* @returns {boolean} True if the device is mobile, otherwise false.
*/
function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
}

var Placement;
(function (Placement) {
    Placement["top"] = "top";
    Placement["right"] = "right";
    Placement["bottom"] = "bottom";
    Placement["left"] = "left";
})(Placement || (Placement = {}));
exports.CometChatPopover = class CometChatPopover extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.popoverStyle = {
            width: "372px",
            height: "330px",
            border: "none",
            background: "white",
            borderRadius: "8px",
            boxShadow: "0px 0px 32px rgba(20, 20, 20, 0.2)",
        };
        this.hasToolTip = false;
        this.closeOnOutsideClick = true;
        this.placement = Placement.bottom;
        this.showOnHover = false;
        this.debounceOnHover = 0;
        this.deg = {
            top: 180,
            right: 270,
            bottom: 0,
            left: 90
        };
        this.x = 0;
        this.y = 0;
        this.tipPositionMapping = {
            top: "x",
            right: "y",
            bottom: "x",
            left: "y"
        };
        this.openContentView = (e) => {
            var _a, _b;
            this.activeChildElement = e === null || e === void 0 ? void 0 : e.target;
            e.stopPropagation();
            const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="children"]');
            const childElements = slot === null || slot === void 0 ? void 0 : slot.assignedNodes({ flatten: true });
            const childElement = (_b = childElements === null || childElements === void 0 ? void 0 : childElements[0]) !== null && _b !== void 0 ? _b : this.activeChildElement;
            if (childElement instanceof HTMLElement) {
                this.x = childElement.getBoundingClientRect().left;
                this.y = childElement.getBoundingClientRect().top;
            }
            this.renderRoot.querySelector('.cc__tooltip').classList.toggle("hide");
            this.requestUpdate();
        };
        this.toolTipWrapperStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            const axis = this.tipPositionMapping[this.placement];
            let x = this.x ? this.x : 0;
            let y = this.y ? this.y : 0;
            let width = parseInt((_a = this.popoverStyle) === null || _a === void 0 ? void 0 : _a.width);
            let height = parseInt((_b = this.popoverStyle) === null || _b === void 0 ? void 0 : _b.height);
            let windowWidth = window.innerWidth;
            let windowHeight = window.innerHeight;
            let percent = 0;
            if (axis === "x") {
                percent = (100 * x) / windowWidth;
            }
            else {
                percent = (100 * y) / windowHeight;
            }
            let axisPosition = {};
            if (axis === "x") {
                axisPosition = {
                    left: `${x - width * (percent / 100)}px`
                };
            }
            else {
                axisPosition = {
                    top: `${y - height * (percent / 100)}px`
                };
            }
            let positionStyle = {};
            if (this.placement === Placement.top) {
                positionStyle = {
                    top: `${y - parseInt(height) - 20}px`
                };
            }
            else if (this.placement === Placement.bottom) {
                positionStyle = {
                    top: `${y + 20}px`
                };
            }
            else if (this.placement === Placement.left) {
                positionStyle = {
                    left: `${x - parseInt(width) - 10}px`
                };
            }
            else if (this.placement === Placement.right) {
                positionStyle = {
                    left: `${x + 25}px`
                };
            }
            return {
                boxShadow: (_c = this.popoverStyle) === null || _c === void 0 ? void 0 : _c.boxShadow,
                borderRadius: (_d = this.popoverStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                width: `${width}px`,
                height: `${height}px`,
                position: "fixed",
                border: (_e = this.popoverStyle) === null || _e === void 0 ? void 0 : _e.border,
                background: `${(_f = this.popoverStyle) === null || _f === void 0 ? void 0 : _f.background}`,
                ...positionStyle,
                ...axisPosition,
                zIndex: "2"
            };
        };
        this.toolTipContentStyle = () => {
            return {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%"
            };
        };
        this.toolTipStyles = () => {
            var _a, _b, _c;
            const axis = this.tipPositionMapping[this.placement];
            let x = this.x ? this.x : 0;
            let y = this.y ? this.y : 0;
            let width = parseInt((_a = this.popoverStyle) === null || _a === void 0 ? void 0 : _a.width);
            let height = parseInt((_b = this.popoverStyle) === null || _b === void 0 ? void 0 : _b.height);
            let windowWidth = window.innerWidth;
            let windowHeight = window.innerHeight;
            let percent = 0;
            if (axis === "x") {
                percent = (100 * x) / windowWidth;
            }
            else {
                percent = (100 * y) / windowHeight;
            }
            let positionStyle = {};
            if (axis === "x") {
                if (this.placement === Placement.top) {
                    positionStyle = {
                        left: `${width * (percent / 100) - 10}px`,
                        top: height + "px"
                    };
                }
                else if (this.placement === Placement.bottom) {
                    positionStyle = {
                        left: `${width * (percent / 100) - 10}px`,
                        top: -10 + "px"
                    };
                }
            }
            else {
                if (this.placement === Placement.left) {
                    positionStyle = {
                        left: `calc(${width + "px"} - 5px)`,
                        top: `${height * (percent / 100) - 10}px`
                    };
                }
                else if (this.placement === Placement.right) {
                    positionStyle = {
                        left: -15 + "px",
                        top: `${height * (percent / 100) - 10}px`
                    };
                }
            }
            const color = ((_c = this.popoverStyle) === null || _c === void 0 ? void 0 : _c.background) || "grey";
            return {
                zIndex: 11,
                width: "0",
                height: "0",
                borderLeft: "10px solid transparent",
                borderRight: "10px solid transparent",
                borderBottom: `10px solid ${color}`,
                position: "relative",
                ...positionStyle,
                transform: `rotate(${this.deg[this.placement]}deg)`
            };
        };
    }
    debouncedHandleWindowChange() {
        // Trigger a check to re-evaluate the tooltip position
        if (this.shadowRoot) {
            this.handleClick(new MouseEvent('click'));
        }
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.closeOnOutsideClick) {
            document.addEventListener('click', this.handleClick.bind(this));
        }
        window.addEventListener('resize', this.debouncedHandleWindowChange.bind(this));
        window.addEventListener('scroll', this.debouncedHandleWindowChange.bind(this), true);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedHandleWindowChange.bind(this));
        window.removeEventListener('scroll', this.debouncedHandleWindowChange.bind(this), true);
        super.disconnectedCallback();
        if (this.closeOnOutsideClick) {
            document.removeEventListener('click', this.handleClick.bind(this));
        }
    }
    handleChangeInWindow() {
        var _a, _b;
        // if popover is not open then return
        if (this.shadowRoot) {
            const tooltip = this.shadowRoot.querySelector('.cc__tooltip');
            if (tooltip.classList.contains('hide')) {
                return;
            }
        }
        const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="children"]');
        const childElements = slot === null || slot === void 0 ? void 0 : slot.assignedNodes({ flatten: true });
        const childElement = (_b = childElements === null || childElements === void 0 ? void 0 : childElements[0]) !== null && _b !== void 0 ? _b : this.activeChildElement;
        // check if child element is present in visible area or not
        if (childElement instanceof HTMLElement) {
            const isVisible = isElementVisibleWithScrollableAncestor(childElement);
            if (!isVisible) {
                this.closeContentView();
                return;
            }
        }
        if (childElement instanceof HTMLElement) {
            this.x = childElement.getBoundingClientRect().left;
            this.y = childElement.getBoundingClientRect().top;
        }
        this.requestUpdate();
    }
    isPopoverOpen() {
        if (this.renderRoot) {
            const tooltip = this.renderRoot.querySelector('.cc__tooltip');
            return !tooltip.classList.contains('hide');
        }
        return false;
    }
    firstUpdated(_changedProperties) {
    }
    updated(_changedProperties) {
    }
    handleScrollOrResize() {
        if (this.closeOnOutsideClick) {
            this.closeContentView();
        }
    }
    handleClick(event) {
        if (!this.closeOnOutsideClick || !this.shadowRoot)
            return;
        const tooltip = this.shadowRoot.querySelector('.cc__tooltip');
        if (!tooltip)
            return;
        const tooltipRect = tooltip.getBoundingClientRect();
        const isOutsideClick = (event === null || event === void 0 ? void 0 : event.clientX) >= (tooltipRect === null || tooltipRect === void 0 ? void 0 : tooltipRect.left) && (event === null || event === void 0 ? void 0 : event.clientX) <= (tooltipRect === null || tooltipRect === void 0 ? void 0 : tooltipRect.right) && (event === null || event === void 0 ? void 0 : event.clientY) >= (tooltipRect === null || tooltipRect === void 0 ? void 0 : tooltipRect.top) && (event === null || event === void 0 ? void 0 : event.clientY) <= (tooltipRect === null || tooltipRect === void 0 ? void 0 : tooltipRect.bottom);
        if (isOutsideClick) {
            this.closeContentView();
        }
    }
    closeContentView() {
        this.activeChildElement = null;
        if (this.renderRoot) {
            const tooltip = this.renderRoot.querySelector('.cc__tooltip');
            if (!tooltip.classList.contains('hide')) {
                tooltip.classList.add('hide');
                this.dispatchEvent(new CustomEvent("cc-popover-outside-clicked", {
                    bubbles: true,
                    composed: true,
                    detail: { isOpen: false },
                }));
            }
        }
    }
    requestUpdate(name, oldValue, options) {
        super.requestUpdate();
    }
    render() {
        return lit.html `
      <div
        class="cc__tooltip hide"
        style=${styleMap_js.styleMap(this.toolTipWrapperStyle())}
      >
        ${this.hasToolTip
            ? lit.html `<div
              class="cc__tooltip__pointer"
              style=${styleMap_js.styleMap(this.toolTipStyles())}
            ></div>`
            : lit.nothing}
        <div
          class="cc__tooltip__content"
          style=${styleMap_js.styleMap(this.toolTipContentStyle())}
        >
          <slot name="content"></slot>
        </div>
      </div>
      <div
        @click="${(e) => {
            if (!this.showOnHover) {
                if (this.childClickHandler) {
                    this.childClickHandler(this.openContentView, e);
                }
                else {
                    this.openContentView(e);
                }
            }
        }}"
        @mouseover="${(e) => {
            if (this.showOnHover) {
                this.timeOut = setTimeout(() => {
                    this.openContentView(e);
                }, this.debounceOnHover);
            }
        }}"
        @mouseout="${() => {
            if (this.showOnHover) {
                if (this.timeOut)
                    clearTimeout(this.timeOut);
                this.closeContentView();
            }
        }}"
      >
        <slot name="children"></slot>
      </div>
    `;
    }
};
exports.CometChatPopover.styles = [
    lit.css `
.hide { display: none };
.cc__tooltip{
  z-index:2;
}

`
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatPopover.prototype, "popoverStyle", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatPopover.prototype, "hasToolTip", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatPopover.prototype, "closeOnOutsideClick", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatPopover.prototype, "placement", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatPopover.prototype, "showOnHover", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatPopover.prototype, "debounceOnHover", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatPopover.prototype, "x", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatPopover.prototype, "y", void 0);
__decorate([
    decorators_js.property({ type: Function })
], exports.CometChatPopover.prototype, "childClickHandler", void 0);
exports.CometChatPopover = __decorate([
    decorators_js.customElement('cometchat-popover')
], exports.CometChatPopover);

/**
 * PopoverStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class PopoverStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.boxShadow = "0px 0px 32px rgba(20, 20, 20, 0.2)";
        Object.assign(this, props);
    }
}

exports.CometChatLabel = class CometChatLabel extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.text = "";
        this.dir = "auto";
        this.labelStyle = {
            height: "",
            width: "",
            border: "",
            borderRadius: "",
            background: "",
            textFont: "",
            textColor: ""
        };
    }
    render() {
        return lit.html ` <label class="cc__label" dir=${this.dir} style=${styleMap_js.styleMap(this.labelStyles())}> ${this.text} </label>`;
    }
    labelStyles() {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            color: (_a = this.labelStyle) === null || _a === void 0 ? void 0 : _a.textColor,
            font: (_b = this.labelStyle) === null || _b === void 0 ? void 0 : _b.textFont,
            height: ((_c = this.labelStyle) === null || _c === void 0 ? void 0 : _c.height) || "fit-content",
            width: ((_d = this.labelStyle) === null || _d === void 0 ? void 0 : _d.width) || "fit-content",
            border: (_e = this.labelStyle) === null || _e === void 0 ? void 0 : _e.border,
            borderRadius: (_f = this.labelStyle) === null || _f === void 0 ? void 0 : _f.borderRadius,
            background: (_g = this.labelStyle) === null || _g === void 0 ? void 0 : _g.background
        };
    }
};
exports.CometChatLabel.styles = [
    lit.css `
    .cc__label{
      text-align: left;
      cursor:inherit;
    }

    `
];
__decorate([
    decorators_js.property()
], exports.CometChatLabel.prototype, "text", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatLabel.prototype, "dir", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatLabel.prototype, "labelStyle", void 0);
exports.CometChatLabel = __decorate([
    decorators_js.customElement('cometchat-label')
], exports.CometChatLabel);

class LabelStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "";
        this.textColor = "";
        Object.assign(this, props);
    }
}

exports.CometChatInput = class CometChatInput extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.value = "";
        this.type = "text";
        this.checked = true;
        this.placeholderText = "Start typing...";
        this.hidden = false;
        this.multiple = false;
        this.accept = "";
        this.dir = "auto";
        this.inputStyle = {
            height: "24px",
            width: "fit-content",
            border: "none",
            textFont: "400 14px Inter",
            textColor: "grey",
            placeholderTextFont: "500 13px Inter",
            placeholderTextColor: "#bcbcbc",
            borderRadius: "12px",
            boxShadow: "",
            background: "transparent"
        };
        this.onChange = (e) => {
            var _a;
            this.value = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            this.dispatchEvent(new CustomEvent('cc-input-changed', {
                bubbles: true,
                composed: true,
                detail: { value: this.value }
            }));
        };
        this.labelStyle = () => {
            var _a;
            return {
                padding: (_a = this.inputStyle) === null || _a === void 0 ? void 0 : _a.padding
            };
        };
        this.inputStyles = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return {
                font: (_a = this.inputStyle) === null || _a === void 0 ? void 0 : _a.textFont,
                color: (_b = this.inputStyle) === null || _b === void 0 ? void 0 : _b.textColor,
                height: (_c = this.inputStyle) === null || _c === void 0 ? void 0 : _c.height,
                width: (_d = this.inputStyle) === null || _d === void 0 ? void 0 : _d.width,
                border: (_e = this.inputStyle) === null || _e === void 0 ? void 0 : _e.border,
                borderRadius: (_f = this.inputStyle) === null || _f === void 0 ? void 0 : _f.borderRadius,
                background: (_g = this.inputStyle) === null || _g === void 0 ? void 0 : _g.background,
                boxShadow: (_h = this.inputStyle) === null || _h === void 0 ? void 0 : _h.boxShadow,
                padding: (_j = this.inputStyle) === null || _j === void 0 ? void 0 : _j.padding
            };
        };
        this.placeholderStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.inputStyle) === null || _a === void 0 ? void 0 : _a.placeholderTextFont,
                textColor: (_b = this.inputStyle) === null || _b === void 0 ? void 0 : _b.placeholderTextColor,
                background: "transparent",
            };
        };
    }
    render() {
        return lit.html `  <div class="input-container">${!this.value ? lit.html ` 
    <cometchat-label .dir=${this.dir}  style=${styleMap_js.styleMap(this.labelStyle())}   class="cc__input__label"  text="${this.placeholderText}" .labelStyle=${this.placeholderStyle()} ></cometchat-label>` : ""}
      <input dir=${this.dir}  @input="${(e) => { this.onChange(e); }}" class="cc__input"  type="${this.type}" ?hidden=${this.hidden}  accept=${this.accept} ?multiple=${this.multiple}   value=${this.value}  style=${styleMap_js.styleMap(this.inputStyles())}   />
      </div>
      `;
    }
};
exports.CometChatInput.styles = [
    lit.css `
    .cc__input{
      border:none;
      outline:none;
      width:100%;
      box-sizing: border-box;
    }
    .cc__input__label{position:absolute;
       pointer-events:none;}

      .input-container {
        display: flex;
        align-items: center; /* Center vertically */
        position: relative;
      }
    `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatInput.prototype, "disabled", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatInput.prototype, "value", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatInput.prototype, "type", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatInput.prototype, "checked", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatInput.prototype, "placeholderText", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatInput.prototype, "hidden", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatInput.prototype, "multiple", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatInput.prototype, "accept", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatInput.prototype, "dir", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatInput.prototype, "inputStyle", void 0);
exports.CometChatInput = __decorate([
    decorators_js.customElement('cometchat-input')
], exports.CometChatInput);

class InputStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.placeholderTextFont = "500 13px Inter";
        this.placeholderTextColor = "#bcbcbc";
        this.textFont = "400 14px Inter";
        this.textColor = "grey";
        this.boxShadow = "";
        this.padding = "0px";
        Object.assign(this, props);
    }
}

var searchIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M4.9598%2011.531C5.47958%2012.7541%206.4639%2013.7205%207.69625%2014.2178C8.92859%2014.7151%2010.308%2014.7024%2011.531%2014.1826C12.754%2013.6629%2013.7205%2012.6785%2014.2178%2011.4462C14.715%2010.2139%2014.7024%208.83445%2014.1826%207.61142C13.6629%206.3884%2012.6785%205.42195%2011.4462%204.92467C10.2138%204.4274%208.83444%204.44004%207.61141%204.95981C6.38839%205.47959%205.42194%206.46391%204.92467%207.69626C4.42739%208.9286%204.44003%2010.308%204.9598%2011.531V11.531Z%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.114%2013.1139L17.0001%2017.0005%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

exports.CometChatSearchInput = class CometChatSearchInput extends lit.LitElement {
    constructor() {
        super();
        this.name = "";
        this.searchText = "";
        this.placeholderText = "Start typing...";
        this.searchIconURL = searchIcon;
        this.searchInputStyle = {
            height: "fit-content",
            width: "fit-content",
            border: "1px solid #dedede",
            searchTextFont: "400 14px Inter",
            searchTextColor: "grey",
            placeholderTextFont: "500 13px Inter",
            placeholderTextColor: "#bcbcbc",
            borderRadius: "6px",
            background: "",
            searchIconTint: "grey"
        };
        this.inputStyle = {
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "inherit",
            background: "transparent"
        };
        this.iconStyle = {
            height: "24px",
            width: "24px",
            iconTint: "grey"
        };
        this.keyDownEvent = (options) => {
            this.searchText = options.detail.value;
            this.dispatchEvent(new CustomEvent('cc-search-changed', {
                bubbles: true,
                composed: true,
                detail: { searchText: this.searchText }
            }));
        };
    }
    render() {
        var _a, _b, _c, _d, _e;
        this.inputStyle.placeholderTextFont = (_a = this.searchInputStyle) === null || _a === void 0 ? void 0 : _a.placeholderTextFont;
        this.inputStyle.placeholderTextColor = (_b = this.searchInputStyle) === null || _b === void 0 ? void 0 : _b.placeholderTextColor;
        this.inputStyle.textFont = (_c = this.searchInputStyle) === null || _c === void 0 ? void 0 : _c.searchTextFont;
        this.inputStyle.textColor = (_d = this.searchInputStyle) === null || _d === void 0 ? void 0 : _d.searchTextColor;
        this.iconStyle.iconTint = (_e = this.searchInputStyle) === null || _e === void 0 ? void 0 : _e.searchIconTint;
        return lit.html `<div class="cc__search" style= ${styleMap_js.styleMap(this.searchStyle())} >
          <cometchat-icon class="cc__search__icon"  .URL=${this.searchIconURL} .iconStyle=${this.iconStyle}></cometchat-icon>
          <cometchat-input class="cc__search__input" @cc-input-changed=${this.keyDownEvent}  .placeholderText=${this.placeholderText} .value=${this.searchText} .inputStyle=${this.inputStyle}></cometchat-input>
</div>`;
    }
    searchStyle() {
        var _a, _b, _c, _d, _e, _f;
        return {
            height: (_a = this.searchInputStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.searchInputStyle) === null || _b === void 0 ? void 0 : _b.width,
            border: (_c = this.searchInputStyle) === null || _c === void 0 ? void 0 : _c.border,
            borderRadius: (_d = this.searchInputStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
            background: (_e = this.searchInputStyle) === null || _e === void 0 ? void 0 : _e.background,
            boxShadow: (_f = this.searchInputStyle) === null || _f === void 0 ? void 0 : _f.boxShadow,
        };
    }
};
exports.CometChatSearchInput.styles = [
    lit.css `
    .cc__search{
      display: flex;
      align-items: center;
      padding:3px;
    }
    .cc__search__input{
      width:100%;
    }
    .cc__search__icon{
      margin-right:4px;
    }
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatSearchInput.prototype, "name", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatSearchInput.prototype, "searchText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatSearchInput.prototype, "placeholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatSearchInput.prototype, "searchIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatSearchInput.prototype, "searchInputStyle", void 0);
exports.CometChatSearchInput = __decorate([
    decorators_js.customElement('cometchat-search-input')
], exports.CometChatSearchInput);

class SearchInputStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.searchTextFont = "400 14px Inter";
        this.searchTextColor = "rgba(20, 20, 20, 0.30)";
        this.placeholderTextFont = "500 13px Inter";
        this.placeholderTextColor = "#bcbcbc";
        this.searchIconTint = "grey";
        this.boxShadow = "";
        Object.assign(this, props);
    }
}

exports.CometChatModal = class CometChatModal extends lit.LitElement {
    constructor() {
        super();
        this.title = "";
        this.closeIconURL = "";
        this.closeOnBackdropClick = true;
        this.modalStyle = {
            titleFont: "",
            titleColor: "",
            closeIconTint: "",
            boxShadow: "",
            height: "266px",
            width: "300px",
            border: "",
            borderRadius: "",
            background: "white",
        };
        this.backdropStyle = {
            height: "100%",
            width: "100%",
            border: "",
            borderRadius: "",
            background: "rgba(0, 0, 0, 0.5)",
        };
        this.iconStyle = {
            height: "24px",
            width: "24px",
            iconTint: "grey"
        };
        this.dispatchClickEvent = (event) => {
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
            this.dispatchEvent(new CustomEvent('cc-modal-close-clicked', {
                bubbles: true,
                composed: true,
                detail: { event: event }
            }));
        };
        this.modalWrapperStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                height: (_a = this.modalStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.modalStyle) === null || _b === void 0 ? void 0 : _b.width,
                background: (_c = this.modalStyle) === null || _c === void 0 ? void 0 : _c.background,
                border: (_d = this.modalStyle) === null || _d === void 0 ? void 0 : _d.border,
                borderRadius: (_e = this.modalStyle) === null || _e === void 0 ? void 0 : _e.borderRadius,
                boxShadow: (_f = this.modalStyle) === null || _f === void 0 ? void 0 : _f.boxShadow
            };
        };
        this.titleStyle = () => {
            var _a, _b;
            return {
                font: (_a = this.modalStyle) === null || _a === void 0 ? void 0 : _a.titleFont,
                color: (_b = this.modalStyle) === null || _b === void 0 ? void 0 : _b.titleColor
            };
        };
    }
    render() {
        var _a;
        this.iconStyle.iconTint = (_a = this.modalStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint;
        return lit.html `
         <cometchat-backdrop .onClick=${this.closeOnBackdropClick ? this.dispatchClickEvent : null} .backdropStyle=${this.backdropStyle}>
         <div class="cc__modal"  style=${styleMap_js.styleMap(this.modalWrapperStyle())}>

     <div class="cc__modal__body ">  ${this.title ? lit.html `   <div class="cc__modal__caption" style=${styleMap_js.styleMap(this.titleStyle())} > ${this.title} </div>` : ""}
     ${this.closeIconURL ? lit.html ` <span class="cc__modal__close" @click=${this.dispatchClickEvent}  > <cometchat-icon .URL=${this.closeIconURL} .iconStyle=${this.iconStyle}></cometchat-icon></span>` : ""}
    </div>
    <div class="slot__view">    <slot></slot></div>

     </div>
      </div>
        </cometchat-backdrop>

     <!-- <cometchat-backdrop .onClick=${this.closeOnBackdropClick ? this.dispatchClickEvent : null}> </cometchat-backdrop>
      <div class="cc__modal"  style=${styleMap_js.styleMap(this.modalWrapperStyle())}>
     ${this.closeIconURL ? lit.html ` <span class="cc__modal__close" @click=${this.dispatchClickEvent}  > <cometchat-icon .URL=${this.closeIconURL} .iconStyle=${this.iconStyle}></cometchat-icon></span>` : ""}
    ${this.title ? lit.html ` <div class="cc__modal__body ">  <div class="cc__modal__caption" style=${styleMap_js.styleMap(this.titleStyle())} > ${this.title} </div></div>` : ""}
    <div class="slot__view">    <slot></slot></div>

     </div>
      </div> -->
      `;
    }
};
exports.CometChatModal.styles = [
    lit.css `
    .cc__modal {
      display: flex;
      align-items: center;
      justify-content: center;
      height: fit-content;
      width: fit-content;
      flex-direction: column;
    }
    .cc__modal__close {
      display: flex;
    justify-content: flex-end;
    align-items: flex-start;
      cursor: pointer;
    }
    .cc__modal__body {
      display:flex;
      height: fit-content;
     padding:8px;
      width: 100%;
      border-collapse: collapse;
      margin: 0;
      box-sizing: border-box;
    justify-content: flex-end;
    }
   .cc__modal__caption {
      margin-bottom: 15px;
      text-align: center;
      width:100%;
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items:flex-start;
    }
    .slot__view{
     height:100%;
     width:100%;
     border:inherit;
     border-radius:inherit;
   }

    `
];
__decorate([
    decorators_js.property()
], exports.CometChatModal.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatModal.prototype, "closeIconURL", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatModal.prototype, "closeOnBackdropClick", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatModal.prototype, "modalStyle", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatModal.prototype, "backdropStyle", void 0);
exports.CometChatModal = __decorate([
    decorators_js.customElement('cometchat-modal')
], exports.CometChatModal);

/**
 * ModalStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class ModalStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.closeIconTint = "";
        this.boxShadow = "";
        Object.assign(this, props);
    }
}

var moreIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FMore%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FMore%22%20fill%3D%22%23000000%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.5%2C10%20C5.88071187%2C10%207%2C11.1192881%207%2C12.5%20C7%2C13.8807119%205.88071187%2C15%204.5%2C15%20C3.11928813%2C15%202%2C13.8807119%202%2C12.5%20C2%2C11.1192881%203.11928813%2C10%204.5%2C10%20Z%20M12%2C10%20C13.3807119%2C10%2014.5%2C11.1192881%2014.5%2C12.5%20C14.5%2C13.8807119%2013.3807119%2C15%2012%2C15%20C10.6192881%2C15%209.5%2C13.8807119%209.5%2C12.5%20C9.5%2C11.1192881%2010.6192881%2C10%2012%2C10%20Z%20M19.5%2C10%20C20.8807119%2C10%2022%2C11.1192881%2022%2C12.5%20C22%2C13.8807119%2020.8807119%2C15%2019.5%2C15%20C18.1192881%2C15%2017%2C13.8807119%2017%2C12.5%20C17%2C11.1192881%2018.1192881%2C10%2019.5%2C10%20Z%22%20id%3D%22Rectangle-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.CometChatMenuList = class CometChatMenuList extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.menuListStyle = {
            width: "",
            height: "",
            border: "1px solid #e8e8e8",
            borderRadius: "8px",
            background: "white",
            submenuWidth: "100%",
            submenuHeight: "100%",
            submenuBorder: "1px solid #e8e8e8",
            submenuBorderRadius: "8px",
            submenuBackground: "white",
            moreIconTint: "grey"
        }; //CSS properties
        this.data = [];
        this.moreIconURL = moreIcon; //Image URL for more icon
        this.topMenuSize = 2;
        this.buttonStyle = {
            buttonTextFont: "",
            buttonTextColor: "",
            iconTint: "",
            background: "",
            border: "",
            borderRadius: "",
        };
        // subMenuList: any = null;
        this.mainMenuList = [];
        this.subMenuList = [];
        this.isShown = false; // hidden by defaul
        this.showSubMenu = false;
        this.openSubMenu = () => {
            this.showSubMenu = !this.showSubMenu;
            this.requestUpdate("showSubMenu");
            this.dispatchEvent(new CustomEvent('cc-submenu-clicked', {
                bubbles: true,
                composed: true,
                detail: { isOpen: this.showSubMenu }
            }));
        };
    }
    onMenuItemClick(item, event) {
        this.dispatchEvent(new CustomEvent('cc-menu-clicked', {
            bubbles: true,
            composed: true,
            detail: { data: item, event: event }
        }));
        this.isShown = false;
        this.showSubMenu = false;
        this.requestUpdate("isShown");
        this.requestUpdate("showSubMenu");
    }
    getMenuStyle(option, isMainMenu = true) {
        return {
            background: (option === null || option === void 0 ? void 0 : option.backgroundColor) || "transparent",
            border: "none",
            borderRadius: "0",
            buttonIconTint: option === null || option === void 0 ? void 0 : option.iconTint,
            buttonTextFont: option === null || option === void 0 ? void 0 : option.titleFont,
            buttonTextColor: option === null || option === void 0 ? void 0 : option.titleColor,
            gap: !isMainMenu && option.title && option.iconURL ? "10px" : "0",
            padding: "4px"
        };
    }
    moreIconStyle() {
        return {
            background: this.menuListStyle.background
        };
    }
    /**
     * hide show submenu on click of more icon
     * @param  {any} e
     */
    render() {
        var _a, _b, _c;
        this.mainMenuList = this.mainMenuItems();
        this.subMenuList = this.subMenuItems();
        this.buttonStyle = {
            background: "transparent",
            border: "none",
            borderRadius: "0",
            buttonIconTint: (_a = this.menuListStyle) === null || _a === void 0 ? void 0 : _a.moreIconTint,
            padding: "4px"
        };
        return lit.html `
    <div class="cc__menulist" style=${styleMap_js.styleMap(this.mainMenuStyles())}>
    <ul class="cc__menuitem__wrapper">
          ${this.mainMenuList.map((button) => lit.html `     <cometchat-button .buttonStyle=${this.getMenuStyle(button, true)} hoverText=${button.title} iconURL=${button.iconURL}
           @click=${(event) => { this.onMenuItemClick(button, event); }} class="cc__menu__item" ></cometchat-button>`)}
    </ul>
    <div class="cc__menulist__moreicon">
      ${this.data && ((_b = this.data) === null || _b === void 0 ? void 0 : _b.length) > this.topMenuSize ? lit.html `
            <cometchat-button
            .buttonStyle=${this.buttonStyle} hoverText="more" iconURL=${this.moreIconURL} @click=${this.openSubMenu}
            ></cometchat-button>
      ` : ""}
    </div>
</div>
<div class="cc__menulist__submenu
 ">
${this.showSubMenu ? lit.html `
         <ul class="cc__menuitem__wrapper cc__submenu__wrapper "  style=${styleMap_js.styleMap(this.subMenuStyle())}>
         ${(_c = this.subMenuList) === null || _c === void 0 ? void 0 : _c.map((button) => lit.html `
         <cometchat-button  hoverText=${button.title} .buttonStyle=${this.getMenuStyle(button, false)}   class="cc__menu__item"
            iconURL=${button.iconURL}  text=${button.title} @click=${(event) => { this.onMenuItemClick(button, event); }}>
        </cometchat-button>`)}
    </ul>` : lit.nothing}
</div>
    `;
    }
    // filtering main menu options from list
    mainMenuItems() {
        var _a;
        const defaultNumber = this.topMenuSize - 1;
        return (_a = this.data) === null || _a === void 0 ? void 0 : _a.filter((item, i) => {
            return i <= defaultNumber;
        });
    }
    // filtering submenu options from list
    subMenuItems() {
        var _a;
        const defaultNumber = this.topMenuSize - 1;
        return (_a = this.data) === null || _a === void 0 ? void 0 : _a.filter((item, i) => {
            return i > defaultNumber;
        });
    }
    // mainmenu style
    mainMenuStyles() {
        var _a, _b, _c;
        return {
            background: (_a = this.menuListStyle) === null || _a === void 0 ? void 0 : _a.background,
            borderRadius: (_b = this.menuListStyle) === null || _b === void 0 ? void 0 : _b.borderRadius,
            border: (_c = this.menuListStyle) === null || _c === void 0 ? void 0 : _c.border
        };
    }
    subMenuStyle() {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            background: (_a = this.menuListStyle) === null || _a === void 0 ? void 0 : _a.submenuBackground,
            borderRadius: (_b = this.menuListStyle) === null || _b === void 0 ? void 0 : _b.submenuBorderRadius,
            border: (_c = this.menuListStyle) === null || _c === void 0 ? void 0 : _c.submenuBorder,
            height: (_d = this.menuListStyle) === null || _d === void 0 ? void 0 : _d.submenuHeight,
            width: (_e = this.menuListStyle) === null || _e === void 0 ? void 0 : _e.submenuWidth,
            minWidth: ((_f = this.mainMenuList) === null || _f === void 0 ? void 0 : _f.length) > 0 ? ((_g = this.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector(".cc__menulist").offsetWidth) + "px" : "110px"
        };
    }
};
exports.CometChatMenuList.styles = [
    lit.css `
    .cc__menuitem__wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin: 0;
    padding-left: 0px;
    border-radius: inherit;
}
.cc__menulist {
    display: flex;
    align-items: center;
}
.cc__submenu__wrapper {
  display: flex;
    flex-direction: column;
    position: relative;
    height: max-content;
    width: max-content;
    min-height: 50px;
    z-index: 10;
    border-radius: 8px;
    overflow: visible;
    align-self: flex-end;
    margin-top: 2px;
    padding:4px;
    align-items: flex-start;
    justify-content: flex-start;
}
.cc__menu__item{
    border-radius: inherit;
}
.cc__menulist__submenu
{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
    right: 0;
}
.cc__menulist__moreicon{
    border-radius: inherit;
    background:"transparent"
}
    `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatMenuList.prototype, "menuListStyle", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatMenuList.prototype, "data", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMenuList.prototype, "moreIconURL", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatMenuList.prototype, "topMenuSize", void 0);
exports.CometChatMenuList = __decorate([
    decorators_js.customElement('cometchat-menu-list')
], exports.CometChatMenuList);

/**
 * MenuListStyle class defines the style for a menu list component.
 *
 * @property {string} textFont - The font for the menu list text.
 * @property {string} textColor - The color for the menu list text.
 * @property {string} iconTint - The tint color for the menu list icons.
 * @property {string} iconBackground - The background color for the menu list icons.
 * @property {string} iconBorder - The border color for the menu list icons.
 * @property {string} iconBorderRadius - The border radius for the menu list icons.
 * @property {string} submenuWidth - The width of the submenu.
 * @property {string} submenuHeight - The height of the submenu.
 * @property {string} submenuBorder - The border color for the submenu.
 * @property {string} submenuBorderRadius - The border radius for the submenu.
 * @property {string} submenuBackground - The background color for the submenu.
 * @extends {BaseStyle}
 */
class MenuListStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.moreIconTint = "RGB(20, 20, 20)";
        this.submenuWidth = "100%";
        this.submenuHeight = "100%";
        this.submenuBorder = "1px solid #e8e8e8";
        this.submenuBorderRadius = "8px";
        this.submenuBackground = "white";
        Object.assign(this, props);
    }
}

var spinnerIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FSpinner%402x%3C%2Ftitle%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpattern%20id%3D%22pattern-1%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20patternUnits%3D%22objectBoundingBox%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23image-2%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%3C%2Fpattern%3E%20%20%20%20%20%20%20%20%3Cimage%20id%3D%22image-2%22%20width%3D%2224%22%20height%3D%2224%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAACH0lEQVRIDY2SyU0FQQxE57PDlThIAIkDSARARqRAJITACQ5ciYMr%2B1av6TfyDAPCUn27vVS5%2B89qGIaLYK1gvcd4sTGL5%2Bc6Ixe5FY0fQbVVDuBzAUt99kusJ7%2F2l0AdRKxarTWiFCWe%2BP8IcENvgwiEWBWZkKbmk41PVAnadP%2BBBAFFrP2HvIlyg%2FeAg%2BZzQGJNAWt1Yz%2BE6q23G0DCICQ0SZKwGc3kqWNuXwmJWRYvOX4iwCDkFPAKkVeAHGdFIa0wb88owHYmaeIMFCEHkX3EmwWcvRG9cDVQ4IlMSEATeYUSNoKdeGqQbwXbPf7xNMmPAm%2F9EDcKUYSImkskHHYDyPc6EHFzl6x%2BMpzeZjRgtRGxx5YdhoP4%2FQAhyO1L2GI81njYji2r%2Be54wVO9BnfBeXAZHAY%2BYZ1JerRPr18bKikELAD5Q3AfsP1ZP7%2FEXwVHAb3Ojny%2BsyQQAQbBUwfkgFr9D%2FhPTnuO%2FE2PWZzn20CAr0VUIUWeUwec2ZIZyPyK%2BJKIyZ0E1LnRdbDuE3k9PJgLIkyOGn8ecxD6FP7RLnyb2jH1JQHJ8RALl4AMovYE8YokbEtQd5GJAEkhuWLmIXFbBMwrQo0Ze0YBGmimuOTJ0SMRNxAImU%2FYTIEPnsgt9G6tmPlKIoEi%2BLrAt0xusiQgYfV1GHJsLlJ7rC%2FeQGIGiOeDDiPA5vT8doP2uUlY%2FRI5uWr1Bi4x7xm%2BABSc5FGl1EGyAAAAAElFTkSuQmCC%22%3E%3C%2Fimage%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FSpinner%22%20fill%3D%22url%28%23pattern-1%29%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3.86827202%2C3.86827202%20C4.25879631%2C3.47774772%204.89196129%2C3.47774772%205.28248558%2C3.86827202%20L9.17157288%2C7.75735931%20C9.56209717%2C8.1478836%209.56209717%2C8.78104858%209.17157288%2C9.17157288%20C8.78104858%2C9.56209717%208.1478836%2C9.56209717%207.75735931%2C9.17157288%20L3.86827202%2C5.28248558%20C3.47774772%2C4.89196129%203.47774772%2C4.25879631%203.86827202%2C3.86827202%20Z%20M12%2C0.5%20C12.5522847%2C0.5%2013%2C0.94771525%2013%2C1.5%20L13%2C7%20C13%2C7.55228475%2012.5522847%2C8%2012%2C8%20C11.4477153%2C8%2011%2C7.55228475%2011%2C7%20L11%2C1.5%20C11%2C0.94771525%2011.4477153%2C0.5%2012%2C0.5%20Z%20M20.131728%2C3.86827202%20C20.5222523%2C4.25879631%2020.5222523%2C4.89196129%2020.131728%2C5.28248558%20L16.2426407%2C9.17157288%20C15.8521164%2C9.56209717%2015.2189514%2C9.56209717%2014.8284271%2C9.17157288%20C14.4379028%2C8.78104858%2014.4379028%2C8.1478836%2014.8284271%2C7.75735931%20L18.7175144%2C3.86827202%20C19.1080387%2C3.47774772%2019.7412037%2C3.47774772%2020.131728%2C3.86827202%20Z%20M23.5%2C12%20C23.5%2C12.5522847%2023.0522847%2C13%2022.5%2C13%20L17%2C13%20C16.4477153%2C13%2016%2C12.5522847%2016%2C12%20C16%2C11.4477153%2016.4477153%2C11%2017%2C11%20L22.5%2C11%20C23.0522847%2C11%2023.5%2C11.4477153%2023.5%2C12%20Z%20M20.131728%2C20.131728%20C19.7412037%2C20.5222523%2019.1080387%2C20.5222523%2018.7175144%2C20.131728%20L14.8284271%2C16.2426407%20C14.4379028%2C15.8521164%2014.4379028%2C15.2189514%2014.8284271%2C14.8284271%20C15.2189514%2C14.4379028%2015.8521164%2C14.4379028%2016.2426407%2C14.8284271%20L20.131728%2C18.7175144%20C20.5222523%2C19.1080387%2020.5222523%2C19.7412037%2020.131728%2C20.131728%20Z%20M12%2C23.5%20C11.4477153%2C23.5%2011%2C23.0522847%2011%2C22.5%20L11%2C17%20C11%2C16.4477153%2011.4477153%2C16%2012%2C16%20C12.5522847%2C16%2013%2C16.4477153%2013%2C17%20L13%2C22.5%20C13%2C23.0522847%2012.5522847%2C23.5%2012%2C23.5%20Z%20M3.86827202%2C20.131728%20C3.47774772%2C19.7412037%203.47774772%2C19.1080387%203.86827202%2C18.7175144%20L7.75735931%2C14.8284271%20C8.1478836%2C14.4379028%208.78104858%2C14.4379028%209.17157288%2C14.8284271%20C9.56209717%2C15.2189514%209.56209717%2C15.8521164%209.17157288%2C16.2426407%20L5.28248558%2C20.131728%20C4.89196129%2C20.5222523%204.25879631%2C20.5222523%203.86827202%2C20.131728%20Z%20M0.5%2C12%20C0.5%2C11.4477153%200.94771525%2C11%201.5%2C11%20L7%2C11%20C7.55228475%2C11%208%2C11.4477153%208%2C12%20C8%2C12.5522847%207.55228475%2C13%207%2C13%20L1.5%2C13%20C0.94771525%2C13%200.5%2C12.5522847%200.5%2C12%20Z%22%20id%3D%22Rectangle-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.CometChatLoader = class CometChatLoader extends lit.LitElement {
    constructor() {
        super();
        this.name = "spinner";
        this.iconURL = spinnerIcon;
        this.loaderStyle = {
            height: "24px",
            width: "24px",
            border: "",
            borderRadius: "",
            background: "",
            iconTint: "grey"
        };
        this.iconStyle = {
            height: "24px",
            width: "24px",
            iconTint: "grey"
        };
        this.loaderStyles = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.loaderStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.loaderStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.loaderStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.loaderStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.loaderStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
    }
    render() {
        var _a;
        this.iconStyle.iconTint = ((_a = this.loaderStyle) === null || _a === void 0 ? void 0 : _a.iconTint) || "grey";
        if (this.iconURL) {
            return lit.html ` <div class="cc__loader" style=${styleMap_js.styleMap(this.loaderStyles())}><cometchat-icon .URL=${this.iconURL} .name=${this.name} .iconStyle=${this.iconStyle}></cometchat-icon></div>`;
        }
    }
};
exports.CometChatLoader.styles = [
    lit.css `
    .cc__loader{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatLoader.prototype, "name", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatLoader.prototype, "iconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatLoader.prototype, "loaderStyle", void 0);
exports.CometChatLoader = __decorate([
    decorators_js.customElement('cometchat-loader')
], exports.CometChatLoader);

/**
 * LoaderStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class LoaderStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.iconTint = "grey";
        Object.assign(this, props);
    }
}

exports.CometChatListItem = class CometChatListItem extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.id = "";
        this.avatarURL = "";
        this.avatarName = "";
        this.statusIndicatorColor = "";
        this.statusIndicatorIcon = "";
        this.avatarStyle = {
            borderRadius: "16px",
            width: "28px",
            height: "28px",
            border: "1px solid rgb(238 238 238)",
            backgroundColor: "white",
            nameTextColor: "rgb(20,20,20)",
            backgroundSize: "cover",
            nameTextFont: "500 16px Inter",
        };
        this.statusIndicatorStyle = {
            borderRadius: "16px",
            width: "10px",
            height: "10px",
            border: "none",
        };
        this.title = "";
        this.hideSeparator = false;
        this.isActive = false;
        this.dir = "auto";
        this.listItemStyle = {
            background: "white",
            titleColor: "",
            titleFont: "500 16px Inter",
            width: "",
            height: "100%",
            border: "",
            borderRadius: "2px",
            separatorColor: "#efefef",
            activeBackground: "#eeeeee",
            hoverBackground: "#eeeeee",
            padding: "0",
        }; //consists of all styling properties
        /**
         * to change the position of use presence icon
         */
        this.userPresencePlacement = uikitResources.UserPresencePlacement.bottom;
        this.isHovering = false;
        this.hideShowTail = () => {
            this.isHovering = !this.isHovering;
            this.requestUpdate("isHovering", !this.isHovering);
        };
        this.dividerStyles = {
            height: "1px",
            width: "100%",
            background: "grey",
        };
        this.dispatchClickEvent = (event) => {
            if (event && (event === null || event === void 0 ? void 0 : event.stopPropagation)) {
                event.stopPropagation();
            }
            this.dispatchEvent(new CustomEvent("cc-listitem-clicked", {
                bubbles: true,
                composed: true,
                detail: { id: this.id },
            }));
            this.requestUpdate("isActive");
        };
        this.listItemStyles = {
            listItemStyle: () => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                let background = { background: (_a = this.listItemStyle) === null || _a === void 0 ? void 0 : _a.background };
                if (this.isActive) {
                    background = { background: (_b = this.listItemStyle) === null || _b === void 0 ? void 0 : _b.activeBackground };
                }
                else if (this.isHovering) {
                    background = { background: (_c = this.listItemStyle) === null || _c === void 0 ? void 0 : _c.hoverBackground };
                }
                else {
                    background = { background: (_d = this.listItemStyle) === null || _d === void 0 ? void 0 : _d.background };
                }
                return {
                    height: (_e = this.listItemStyle) === null || _e === void 0 ? void 0 : _e.height,
                    width: (_f = this.listItemStyle) === null || _f === void 0 ? void 0 : _f.width,
                    border: (_g = this.listItemStyle) === null || _g === void 0 ? void 0 : _g.border,
                    borderRadius: (_h = this.listItemStyle) === null || _h === void 0 ? void 0 : _h.borderRadius,
                    padding: (_j = this.listItemStyle) === null || _j === void 0 ? void 0 : _j.padding,
                    ...background,
                };
            },
            itemDetailStyle: (style) => {
                var _a, _b;
                const padding = { paddingLeft: "8px" };
                return {
                    flexGrow: "1",
                    ...padding,
                    width: ((_a = this.menuSlot) === null || _a === void 0 ? void 0 : _a.length) === 0 && ((_b = this.tailSlot) === null || _b === void 0 ? void 0 : _b.length) === 0
                        ? "100%"
                        : "80%",
                };
            },
            subtitleSlotStyle: (tailSlot, menuSlot) => {
                return {
                    width: (!(tailSlot === null || tailSlot === void 0 ? void 0 : tailSlot.length) && !(menuSlot === null || menuSlot === void 0 ? void 0 : menuSlot.length)) ||
                        ((tailSlot === null || tailSlot === void 0 ? void 0 : tailSlot.length) === 0 && (menuSlot === null || menuSlot === void 0 ? void 0 : menuSlot.length) === 0)
                        ? "100%"
                        : "80%",
                };
            },
            titleStyle: (style) => {
                var _a;
                return {
                    flexShrink: "0",
                    width: "fit-content",
                    font: style === null || style === void 0 ? void 0 : style.titleFont,
                    color: style === null || style === void 0 ? void 0 : style.titleColor,
                    maxWidth: ((_a = this.menuSlot) === null || _a === void 0 ? void 0 : _a.length) === 0 ? "75%" : "70%",
                };
            },
            tailViewStyle: (style) => {
                var _a;
                return {
                    display: !this.isHovering || (this.isHovering && ((_a = this.menuSlot) === null || _a === void 0 ? void 0 : _a.length) === 0)
                        ? "flex"
                        : "none",
                };
            },
            menuViewStyle: (style) => {
                var _a;
                return {
                    display: this.isHovering && ((_a = this.menuSlot) === null || _a === void 0 ? void 0 : _a.length) >= 0 ? "flex" : "none",
                };
            },
        };
    }
    requestUpdate(name, oldValue, options) {
        super.requestUpdate();
    }
    firstUpdated(_changedProperties) {
        var _a, _b;
        const menuslot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#menu");
        const tailslot = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("#tail");
        this.tailSlot = tailslot === null || tailslot === void 0 ? void 0 : tailslot.assignedNodes();
        this.menuSlot = menuslot === null || menuslot === void 0 ? void 0 : menuslot.assignedNodes();
        this.requestUpdate("tailSlot");
    }
    render() {
        var _a, _b, _c, _d, _e;
        this.dividerStyles.background =
            ((_a = this.listItemStyle) === null || _a === void 0 ? void 0 : _a.separatorColor) || "grey";
        return lit.html `
      <div
        class="cc__list__item"
        style=" ${styleMap_js.styleMap(this.listItemStyles.listItemStyle())}"
        data-id=${this.id}
        @mouseenter=${this.hideShowTail}
        @mouseleave=${this.hideShowTail}
        @click=${this.dispatchClickEvent}
      >
        ${((_c = (_b = this.avatarName) === null || _b === void 0 ? void 0 : _b.trim()) === null || _c === void 0 ? void 0 : _c.length) > 0 ||
            ((_e = (_d = this.avatarURL) === null || _d === void 0 ? void 0 : _d.trim()) === null || _e === void 0 ? void 0 : _e.length) > 0
            ? lit.html `<div class="cc__item__thumbnail">
              <cometchat-avatar
                .image="${this.avatarURL}"
                .name="${this.avatarName}"
                .avatarStyle=${this.avatarStyle}
              >
              </cometchat-avatar>
              ${this.userPresencePlacement == uikitResources.UserPresencePlacement.bottom
                ? lit.html `<cometchat-status-indicator
                    .backgroundColor="${this.statusIndicatorColor}"
                    .backgroundImage="${this.statusIndicatorIcon}"
                    .statusIndicatorStyle=${this.statusIndicatorStyle}
                  >
                  </cometchat-status-indicator>`
                : lit.nothing}
            </div>`
            : lit.nothing}
        <div class="cc__item__details">
          <div
            class="cc__item__title"
            style="${styleMap_js.styleMap(this.listItemStyles.itemDetailStyle(this.listItemStyle))}"
          >
            <div style="display: flex; flex-direction: row;">
              <div
                class="cc__item__innerTitle"
                style="${styleMap_js.styleMap(this.listItemStyles.titleStyle(this.listItemStyle))}"
              >
                ${this.title}
              </div>

              ${this.userPresencePlacement == uikitResources.UserPresencePlacement.right
            ? lit.html ` <cometchat-status-indicator
                    style="position: relative; bottom: 20%; margin-left: 20px"
                    .backgroundColor="${this.statusIndicatorColor}"
                    .backgroundImage="${this.statusIndicatorIcon}"
                    .statusIndicatorStyle=${this.statusIndicatorStyle}
                  >
                  </cometchat-status-indicator>`
            : lit.nothing}
            </div>

            <div
              class="cc__subtitle__view"
              style="${styleMap_js.styleMap(this.listItemStyles.subtitleSlotStyle(this.tailSlot, this.menuSlot))}"
            >
              <slot name="subtitleView"></slot>
            </div>
            <div
              class="cc__tail__view"
              style="${styleMap_js.styleMap(this.listItemStyles.tailViewStyle(this.listItemStyle))}"
              @click=${(event) => {
            if (event === null || event === void 0 ? void 0 : event.stopPropagation) {
                event.stopPropagation();
            }
        }}
            >
              <slot name="tailView" id="tail"> </slot>
            </div>
            <div
              class="cc__menu__view"
              style="${styleMap_js.styleMap(this.listItemStyles.menuViewStyle(this.listItemStyle))}"
              @click=${(event) => {
            if (event === null || event === void 0 ? void 0 : event.stopPropagation) {
                event.stopPropagation();
            }
        }}
            >
              <slot name="menuView" id="menu"> </slot>
            </div>
          </div>
        </div>
      </div>
      ${this.hideSeparator !== true ? lit.html `<div class="cc__divider"> <cometchat-divider .dividerStyle=${this.dividerStyles}></cometchat-divider> </div>` : lit.nothing}
    `;
    }
};
exports.CometChatListItem.styles = [
    lit.css `
      * {
        box-sizing: border-box;
      }
      .cc__item__details {
        display: flex;
        justify-content: space-between;
        width: 100%;
        overflow: hidden;
      }
      .cc__item__title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 80%;
      }
      .cc__tail__view {
        pointer-events: all;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0;
      }
      .cc__menu__view {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 8px;
      }
      .cc__list__item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        position: relative;
        min-height: 45px;
      }
      .cc__item__thumbnail {
        display: flex;
        flex-direction: column;
        width: fit-content;
        height: auto;
        flex-shrink: 0;
        position: relative;
      }
      .cc__subtitle__view {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 80%;
        text-align: left;
      }
      .cc__item__innerTitle {
        width: 75%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: left;
      }
    `,
];
__decorate([
    decorators_js.property()
], exports.CometChatListItem.prototype, "id", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatListItem.prototype, "avatarURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatListItem.prototype, "avatarName", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatListItem.prototype, "statusIndicatorColor", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatListItem.prototype, "statusIndicatorIcon", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatListItem.prototype, "avatarStyle", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatListItem.prototype, "statusIndicatorStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatListItem.prototype, "title", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatListItem.prototype, "hideSeparator", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatListItem.prototype, "isActive", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatListItem.prototype, "dir", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatListItem.prototype, "listItemStyle", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatListItem.prototype, "userPresencePlacement", void 0);
exports.CometChatListItem = __decorate([
    decorators_js.customElement("cometchat-list-item")
], exports.CometChatListItem);

/**
 * ListItemStyle class defines the style for a list item component.
 *
 * @property {string} activeBackground - The background color for an active list item.
 * @property {string} hoverBackground - The background color for a hovered list item.
 * @property {string} borderBottom - The bottom border color for a list item.
 * @property {string} separatorColor - The color for the separator line.
 * @property {string} titleFont - The font for the title text.
 * @property {string} titleColor - The color for the title text.
 * @extends {BaseStyle}
 */
class ListItemStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.activeBackground = "RGBA(20, 20, 20, 0.04)";
        this.hoverBackground = "transparent";
        this.separatorColor = "rgb(232, 232, 232)";
        this.titleFont = "600 15px Inter, sans-serif";
        this.titleColor = "black";
        this.padding = '0';
        Object.assign(this, props);
    }
}

exports.CometChatConfirmDialog = class CometChatConfirmDialog extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = "Delete ?";
        this.messageText = "Would you like to delete this?";
        this.cancelButtonText = "Cancel";
        this.confirmButtonText = "Delete";
        this.cancelButtonIconURL = "";
        this.confirmButtonIconURL = "";
        this.confirmDialogStyle = {
            titleFont: "",
            titleColor: "",
            height: "100%",
            width: "100%",
            background: "white",
            borderRadius: "8px",
            border: "1px solid grey",
            // boxShadow: "",
            messageTextFont: "",
            messageTextColor: "",
            confirmButtonTextFont: "",
            confirmButtonTextColor: "white",
            confirmButtonBackground: "red",
            cancelButtonTextColor: "",
            cancelButtonTextFont: "",
            cancelButtonBackground: "",
        }; //styling style
        this.loadingIconURL = spinnerIcon;
        this.dispatchClickEvent = (eventName) => {
            this.dispatchEvent(new CustomEvent(eventName, {
                bubbles: true,
                composed: true,
            }));
        };
        /**
       * loading icon wrapper style
       * @param  {string} state
       */
        this.dialogWrapperStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.confirmDialogStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.confirmDialogStyle) === null || _b === void 0 ? void 0 : _b.width,
                background: (_c = this.confirmDialogStyle) === null || _c === void 0 ? void 0 : _c.background,
                border: (_d = this.confirmDialogStyle) === null || _d === void 0 ? void 0 : _d.border,
                borderRadius: (_e = this.confirmDialogStyle) === null || _e === void 0 ? void 0 : _e.borderRadius,
            };
        };
        this.dialogFormStyle = () => {
            const display = { display: "flex" };
            return {
                ...display,
            };
        };
        // subtitle styles
        this.dialogMessageStyle = () => {
            var _a, _b;
            return {
                textAlign: "center",
                lineHeight: "1.6",
                font: (_a = this.confirmDialogStyle) === null || _a === void 0 ? void 0 : _a.messageTextFont,
                letterSpacing: "-0.1",
                color: (_b = this.confirmDialogStyle) === null || _b === void 0 ? void 0 : _b.messageTextColor,
            };
        };
        this.buttonConfirmStyle = () => {
            var _a, _b, _c;
            return {
                buttonTextFont: (_a = this.confirmDialogStyle) === null || _a === void 0 ? void 0 : _a.confirmButtonTextFont,
                background: (_b = this.confirmDialogStyle) === null || _b === void 0 ? void 0 : _b.confirmButtonBackground,
                buttonTextColor: (_c = this.confirmDialogStyle) === null || _c === void 0 ? void 0 : _c.confirmButtonTextColor,
                height: "34px",
                width: "100%",
                border: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: '5px'
            };
        };
        this.buttonCancelStyle = () => {
            var _a, _b, _c;
            return {
                buttonTextColor: (_a = this.confirmDialogStyle) === null || _a === void 0 ? void 0 : _a.cancelButtonTextColor,
                buttonTextFont: (_b = this.confirmDialogStyle) === null || _b === void 0 ? void 0 : _b.cancelButtonTextFont,
                background: (_c = this.confirmDialogStyle) === null || _c === void 0 ? void 0 : _c.cancelButtonBackground,
                height: "34px",
                width: "100%",
                border: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: '5px'
            };
        };
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return lit.html `<div class="cc__confirm__dialog" style=${styleMap_js.styleMap(this.dialogWrapperStyle())} >
    <div class="cc__dialog__body" >
        <div class="cc__dialog__title" style=${styleMap_js.styleMap(this.dialogTitleStyle())}>
        ${this.title}
        </div>
        <div class="cc__dialog__message" style=${styleMap_js.styleMap(this.dialogMessageStyle())}>
            ${this.messageText}
        </div>
        <div class="cc__dialog__button">
            <cometchat-button   .text=  ${this.confirmButtonText} class="cc__dialog_button--confirm" .buttonStyle=${this.buttonConfirmStyle()} @click=${() => { this.dispatchClickEvent("cc-confirm-clicked"); }}>

            </cometchat-button >
            <cometchat-button  .text=${this.cancelButtonText} class="cc__dialog_button--cancel" .buttonStyle=${this.buttonCancelStyle()} @click=${() => { this.dispatchClickEvent("cc-cancel-clicked"); }}>
            </cometchat-button>
        </div>
    </div>
</div>`;
    }
    // title message style
    dialogTitleStyle() {
        var _a, _b;
        return {
            font: (_a = this.confirmDialogStyle) === null || _a === void 0 ? void 0 : _a.titleFont,
            color: (_b = this.confirmDialogStyle) === null || _b === void 0 ? void 0 : _b.titleColor,
        };
    }
};
exports.CometChatConfirmDialog.styles = [
    lit.css `
    .cc__confirm__dialog {
      margin: 0 auto;
      padding: 16px;
      height: 100%;
      width: 100%;
      box-sizing:border-box;
    }
    .cc__dialog__body{
      justify-content: flex-start;
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .cc__dialog__title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 3px 0;
    }
    button{
      height: 42px;
      border: none;
      letter-spacing: 0.1px;
      width: 100%;
      margin: 5px 0;
      border-radius: 4px;
      cursor: pointer;
      width: 100%;
      border-radius: 8px;
    }
    .cc__dialog__message {
      width: 100%;
      line-height: 22px !important;
    }
    .cc__dialog__button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 12px 0 0 0;
      width: 100%;
      height:85px;
    }
    .cc__dialog_button--confirm,.cc__dialog_button--cancel{
      height:100%;
      width:100%;
    }
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatConfirmDialog.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatConfirmDialog.prototype, "messageText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatConfirmDialog.prototype, "cancelButtonText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatConfirmDialog.prototype, "confirmButtonText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatConfirmDialog.prototype, "cancelButtonIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatConfirmDialog.prototype, "confirmButtonIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatConfirmDialog.prototype, "confirmDialogStyle", void 0);
exports.CometChatConfirmDialog = __decorate([
    decorators_js.customElement('cometchat-confirm-dialog')
], exports.CometChatConfirmDialog);

/**
 * ConfirmDialogStyle
 *
 * @extends BaseStyle
 *
 * @property {string} confirmButtonBackground - The background color of the confirm button.
 * @property {string} cancelButtonBackground - The background color of the cancel button.
 * @property {string} confirmButtonTextColor - The text color of the confirm button.
 * @property {string} confirmButtonTextFont - The font of the confirm button text.
 * @property {string} cancelButtonTextColor - The text color of the cancel button.
 * @property {string} cancelButtonTextFont - The font of the cancel button text.
 * @property {string} titleFont - The font of the title.
 * @property {string} titleColor - The color of the title.
 * @property {string} messageTextFont - The font of the message text.
 * @property {string} messageTextColor - The color of the message text.
 */
class ConfirmDialogStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.confirmButtonBackground = "RGB(255, 59, 48)";
        this.cancelButtonBackground = "RGBA(20, 20, 20, 0.06)";
        this.confirmButtonTextColor = "white";
        this.confirmButtonTextFont = "600 15px Inter, sans-serif";
        this.cancelButtonTextColor = "black";
        this.cancelButtonTextFont = "600 15px Inter, sans-serif";
        this.titleFont = "700 22px Inter, sans-serif";
        this.titleColor = "black";
        this.messageTextFont = "400 13px Inter, sans-serif";
        this.messageTextColor = "RGBA(20, 20, 20, 0.46)";
        this.boxShadow = "";
        Object.assign(this, props);
    }
}

exports.CometChatDivider = class CometChatDivider extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.dividerStyle = {
            height: "1px",
            width: "100%",
            background: "#eee"
        }; //Styles applied to the backdrop element
    }
    render() {
        return lit.html `<div class="cc__divider" style= ${styleMap_js.styleMap(this.dividerStyles())}>
</div>`;
    }
    dividerStyles() {
        var _a, _b, _c;
        return {
            height: (_a = this.dividerStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.dividerStyle) === null || _b === void 0 ? void 0 : _b.width,
            background: (_c = this.dividerStyle) === null || _c === void 0 ? void 0 : _c.background,
        };
    }
};
exports.CometChatDivider.styles = [
    lit.css `
   .cc__divider{
     /* margin:2px 0; */
   }
    `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatDivider.prototype, "dividerStyle", void 0);
exports.CometChatDivider = __decorate([
    decorators_js.customElement('cometchat-divider')
], exports.CometChatDivider);

exports.CometChatButtonGroup = class CometChatButtonGroup extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.data = [];
        this.buttonGroupStyle = {
            height: "100%",
            width: "100%",
            border: "1px solid #ededed",
            borderRadius: "12px",
            background: "",
            iconTint: "grey",
            buttonTextFont: "400 11px Inter",
            buttonTextColor: "black",
            buttonBorder: "none",
            buttonBorderRadius: "12px",
            buttonBackground: "white",
            activeButtonBackground: "red",
            activeButtonBorder: "",
            activeButtonBorderRadius: "",
            activeButtonTextFont: "",
            activeButtonBoxShadow: "",
            activeButtonTextColor: "",
            buttonSeparatorColor: ""
        };
        this.btnStyle = {};
        this.activeButtonId = "";
        this.dispatchClickEvent = (id) => {
            this.dispatchEvent(new CustomEvent('cc-button-group-clicked', {
                bubbles: true,
                composed: true,
                detail: { id: id }
            }));
            this.activeButtonId = id;
            this.requestUpdate("activeButtonId");
        };
        this.getButtonStyle = (id) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return this.btnStyle = {
                buttonTextFont: id && this.activeButtonId == id ? (_a = this.buttonGroupStyle) === null || _a === void 0 ? void 0 : _a.activeButtonTextFont : (_b = this.buttonGroupStyle) === null || _b === void 0 ? void 0 : _b.buttonTextFont,
                buttonTextColor: id && this.activeButtonId == id ? (_c = this.buttonGroupStyle) === null || _c === void 0 ? void 0 : _c.activeButtonTextColor : (_d = this.buttonGroupStyle) === null || _d === void 0 ? void 0 : _d.buttonTextColor,
                buttonIconTint: (_e = this.buttonGroupStyle) === null || _e === void 0 ? void 0 : _e.iconTint,
                border: id && this.activeButtonId == id ? (_f = this.buttonGroupStyle) === null || _f === void 0 ? void 0 : _f.activeButtonBorder : (_g = this.buttonGroupStyle) === null || _g === void 0 ? void 0 : _g.buttonBorder,
                borderRadius: id && this.activeButtonId == id ? (_h = this.buttonGroupStyle) === null || _h === void 0 ? void 0 : _h.activeButtonBorderRadius : (_j = this.buttonGroupStyle) === null || _j === void 0 ? void 0 : _j.buttonBorderRadius,
                background: id && this.activeButtonId == id ? (_k = this.buttonGroupStyle) === null || _k === void 0 ? void 0 : _k.activeButtonBackground : (_l = this.buttonGroupStyle) === null || _l === void 0 ? void 0 : _l.buttonBackground,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: id && this.activeButtonId == id ? (_m = this.buttonGroupStyle) === null || _m === void 0 ? void 0 : _m.activeButtonBoxShadow : "none",
                height: "100%",
                width: "100%"
            };
        };
        this.listStyle = () => {
            var _a;
            return {
                borderRight: (_a = this.buttonGroupStyle) === null || _a === void 0 ? void 0 : _a.buttonSeparatorColor
            };
        };
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        if (this.data && ((_a = this.data) === null || _a === void 0 ? void 0 : _a.length) > 0 && !this.activeButtonId) {
            this.activeButtonId = (_b = this.data[0]) === null || _b === void 0 ? void 0 : _b.id;
        }
    }
    render() {
        if (this.data.length >= 1) {
            return lit.html `<ul class="cc__button__group" role="group" aria-label="menu" style=${styleMap_js.styleMap(this.buttonStyle())}>
    ${this.data.map((button) => lit.html `<li class="cc__button__group--button" style=${styleMap_js.styleMap(this.listStyle())}><cometchat-button class="button" .buttonStyle=${this.getButtonStyle(button === null || button === void 0 ? void 0 : button.id)} .text=${button.buttonText} .hoverText=${button.hoverText}  .iconURL=${button.iconURL} @cc-button-clicked=${() => { this.dispatchClickEvent(button === null || button === void 0 ? void 0 : button.id); }}></cometchat-button></li>`)}
</ul>`;
        }
        else {
            return null;
        }
    }
    buttonStyle() {
        var _a, _b, _c, _d, _e;
        return {
            height: (_a = this.buttonGroupStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.buttonGroupStyle) === null || _b === void 0 ? void 0 : _b.width,
            border: (_c = this.buttonGroupStyle) === null || _c === void 0 ? void 0 : _c.border,
            borderRadius: (_d = this.buttonGroupStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
            background: (_e = this.buttonGroupStyle) === null || _e === void 0 ? void 0 : _e.background,
            ...this.buttonGroupStyle
        };
    }
};
exports.CometChatButtonGroup.styles = [
    lit.css `
    .cc__button__group{
      display:flex;
      flex-direction:row;
      justify-content: space-around;
    align-items: center;
    padding: 2px;
    }
    li{ list-style: none;
    height:100%;
    width:100%;

    }
    li:last-child{
      border-right:none !important;
    }

    .button{
      display: flex;
    align-items: center;
    justify-content: center;
    height:100%;
    width:100%;
    }

    `
];
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatButtonGroup.prototype, "data", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatButtonGroup.prototype, "buttonGroupStyle", void 0);
exports.CometChatButtonGroup = __decorate([
    decorators_js.customElement('cometchat-button-group')
], exports.CometChatButtonGroup);

/**
 * ButtonGroupStyle class defines the style properties for date.
 *
 * @property {string} textFont - The font style for the text.
 * @property {string} textColor - The text color for the text.
 *
 * @extends {BaseStyle}
 */
class ButtonGroupStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.iconTint = "grey";
        this.buttonTextFont = "400 11px Inter";
        this.buttonTextColor = "black";
        this.buttonBorder = "none";
        this.buttonBorderRadius = "12px";
        this.buttonBackground = "white";
        this.activeButtonBackground = "red";
        this.activeButtonBorder = "";
        this.activeButtonBorderRadius = "";
        this.activeButtonTextFont = "";
        this.activeButtonBoxShadow = "";
        this.activeButtonTextColor = "";
        this.buttonSeparatorColor = "";
        Object.assign(this, props);
    }
}

exports.CometChatCheckbox = class CometChatCheckbox extends lit.LitElement {
    constructor() {
        super();
        this.checked = false;
        this.name = "";
        this.dir = "auto";
        this.labelText = "";
        this.labelAlignment = uikitResources.LabelAlignment.left;
        this.disabled = false;
        this.checkboxStyle = {
            height: "24px",
            width: "24px",
            border: "none",
            labelTextFont: "400 14px Inter",
            labelTextColor: "grey",
            borderRadius: "4px",
            background: "",
            checkedBackgroundColor: "#2196F3",
            uncheckedBackgroundColor: "#ccc"
        };
        this.updateChechbox = (event) => {
            var _a, _b;
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
            event === null || event === void 0 ? void 0 : event.preventDefault();
            this.checked = (_a = event.target) === null || _a === void 0 ? void 0 : _a.checked;
            this.dispatchEvent(new CustomEvent('cc-checkbox-changed', {
                bubbles: true,
                composed: true,
                detail: { checked: (_b = event.target) === null || _b === void 0 ? void 0 : _b.checked }
            }));
        };
        this.labelStyle = () => {
            var _a, _b;
            return {
                font: (_a = this.checkboxStyle) === null || _a === void 0 ? void 0 : _a.labelTextFont,
                color: (_b = this.checkboxStyle) === null || _b === void 0 ? void 0 : _b.labelTextColor,
                display: "flex",
                flexDirection: this.labelAlignment,
                gap: "10px",
                alignItems: "center",
            };
        };
        this.checkboxStyles = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                height: (_a = this.checkboxStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.checkboxStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.checkboxStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.checkboxStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: this.checked ? (_e = this.checkboxStyle) === null || _e === void 0 ? void 0 : _e.checkedBackgroundColor : (_f = this.checkboxStyle) === null || _f === void 0 ? void 0 : _f.uncheckedBackgroundColor,
            };
        };
    }
    render() {
        return lit.html `<label dir=${this.dir}  style=${styleMap_js.styleMap(this.labelStyle())} class="cc__checkbox__label"> ${this.labelText}
    <input type="checkbox" @change=${this.updateChechbox} ?disabled=${this.disabled}  ?checked=${this.checked}>
    <span class="cc__checkmark"  style=${styleMap_js.styleMap(this.checkboxStyles())}></span>
  </label>`;
    }
    requestUpdate(name, oldValue, options) {
        super.requestUpdate(name, oldValue);
    }
};
exports.CometChatCheckbox.styles = [
    lit.css `
/* checkbox style */
.cc__checkbox__label {
    display: block;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  /* Hide the browser's default checkbox */
  .cc__checkbox__label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  /* Create a custom checkbox */
  .cc__checkmark {
    position: relative;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    border-radius: 4px;
    display:block;
  }
  /* Create the cc__checkmark/indicator (hidden when not checked) */
  .cc__checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the cc__checkmark when checked */
  .cc__checkbox__label input:checked ~ .cc__checkmark:after {
    display: block;
  }
  /* Style the cc__checkmark/indicator */
  .cc__checkbox__label .cc__checkmark:after {
    left: 30%;
    top: 15%;
    width: 40%;
    height: 65%;
    border-style: solid;
    border-color: white;
    border-image: initial;
    border-width: 0px 3px 3px 0px;
    transform: rotate(45deg);
    box-sizing: border-box;
  }
    `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatCheckbox.prototype, "checked", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCheckbox.prototype, "name", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatCheckbox.prototype, "dir", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCheckbox.prototype, "labelText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCheckbox.prototype, "labelAlignment", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatCheckbox.prototype, "disabled", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCheckbox.prototype, "checkboxStyle", void 0);
exports.CometChatCheckbox = __decorate([
    decorators_js.customElement('cometchat-checkbox')
], exports.CometChatCheckbox);

class CheckboxStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.labelTextFont = "400 14px Inter";
        this.labelTextColor = "grey";
        this.checkedBackgroundColor = "#2196F3";
        this.uncheckedBackgroundColor = "#ccc";
        Object.assign(this, props);
    }
}

exports.CometChatTextBubble = class CometChatTextBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.text = "";
        this.textStyle = {
            height: "",
            width: "",
            border: "",
            borderRadius: "",
            background: "",
            textFont: "",
            textColor: "",
        };
        this.textFormatters = [];
        this.messageKitBlockStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                width: (_a = this.textStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.textStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.textStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.textStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.textStyle) === null || _e === void 0 ? void 0 : _e.background,
                padding: ((_f = this.textStyle) === null || _f === void 0 ? void 0 : _f.bubblePadding) || "8px 12px",
            };
        };
    }
    render() {
        return lit.html ` <div
      style=${styleMap_js.styleMap(this.messageKitBlockStyle())}
      class="cc__text__bubble"
    >
      <p
        id="textContent"
        style=${styleMap_js.styleMap(this.textStyles())}
        class="cc__text"
      ></p>
    </div>`;
    }
    updated(_changedProperties) {
        var _a;
        if (_changedProperties.has("text")) {
            if (this.textFormatters) {
                const regexList = this.textFormatters.map((f) => {
                    return f.getRegexPatterns();
                });
                this.text = sanitizeHtml(this.text, regexList.flat());
            }
        }
        if (_changedProperties.has("text") ||
            _changedProperties.has("textFormatters")) {
            const textElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#textContent");
            let finalText = this.text;
            if (textElement && this.textFormatters && this.textFormatters.length) {
                if (this.textFormatters) {
                    for (let i = 0; i < this.textFormatters.length; i++) {
                        finalText = this.textFormatters[i].getFormattedText(finalText, {
                            mentionsTargetElement: uikitResources.MentionsTargetElement.textbubble,
                        });
                    }
                }
            }
            textElement.textContent = "";
            this.pasteHtml(textElement, finalText);
        }
    }
    pasteHtml(textElement, html) {
        try {
            let el = document.createElement("div");
            el.innerHTML = html;
            let frag = document.createDocumentFragment(), node, lastNode;
            while ((node = el.firstChild)) {
                if (node instanceof HTMLElement) {
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            node = this.textFormatters[i].registerEventListeners(node, node.classList);
                        }
                    }
                    frag.appendChild(node);
                }
                lastNode = frag.appendChild(node);
            }
            textElement.appendChild(frag);
        }
        catch (error) {
            console.log(error);
        }
    }
    textStyles() {
        var _a, _b;
        return {
            color: (_a = this.textStyle) === null || _a === void 0 ? void 0 : _a.textColor,
            font: (_b = this.textStyle) === null || _b === void 0 ? void 0 : _b.textFont,
        };
    }
};
exports.CometChatTextBubble.styles = [
    lit.css `
      .cc__text__bubble {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 8px 12px 2px 8px;
        align-self: flex-end;
        width: auto;
        max-width: 500px;
      }
      .cc__text {
        margin: 0;
        word-break: break-word;
        text-align: left;
        white-space: pre-line;
        overflow: auto;
      }
    `,
];
__decorate([
    decorators_js.property()
], exports.CometChatTextBubble.prototype, "text", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTextBubble.prototype, "textStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatTextBubble.prototype, "textFormatters", void 0);
exports.CometChatTextBubble = __decorate([
    decorators_js.customElement("cometchat-text-bubble")
], exports.CometChatTextBubble);

class TextBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "";
        this.textColor = "";
        this.bubblePadding = "";
        Object.assign(this, props);
    }
}

exports.CometChatVideoBubble = class CometChatVideoBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.src = "";
        this.autoPlay = false;
        this.loop = false;
        this.muted = false;
        this.poster = "";
        this.videoStyle = {
            height: "100%",
            width: "100%",
            border: "",
            borderRadius: "",
            background: "inherit",
        };
        this.posterImage = "";
        this.videoBubbleStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                background: (_a = this.videoStyle) === null || _a === void 0 ? void 0 : _a.background,
                width: (_b = this.videoStyle) === null || _b === void 0 ? void 0 : _b.width,
                height: (_c = this.videoStyle) === null || _c === void 0 ? void 0 : _c.height,
                border: (_d = this.videoStyle) === null || _d === void 0 ? void 0 : _d.border,
                borderRadius: (_e = this.videoStyle) === null || _e === void 0 ? void 0 : _e.borderRadius,
            };
        };
    }
    firstUpdated(_changedProperties) {
        this.updateImage();
    }
    updateImage() {
        this.posterImage = "";
        const img = new Image();
        img.onload = () => {
            this.posterImage = img.src;
            this.requestUpdate("posterImage");
        };
        img.onerror = () => {
            this.posterImage = "";
            this.requestUpdate("posterImage");
        };
        img.src = this.src;
        this.requestUpdate("posterImage");
    }
    render() {
        return lit.html `
      <div class="cc__video__bubble" style=${styleMap_js.styleMap(this.videoBubbleStyle())}>
    <video controls .loop=${this.loop} .muted=${this.muted} .autoplay=${this.autoPlay} class="cc__video" .poster=${this.posterImage}>
      <source src=${this.src} />
    </video>
</div>
      `;
    }
};
exports.CometChatVideoBubble.styles = [
    lit.css `
    .cc__video{
  margin: 0;
  border-radius: inherit;
  height:100%;
  width:100%;
  max-height:100%;
  max-width:100%;
    }
.cc__video__bubble {
    margin: 0;
  border-radius: inherit;
  background: inherit;
  padding: 0;
  height:100%;
  width:100%;
  display: flex;
    align-items: center;
    justify-content: center;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatVideoBubble.prototype, "src", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatVideoBubble.prototype, "autoPlay", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatVideoBubble.prototype, "loop", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatVideoBubble.prototype, "muted", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatVideoBubble.prototype, "poster", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatVideoBubble.prototype, "videoStyle", void 0);
exports.CometChatVideoBubble = __decorate([
    decorators_js.customElement('cometchat-video-bubble')
], exports.CometChatVideoBubble);

exports.CometChatAudioBubble = class CometChatAudioBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.src = "";
        this.autoPlay = false;
        this.loop = false;
        this.muted = false;
        this.audioStyle = {
            height: "",
            width: "",
            border: "",
            borderRadius: "",
            background: "",
        };
        this.audioBubbleStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                width: (_a = this.audioStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.audioStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.audioStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.audioStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.audioStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
    }
    render() {
        return lit.html `
      <div class="cc__audio__bubble" style=${styleMap_js.styleMap(this.audioBubbleStyle())}>
    <audio controlsList="nodownload" controls .loop=${this.loop} .muted=${this.muted} .autoplay=${this.autoPlay}>
      <source src=${this.src} />
    </audio>
</div>
      `;
    }
};
exports.CometChatAudioBubble.styles = [
    lit.css `
.cc__audio__bubble {
  border: 0 none;
  display: flex;
  max-width: max-content;
  background: transparent;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatAudioBubble.prototype, "src", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatAudioBubble.prototype, "autoPlay", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatAudioBubble.prototype, "loop", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatAudioBubble.prototype, "muted", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatAudioBubble.prototype, "audioStyle", void 0);
exports.CometChatAudioBubble = __decorate([
    decorators_js.customElement('cometchat-audio-bubble')
], exports.CometChatAudioBubble);

var placeholderIcon = "data:image/png;base64,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";

exports.CometChatImageBubble = class CometChatImageBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.src = "";
        this.placeholderImage = placeholderIcon;
        this.caption = "";
        this.imageStyle = {
            height: "auto",
            width: "100%",
            border: "",
            borderRadius: "8px",
            background: "",
            captionTextFont: "",
            captionTextColor: "",
            maxHeight: "500px",
            maxWidth: "400px",
        };
        this.timer = null;
        this.image = "";
        this.dispatchClickEvent = (event) => {
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
            this.dispatchEvent(new CustomEvent('cc-image-clicked', {
                bubbles: true,
                composed: true,
                detail: { url: this.src }
            }));
        };
        this.imageBubbleStyle = () => {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
                height: (_a = this.imageStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.imageStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.imageStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.imageStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.imageStyle) === null || _e === void 0 ? void 0 : _e.background,
                maxHeight: (_f = this.imageStyle) === null || _f === void 0 ? void 0 : _f.maxHeight,
                maxWidth: (_g = this.imageStyle) === null || _g === void 0 ? void 0 : _g.maxWidth,
            };
        };
        this.captionStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.imageStyle) === null || _a === void 0 ? void 0 : _a.captionTextFont,
                textColor: (_b = this.imageStyle) === null || _b === void 0 ? void 0 : _b.captionTextColor,
            };
        };
    }
    firstUpdated(_changedProperties) {
        this.updateImage();
    }
    downloadImage(imgUrl, attemptCount = 0) {
        const maxAttempts = 5;
        const promise = new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", imgUrl, true);
            xhr.responseType = "blob";
            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        clearTimeout(this.timer); // Clear the timer if the download is successful
                        resolve(xhr.response);
                    }
                    else if (xhr.status === 403 && attemptCount < maxAttempts) {
                        this.timer = setTimeout(() => {
                            this.downloadImage(imgUrl, attemptCount + 1)
                                .then((response) => resolve(response))
                                .catch((error) => reject(error));
                        }, 800);
                    }
                    else {
                        reject(xhr.statusText);
                    }
                }
            };
            xhr.onerror = (event) => reject(new Error("There was a network error."));
            xhr.ontimeout = (event) => reject(new Error("There was a timeout error."));
            xhr.send();
        });
        return promise;
    }
    updateImage() {
        this.image = this.placeholderImage;
        this.downloadImage(this.src)
            .then((response) => {
            let img = new Image();
            img.src = this.src;
            img.onload = () => {
                this.image = img.src;
                this.requestUpdate("image");
            };
        })
            .catch((error) => {
            if (this.src) {
                this.image = this.src;
            }
            else {
                this.image = this.placeholderImage;
            }
            this.requestUpdate("image");
        });
        this.requestUpdate("image");
    }
    render() {
        return lit.html `
  <div style=${styleMap_js.styleMap(this.imageBubbleStyle())} class="cc__image__bubble" @click=${this.dispatchClickEvent}>
  <img class="cc__image" src=${this.image} />
</div>
${this.caption ? lit.html `<div class="cc__image__caption"><cometchat-label .text=${this.caption} .style=${this.captionStyle()}></cometchat-label></div>` : lit.nothing}
      `;
    }
};
exports.CometChatImageBubble.styles = [
    lit.css `
.cc__image__bubble {
  padding: 0;
  background: transparent;
  height: auto;
  width: 100%;
  display:flex;
  justify-content:center;
  width:100%;
  max-height: 500px;
  max-width: 400px;
}
.cc__image {
  margin: 0;
  border-radius: inherit;
  max-width:100%;
}
.cc__image__caption{
  text-align:center;
}
.placeholder__image{
  z-index:10;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatImageBubble.prototype, "src", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatImageBubble.prototype, "placeholderImage", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatImageBubble.prototype, "caption", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatImageBubble.prototype, "imageStyle", void 0);
exports.CometChatImageBubble = __decorate([
    decorators_js.customElement('cometchat-image-bubble')
], exports.CometChatImageBubble);

class ImageBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.captionTextFont = "";
        this.captionTextColor = "";
        this.maxHeight = "";
        this.maxWidth = "";
        Object.assign(this, props);
    }
}

var downloadIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FDownload%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FDownload%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Path%22%20points%3D%227.33333333%2013.2%2011%2016.8666667%2014.6666667%2013.2%22%3E%3C%2Fpolyline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2211%22%20y1%3D%225.86666667%22%20x2%3D%2211%22%20y2%3D%2216.8666667%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C11%20C0%2C17.0751322%204.92486775%2C22%2011%2C22%20C17.0751322%2C22%2022%2C17.0751322%2022%2C11%20C22%2C4.92486775%2017.0751322%2C0%2011%2C0%20C4.92486775%2C0%200%2C4.92486775%200%2C11%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.CometChatFileBubble = class CometChatFileBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.fileURL = "";
        this.downloadIconURL = downloadIcon;
        this.title = "";
        this.subtitle = "";
        this.fileStyle = {
            width: "fit-content",
            height: "fit-content",
            border: "none",
            background: "transparent",
            borderRadius: "none",
            titleFont: "600 15px Inter, sans-serif",
            titleColor: "rgb(20, 20, 20)",
            subtitleFont: "400 13px Inter, sans-serif",
            subtitleColor: "rgba(20, 20, 20, 0.58)",
            iconTint: "rgb(51, 153, 255)",
        };
        this.messageKitBlockStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                width: (_a = this.fileStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.fileStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.fileStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.fileStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.fileStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
        this.messageTitleStyle = () => {
            var _a, _b;
            return {
                font: (_a = this.fileStyle) === null || _a === void 0 ? void 0 : _a.titleFont,
                color: (_b = this.fileStyle) === null || _b === void 0 ? void 0 : _b.titleColor,
            };
        };
        this.messageSubTitleStyle = () => {
            var _a, _b;
            return {
                font: (_a = this.fileStyle) === null || _a === void 0 ? void 0 : _a.subtitleFont,
                color: (_b = this.fileStyle) === null || _b === void 0 ? void 0 : _b.subtitleColor,
            };
        };
        this.messageFileIconStyle = () => {
            var _a;
            let isDisable = true;
            if (this.fileURL) {
                isDisable = false;
            }
            return {
                WebkitMask: `url(${this.downloadIconURL}) `,
                background: (_a = this.fileStyle) === null || _a === void 0 ? void 0 : _a.iconTint,
                opacity: isDisable ? 0.5 : 1,
            };
        };
    }
    downloadFile() {
        if (!this.fileURL) {
            console.error("Resource URL not provided! You need to provide one");
            return;
        }
        fetch(this.fileURL)
            .then((response) => response.blob())
            .then((blob) => {
            const blobURL = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobURL;
            if (this.title && this.title.length)
                a.download = this.title;
            document.body.appendChild(a);
            a.click();
        })
            .catch((error) => console.log("error"));
    }
    ;
    render() {
        return lit.html `
<div style=${styleMap_js.styleMap(this.messageKitBlockStyle())} class="cc__file__bubble">
  <div class="message__block">
    <div class="cc__file__title">
      <a href=${this.fileURL} target="_blank" style=${styleMap_js.styleMap(this.messageTitleStyle())}  class="cc__file__url"> ${this.title} </a>
    </div>
    <div style=${styleMap_js.styleMap(this.messageSubTitleStyle())} class="cc__file__subtitle"> ${this.subtitle} </div>
  </div>
  <div class="cc__file__icon">
    <i style=${styleMap_js.styleMap(this.messageFileIconStyle())} @click=${() => {
            if (this.fileURL) {
                this.downloadFile();
            }
        }}></i>
  </div>
</div>
      `;
    }
};
exports.CometChatFileBubble.styles = [
    lit.css `
.cc__file__bubble {
  padding: 12px;
  background: transparent;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  gap:8px;
}
.message__block {
  word-wrap: break-word;
  text-align: left;
  overflow:hidden;
}
.cc__file__title {
  overflow: hidden;
   overflow-wrap: anywhere;
}
.cc__file__url {
  all: unset;
}
.cc__file__subtitle {
  margin-top: 4px;
}
.cc__file__icon {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
    width:fit-content;
}
i{
  display: inline-block;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatFileBubble.prototype, "fileURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatFileBubble.prototype, "downloadIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatFileBubble.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatFileBubble.prototype, "subtitle", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatFileBubble.prototype, "fileStyle", void 0);
exports.CometChatFileBubble = __decorate([
    decorators_js.customElement('cometchat-file-bubble')
], exports.CometChatFileBubble);

/**
 * FileBubbleStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class FileBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "600 15px Inter, sans-serif";
        this.titleColor = "rgb(20, 20, 20)";
        this.subtitleFont = "400 13px Inter, sans-serif";
        this.subtitleColor = "rgba(20, 20, 20, 0.58)";
        this.iconTint = "rgb(51, 153, 255)";
        Object.assign(this, props);
    }
}

exports.CometChatRadioButton = class CometChatRadioButton extends lit.LitElement {
    createRenderRoot() {
        return this;
    }
    constructor() {
        super();
        this.checked = false;
        this.name = "name";
        this.dir = "auto";
        this.labelText = "";
        this.labelAlignment = uikitResources.LabelAlignment.left;
        this.disabled = false;
        this.radioButtonStyle = {
            height: "16px",
            width: "16px",
            border: "none",
            labelTextFont: "400 14px Inter",
            labelTextColor: "grey",
            borderRadius: "4px",
            background: "",
        };
        this.updateChechbox = (event) => {
            var _a, _b;
            this.checked = (_a = event.target) === null || _a === void 0 ? void 0 : _a.checked;
            this.dispatchEvent(new CustomEvent('cc-radio-button-changed', {
                bubbles: true,
                composed: true,
                detail: { checked: (_b = event.target) === null || _b === void 0 ? void 0 : _b.checked }
            }));
        };
        this.labelStyle = () => {
            var _a, _b;
            return {
                width: "fit-content",
                font: (_a = this.radioButtonStyle) === null || _a === void 0 ? void 0 : _a.labelTextFont,
                color: (_b = this.radioButtonStyle) === null || _b === void 0 ? void 0 : _b.labelTextColor,
                display: "flex",
                alignItems: "center",
                flexDirection: this.labelAlignment,
                gap: "5px"
            };
        };
        this.checkboxStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.radioButtonStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.radioButtonStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.radioButtonStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.radioButtonStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.radioButtonStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
    }
    render() {
        return lit.html `<label dir=${this.dir} class="cc__radio__button__label"  style=${styleMap_js.styleMap(this.labelStyle())}> ${this.labelText}
    <input type="radio" name=${this.name} @change=${this.updateChechbox} ?disabled=${this.disabled}  ?checked=${this.checked} style=${styleMap_js.styleMap(this.checkboxStyle())}>
  </label>`;
    }
    requestUpdate(name, oldValue, options) {
        super.requestUpdate(name, oldValue);
    }
};
exports.CometChatRadioButton.styles = [
    lit.css `
    .cc__radio__button__label{
        display: flex;
        align-items: center;
    }
/* checkbox style */
    `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatRadioButton.prototype, "checked", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatRadioButton.prototype, "name", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatRadioButton.prototype, "dir", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatRadioButton.prototype, "labelText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatRadioButton.prototype, "labelAlignment", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatRadioButton.prototype, "disabled", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatRadioButton.prototype, "radioButtonStyle", void 0);
exports.CometChatRadioButton = __decorate([
    decorators_js.customElement('cometchat-radio-button')
], exports.CometChatRadioButton);

class RadioButtonStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.labelTextFont = "400 14px Inter";
        this.labelTextColor = "grey";
        Object.assign(this, props);
    }
}

var smileyIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FSmileys%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FSmileys%22%20fill%3D%22%23000001%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%280.250000%2C%200.250000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.75%2C0%20C5.26065755%2C0%200%2C5.26065755%200%2C11.75%20C0%2C18.2393425%205.26065755%2C23.5%2011.75%2C23.5%20C18.2393425%2C23.5%2023.5%2C18.2393425%2023.5%2C11.75%20C23.5%2C5.26065755%2018.2393425%2C0%2011.75%2C0%20Z%20M11.75%2C1.5%20C17.4109153%2C1.5%2022%2C6.08908467%2022%2C11.75%20C22%2C17.4109153%2017.4109153%2C22%2011.75%2C22%20C6.08908467%2C22%201.5%2C17.4109153%201.5%2C11.75%20C1.5%2C6.08908467%206.08908467%2C1.5%2011.75%2C1.5%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.08333333%2C9.93333333%20C7.46661222%2C9.93333333%206.96666667%2C9.43338778%206.96666667%2C8.81666667%20C6.96666667%2C8.24106029%207.40217479%2C7.76717841%207.96165965%2C7.70655241%20L8.08333333%2C7.7%20L8.08333333%2C8.43333333%20C8.29503934%2C8.43333333%208.46666667%2C8.60496066%208.46666667%2C8.81666667%20C8.46666667%2C9.02837267%208.29503934%2C9.2%208.08333333%2C9.2%20L8.08333333%2C9.93333333%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.7%2C8.81666667%20C7.7%2C8.60496066%207.87162733%2C8.43333333%208.08333333%2C8.43333333%20L8.08333333%2C7.7%20C8.70005445%2C7.7%209.2%2C8.19994555%209.2%2C8.81666667%20C9.2%2C9.39227304%208.76449188%2C9.86615492%208.20500702%2C9.92678092%20L8.08333333%2C9.93333333%20L8.08333333%2C9.2%20C7.87162733%2C9.2%207.7%2C9.02837267%207.7%2C8.81666667%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.4166667%2C9.93333333%20C14.799955%2C9.93333333%2014.3%2C9.4333875%2014.3%2C8.81666667%20C14.3%2C8.24106056%2014.7355164%2C7.76717844%2015.2949946%2C7.70655241%20L15.4166667%2C7.7%20L15.4166667%2C8.43333333%20C15.628376%2C8.43333333%2015.8%2C8.60495419%2015.8%2C8.81666667%20C15.8%2C9.02837914%2015.628376%2C9.2%2015.4166667%2C9.2%20L15.4166667%2C9.93333333%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.0333333%2C8.81666667%20C15.0333333%2C8.60495419%2015.2049574%2C8.43333333%2015.4166667%2C8.43333333%20L15.4166667%2C7.7%20C16.0333783%2C7.7%2016.5333333%2C8.19994583%2016.5333333%2C8.81666667%20C16.5333333%2C9.39227278%2016.0978169%2C9.86615489%2015.5383387%2C9.92678092%20L15.4166667%2C9.93333333%20L15.4166667%2C9.2%20C15.2049574%2C9.2%2015.0333333%2C9.02837914%2015.0333333%2C8.81666667%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.49950837%2C14.0113036%20C5.87066015%2C13.8274035%206.32061857%2C13.979201%206.50451863%2C14.3503528%20C6.98858128%2C15.3273004%207.73599098%2C16.1495708%208.6625211%2C16.7245729%20C9.58905063%2C17.2994827%2010.6576892%2C17.6041067%2011.7480444%2C17.6041067%20C12.8384011%2C17.6041067%2013.9070516%2C17.2994819%2014.8335327%2C16.7246129%20C15.7600626%2C16.1495732%2016.5074791%2C15.327288%2016.9915797%2C14.3503337%20C17.1754904%2C13.9791871%2017.6254531%2C13.8274024%2017.9965997%2C14.0113131%20C18.3677462%2C14.1952237%2018.5195309%2C14.6451865%2018.3356203%2C15.016333%20C17.7274399%2C16.2436902%2016.7884697%2C17.2767171%2015.6244598%2C17.9991459%20C14.4604446%2C18.7214015%2013.1178815%2C19.1041067%2011.7480444%2C19.1041067%20C10.3782056%2C19.1041067%209.03565021%2C18.7214005%207.87160741%2C17.9991142%20C6.70759369%2C17.2767304%205.76860838%2C16.2436961%205.16045914%2C15.0163138%20C4.97655908%2C14.6451621%205.1283566%2C14.1952036%205.49950837%2C14.0113036%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var animalsIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FAnimals%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FAnimals%22%20fill%3D%22%23000001%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%281.250000%2C%201.250000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M14.7040484%2C0.00374294363%20C13.7499%2C-0.0312679275%2012.8027496%2C0.179818592%2011.9538015%2C0.616681975%20C11.1047764%2C1.0535808%2010.3825847%2C1.70158275%209.85681975%2C2.49829357%20C9.33098933%2C3.29493248%209.01920613%2C4.21356642%208.95148961%2C5.16570939%20C8.88377994%2C6.11776676%209.06250643%2C7.07125794%209.47039969%2C7.93437236%20L9.59915191%2C8.18960866%20C9.77928117%2C8.52495566%209.9929284%2C8.84004848%2010.2362465%2C9.13030407%20L10.274%2C9.17300018%20L10.0770979%2C9.23138544%20C9.45935152%2C9.40456866%208.83147422%2C9.54116659%208.19675301%2C9.64031048%20C5.77957443%2C10.0208168%203.30648724%2C9.79612376%200.998221762%2C8.98655045%20C0.510507364%2C8.81549535%200%2C9.17744187%200%2C9.69428342%20L0%2C12.4426334%20C0%2C15.0106661%201.02071319%2C17.473454%202.83756077%2C19.2892285%20C4.65427794%2C21.104972%207.11826343%2C22.1250001%209.6875%2C22.1250001%20C12.2567549%2C22.1250001%2014.7206983%2C21.104985%2016.53746%2C19.2892169%20C18.3542992%2C17.4734707%2019.375%2C15.0106873%2019.375%2C12.4426334%20L19.3841935%2C12.1823926%20C19.3949565%2C11.2273607%2019.1541154%2C10.2666418%2018.6882618%2C9.40867178%20L18.616%2C9.28400018%20L18.7675482%2C9.11404439%20C19.0843802%2C8.73688537%2019.3502233%2C8.31805806%2019.557115%2C7.86814643%20C19.8881236%2C7.14832737%2020.0604801%2C6.36578627%2020.0625282%2C5.57354438%20C20.064827%2C4.61889131%2019.8212793%2C3.67987279%2019.3552736%2C2.84677364%20C18.8894014%2C2.01373452%2018.2166828%2C1.31454575%2017.4019756%2C0.816587932%20C16.5874573%2C0.318691352%2015.6583018%2C0.0387537761%2014.7040484%2C0.00374294363%20Z%20M14.3880595%2C1.50154152%20L14.6704507%2C1.50321386%20C15.3460922%2C1.52830828%2016.0247685%2C1.73278104%2016.6196767%2C2.09643496%20C17.2146977%2C2.46011823%2017.7059422%2C2.97069218%2018.0461263%2C3.57898498%20C18.3863934%2C4.18729557%2018.5642067%2C4.87286955%2018.5625285%2C5.56980212%20C18.5610365%2C6.14689133%2018.4354649%2C6.71701771%2018.1943016%2C7.24145707%20C17.9531143%2C7.76594872%2017.6019648%2C8.23246714%2017.1645977%2C8.60943743%20C16.8673532%2C8.86563491%2016.8178519%2C9.30765436%2017.0510613%2C9.62325675%20C17.5931397%2C10.356852%2017.883668%2C11.2432486%2017.8835493%2C12.1508533%20L17.8762815%2C12.3988089%20C17.875%2C14.6126784%2017.012478%2C16.6938023%2015.4771045%2C18.2282521%20C13.9416342%2C19.7628827%2011.8591076%2C20.6250001%209.6875%2C20.6250001%20C7.51591123%2C20.6250001%205.43334574%2C19.7628703%203.89792208%2C18.2282695%20L3.68317867%2C18.0053887%20C2.28234393%2C16.4953839%201.5%2C14.5093222%201.5%2C12.4426334%20L1.5%2C10.7150002%20L1.86330524%2C10.8137598%20C4.0034445%2C11.3602524%206.23748675%2C11.4672048%208.42912714%2C11.1222017%20C9.64145115%2C10.9328363%2010.8317634%2C10.6180512%2011.9799552%2C10.1830648%20C12.5412617%2C9.97041677%2012.6377785%2C9.21736141%2012.1482428%2C8.87003016%20C11.5795342%2C8.46652487%2011.1243557%2C7.92355749%2010.8265836%2C7.2934628%20C10.5287641%2C6.66326759%2010.3982805%2C5.96714844%2010.4477104%2C5.27212019%20C10.4971515%2C4.57694259%2010.7247869%2C3.90624081%2011.1087394%2C3.32454841%20C11.4926854%2C2.7427411%2012.0200753%2C2.26952924%2012.6401458%2C1.95044788%20C13.1827314%2C1.67123672%2013.7802513%2C1.51828455%2014.3880595%2C1.50154152%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.9589749%2C3.57252819%20C21.3036214%2C3.34276385%2021.7692734%2C3.43589425%2021.9990377%2C3.78054077%20C22.2079144%2C4.09385578%2022.1499359%2C4.50717534%2021.8787301%2C4.75236032%20L21.7910251%2C4.82060364%20L20.664%2C5.57100018%20L21.7910251%2C6.32252819%20C22.1043402%2C6.53140487%2022.2097906%2C6.93523003%2022.0537487%2C7.26586456%20L21.9990377%2C7.36259106%20C21.790161%2C7.67590608%2021.3863359%2C7.78135653%2021.0557014%2C7.62531461%20L20.9589749%2C7.57060364%20L18.8964749%2C6.19560364%20C18.4829822%2C5.91994185%2018.453447%2C5.33604836%2018.8078693%2C5.01635347%20L18.8964749%2C4.94752819%20L20.9589749%2C3.57252819%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M14.5170273%2C12.3842684%20C14.9311341%2C12.3936723%2015.2592106%2C12.7369956%2015.2498067%2C13.1511024%20C15.2280139%2C14.1107604%2014.891379%2C15.0366503%2014.2917182%2C15.7861986%20C13.6920831%2C16.5357148%2012.8626902%2C17.0673695%2011.9319017%2C17.299182%20C10.3328372%2C17.6989481%208.9724703%2C17.1888105%207.90948473%2C16.1258249%20C7.43733181%2C15.653672%207.12309644%2C15.182319%206.95417961%2C14.8444853%20C6.76893767%2C14.4740014%206.91910593%2C14.0234966%207.2895898%2C13.8382547%20C7.62920002%2C13.6684496%208.03605003%2C13.7804822%208.24418342%2C14.0857004%20L8.29582039%2C14.1736649%20C8.39850849%2C14.3790411%208.62748301%2C14.7225029%208.9701449%2C15.0651647%20C9.68956674%2C15.7845866%2010.5359899%2C16.1019953%2011.5687491%2C15.8438058%20C12.1810568%2C15.6913107%2012.7262687%2C15.3418207%2013.1204318%2C14.8491349%20C13.5145936%2C14.3564509%2013.7358685%2C13.7478504%2013.7501933%2C13.1170478%20C13.7595972%2C12.702941%2014.1029205%2C12.3748645%2014.5170273%2C12.3842684%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M14.84375%2C6.32156592%20C14.2396948%2C6.32156592%2013.75%2C5.83187114%2013.75%2C5.22781592%20C13.75%2C4.66402255%2014.1765785%2C4.19986569%2014.724575%2C4.14048386%20L14.84375%2C4.13406592%20L14.84375%2C4.82156592%20C15.0681219%2C4.82156592%2015.25%2C5.00344402%2015.25%2C5.22781592%20C15.25%2C5.4521849%2015.0681156%2C5.63406592%2014.84375%2C5.63406592%20L14.84375%2C6.32156592%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M14.4375%2C5.22781592%20C14.4375%2C5.00344402%2014.6193781%2C4.82156592%2014.84375%2C4.82156592%20L14.84375%2C4.13406592%20C15.4478053%2C4.13406592%2015.9375%2C4.62375159%2015.9375%2C5.22781592%20C15.9375%2C5.7916008%2015.5109214%2C6.25576501%2014.962925%2C6.31514786%20L14.84375%2C6.32156592%20L14.84375%2C5.63406592%20C14.6193844%2C5.63406592%2014.4375%2C5.4521849%2014.4375%2C5.22781592%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var foodIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FFood%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FFood%22%20fill%3D%22%23000001%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M6.26081031%2C5.06079387%20L6.05008078%2C5.25485649%20C5.13804905%2C6.07779806%204.40413987%2C7.07873841%203.89355108%2C8.19603576%20C3.38296391%2C9.31332958%203.10651161%2C10.5233273%203.08121157%2C11.751529%20C3.05592076%2C12.9796687%203.2823325%2C14.2000667%203.74647688%2C15.3373529%20C4.2106271%2C16.474729%204.90269562%2C17.5050318%205.78008032%2C18.3648364%20L7.55202905%2C20.0263157%20C7.84933547%2C20.3050449%208.31480833%2C20.2953601%208.60026381%2C20.0045058%20L19.7469305%2C8.64702417%20C19.9313149%2C8.46392641%2020.0829001%2C8.23819112%2020.1863603%2C7.98951005%20C20.2897828%2C7.74091939%2020.3429892%2C7.47431068%2020.3429892%2C7.20501851%20C20.3429892%2C6.93572633%2020.2897828%2C6.66911762%2020.1863603%2C6.42052696%20C20.0829001%2C6.17184589%2019.9313149%2C5.9461106%2019.7402485%2C5.75629004%20L18.9858943%2C5.03893651%20C15.377551%2C1.58662448%2010.0922057%2C1.62500619%206.26081031%2C5.06079387%20Z%20M17.9506723%2C6.12443628%20L18.6949174%2C6.83193383%20C18.7337331%2C6.87075319%2018.7739513%2C6.93064468%2018.8014347%2C6.99670505%20C18.8288622%2C7.06263098%2018.8429892%2C7.13341877%2018.8429892%2C7.20501851%20C18.8429892%2C7.27661824%2018.8288622%2C7.34740603%2018.8014347%2C7.41333196%20L18.7697909%2C7.47721074%20C18.7459778%2C7.51825866%2018.7168431%2C7.55606367%2018.6830631%2C7.58962338%20L8.042%2C18.43%20L6.81797678%2C17.2820179%20C6.09879876%2C16.5769932%205.52207649%2C15.7184098%205.13527803%2C14.7705802%20C4.74849451%2C13.8228502%204.55981814%2C12.8058522%204.58089353%2C11.7824165%20C4.60197698%2C10.7589106%204.83235459%2C9.75057613%205.25784392%2C8.81949792%20C5.63605835%2C7.99186914%206.16131472%2C7.24085477%206.80715974%2C6.60253201%20L7.06789863%2C6.35655344%20C10.3450384%2C3.25676065%2014.8586226%2C3.16609676%2017.9506723%2C6.12443628%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.7071405%2C-0.74864612%20C13.6540803%2C-0.774157955%2014.5751175%2C-0.43838074%2015.3045603%2C0.210841894%20C15.7932732%2C0.681756455%2016.1257121%2C1.29076512%2016.2571458%2C1.95611121%20C16.3884544%2C2.62143575%2016.3122655%2C3.31093823%2016.0388887%2C3.93176543%20C15.87196%2C4.3108534%2015.4293261%2C4.48284251%2015.0502381%2C4.31591385%20C14.7027408%2C4.1628959%2014.529264%2C3.77820894%2014.631342%2C3.4231628%20L14.6660897%2C3.32726325%20C14.8156789%2C2.98755239%2014.8573495%2C2.61043727%2014.7855579%2C2.24667777%20C14.7136304%2C1.88256529%2014.5315841%2C1.54906715%2014.285875%2C1.31146513%20C13.8636614%2C0.936153442%2013.3134431%2C0.735563549%2012.7475412%2C0.750809709%20C12.181721%2C0.766056201%2011.6431393%2C0.995988759%2011.2344918%2C1.4007153%20C10.9636151%2C1.66166077%2010.7675316%2C1.98977795%2010.6664185%2C2.35116915%20C10.5264543%2C2.85141982%209.93261908%2C3.06134266%209.50935743%2C2.76019435%20C9.08328236%2C2.4570443%208.56392587%2C2.31222288%208.04163252%2C2.35102378%20C7.51945078%2C2.38981945%207.02751483%2C2.60971661%206.64832646%2C2.97524633%20C6.33886141%2C3.2702505%206.128481%2C3.65128158%206.04304609%2C4.06628628%20L6.01415624%2C4.24607369%20C5.9632171%2C4.68462304%205.5463653%2C4.98451309%205.11437295%2C4.89339263%20C4.74599339%2C4.81569005%204.36411585%2C4.82914683%204.0021882%2C4.93258044%20C3.64038765%2C5.03597772%203.30959883%2C5.2261181%203.01856952%2C5.50499337%20C2.65223243%2C5.83195382%202.42619012%2C6.28654108%202.38701828%2C6.77466025%20C2.35275005%2C7.2016813%202.46377786%2C7.6259474%202.69933408%2C7.98036209%20L2.80785039%2C8.12778186%20C3.1531199%2C8.55260639%202.94166194%2C9.19222539%202.41121149%2C9.32753701%20C2.02938942%2C9.4249353%201.6787772%2C9.61753531%201.37795962%2C9.90036638%20C1.180235%2C10.07698%201.02217344%2C10.2930235%200.913973909%2C10.5345228%20C0.805880732%2C10.7757192%200.75%2C11.0370318%200.75%2C11.3012168%20C0.75%2C11.565456%200.805865388%2C11.8266803%200.914004971%2C12.0679802%20C1.00053975%2C12.2611242%201.1190061%2C12.4380208%201.26416625%2C12.5914799%20L1.37795962%2C12.7020673%20C1.63110649%2C12.9281858%201.69769397%2C13.2918375%201.55304191%2C13.5890889%20L1.49696702%2C13.6854337%20C1.25291048%2C14.0415092%201.14321016%2C14.4720029%201.18717045%2C14.9008299%20C1.23113999%2C15.3296823%201.42603179%2C15.7293374%201.72711894%2C16.0192228%20C2.034424%2C16.3038315%202.42265288%2C16.4839813%202.83599751%2C16.5365054%20L3.01452021%2C16.5511343%20C3.47385511%2C16.5682059%203.80174073%2C16.9871323%203.72630549%2C17.4258119%20L3.70386844%2C17.5199778%20C3.60699921%2C17.836693%203.59978632%2C18.1740089%203.6830285%2C18.494544%20C3.76632442%2C18.8153257%203.93695887%2C19.107056%204.14851866%2C19.312169%20C4.53457925%2C19.6485371%205.02311956%2C19.845798%205.5353423%2C19.8720354%20C5.98373952%2C19.8949433%206.4274306%2C19.7857484%206.81179399%2C19.5602963%20L6.94%2C19.477%20L7.5867141%2C18.8663242%20C7.86048885%2C18.6077837%208.27767447%2C18.5955072%208.56493357%2C18.8216719%20L8.64694017%2C18.8966668%20C8.9054806%2C19.1704415%208.91775713%2C19.5876271%208.6915924%2C19.8748862%20L8.61659757%2C19.9568928%20L7.91994007%2C20.6147845%20L7.83726706%2C20.682398%20C7.14417328%2C21.1712279%206.30647498%2C21.4133876%205.45870918%2C21.3700765%20C4.61105051%2C21.3266572%203.80252078%2C21.0001924%203.13548641%2C20.4177722%20C2.69703547%2C19.9953818%202.38405209%2C19.4602804%202.23118218%2C18.8715616%20C2.15472374%2C18.5771482%202.11980723%2C18.2750205%202.1262485%2C17.9737718%20L2.129%2C17.916%20L2.06690648%2C17.8999431%20C1.63516194%2C17.7679754%201.22959672%2C17.5524838%200.872119657%2C17.2616158%20L0.697489902%2C17.1099382%20C0.130378203%2C16.5642812%20-0.224823091%2C15.835887%20-0.305008291%2C15.053809%20C-0.361141513%2C14.5062365%20-0.27993925%2C13.9572206%20-0.0735965036%2C13.4544957%20L-0.036%2C13.372%20L-0.098298633%2C13.2948906%20C-0.191431892%2C13.1675865%20-0.275643023%2C13.0337892%20-0.350244117%2C12.8944359%20L-0.454852242%2C12.6813561%20C-0.649426899%2C12.2471871%20-0.75%2C11.7769114%20-0.75%2C11.3012168%20C-0.75%2C10.8255831%20-0.649414278%2C10.3552184%20-0.454883304%2C9.92114691%20C-0.260395%2C9.48705279%200.0236481552%2C9.09881368%200.364249624%2C8.79492193%20C0.541034304%2C8.62850062%200.732642896%2C8.47992708%200.936210939%2C8.35077153%20L1.141%2C8.229%20L1.10456507%2C8.13977342%20C0.951148225%2C7.73775767%200.874412571%2C7.30790416%200.881350806%2C6.87264636%20L0.891825122%2C6.65467096%20C0.961865372%2C5.78190148%201.36579715%2C4.96956577%201.99958625%2C4.40457659%20C2.44695873%2C3.97481307%202.99301687%2C3.66093396%203.5900118%2C3.49032158%20C3.93107463%2C3.39285083%204.28284299%2C3.34383267%204.63505605%2C3.34362711%20L4.688%2C3.345%20L4.74078742%2C3.19535709%20C4.90298768%2C2.77499351%205.14350946%2C2.3872438%205.45101905%2C2.05425722%20L5.61030368%2C1.89243007%20C6.23851512%2C1.2868202%207.05944491%2C0.91986159%207.93050018%2C0.855146243%20C8.4847843%2C0.813968767%209.03714981%2C0.896817085%209.54884202%2C1.09290782%20L9.578%2C1.105%20L9.59813374%2C1.06992467%20C9.72000724%2C0.865479339%209.8617507%2C0.673682895%2010.0211365%2C0.49797733%20L10.1863205%2C0.327762873%20C10.8585514%2C-0.338187737%2011.7602209%2C-0.72313059%2012.7071405%2C-0.74864612%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.6300225%2C14.5045835%20C8.02596727%2C14.5045835%207.5362725%2C14.0148887%207.5362725%2C13.4108335%20C7.5362725%2C12.8470486%207.96285106%2C12.3828844%208.51084747%2C12.3235016%20L8.6300225%2C12.3170835%20L8.6300225%2C13.0045835%20C8.8543944%2C13.0045835%209.0362725%2C13.1864616%209.0362725%2C13.4108335%20C9.0362725%2C13.6352054%208.8543944%2C13.8170835%208.6300225%2C13.8170835%20L8.6300225%2C14.5045835%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.2237725%2C13.4108335%20C8.2237725%2C13.1864616%208.4056506%2C13.0045835%208.6300225%2C13.0045835%20L8.6300225%2C12.3170835%20C9.23407773%2C12.3170835%209.7237725%2C12.8067783%209.7237725%2C13.4108335%20C9.7237725%2C13.9746184%209.29719394%2C14.4387826%208.74919753%2C14.4981655%20L8.6300225%2C14.5045835%20L8.6300225%2C13.8170835%20C8.4056506%2C13.8170835%208.2237725%2C13.6352054%208.2237725%2C13.4108335%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.94255917%2C11.0854168%20C7.33849484%2C11.0854168%206.84880917%2C10.5957221%206.84880917%2C9.99166684%20C6.84880917%2C9.42788189%207.2753798%2C8.96371774%207.82338255%2C8.90433489%20L7.94255917%2C8.89791684%20L7.94255917%2C9.58541684%20C8.16692815%2C9.58541684%208.34880917%2C9.7673012%208.34880917%2C9.99166684%20C8.34880917%2C10.2160325%208.16692815%2C10.3979168%207.94255917%2C10.3979168%20L7.94255917%2C11.0854168%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.5362725%2C9.99166684%20C7.5362725%2C9.76730164%207.7181439%2C9.58541684%207.94255917%2C9.58541684%20L7.94255917%2C8.89791684%20C8.54659577%2C8.89791684%209.0362725%2C9.38762965%209.0362725%2C9.99166684%20C9.0362725%2C10.5554349%208.60970966%2C11.0196137%208.06173048%2C11.0789986%20L7.94255917%2C11.0854168%20L7.94255917%2C10.3979168%20C7.7181439%2C10.3979168%207.5362725%2C10.216032%207.5362725%2C9.99166684%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.3800225%2C11.7454168%20C10.7759673%2C11.7454168%2010.2862725%2C11.2557221%2010.2862725%2C10.6516668%20C10.2862725%2C10.087882%2010.7128511%2C9.62371774%2011.2608475%2C9.56433489%20L11.3800225%2C9.55791684%20L11.3800225%2C10.2454168%20C11.6043944%2C10.2454168%2011.7862725%2C10.4272949%2011.7862725%2C10.6516668%20C11.7862725%2C10.8760387%2011.6043944%2C11.0579168%2011.3800225%2C11.0579168%20L11.3800225%2C11.7454168%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.9737725%2C10.6516668%20C10.9737725%2C10.4272949%2011.1556506%2C10.2454168%2011.3800225%2C10.2454168%20L11.3800225%2C9.55791684%20C11.9840777%2C9.55791684%2012.4737725%2C10.0476116%2012.4737725%2C10.6516668%20C12.4737725%2C11.2154517%2012.0471939%2C11.6796159%2011.4991975%2C11.7389988%20L11.3800225%2C11.7454168%20L11.3800225%2C11.0579168%20C11.1556506%2C11.0579168%2010.9737725%2C10.8760387%2010.9737725%2C10.6516668%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2810.062314%2C%206.783324%29%22%20id%3D%22Path%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.630208333%2C1.55208333%20C0.0261530309%2C1.55208333%20-0.463541667%2C1.06239766%20-0.463541667%2C0.458333333%20C-0.463541667%2C-0.105451547%20-0.0369631106%2C-0.569615762%200.511033304%2C-0.628998613%20L0.630208333%2C-0.635416667%20L0.630208333%2C0.0520833333%20C0.854573971%2C0.0520833333%201.03645833%2C0.233964346%201.03645833%2C0.458333333%20C1.03645833%2C0.682705229%200.854580229%2C0.864583333%200.630208333%2C0.864583333%20L0.630208333%2C1.55208333%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.223958333%2C0.458333333%20C0.223958333%2C0.233964346%200.405842696%2C0.0520833333%200.630208333%2C0.0520833333%20L0.630208333%2C-0.635416667%20C1.23426356%2C-0.635416667%201.72395833%2C-0.145721896%201.72395833%2C0.458333333%20C1.72395833%2C1.0221267%201.29737984%2C1.48628356%200.749383376%2C1.54566539%20L0.630208333%2C1.55208333%20L0.630208333%2C0.864583333%20C0.405836438%2C0.864583333%200.223958333%2C0.682705229%200.223958333%2C0.458333333%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2813.495231%2C%207.447917%29%22%20id%3D%22Path%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.630208333%2C1.55208333%20C0.0261530309%2C1.55208333%20-0.463541667%2C1.06239766%20-0.463541667%2C0.458333333%20C-0.463541667%2C-0.105460034%20-0.0369631746%2C-0.569616893%200.511033291%2C-0.628998726%20L0.630208333%2C-0.635416667%20L0.630208333%2C0.0520833333%20C0.854573971%2C0.0520833333%201.03645833%2C0.233964346%201.03645833%2C0.458333333%20C1.03645833%2C0.682702321%200.854573971%2C0.864583333%200.630208333%2C0.864583333%20L0.630208333%2C1.55208333%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.223958333%2C0.458333333%20C0.223958333%2C0.233964346%200.405842696%2C0.0520833333%200.630208333%2C0.0520833333%20L0.630208333%2C-0.635416667%20C1.23426364%2C-0.635416667%201.72395833%2C-0.145730989%201.72395833%2C0.458333333%20C1.72395833%2C1.0221267%201.29737984%2C1.48628356%200.749383376%2C1.54566539%20L0.630208333%2C1.55208333%20L0.630208333%2C0.864583333%20C0.405842696%2C0.864583333%200.223958333%2C0.682702321%200.223958333%2C0.458333333%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var activityIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FActivity%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FActivity%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.3125%2C-0.75%20C4.20284995%2C-0.75%20-0.75%2C4.20284995%20-0.75%2C10.3125%20C-0.75%2C16.42215%204.20284995%2C21.375%2010.3125%2C21.375%20C16.42215%2C21.375%2021.375%2C16.42215%2021.375%2C10.3125%20C21.375%2C7.37854258%2020.20949%2C4.56475242%2018.1348688%2C2.49013123%20C16.0602476%2C0.415510047%2013.2464574%2C-0.75%2010.3125%2C-0.75%20Z%20M10.3125%2C0.75%20C12.8486327%2C0.75%2015.280892%2C1.75747479%2017.0742086%2C3.5507914%20C18.8675252%2C5.34410802%2019.875%2C7.77636732%2019.875%2C10.3125%20C19.875%2C15.5937229%2015.5937229%2C19.875%2010.3125%2C19.875%20C5.03127708%2C19.875%200.75%2C15.5937229%200.75%2C10.3125%20C0.75%2C5.03127708%205.03127708%2C0.75%2010.3125%2C0.75%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.87147193%2C5.31320805%20L5.27438859%2C8.65537471%20C5.01189314%2C8.84621388%204.90192054%2C9.18423429%205.00187496%2C9.49299401%20L6.75270829%2C14.9013273%20C6.8528727%2C15.2107357%207.14103245%2C15.4203333%207.46625%2C15.4203333%20L13.15875%2C15.4203333%20C13.4839675%2C15.4203333%2013.7721273%2C15.2107357%2013.8722917%2C14.9013273%20L15.623125%2C9.49299401%20C15.7230795%2C9.18423429%2015.6131069%2C8.84621388%2015.3506114%2C8.65537471%20L10.7535281%2C5.31320805%20C10.4905827%2C5.12204176%2010.1344173%2C5.12204176%209.87147193%2C5.31320805%20Z%20M10.312%2C6.847%20L14.028%2C9.548%20L12.613%2C13.92%20L8.011%2C13.92%20L6.596%2C9.548%20L10.312%2C6.847%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13.8358935%2C0.158167021%20C14.1793684%2C-0.0733451208%2014.6454875%2C0.0174186242%2014.8769996%2C0.360893519%20C15.0874652%2C0.673143424%2015.0315871%2C1.08675217%2014.7616303%2C1.33331168%20L14.6742731%2C1.40199965%20L10.7316898%2C4.05941631%20C10.5099918%2C4.20884728%2010.2283667%2C4.22752615%209.99168688%2C4.11545293%20L9.89331019%2C4.05941631%20L5.95072685%2C1.40199965%20C5.60725196%2C1.1704875%205.51648821%2C0.704368414%205.74800035%2C0.360893519%20C5.95846594%2C0.0486436147%206.36282156%2C-0.0547540998%206.69265915%2C0.102965392%20L6.78910648%2C0.158167021%20L10.312%2C2.533%20L13.8358935%2C0.158167021%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19.0188291%2C14.9171897%20C19.4282435%2C14.8543189%2019.8111062%2C15.135248%2019.873977%2C15.5446624%20C19.9316085%2C15.9199589%2019.7003527%2C16.2729447%2019.3460565%2C16.377596%20L19.2465042%2C16.3998103%20L15.156%2C17.027%20L13.3684301%2C20.6781358%20C13.2013796%2C21.0191094%2012.8099434%2C21.176767%2012.4593515%2C21.0603066%20L12.3649475%2C21.0216801%20C12.0239739%2C20.8546296%2011.8663163%2C20.4631934%2011.9827767%2C20.1126015%20L12.0214032%2C20.0181975%20L13.9821532%2C16.0160309%20C14.0747247%2C15.8270795%2014.2415313%2C15.6872092%2014.4400966%2C15.6276387%20L14.5418291%2C15.6046897%20L19.0188291%2C14.9171897%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M18.2369597%2C2.83992135%20C18.6123499%2C2.8969397%2018.8802161%2C3.22301623%2018.8743424%2C3.59239838%20L18.8658286%2C3.69404305%20L18.249%2C7.754%20L21.1212435%2C10.6143356%20C21.3880545%2C10.8800566%2021.4131133%2C11.2966698%2021.1958603%2C11.5907266%20L21.1234144%2C11.6749935%20C20.8576934%2C11.9418045%2020.4410802%2C11.9668633%2020.1470234%2C11.7496103%20L20.0627565%2C11.6771644%20L16.9213398%2C8.54858111%20C16.776222%2C8.40405612%2016.6975753%2C8.20767517%2016.7006626%2C8.0057503%20L16.709088%2C7.90454029%20L17.382838%2C3.46879029%20C17.4398564%2C3.09340011%2017.7659329%2C2.82553385%2018.135315%2C2.8314076%20L18.2369597%2C2.83992135%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.3125%2C2.6875%20C10.6921958%2C2.6875%2011.005991%2C2.96965388%2011.0556534%2C3.33572944%20L11.0625%2C3.4375%20L11.0625%2C5.91983333%20C11.0625%2C6.3340469%2010.7267136%2C6.66983333%2010.3125%2C6.66983333%20C9.93280423%2C6.66983333%209.61900904%2C6.38767945%209.56934662%2C6.02160389%20L9.5625%2C5.91983333%20L9.5625%2C3.4375%20C9.5625%2C3.02328644%209.89828644%2C2.6875%2010.3125%2C2.6875%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.1206268%2C7.34364706%20C17.4926014%2C7.16141708%2017.941873%2C7.31523549%2018.1241029%2C7.68721009%20C18.2911471%2C8.02818682%2018.1758172%2C8.43411447%2017.8689204%2C8.63976468%20L17.7805399%2C8.69068627%20L15.2395399%2C9.93551961%20C14.8675653%2C10.1177496%2014.4182937%2C9.96393118%2014.2360637%2C9.59195657%20C14.0690196%2C9.25097985%2014.1843494%2C8.84505219%2014.4912463%2C8.63940199%20L14.5796268%2C8.58848039%20L17.1206268%2C7.34364706%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.38804029%2C2.83992135%20C2.76343046%2C2.78290301%203.11603798%2C3.01473523%203.22011027%2C3.36920191%20L3.24216198%2C3.46879029%20L3.91591198%2C7.90454029%20C3.94666782%2C8.10702667%203.89314597%2C8.31168782%203.77060916%2C8.47221169%20L3.70366017%2C8.54858111%20L0.562243506%2C11.6771644%20C0.268751413%2C11.9694576%20-0.206121326%2C11.9684856%20-0.498414444%2C11.6749935%20C-0.76413546%2C11.4081825%20-0.787488641%2C10.9914702%20-0.56903368%2C10.6983052%20L-0.496243506%2C10.6143356%20L2.375%2C7.754%20L1.75917135%2C3.69404305%20C1.70215301%2C3.31865287%201.93398523%2C2.96604536%202.28845191%2C2.86197307%20L2.38804029%2C2.83992135%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.50089706%2C7.68721009%20C2.66794121%2C7.34623337%203.05937449%2C7.18856845%203.40996851%2C7.30502235%20L3.50437324%2C7.34364706%20L6.04537324%2C8.58848039%20C6.41734785%2C8.77071038%206.57116626%2C9.21998197%206.38893627%2C9.59195657%20C6.22189212%2C9.9329333%205.83045884%2C10.0905982%205.47986483%2C9.97414432%20L5.38546009%2C9.93551961%20L2.84446009%2C8.69068627%20C2.47248549%2C8.50845629%202.31866708%2C8.0591847%202.50089706%2C7.68721009%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.6590923%2C14.1110104%20C12.9399155%2C13.8601437%2013.357281%2C13.8594145%2013.6381727%2C14.0934405%20L13.7180729%2C14.1706756%20L15.2149896%2C15.8463423%20C15.4909429%2C16.1552478%2015.4642299%2C16.6293696%2015.1553244%2C16.9053229%20C14.8745012%2C17.1561896%2014.4571356%2C17.1569188%2014.176244%2C16.9228928%20L14.0963437%2C16.8456577%20L12.5994271%2C15.1699911%20C12.3234737%2C14.8610855%2012.3501867%2C14.3869638%2012.6590923%2C14.1110104%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.60617091%2C14.9171897%20L6.08317091%2C15.6046897%20C6.29114243%2C15.6366263%206.47443481%2C15.754066%206.59057144%2C15.9257898%20L6.64284678%2C16.0160309%20L8.60359678%2C20.0181975%20C8.78583371%2C20.3901687%208.63202368%2C20.8394432%208.26005247%2C21.0216801%20C7.91907887%2C21.1887306%207.51314906%2C21.0734084%207.30749313%2C20.7665154%20L7.25656988%2C20.6781358%20L5.468%2C17.027%20L1.37849575%2C16.3998103%20C1.00319923%2C16.3421788%200.735866022%2C16.0156651%200.742343208%2C15.646293%20L0.751023004%2C15.5446624%20C0.808654534%2C15.1693659%201.13516823%2C14.9020327%201.50454029%2C14.9085099%20L1.60617091%2C14.9171897%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M6.90692707%2C14.1706756%20C7.18288042%2C13.8617701%207.65700221%2C13.8350571%207.96590774%2C14.1110104%20C8.24673095%2C14.3618771%208.2943372%2C14.7765193%208.09334419%2C15.0819209%20L8.02557293%2C15.1699911%20L6.52865627%2C16.8456577%20C6.25270292%2C17.1545633%205.77858112%2C17.1812763%205.46967559%2C16.9053229%20C5.18885239%2C16.6544563%205.14124613%2C16.239814%205.34223914%2C15.9344125%20L5.4100104%2C15.8463423%20L6.90692707%2C14.1706756%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var travelIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FTravel%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FTravel%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%201.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.63555583%2C12.6153443%20C10.0152516%2C12.6153443%2010.3290468%2C12.8974981%2010.3787092%2C13.2635737%20L10.3855558%2C13.3653443%20L10.3855558%2C20.5795109%20C10.3855558%2C20.9937245%2010.0497694%2C21.3295109%209.63555583%2C21.3295109%20C9.25586006%2C21.3295109%208.94206486%2C21.0473571%208.89240244%2C20.6812815%20L8.88555583%2C20.5795109%20L8.88555583%2C13.3653443%20C8.88555583%2C12.9511307%209.22134226%2C12.6153443%209.63555583%2C12.6153443%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.38555583%2C12.6153443%20C1.76525159%2C12.6153443%202.07904679%2C12.8974981%202.12870921%2C13.2635737%20L2.13555583%2C13.3653443%20L2.13555583%2C20.5795109%20C2.13555583%2C20.9937245%201.79976939%2C21.3295109%201.38555583%2C21.3295109%20C1.00586006%2C21.3295109%200.692064865%2C21.0473571%200.642402441%2C20.6812815%20L0.635555825%2C20.5795109%20L0.635555825%2C13.3653443%20C0.635555825%2C12.9511307%200.971342263%2C12.6153443%201.38555583%2C12.6153443%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.06055583%2C9.66701093%20C5.29759286%2C9.48923315%205.61364225%2C9.46948007%205.86823758%2C9.60775167%20L5.96055583%2C9.66701093%20L11.4605558%2C13.7920109%20C11.7919267%2C14.0405391%2011.859084%2C14.5106401%2011.6105558%2C14.8420109%20C11.3846212%2C15.1432572%2010.9755684%2C15.2261451%2010.6540986%2C15.0520031%20L10.5605558%2C14.9920109%20L5.51%2C11.205%20L0.460555825%2C14.9920109%20C0.159309598%2C15.2179456%20-0.256589656%2C15.1829832%20-0.516440932%2C14.9257954%20L-0.589444175%2C14.8420109%20C-0.815378845%2C14.5407647%20-0.78041647%2C14.1248655%20-0.523228622%2C13.8650142%20L-0.439444175%2C13.7920109%20L5.06055583%2C9.66701093%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.8397354%2C5.11910074%20L15.7148224%2C5.37733736%20L15.6147465%2C5.59065688%20L15.3955097%2C6.07373521%20C15.0665468%2C6.81390157%2014.7378063%2C7.6193158%2014.4307108%2C8.46382864%20C13.9443046%2C9.80144551%2013.5585622%2C11.1102145%2013.3111203%2C12.3474238%20C13.1150443%2C13.3278039%2013.0105558%2C14.2420781%2013.0105558%2C15.0795109%20C13.0105558%2C17.0125076%2014.5775592%2C18.5795109%2016.5105558%2C18.5795109%20C18.4435524%2C18.5795109%2020.0105558%2C17.0125076%2020.0105558%2C15.0795109%20C20.0105558%2C12.6028287%2019.1411293%2C9.61713244%2017.8776404%2C6.653014%20L17.5491525%2C5.90297573%20L17.2161608%2C5.18944437%20C17.2034972%2C5.16358905%2017.1918886%2C5.14012548%2017.1813762%2C5.11910074%20C16.904983%2C4.56631433%2016.1161286%2C4.56631433%2015.8397354%2C5.11910074%20Z%20M16.511%2C7.273%20L16.6792961%2C7.67469517%20C17.7695325%2C10.3228139%2018.5105558%2C12.9726969%2018.5105558%2C15.0795109%20C18.5105558%2C16.1840804%2017.6151253%2C17.0795109%2016.5105558%2C17.0795109%20C15.4059863%2C17.0795109%2014.5105558%2C16.1840804%2014.5105558%2C15.0795109%20C14.5105558%2C14.3494438%2014.6040673%2C13.531218%2014.7819913%2C12.641598%20C15.0130495%2C11.4863074%2015.378057%2C10.2478889%2015.8404009%2C8.97644323%20C16.017081%2C8.4905728%2016.2014378%2C8.0176972%2016.3888171%2C7.56376972%20L16.511%2C7.273%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16.5105558%2C17.0795109%20C16.8902516%2C17.0795109%2017.2040468%2C17.3616648%2017.2537092%2C17.7277404%20L17.2605558%2C17.8295109%20L17.2605558%2C20.5795109%20C17.2605558%2C20.9937245%2016.9247694%2C21.3295109%2016.5105558%2C21.3295109%20C16.1308601%2C21.3295109%2015.8170649%2C21.0473571%2015.7674024%2C20.6812815%20L15.7605558%2C20.5795109%20L15.7605558%2C17.8295109%20C15.7605558%2C17.4152974%2016.0963423%2C17.0795109%2016.5105558%2C17.0795109%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.6355558%2C19.8295109%20C21.0497694%2C19.8295109%2021.3855558%2C20.1652974%2021.3855558%2C20.5795109%20C21.3855558%2C20.9592067%2021.1034019%2C21.2730019%2020.7373264%2C21.3226643%20L20.6355558%2C21.3295109%20L0.0105558255%2C21.3295109%20C-0.403657737%2C21.3295109%20-0.739444175%2C20.9937245%20-0.739444175%2C20.5795109%20C-0.739444175%2C20.1998152%20-0.457290293%2C19.88602%20-0.0912147319%2C19.8363575%20L0.0105558255%2C19.8295109%20L20.6355558%2C19.8295109%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.51055583%2C15.7045109%20C6.63313461%2C15.7045109%207.55240578%2C16.5749743%207.63022032%2C17.6777521%20L7.63555583%2C17.8295109%20L7.63555583%2C20.5795109%20C7.63555583%2C20.9937245%207.29976939%2C21.3295109%206.88555583%2C21.3295109%20C6.50586006%2C21.3295109%206.19206486%2C21.0473571%206.14240244%2C20.6812815%20L6.13555583%2C20.5795109%20L6.13555583%2C17.8295109%20C6.13555583%2C17.484333%205.85573379%2C17.2045109%205.51055583%2C17.2045109%20C5.19675767%2C17.2045109%204.93697269%2C17.4357688%204.89233243%2C17.737153%20L4.88555583%2C17.8295109%20L4.88555583%2C20.5795109%20C4.88555583%2C20.9937245%204.54976939%2C21.3295109%204.13555583%2C21.3295109%20C3.75586006%2C21.3295109%203.44206486%2C21.0473571%203.39240244%2C20.6812815%20L3.38555583%2C20.5795109%20L3.38555583%2C17.8295109%20C3.38555583%2C16.6559058%204.33695073%2C15.7045109%205.51055583%2C15.7045109%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.11932958%2C-0.692320384%20C0.336197697%2C-0.365592266%20-0.902348765%2C1.26860098%20-0.734893708%2C3.07366868%20C-0.567439205%2C4.8787304%200.950582069%2C6.2571983%202.76338539%2C6.25038432%20L6.89389229%2C6.2044646%20C8.43885668%2C6.20451093%209.69805583%2C4.94531179%209.69805583%2C3.39201093%20C9.69805583%2C1.83871007%208.43885668%2C0.579510932%206.88555583%2C0.579510932%20L6.68830064%2C0.590482133%20C6.36188794%2C0.619840843%206.04798019%2C0.70417188%205.75820729%2C0.837557048%20L5.699%2C0.867%20L5.65175457%2C0.791958708%20C4.89322527%2C-0.33182676%203.52036177%2C-0.949035335%202.11932958%2C-0.692320384%20Z%20M4.6777157%2C2.21701631%20C4.82641094%2C2.75441631%205.4780205%2C2.936863%205.88402376%2C2.5908839%20L5.96172788%2C2.514591%20C6.2008359%2C2.24492437%206.54156391%2C2.08717992%206.90188483%2C2.07933315%20C7.61042956%2C2.07951093%208.19805583%2C2.6671372%208.19805583%2C3.39201093%20C8.19805583%2C4.11688467%207.61042956%2C4.70451093%206.88555583%2C4.70451093%20L2.75221936%2C4.75042483%20C1.72182871%2C4.75427788%200.854381578%2C3.96657612%200.758693036%2C2.93510952%20C0.663004432%2C1.90364227%201.37074527%2C0.969817555%202.38967777%2C0.783115773%20C3.40861028%2C0.596413991%204.40146928%2C1.21863316%204.6777157%2C2.21701631%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var objectsIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FObjects%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FObjects%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%284.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.25%2C-0.75%20C7.78390769%2C-0.75%207.3417524%2C-0.543558852%207.0425%2C-0.186221415%20L-0.28283501%2C8.99420905%20C-0.907295844%2C9.75867898%20-0.907295844%2C10.8666129%20-0.277452456%2C11.6377502%20L7.03124832%2C20.7977495%20C7.3417524%2C21.1688507%207.78390769%2C21.3752919%208.25%2C21.3752919%20C8.71609231%2C21.3752919%209.1582476%2C21.1688507%209.4575%2C20.8115133%20L16.782835%2C11.6310828%20C17.4072958%2C10.8666129%2017.4072958%2C9.75867898%2016.7774525%2C8.98754163%20L9.46875168%2C-0.17245762%20C9.1582476%2C-0.543558852%208.71609231%2C-0.75%208.25%2C-0.75%20Z%20M8.25%2C0.75%20C8.27219487%2C0.75%208.29324989%2C0.759830531%208.3075%2C0.776846599%20L15.6103317%2C9.92974947%20C15.7945419%2C10.1553614%2015.7945419%2C10.4699305%2015.6157142%2C10.688875%20L8.29624832%2C19.862209%20L8.27118837%2C19.8726227%20C8.26466993%2C19.8741996%208.25739829%2C19.8752919%208.25%2C19.8752919%20C8.22780513%2C19.8752919%208.20675011%2C19.8654613%208.1925%2C19.8484453%20L0.889668343%2C10.6955424%20C0.705458074%2C10.4699305%200.705458074%2C10.1553614%200.884285789%2C9.93641689%20L8.20375168%2C0.763082805%20L8.22881163%2C0.752669111%20C8.23533007%2C0.751092281%208.24260171%2C0.75%208.25%2C0.75%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16.3568252%2C9.5782721%20C16.7634212%2C9.49919886%2017.1571339%2C9.76470851%2017.2362072%2C10.1713045%20C17.308691%2C10.5440175%2017.0916294%2C10.9059049%2016.7417667%2C11.0245378%20L16.6431748%2C11.0506864%20L11.8306748%2C11.9866031%20L11.6875%2C12.0003959%20L4.8125%2C12.0003959%20L4.66932524%2C11.9866031%20L-0.143174764%2C11.0506864%20C-0.549770753%2C10.9716132%20-0.815280402%2C10.5779005%20-0.736207163%2C10.1713045%20C-0.663723361%2C9.7985915%20-0.326855011%2C9.54443023%200.0419687965%2C9.56556483%20L0.143174764%2C9.5782721%20L4.883%2C10.5%20L11.616%2C10.5%20L16.3568252%2C9.5782721%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.53275993%2C-0.214511879%20L4.09525993%2C11.0311548%20C4.04748189%2C11.187459%204.05207089%2C11.3550922%204.10832867%2C11.5085485%20L7.54582867%2C20.8851318%20C7.78624682%2C21.5409284%208.71375318%2C21.5409284%208.95417133%2C20.8851318%20L12.3916713%2C11.5085485%20C12.4479291%2C11.3550922%2012.4525181%2C11.187459%2012.4047401%2C11.0311548%20L8.96724007%2C-0.214511879%20C8.75092166%2C-0.922190362%207.74907834%2C-0.922190362%207.53275993%2C-0.214511879%20Z%20M8.25%2C2.57%20L10.896%2C11.228%20L8.25%2C18.447%20L5.603%2C11.228%20L8.25%2C2.57%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var symbolsIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FSymbols%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FSymbols%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.9627806%2C13.203068%20L15.806%2C13.351%20L15.6530023%2C13.2053212%20C14.9231585%2C12.5182605%2013.9205546%2C12.2069478%2012.9330536%2C12.3593011%20C11.9455526%2C12.5116544%2011.0833949%2C13.1106657%2010.5961033%2C13.982971%20L10.4979137%2C14.1858502%20C10.0194632%2C15.3031918%2010.2486285%2C16.5666509%2011.05907%2C17.4237671%20L14.5223891%2C20.8579947%20C15.2427573%2C21.5564202%2016.3779752%2C21.5564202%2017.0923232%2C20.8638969%20L20.4336884%2C17.5446536%20C21.3991287%2C16.6491652%2021.6500901%2C15.1905772%2021.0280493%2C14.0011646%20L20.9132747%2C13.80896%20C20.3958102%2C13.018914%2019.5898662%2C12.4995125%2018.680745%2C12.3592848%20C17.6931574%2C12.2069541%2016.6904731%2C12.5182342%2015.9627806%2C13.203068%20Z%20M18.4520812%2C13.8417533%20C18.9408486%2C13.9171434%2019.3741932%2C14.1964182%2019.6447299%2C14.6090166%20L19.7221018%2C14.7375477%20C20.0074236%2C15.2863391%2019.88293%2C16.0098958%2019.3949011%2C16.4628619%20L16.0417108%2C19.7933224%20C15.9156902%2C19.9154151%2015.7050423%2C19.9154151%2015.5724899%2C19.7869124%20L12.2372601%2C16.4799813%20C11.7614079%2C16.0385652%2011.6209189%2C15.3731734%2011.8649318%2C14.8026067%20L11.9283001%2C14.6705817%20C12.1675547%2C14.2456296%2012.6309756%2C13.9236533%2013.16177%2C13.8417615%20C13.6925645%2C13.7598696%2014.231477%2C13.9272042%2014.6225373%2C14.2953358%20L15.2903135%2C14.9293214%20C15.5797407%2C15.2040991%2016.0336585%2C15.2040991%2016.3230857%2C14.9293214%20L16.993169%2C14.2931547%20C17.3431389%2C13.9638057%2017.8147961%2C13.7953111%2018.2927051%2C13.8246105%20L18.4520812%2C13.8417533%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3.52840931%2C11.4654124%20L0.183522691%2C14.7863449%20C-0.782062799%2C15.6819775%20-1.03302426%2C17.1405654%20-0.410983412%2C18.329978%20L-0.296208774%2C18.5221826%20C0.2212557%2C19.3122286%201.02719967%2C19.8316301%201.93632087%2C19.9718578%20L2.14807213%2C19.9974368%20C3.06574604%2C20.0778141%203.97857077%2C19.7639917%204.65428528%2C19.1280746%20L4.811%2C18.978%20L4.96921399%2C19.1272262%20C5.69757401%2C19.8128821%206.70017799%2C20.1241948%207.68767899%2C19.9718415%20C8.67517999%2C19.8194882%209.53733767%2C19.220477%2010.0246292%2C18.3481716%20L10.1228189%2C18.1452925%20C10.6012693%2C17.0279508%2010.372104%2C15.7644917%209.5616626%2C14.9073756%20L6.09232325%2C11.4654124%20C5.37797523%2C10.7728891%204.24275732%2C10.7728891%203.52840931%2C11.4654124%20Z%20M5.04824264%2C12.5423969%20L8.38332518%2C15.8510153%20C8.85932468%2C16.2925775%208.9998137%2C16.9579692%208.7558008%2C17.5285359%20L8.69243243%2C17.6605609%20C8.45317783%2C18.085513%207.989757%2C18.4074893%207.45896253%2C18.4893812%20C6.92816806%2C18.571273%206.38925553%2C18.4039384%205.99819522%2C18.0358068%20L5.32526856%2C17.4004164%20C5.03566777%2C17.1269702%204.58283493%2C17.1275871%204.2939802%2C17.4018212%20L3.62389687%2C18.0379879%20C3.23504142%2C18.4039312%202.69595471%2C18.5712889%202.16498464%2C18.4893893%20C1.67621732%2C18.4139992%201.24287273%2C18.1347245%200.972335968%2C17.722126%20L0.894964079%2C17.5935949%20C0.609642328%2C17.0448035%200.734135905%2C16.3212468%201.22216478%2C15.8682808%20L4.57887653%2C12.5361311%20C4.70504234%2C12.4138942%204.91569021%2C12.4138942%205.04824264%2C12.5423969%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.81036628%2C17.195738%20C5.19006204%2C17.195738%205.50385724%2C17.4778919%205.55351966%2C17.8439674%20L5.56036628%2C17.945738%20L5.56036628%2C20.6334046%20C5.56036628%2C21.0476182%205.22457984%2C21.3834046%204.81036628%2C21.3834046%20C4.43067051%2C21.3834046%204.11687532%2C21.1012508%204.06721289%2C20.7351752%20L4.06036628%2C20.6334046%20L4.06036628%2C17.945738%20C4.06036628%2C17.5315244%204.39615271%2C17.195738%204.81036628%2C17.195738%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.8103663%2C-0.75%20C14.4435612%2C-0.75%2013.2320663%2C0.129752794%2012.8090686%2C1.4294562%20L12.7546321%2C1.61589522%20C12.6092202%2C2.17727243%2012.6241806%2C2.75502086%2012.7805212%2C3.29054337%20L12.828%2C3.44%20L12.7747444%2C3.44994276%20C12.2020094%2C3.5660001%2011.6604099%2C3.84111525%2011.2194993%2C4.26341214%20C10.2886879%2C5.15492777%209.99388072%2C6.52305157%2010.474923%2C7.71879744%20C10.9559614%2C8.91453366%2012.1160681%2C9.69735007%2013.4049426%2C9.69596388%20L18.2166163%2C9.69596388%20C19.5054613%2C9.70185461%2020.6708238%2C8.91942972%2021.1545348%2C7.72107661%20C21.6382496%2C6.52271387%2021.3425699%2C5.15054143%2020.4082455%2C4.25774181%20L20.2570782%2C4.12227242%20C19.8445084%2C3.77572777%2019.3583324%2C3.54718455%2018.8477349%2C3.44492331%20L18.793%2C3.435%20L18.8402113%2C3.29054337%20C19.0139232%2C2.69551836%2019.0130915%2C2.04836258%2018.811664%2C1.4294562%20C18.3886662%2C0.129752794%2017.1771713%2C-0.75%2015.8103663%2C-0.75%20Z%20M15.8103663%2C0.75%20C16.5276006%2C0.75%2017.1633356%2C1.21165246%2017.3853047%2C1.89367504%20C17.5914189%2C2.52698172%2017.3972699%2C3.21665642%2016.9042266%2C3.64994205%20L16.7851877%2C3.7452374%20C16.0819991%2C4.257179%2016.667185%2C5.32372121%2017.444518%2C5.07042948%20L17.5386501%2C5.0335793%20C18.155313%2C4.7514423%2018.8816694%2C4.87372861%2019.3719584%2C5.34222742%20C19.8622475%2C5.81072623%2020.0174061%2C6.53077711%2019.7635755%2C7.15962093%20C19.5097452%2C7.78846433%2018.898207%2C8.1990513%2018.220059%2C8.19595595%20L13.4041163%2C8.19595595%20C12.727289%2C8.19667573%2012.1188293%2C7.78609949%2011.8665342%2C7.15895957%20C11.6142389%2C6.53181925%2011.7688583%2C5.81427079%2012.2570467%2C5.346692%20C12.7076822%2C4.91508081%2013.3588596%2C4.77661138%2013.9406246%2C4.97737794%20L14.0844635%2C5.03466367%20C14.8752842%2C5.39315078%2015.5146714%2C4.36148183%2014.9136865%2C3.80910266%20L14.8355448%2C3.7452374%20C14.2557002%2C3.32309376%2014.0134587%2C2.57569761%2014.2354279%2C1.89367504%20C14.457397%2C1.21165246%2015.0931319%2C0.75%2015.8103663%2C0.75%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.8103663%2C8.19590464%20C16.190062%2C8.19590464%2016.5038572%2C8.47805853%2016.5535197%2C8.84413409%20L16.5603663%2C8.94590464%20L16.5603663%2C10.3209046%20C16.5603663%2C10.7351182%2016.2245798%2C11.0709046%2015.8103663%2C11.0709046%20C15.4306705%2C11.0709046%2015.1168753%2C10.7887508%2015.0672129%2C10.4226752%20L15.0603663%2C10.3209046%20L15.0603663%2C8.94590464%20C15.0603663%2C8.53169108%2015.3961527%2C8.19590464%2015.8103663%2C8.19590464%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.24092382%2C-0.479688887%20L0.115923824%2C4.33281111%20C-0.124819573%2C4.61367841%20-0.124819573%2C5.02813088%200.115923824%2C5.30899817%20L4.24092382%2C10.1214982%20C4.5402455%2C10.4707068%205.08048705%2C10.4707068%205.37980873%2C10.1214982%20L9.50480873%2C5.30899817%20C9.74555213%2C5.02813088%209.74555213%2C4.61367841%209.50480873%2C4.33281111%20L5.37980873%2C-0.479688887%20C5.08048705%2C-0.828897513%204.5402455%2C-0.828897513%204.24092382%2C-0.479688887%20Z%20M4.81%2C1.16%20L7.947%2C4.82%20L4.809%2C8.481%20L1.672%2C4.82%20L4.81%2C1.16%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var flagsIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Emoji%2FFlags%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Emoji%2FFlags%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%281.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.458333333%2C-0.75%20C0.838029099%2C-0.75%201.15182429%2C-0.467846118%201.20148672%2C-0.101770557%20L1.20833333%2C0%20L1.20833333%2C20.625%20C1.20833333%2C21.0392136%200.872546896%2C21.375%200.458333333%2C21.375%20C0.0786375678%2C21.375%20-0.235157628%2C21.0928461%20-0.284820051%2C20.7267706%20L-0.291666667%2C20.625%20L-0.291666667%2C0%20C-0.291666667%2C-0.414213562%200.044119771%2C-0.75%200.458333333%2C-0.75%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.3966324%2C0.625%20C20.9623041%2C0.625603094%2021.4750351%2C0.957903189%2021.7066165%2C1.473999%20C21.9171451%2C1.94317701%2021.8597339%2C2.48494897%2021.5650253%2C2.89773292%20L21.4695245%2C3.01749688%20L17.7982717%2C7.14433333%20C17.610968%2C7.35487809%2017.5901565%2C7.66043107%2017.7361719%2C7.89246541%20L17.7987483%2C7.97570294%20L21.4653824%2C12.1052496%20C21.8409889%2C12.5282207%2021.9336146%2C13.1321552%2021.7020332%2C13.648251%20C21.4897502%2C14.1213388%2021.0412235%2C14.4399872%2020.5316165%2C14.4902745%20L20.39125%2C14.49725%20L0.458333333%2C14.49725%20C0.044119771%2C14.49725%20-0.291666667%2C14.1614636%20-0.291666667%2C13.74725%20C-0.291666667%2C13.3675542%20-0.00951278505%2C13.053759%200.356562776%2C13.0040966%20L0.458333333%2C12.99725%20L20.251%2C12.997%20L16.6775616%2C8.97216667%20C16.0009271%2C8.21157375%2015.9633363%2C7.08631251%2016.5647869%2C6.28520352%20L16.6775589%2C6.14733645%20L20.255%2C2.125%20L0.458333333%2C2.125%20C0.0786375678%2C2.125%20-0.235157628%2C1.84284612%20-0.284820051%2C1.47677056%20L-0.291666667%2C1.375%20C-0.291666667%2C0.995304234%20-0.00951278505%2C0.681509039%200.356562776%2C0.631846616%20L0.458333333%2C0.625%20L20.3966324%2C0.625%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const Emojis = [
    {
        people: {
            id: "people",
            name: "Smileys",
            symbol: smileyIcon,
            emojis: {
                grinning: {
                    keywords: ["face", "smile", "happy", "joy", ":D", "grin"],
                    char: "😀"
                },
                grimacing: {
                    keywords: ["face", "grimace", "teeth"],
                    char: "😬"
                },
                grin: {
                    keywords: ["face", "happy", "smile", "joy", "kawaii"],
                    char: "😁"
                },
                joy: {
                    keywords: [
                        "face",
                        "cry",
                        "tears",
                        "weep",
                        "happy",
                        "happytears",
                        "haha"
                    ],
                    char: "😂"
                },
                rofl: {
                    keywords: ["face", "rolling", "floor", "laughing", "lol", "haha"],
                    char: "🤣"
                },
                partying: {
                    keywords: ["face", "celebration", "woohoo"],
                    char: "🥳"
                },
                smiley: {
                    keywords: [
                        "face",
                        "happy",
                        "joy",
                        "haha",
                        ":D",
                        ":)",
                        "smile",
                        "funny"
                    ],
                    char: "😃"
                },
                smile: {
                    keywords: [
                        "face",
                        "happy",
                        "joy",
                        "funny",
                        "haha",
                        "laugh",
                        "like",
                        ":D",
                        ":)"
                    ],
                    char: "😄"
                },
                sweat_smile: {
                    keywords: [
                        "face",
                        "hot",
                        "happy",
                        "laugh",
                        "sweat",
                        "smile",
                        "relief"
                    ],
                    char: "😅"
                },
                laughing: {
                    keywords: [
                        "happy",
                        "joy",
                        "lol",
                        "satisfied",
                        "haha",
                        "face",
                        "glad",
                        "XD",
                        "laugh"
                    ],
                    char: "😆"
                },
                innocent: {
                    keywords: ["face", "angel", "heaven", "halo"],
                    char: "😇"
                },
                wink: {
                    keywords: [
                        "face",
                        "happy",
                        "mischievous",
                        "secret",
                        ";)",
                        "smile",
                        "eye"
                    ],
                    char: "😉"
                },
                blush: {
                    keywords: [
                        "face",
                        "smile",
                        "happy",
                        "flushed",
                        "crush",
                        "embarrassed",
                        "shy",
                        "joy"
                    ],
                    char: "😊"
                },
                slightly_smiling_face: {
                    keywords: ["face", "smile"],
                    char: "🙂"
                },
                upside_down_face: {
                    keywords: ["face", "flipped", "silly", "smile"],
                    char: "🙃"
                },
                relaxed: {
                    keywords: ["face", "blush", "massage", "happiness"],
                    char: "☺️"
                },
                yum: {
                    keywords: [
                        "happy",
                        "joy",
                        "tongue",
                        "smile",
                        "face",
                        "silly",
                        "yummy",
                        "nom",
                        "delicious",
                        "savouring"
                    ],
                    char: "😋"
                },
                relieved: {
                    keywords: ["face", "relaxed", "phew", "massage", "happiness"],
                    char: "😌"
                },
                heart_eyes: {
                    keywords: [
                        "face",
                        "love",
                        "like",
                        "affection",
                        "valentines",
                        "infatuation",
                        "crush",
                        "heart"
                    ],
                    char: "😍"
                },
                smiling_face_with_three_hearts: {
                    keywords: [
                        "face",
                        "love",
                        "like",
                        "affection",
                        "valentines",
                        "infatuation",
                        "crush",
                        "hearts",
                        "adore"
                    ],
                    char: "🥰"
                },
                kissing_heart: {
                    keywords: [
                        "face",
                        "love",
                        "like",
                        "affection",
                        "valentines",
                        "infatuation",
                        "kiss"
                    ],
                    char: "😘"
                },
                kissing: {
                    keywords: [
                        "love",
                        "like",
                        "face",
                        "3",
                        "valentines",
                        "infatuation",
                        "kiss"
                    ],
                    char: "😗"
                },
                kissing_smiling_eyes: {
                    keywords: ["face", "affection", "valentines", "infatuation", "kiss"],
                    char: "😙"
                },
                kissing_closed_eyes: {
                    keywords: [
                        "face",
                        "love",
                        "like",
                        "affection",
                        "valentines",
                        "infatuation",
                        "kiss"
                    ],
                    char: "😚"
                },
                stuck_out_tongue_winking_eye: {
                    keywords: [
                        "face",
                        "prank",
                        "childish",
                        "playful",
                        "mischievous",
                        "smile",
                        "wink",
                        "tongue"
                    ],
                    char: "😜"
                },
                zany: {
                    keywords: ["face", "goofy", "crazy"],
                    char: "🤪"
                },
                raised_eyebrow: {
                    keywords: [
                        "face",
                        "distrust",
                        "scepticism",
                        "disapproval",
                        "disbelief",
                        "surprise"
                    ],
                    char: "🤨"
                },
                monocle: {
                    keywords: ["face", "stuffy", "wealthy"],
                    char: "🧐"
                },
                stuck_out_tongue_closed_eyes: {
                    keywords: [
                        "face",
                        "prank",
                        "playful",
                        "mischievous",
                        "smile",
                        "tongue"
                    ],
                    char: "😝"
                },
                stuck_out_tongue: {
                    keywords: [
                        "face",
                        "prank",
                        "childish",
                        "playful",
                        "mischievous",
                        "smile",
                        "tongue"
                    ],
                    char: "😛"
                },
                money_mouth_face: {
                    keywords: ["face", "rich", "dollar", "money"],
                    char: "🤑"
                },
                nerd_face: {
                    keywords: ["face", "nerdy", "geek", "dork"],
                    char: "🤓"
                },
                sunglasses: {
                    keywords: ["face", "cool", "smile", "summer", "beach", "sunglass"],
                    char: "😎"
                },
                star_struck: {
                    keywords: ["face", "smile", "starry", "eyes", "grinning"],
                    char: "🤩"
                },
                clown_face: {
                    keywords: ["face"],
                    char: "🤡"
                },
                cowboy_hat_face: {
                    keywords: ["face", "cowgirl", "hat"],
                    char: "🤠"
                },
                hugs: {
                    keywords: ["face", "smile", "hug"],
                    char: "🤗"
                },
                smirk: {
                    keywords: ["face", "smile", "mean", "prank", "smug", "sarcasm"],
                    char: "😏"
                },
                no_mouth: {
                    keywords: ["face", "hellokitty"],
                    char: "😶"
                },
                neutral_face: {
                    keywords: ["indifference", "meh", ":|", "neutral"],
                    char: "😐"
                },
                expressionless: {
                    keywords: ["face", "indifferent", "-_-", "meh", "deadpan"],
                    char: "😑"
                },
                unamused: {
                    keywords: [
                        "indifference",
                        "bored",
                        "straight face",
                        "serious",
                        "sarcasm",
                        "unimpressed",
                        "skeptical",
                        "dubious",
                        "side_eye"
                    ],
                    char: "😒"
                },
                roll_eyes: {
                    keywords: ["face", "eyeroll", "frustrated"],
                    char: "🙄"
                },
                thinking: {
                    keywords: ["face", "hmmm", "think", "consider"],
                    char: "🤔"
                },
                lying_face: {
                    keywords: ["face", "lie", "pinocchio"],
                    char: "🤥"
                },
                hand_over_mouth: {
                    keywords: ["face", "whoops", "shock", "surprise"],
                    char: "🤭"
                },
                shushing: {
                    keywords: ["face", "quiet", "shhh"],
                    char: "🤫"
                },
                symbols_over_mouth: {
                    keywords: [
                        "face",
                        "swearing",
                        "cursing",
                        "cussing",
                        "profanity",
                        "expletive"
                    ],
                    char: "🤬"
                },
                exploding_head: {
                    keywords: ["face", "shocked", "mind", "blown"],
                    char: "🤯"
                },
                flushed: {
                    keywords: ["face", "blush", "shy", "flattered"],
                    char: "😳"
                },
                disappointed: {
                    keywords: ["face", "sad", "upset", "depressed", ":("],
                    char: "😞"
                },
                worried: {
                    keywords: ["face", "concern", "nervous", ":("],
                    char: "😟"
                },
                angry: {
                    keywords: ["mad", "face", "annoyed", "frustrated"],
                    char: "😠"
                },
                rage: {
                    keywords: ["angry", "mad", "hate", "despise"],
                    char: "😡"
                },
                pensive: {
                    keywords: ["face", "sad", "depressed", "upset"],
                    char: "😔"
                },
                confused: {
                    keywords: ["face", "indifference", "huh", "weird", "hmmm", ":/"],
                    char: "😕"
                },
                slightly_frowning_face: {
                    keywords: ["face", "frowning", "disappointed", "sad", "upset"],
                    char: "🙁"
                },
                frowning_face: {
                    keywords: ["face", "sad", "upset", "frown"],
                    char: "☹️"
                },
                persevere: {
                    keywords: ["face", "sick", "no", "upset", "oops"],
                    char: "😣"
                },
                confounded: {
                    keywords: ["face", "confused", "sick", "unwell", "oops", ":S"],
                    char: "😖"
                },
                tired_face: {
                    keywords: ["sick", "whine", "upset", "frustrated"],
                    char: "😫"
                },
                weary: {
                    keywords: ["face", "tired", "sleepy", "sad", "frustrated", "upset"],
                    char: "😩"
                },
                pleading: {
                    keywords: ["face", "begging", "mercy"],
                    char: "🥺"
                },
                triumph: {
                    keywords: ["face", "gas", "phew", "proud", "pride"],
                    char: "😤"
                },
                open_mouth: {
                    keywords: ["face", "surprise", "impressed", "wow", "whoa", ":O"],
                    char: "😮"
                },
                scream: {
                    keywords: ["face", "munch", "scared", "omg"],
                    char: "😱"
                },
                fearful: {
                    keywords: ["face", "scared", "terrified", "nervous", "oops", "huh"],
                    char: "😨"
                },
                cold_sweat: {
                    keywords: ["face", "nervous", "sweat"],
                    char: "😰"
                },
                hushed: {
                    keywords: ["face", "woo", "shh"],
                    char: "😯"
                },
                frowning: {
                    keywords: ["face", "aw", "what"],
                    char: "😦"
                },
                anguished: {
                    keywords: ["face", "stunned", "nervous"],
                    char: "😧"
                },
                cry: {
                    keywords: ["face", "tears", "sad", "depressed", "upset", ":'("],
                    char: "😢"
                },
                disappointed_relieved: {
                    keywords: ["face", "phew", "sweat", "nervous"],
                    char: "😥"
                },
                drooling_face: {
                    keywords: ["face"],
                    char: "🤤"
                },
                sleepy: {
                    keywords: ["face", "tired", "rest", "nap"],
                    char: "😪"
                },
                sweat: {
                    keywords: ["face", "hot", "sad", "tired", "exercise"],
                    char: "😓"
                },
                hot: {
                    keywords: ["face", "feverish", "heat", "red", "sweating"],
                    char: "🥵"
                },
                cold: {
                    keywords: [
                        "face",
                        "blue",
                        "freezing",
                        "frozen",
                        "frostbite",
                        "icicles"
                    ],
                    char: "🥶"
                },
                sob: {
                    keywords: ["face", "cry", "tears", "sad", "upset", "depressed"],
                    char: "😭"
                },
                dizzy_face: {
                    keywords: ["spent", "unconscious", "xox", "dizzy"],
                    char: "😵"
                },
                astonished: {
                    keywords: ["face", "xox", "surprised", "poisoned"],
                    char: "😲"
                },
                zipper_mouth_face: {
                    keywords: ["face", "sealed", "zipper", "secret"],
                    char: "🤐"
                },
                nauseated_face: {
                    keywords: [
                        "face",
                        "vomit",
                        "gross",
                        "green",
                        "sick",
                        "throw up",
                        "ill"
                    ],
                    char: "🤢"
                },
                sneezing_face: {
                    keywords: ["face", "gesundheit", "sneeze", "sick", "allergy"],
                    char: "🤧"
                },
                vomiting: {
                    keywords: ["face", "sick"],
                    char: "🤮"
                },
                mask: {
                    keywords: ["face", "sick", "ill", "disease"],
                    char: "😷"
                },
                face_with_thermometer: {
                    keywords: ["sick", "temperature", "thermometer", "cold", "fever"],
                    char: "🤒"
                },
                face_with_head_bandage: {
                    keywords: ["injured", "clumsy", "bandage", "hurt"],
                    char: "🤕"
                },
                woozy: {
                    keywords: ["face", "dizzy", "intoxicated", "tipsy", "wavy"],
                    char: "🥴"
                },
                sleeping: {
                    keywords: ["face", "tired", "sleepy", "night", "zzz"],
                    char: "😴"
                },
                zzz: {
                    keywords: ["sleepy", "tired", "dream"],
                    char: "💤"
                },
                poop: {
                    keywords: ["hankey", "shitface", "fail", "turd", "shit"],
                    char: "💩"
                },
                smiling_imp: {
                    keywords: ["devil", "horns"],
                    char: "😈"
                },
                imp: {
                    keywords: ["devil", "angry", "horns"],
                    char: "👿"
                },
                japanese_ogre: {
                    keywords: [
                        "monster",
                        "red",
                        "mask",
                        "halloween",
                        "scary",
                        "creepy",
                        "devil",
                        "demon",
                        "japanese",
                        "ogre"
                    ],
                    char: "👹"
                },
                japanese_goblin: {
                    keywords: [
                        "red",
                        "evil",
                        "mask",
                        "monster",
                        "scary",
                        "creepy",
                        "japanese",
                        "goblin"
                    ],
                    char: "👺"
                },
                skull: {
                    keywords: ["dead", "skeleton", "creepy", "death"],
                    char: "💀"
                },
                ghost: {
                    keywords: ["halloween", "spooky", "scary"],
                    char: "👻"
                },
                alien: {
                    keywords: ["UFO", "paul", "weird", "outer_space"],
                    char: "👽"
                },
                robot: {
                    keywords: ["computer", "machine", "bot"],
                    char: "🤖"
                },
                smiley_cat: {
                    keywords: ["animal", "cats", "happy", "smile"],
                    char: "😺"
                },
                smile_cat: {
                    keywords: ["animal", "cats", "smile"],
                    char: "😸"
                },
                joy_cat: {
                    keywords: ["animal", "cats", "haha", "happy", "tears"],
                    char: "😹"
                },
                heart_eyes_cat: {
                    keywords: [
                        "animal",
                        "love",
                        "like",
                        "affection",
                        "cats",
                        "valentines",
                        "heart"
                    ],
                    char: "😻"
                },
                smirk_cat: {
                    keywords: ["animal", "cats", "smirk"],
                    char: "😼"
                },
                kissing_cat: {
                    keywords: ["animal", "cats", "kiss"],
                    char: "😽"
                },
                scream_cat: {
                    keywords: ["animal", "cats", "munch", "scared", "scream"],
                    char: "🙀"
                },
                crying_cat_face: {
                    keywords: ["animal", "tears", "weep", "sad", "cats", "upset", "cry"],
                    char: "😿"
                },
                pouting_cat: {
                    keywords: ["animal", "cats"],
                    char: "😾"
                },
                palms_up: {
                    keywords: ["hands", "gesture", "cupped", "prayer"],
                    char: "🤲",
                    fitzpatrick_scale: true
                },
                raised_hands: {
                    keywords: ["gesture", "hooray", "yea", "celebration", "hands"],
                    char: "🙌",
                    fitzpatrick_scale: true
                },
                clap: {
                    keywords: ["hands", "praise", "applause", "congrats", "yay"],
                    char: "👏",
                    fitzpatrick_scale: true
                },
                wave: {
                    keywords: [
                        "hands",
                        "gesture",
                        "goodbye",
                        "solong",
                        "farewell",
                        "hello",
                        "hi",
                        "palm"
                    ],
                    char: "👋",
                    fitzpatrick_scale: true
                },
                call_me_hand: {
                    keywords: ["hands", "gesture"],
                    char: "🤙",
                    fitzpatrick_scale: true
                },
                "+1": {
                    keywords: [
                        "thumbsup",
                        "yes",
                        "awesome",
                        "good",
                        "agree",
                        "accept",
                        "cool",
                        "hand",
                        "like"
                    ],
                    char: "👍",
                    fitzpatrick_scale: true
                },
                "-1": {
                    keywords: ["thumbsdown", "no", "dislike", "hand"],
                    char: "👎",
                    fitzpatrick_scale: true
                },
                facepunch: {
                    keywords: ["angry", "violence", "fist", "hit", "attack", "hand"],
                    char: "👊",
                    fitzpatrick_scale: true
                },
                fist: {
                    keywords: ["fingers", "hand", "grasp"],
                    char: "✊",
                    fitzpatrick_scale: true
                },
                fist_left: {
                    keywords: ["hand", "fistbump"],
                    char: "🤛",
                    fitzpatrick_scale: true
                },
                fist_right: {
                    keywords: ["hand", "fistbump"],
                    char: "🤜",
                    fitzpatrick_scale: true
                },
                v: {
                    keywords: ["fingers", "ohyeah", "hand", "peace", "victory", "two"],
                    char: "✌",
                    fitzpatrick_scale: true
                },
                ok_hand: {
                    keywords: ["fingers", "limbs", "perfect", "ok", "okay"],
                    char: "👌",
                    fitzpatrick_scale: true
                },
                raised_hand: {
                    keywords: ["fingers", "stop", "highfive", "palm", "ban"],
                    char: "✋",
                    fitzpatrick_scale: true
                },
                raised_back_of_hand: {
                    keywords: ["fingers", "raised", "backhand"],
                    char: "🤚",
                    fitzpatrick_scale: true
                },
                open_hands: {
                    keywords: ["fingers", "butterfly", "hands", "open"],
                    char: "👐",
                    fitzpatrick_scale: true
                },
                muscle: {
                    keywords: ["arm", "flex", "hand", "summer", "strong", "biceps"],
                    char: "💪",
                    fitzpatrick_scale: true
                },
                pray: {
                    keywords: ["please", "hope", "wish", "namaste", "highfive"],
                    char: "🙏",
                    fitzpatrick_scale: true
                },
                foot: {
                    keywords: ["kick", "stomp"],
                    char: "🦶",
                    fitzpatrick_scale: true
                },
                leg: {
                    keywords: ["kick", "limb"],
                    char: "🦵",
                    fitzpatrick_scale: true
                },
                handshake: {
                    keywords: ["agreement", "shake"],
                    char: "🤝"
                },
                point_up: {
                    keywords: ["hand", "fingers", "direction", "up"],
                    char: "☝",
                    fitzpatrick_scale: true
                },
                point_up_2: {
                    keywords: ["fingers", "hand", "direction", "up"],
                    char: "👆",
                    fitzpatrick_scale: true
                },
                point_down: {
                    keywords: ["fingers", "hand", "direction", "down"],
                    char: "👇",
                    fitzpatrick_scale: true
                },
                point_left: {
                    keywords: ["direction", "fingers", "hand", "left"],
                    char: "👈",
                    fitzpatrick_scale: true
                },
                point_right: {
                    keywords: ["fingers", "hand", "direction", "right"],
                    char: "👉",
                    fitzpatrick_scale: true
                },
                fu: {
                    keywords: ["hand", "fingers", "rude", "middle", "flipping"],
                    char: "🖕",
                    fitzpatrick_scale: true
                },
                raised_hand_with_fingers_splayed: {
                    keywords: ["hand", "fingers", "palm"],
                    char: "🖐",
                    fitzpatrick_scale: true
                },
                love_you: {
                    keywords: ["hand", "fingers", "gesture"],
                    char: "🤟",
                    fitzpatrick_scale: true
                },
                metal: {
                    keywords: ["hand", "fingers", "evil_eye", "sign_of_horns", "rock_on"],
                    char: "🤘",
                    fitzpatrick_scale: true
                },
                crossed_fingers: {
                    keywords: ["good", "lucky"],
                    char: "🤞",
                    fitzpatrick_scale: true
                },
                vulcan_salute: {
                    keywords: ["hand", "fingers", "spock", "star trek"],
                    char: "🖖",
                    fitzpatrick_scale: true
                },
                writing_hand: {
                    keywords: [
                        "lower_left_ballpoint_pen",
                        "stationery",
                        "write",
                        "compose"
                    ],
                    char: "✍",
                    fitzpatrick_scale: true
                },
                selfie: {
                    keywords: ["camera", "phone"],
                    char: "🤳",
                    fitzpatrick_scale: true
                },
                nail_care: {
                    keywords: ["beauty", "manicure", "finger", "fashion", "nail"],
                    char: "💅",
                    fitzpatrick_scale: true
                },
                lips: {
                    keywords: ["mouth", "kiss"],
                    char: "👄"
                },
                tooth: {
                    keywords: ["teeth", "dentist"],
                    char: "🦷"
                },
                tongue: {
                    keywords: ["mouth", "playful"],
                    char: "👅"
                },
                ear: {
                    keywords: ["face", "hear", "sound", "listen"],
                    char: "👂",
                    fitzpatrick_scale: true
                },
                nose: {
                    keywords: ["smell", "sniff"],
                    char: "👃",
                    fitzpatrick_scale: true
                },
                eye: {
                    keywords: ["face", "look", "see", "watch", "stare"],
                    char: "👁"
                },
                eyes: {
                    keywords: ["look", "watch", "stalk", "peek", "see"],
                    char: "👀"
                },
                brain: {
                    keywords: ["smart", "intelligent"],
                    char: "🧠"
                },
                bust_in_silhouette: {
                    keywords: ["user", "person", "human"],
                    char: "👤"
                },
                busts_in_silhouette: {
                    keywords: ["user", "person", "human", "group", "team"],
                    char: "👥"
                },
                speaking_head: {
                    keywords: ["user", "person", "human", "sing", "say", "talk"],
                    char: "🗣"
                },
                baby: {
                    keywords: ["child", "boy", "girl", "toddler"],
                    char: "👶",
                    fitzpatrick_scale: true
                },
                child: {
                    keywords: ["gender-neutral", "young"],
                    char: "🧒",
                    fitzpatrick_scale: true
                },
                boy: {
                    keywords: ["man", "male", "guy", "teenager"],
                    char: "👦",
                    fitzpatrick_scale: true
                },
                girl: {
                    keywords: ["female", "woman", "teenager"],
                    char: "👧",
                    fitzpatrick_scale: true
                },
                adult: {
                    keywords: ["gender-neutral", "person"],
                    char: "🧑",
                    fitzpatrick_scale: true
                },
                man: {
                    keywords: [
                        "mustache",
                        "father",
                        "dad",
                        "guy",
                        "classy",
                        "sir",
                        "moustache"
                    ],
                    char: "👨",
                    fitzpatrick_scale: true
                },
                woman: {
                    keywords: ["female", "girls", "lady"],
                    char: "👩",
                    fitzpatrick_scale: true
                },
                blonde_woman: {
                    keywords: ["woman", "female", "girl", "blonde", "person"],
                    char: "👱‍♀️",
                    fitzpatrick_scale: true
                },
                blonde_man: {
                    keywords: ["man", "male", "boy", "blonde", "guy", "person"],
                    char: "👱",
                    fitzpatrick_scale: true
                },
                bearded_person: {
                    keywords: ["person", "bewhiskered"],
                    char: "🧔",
                    fitzpatrick_scale: true
                },
                older_adult: {
                    keywords: ["human", "elder", "senior", "gender-neutral"],
                    char: "🧓",
                    fitzpatrick_scale: true
                },
                older_man: {
                    keywords: ["human", "male", "men", "old", "elder", "senior"],
                    char: "👴",
                    fitzpatrick_scale: true
                },
                older_woman: {
                    keywords: [
                        "human",
                        "female",
                        "women",
                        "lady",
                        "old",
                        "elder",
                        "senior"
                    ],
                    char: "👵",
                    fitzpatrick_scale: true
                },
                man_with_gua_pi_mao: {
                    keywords: ["male", "boy", "chinese"],
                    char: "👲",
                    fitzpatrick_scale: true
                },
                woman_with_headscarf: {
                    keywords: ["female", "hijab", "mantilla", "tichel"],
                    char: "🧕",
                    fitzpatrick_scale: true
                },
                woman_with_turban: {
                    keywords: ["female", "indian", "hinduism", "arabs", "woman"],
                    char: "👳‍♀️",
                    fitzpatrick_scale: true
                },
                man_with_turban: {
                    keywords: ["male", "indian", "hinduism", "arabs"],
                    char: "👳",
                    fitzpatrick_scale: true
                },
                policewoman: {
                    keywords: [
                        "woman",
                        "police",
                        "law",
                        "legal",
                        "enforcement",
                        "arrest",
                        "911",
                        "female"
                    ],
                    char: "👮‍♀️",
                    fitzpatrick_scale: true
                },
                policeman: {
                    keywords: [
                        "man",
                        "police",
                        "law",
                        "legal",
                        "enforcement",
                        "arrest",
                        "911"
                    ],
                    char: "👮",
                    fitzpatrick_scale: true
                },
                construction_worker_woman: {
                    keywords: [
                        "female",
                        "human",
                        "wip",
                        "build",
                        "construction",
                        "worker",
                        "labor",
                        "woman"
                    ],
                    char: "👷‍♀️",
                    fitzpatrick_scale: true
                },
                construction_worker_man: {
                    keywords: [
                        "male",
                        "human",
                        "wip",
                        "guy",
                        "build",
                        "construction",
                        "worker",
                        "labor"
                    ],
                    char: "👷",
                    fitzpatrick_scale: true
                },
                guardswoman: {
                    keywords: ["uk", "gb", "british", "female", "royal", "woman"],
                    char: "💂‍♀️",
                    fitzpatrick_scale: true
                },
                guardsman: {
                    keywords: ["uk", "gb", "british", "male", "guy", "royal"],
                    char: "💂",
                    fitzpatrick_scale: true
                },
                female_detective: {
                    keywords: ["human", "spy", "detective", "female", "woman"],
                    char: "🕵️‍♀️",
                    fitzpatrick_scale: true
                },
                male_detective: {
                    keywords: ["human", "spy", "detective"],
                    char: "🕵",
                    fitzpatrick_scale: true
                },
                woman_health_worker: {
                    keywords: [
                        "doctor",
                        "nurse",
                        "therapist",
                        "healthcare",
                        "woman",
                        "human"
                    ],
                    char: "👩‍⚕️",
                    fitzpatrick_scale: true
                },
                man_health_worker: {
                    keywords: [
                        "doctor",
                        "nurse",
                        "therapist",
                        "healthcare",
                        "man",
                        "human"
                    ],
                    char: "👨‍⚕️",
                    fitzpatrick_scale: true
                },
                woman_farmer: {
                    keywords: ["rancher", "gardener", "woman", "human"],
                    char: "👩‍🌾",
                    fitzpatrick_scale: true
                },
                man_farmer: {
                    keywords: ["rancher", "gardener", "man", "human"],
                    char: "👨‍🌾",
                    fitzpatrick_scale: true
                },
                woman_cook: {
                    keywords: ["chef", "woman", "human"],
                    char: "👩‍🍳",
                    fitzpatrick_scale: true
                },
                man_cook: {
                    keywords: ["chef", "man", "human"],
                    char: "👨‍🍳",
                    fitzpatrick_scale: true
                },
                woman_student: {
                    keywords: ["graduate", "woman", "human"],
                    char: "👩‍🎓",
                    fitzpatrick_scale: true
                },
                man_student: {
                    keywords: ["graduate", "man", "human"],
                    char: "👨‍🎓",
                    fitzpatrick_scale: true
                },
                woman_singer: {
                    keywords: ["rockstar", "entertainer", "woman", "human"],
                    char: "👩‍🎤",
                    fitzpatrick_scale: true
                },
                man_singer: {
                    keywords: ["rockstar", "entertainer", "man", "human"],
                    char: "👨‍🎤",
                    fitzpatrick_scale: true
                },
                woman_teacher: {
                    keywords: ["instructor", "professor", "woman", "human"],
                    char: "👩‍🏫",
                    fitzpatrick_scale: true
                },
                man_teacher: {
                    keywords: ["instructor", "professor", "man", "human"],
                    char: "👨‍🏫",
                    fitzpatrick_scale: true
                },
                woman_factory_worker: {
                    keywords: ["assembly", "industrial", "woman", "human"],
                    char: "👩‍🏭",
                    fitzpatrick_scale: true
                },
                man_factory_worker: {
                    keywords: ["assembly", "industrial", "man", "human"],
                    char: "👨‍🏭",
                    fitzpatrick_scale: true
                },
                woman_technologist: {
                    keywords: [
                        "coder",
                        "developer",
                        "engineer",
                        "programmer",
                        "software",
                        "woman",
                        "human",
                        "laptop",
                        "computer"
                    ],
                    char: "👩‍💻",
                    fitzpatrick_scale: true
                },
                man_technologist: {
                    keywords: [
                        "coder",
                        "developer",
                        "engineer",
                        "programmer",
                        "software",
                        "man",
                        "human",
                        "laptop",
                        "computer"
                    ],
                    char: "👨‍💻",
                    fitzpatrick_scale: true
                },
                woman_office_worker: {
                    keywords: ["business", "manager", "woman", "human"],
                    char: "👩‍💼",
                    fitzpatrick_scale: true
                },
                man_office_worker: {
                    keywords: ["business", "manager", "man", "human"],
                    char: "👨‍💼",
                    fitzpatrick_scale: true
                },
                woman_mechanic: {
                    keywords: ["plumber", "woman", "human", "wrench"],
                    char: "👩‍🔧",
                    fitzpatrick_scale: true
                },
                man_mechanic: {
                    keywords: ["plumber", "man", "human", "wrench"],
                    char: "👨‍🔧",
                    fitzpatrick_scale: true
                },
                woman_scientist: {
                    keywords: [
                        "biologist",
                        "chemist",
                        "engineer",
                        "physicist",
                        "woman",
                        "human"
                    ],
                    char: "👩‍🔬",
                    fitzpatrick_scale: true
                },
                man_scientist: {
                    keywords: [
                        "biologist",
                        "chemist",
                        "engineer",
                        "physicist",
                        "man",
                        "human"
                    ],
                    char: "👨‍🔬",
                    fitzpatrick_scale: true
                },
                woman_artist: {
                    keywords: ["painter", "woman", "human"],
                    char: "👩‍🎨",
                    fitzpatrick_scale: true
                },
                man_artist: {
                    keywords: ["painter", "man", "human"],
                    char: "👨‍🎨",
                    fitzpatrick_scale: true
                },
                woman_firefighter: {
                    keywords: ["fireman", "woman", "human"],
                    char: "👩‍🚒",
                    fitzpatrick_scale: true
                },
                man_firefighter: {
                    keywords: ["fireman", "man", "human"],
                    char: "👨‍🚒",
                    fitzpatrick_scale: true
                },
                woman_pilot: {
                    keywords: ["aviator", "plane", "woman", "human"],
                    char: "👩‍✈️",
                    fitzpatrick_scale: true
                },
                man_pilot: {
                    keywords: ["aviator", "plane", "man", "human"],
                    char: "👨‍✈️",
                    fitzpatrick_scale: true
                },
                woman_astronaut: {
                    keywords: ["space", "rocket", "woman", "human"],
                    char: "👩‍🚀",
                    fitzpatrick_scale: true
                },
                man_astronaut: {
                    keywords: ["space", "rocket", "man", "human"],
                    char: "👨‍🚀",
                    fitzpatrick_scale: true
                },
                woman_judge: {
                    keywords: ["justice", "court", "woman", "human"],
                    char: "👩‍⚖️",
                    fitzpatrick_scale: true
                },
                man_judge: {
                    keywords: ["justice", "court", "man", "human"],
                    char: "👨‍⚖️",
                    fitzpatrick_scale: true
                },
                woman_superhero: {
                    keywords: ["woman", "female", "good", "heroine", "superpowers"],
                    char: "🦸‍♀️",
                    fitzpatrick_scale: true
                },
                man_superhero: {
                    keywords: ["man", "male", "good", "hero", "superpowers"],
                    char: "🦸‍♂️",
                    fitzpatrick_scale: true
                },
                woman_supervillain: {
                    keywords: [
                        "woman",
                        "female",
                        "evil",
                        "bad",
                        "criminal",
                        "heroine",
                        "superpowers"
                    ],
                    char: "🦹‍♀️",
                    fitzpatrick_scale: true
                },
                man_supervillain: {
                    keywords: [
                        "man",
                        "male",
                        "evil",
                        "bad",
                        "criminal",
                        "hero",
                        "superpowers"
                    ],
                    char: "🦹‍♂️",
                    fitzpatrick_scale: true
                },
                mrs_claus: {
                    keywords: ["woman", "female", "xmas", "mother christmas"],
                    char: "🤶",
                    fitzpatrick_scale: true
                },
                santa: {
                    keywords: ["festival", "man", "male", "xmas", "father christmas"],
                    char: "🎅",
                    fitzpatrick_scale: true
                },
                sorceress: {
                    keywords: ["woman", "female", "mage", "witch"],
                    char: "🧙‍♀️",
                    fitzpatrick_scale: true
                },
                wizard: {
                    keywords: ["man", "male", "mage", "sorcerer"],
                    char: "🧙‍♂️",
                    fitzpatrick_scale: true
                },
                woman_elf: {
                    keywords: ["woman", "female"],
                    char: "🧝‍♀️",
                    fitzpatrick_scale: true
                },
                man_elf: {
                    keywords: ["man", "male"],
                    char: "🧝‍♂️",
                    fitzpatrick_scale: true
                },
                woman_vampire: {
                    keywords: ["woman", "female"],
                    char: "🧛‍♀️",
                    fitzpatrick_scale: true
                },
                man_vampire: {
                    keywords: ["man", "male", "dracula"],
                    char: "🧛‍♂️",
                    fitzpatrick_scale: true
                },
                woman_zombie: {
                    keywords: ["woman", "female", "undead", "walking dead"],
                    char: "🧟‍♀️"
                },
                man_zombie: {
                    keywords: ["man", "male", "dracula", "undead", "walking dead"],
                    char: "🧟‍♂️"
                },
                woman_genie: {
                    keywords: ["woman", "female"],
                    char: "🧞‍♀️"
                },
                man_genie: {
                    keywords: ["man", "male"],
                    char: "🧞‍♂️"
                },
                mermaid: {
                    keywords: ["woman", "female", "merwoman", "ariel"],
                    char: "🧜‍♀️",
                    fitzpatrick_scale: true
                },
                merman: {
                    keywords: ["man", "male", "triton"],
                    char: "🧜‍♂️",
                    fitzpatrick_scale: true
                },
                woman_fairy: {
                    keywords: ["woman", "female"],
                    char: "🧚‍♀️",
                    fitzpatrick_scale: true
                },
                man_fairy: {
                    keywords: ["man", "male"],
                    char: "🧚‍♂️",
                    fitzpatrick_scale: true
                },
                angel: {
                    keywords: ["heaven", "wings", "halo"],
                    char: "👼",
                    fitzpatrick_scale: true
                },
                pregnant_woman: {
                    keywords: ["baby"],
                    char: "🤰",
                    fitzpatrick_scale: true
                },
                breastfeeding: {
                    keywords: ["nursing", "baby"],
                    char: "🤱",
                    fitzpatrick_scale: true
                },
                princess: {
                    keywords: [
                        "girl",
                        "woman",
                        "female",
                        "blond",
                        "crown",
                        "royal",
                        "queen"
                    ],
                    char: "👸",
                    fitzpatrick_scale: true
                },
                prince: {
                    keywords: ["boy", "man", "male", "crown", "royal", "king"],
                    char: "🤴",
                    fitzpatrick_scale: true
                },
                bride_with_veil: {
                    keywords: ["couple", "marriage", "wedding", "woman", "bride"],
                    char: "👰",
                    fitzpatrick_scale: true
                },
                man_in_tuxedo: {
                    keywords: ["couple", "marriage", "wedding", "groom"],
                    char: "🤵",
                    fitzpatrick_scale: true
                },
                running_woman: {
                    keywords: [
                        "woman",
                        "walking",
                        "exercise",
                        "race",
                        "running",
                        "female"
                    ],
                    char: "🏃‍♀️",
                    fitzpatrick_scale: true
                },
                running_man: {
                    keywords: ["man", "walking", "exercise", "race", "running"],
                    char: "🏃",
                    fitzpatrick_scale: true
                },
                walking_woman: {
                    keywords: ["human", "feet", "steps", "woman", "female"],
                    char: "🚶‍♀️",
                    fitzpatrick_scale: true
                },
                walking_man: {
                    keywords: ["human", "feet", "steps"],
                    char: "🚶",
                    fitzpatrick_scale: true
                },
                dancer: {
                    keywords: ["female", "girl", "woman", "fun"],
                    char: "💃",
                    fitzpatrick_scale: true
                },
                man_dancing: {
                    keywords: ["male", "boy", "fun", "dancer"],
                    char: "🕺",
                    fitzpatrick_scale: true
                },
                dancing_women: {
                    keywords: ["female", "bunny", "women", "girls"],
                    char: "👯"
                },
                dancing_men: {
                    keywords: ["male", "bunny", "men", "boys"],
                    char: "👯‍♂️"
                },
                couple: {
                    keywords: [
                        "pair",
                        "people",
                        "human",
                        "love",
                        "date",
                        "dating",
                        "like",
                        "affection",
                        "valentines",
                        "marriage"
                    ],
                    char: "👫"
                },
                two_men_holding_hands: {
                    keywords: [
                        "pair",
                        "couple",
                        "love",
                        "like",
                        "bromance",
                        "friendship",
                        "people",
                        "human"
                    ],
                    char: "👬"
                },
                two_women_holding_hands: {
                    keywords: [
                        "pair",
                        "friendship",
                        "couple",
                        "love",
                        "like",
                        "female",
                        "people",
                        "human"
                    ],
                    char: "👭"
                },
                bowing_woman: {
                    keywords: ["woman", "female", "girl"],
                    char: "🙇‍♀️",
                    fitzpatrick_scale: true
                },
                bowing_man: {
                    keywords: ["man", "male", "boy"],
                    char: "🙇",
                    fitzpatrick_scale: true
                },
                man_facepalming: {
                    keywords: ["man", "male", "boy", "disbelief"],
                    char: "🤦‍♂️",
                    fitzpatrick_scale: true
                },
                woman_facepalming: {
                    keywords: ["woman", "female", "girl", "disbelief"],
                    char: "🤦‍♀️",
                    fitzpatrick_scale: true
                },
                woman_shrugging: {
                    keywords: [
                        "woman",
                        "female",
                        "girl",
                        "confused",
                        "indifferent",
                        "doubt"
                    ],
                    char: "🤷",
                    fitzpatrick_scale: true
                },
                man_shrugging: {
                    keywords: ["man", "male", "boy", "confused", "indifferent", "doubt"],
                    char: "🤷‍♂️",
                    fitzpatrick_scale: true
                },
                tipping_hand_woman: {
                    keywords: ["female", "girl", "woman", "human", "information"],
                    char: "💁",
                    fitzpatrick_scale: true
                },
                tipping_hand_man: {
                    keywords: ["male", "boy", "man", "human", "information"],
                    char: "💁‍♂️",
                    fitzpatrick_scale: true
                },
                no_good_woman: {
                    keywords: ["female", "girl", "woman", "nope"],
                    char: "🙅",
                    fitzpatrick_scale: true
                },
                no_good_man: {
                    keywords: ["male", "boy", "man", "nope"],
                    char: "🙅‍♂️",
                    fitzpatrick_scale: true
                },
                ok_woman: {
                    keywords: ["women", "girl", "female", "pink", "human", "woman"],
                    char: "🙆",
                    fitzpatrick_scale: true
                },
                ok_man: {
                    keywords: ["men", "boy", "male", "blue", "human", "man"],
                    char: "🙆‍♂️",
                    fitzpatrick_scale: true
                },
                raising_hand_woman: {
                    keywords: ["female", "girl", "woman"],
                    char: "🙋",
                    fitzpatrick_scale: true
                },
                raising_hand_man: {
                    keywords: ["male", "boy", "man"],
                    char: "🙋‍♂️",
                    fitzpatrick_scale: true
                },
                pouting_woman: {
                    keywords: ["female", "girl", "woman"],
                    char: "🙎",
                    fitzpatrick_scale: true
                },
                pouting_man: {
                    keywords: ["male", "boy", "man"],
                    char: "🙎‍♂️",
                    fitzpatrick_scale: true
                },
                frowning_woman: {
                    keywords: [
                        "female",
                        "girl",
                        "woman",
                        "sad",
                        "depressed",
                        "discouraged",
                        "unhappy"
                    ],
                    char: "🙍",
                    fitzpatrick_scale: true
                },
                frowning_man: {
                    keywords: [
                        "male",
                        "boy",
                        "man",
                        "sad",
                        "depressed",
                        "discouraged",
                        "unhappy"
                    ],
                    char: "🙍‍♂️",
                    fitzpatrick_scale: true
                },
                haircut_woman: {
                    keywords: ["female", "girl", "woman"],
                    char: "💇",
                    fitzpatrick_scale: true
                },
                haircut_man: {
                    keywords: ["male", "boy", "man"],
                    char: "💇‍♂️",
                    fitzpatrick_scale: true
                },
                massage_woman: {
                    keywords: ["female", "girl", "woman", "head"],
                    char: "💆",
                    fitzpatrick_scale: true
                },
                massage_man: {
                    keywords: ["male", "boy", "man", "head"],
                    char: "💆‍♂️",
                    fitzpatrick_scale: true
                },
                woman_in_steamy_room: {
                    keywords: ["female", "woman", "spa", "steamroom", "sauna"],
                    char: "🧖‍♀️",
                    fitzpatrick_scale: true
                },
                man_in_steamy_room: {
                    keywords: ["male", "man", "spa", "steamroom", "sauna"],
                    char: "🧖‍♂️",
                    fitzpatrick_scale: true
                },
                couple_with_heart_woman_man: {
                    keywords: [
                        "pair",
                        "love",
                        "like",
                        "affection",
                        "human",
                        "dating",
                        "valentines",
                        "marriage"
                    ],
                    char: "💑"
                },
                couple_with_heart_woman_woman: {
                    keywords: [
                        "pair",
                        "love",
                        "like",
                        "affection",
                        "human",
                        "dating",
                        "valentines",
                        "marriage"
                    ],
                    char: "👩‍❤️‍👩"
                },
                couple_with_heart_man_man: {
                    keywords: [
                        "pair",
                        "love",
                        "like",
                        "affection",
                        "human",
                        "dating",
                        "valentines",
                        "marriage"
                    ],
                    char: "👨‍❤️‍👨"
                },
                couplekiss_man_woman: {
                    keywords: [
                        "pair",
                        "valentines",
                        "love",
                        "like",
                        "dating",
                        "marriage"
                    ],
                    char: "💏"
                },
                couplekiss_woman_woman: {
                    keywords: [
                        "pair",
                        "valentines",
                        "love",
                        "like",
                        "dating",
                        "marriage"
                    ],
                    char: "👩‍❤️‍💋‍👩"
                },
                couplekiss_man_man: {
                    keywords: [
                        "pair",
                        "valentines",
                        "love",
                        "like",
                        "dating",
                        "marriage"
                    ],
                    char: "👨‍❤️‍💋‍👨"
                },
                family_man_woman_boy: {
                    keywords: [
                        "home",
                        "parents",
                        "child",
                        "mom",
                        "dad",
                        "father",
                        "mother",
                        "people",
                        "human"
                    ],
                    char: "👪"
                },
                family_man_woman_girl: {
                    keywords: ["home", "parents", "people", "human", "child"],
                    char: "👨‍👩‍👧"
                },
                family_man_woman_girl_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👩‍👧‍👦"
                },
                family_man_woman_boy_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👩‍👦‍👦"
                },
                family_man_woman_girl_girl: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👩‍👧‍👧"
                },
                family_woman_woman_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👩‍👩‍👦"
                },
                family_woman_woman_girl: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👩‍👩‍👧"
                },
                family_woman_woman_girl_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👩‍👩‍👧‍👦"
                },
                family_woman_woman_boy_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👩‍👩‍👦‍👦"
                },
                family_woman_woman_girl_girl: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👩‍👩‍👧‍👧"
                },
                family_man_man_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👨‍👦"
                },
                family_man_man_girl: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👨‍👧"
                },
                family_man_man_girl_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👨‍👧‍👦"
                },
                family_man_man_boy_boy: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👨‍👦‍👦"
                },
                family_man_man_girl_girl: {
                    keywords: ["home", "parents", "people", "human", "children"],
                    char: "👨‍👨‍👧‍👧"
                },
                family_woman_boy: {
                    keywords: ["home", "parent", "people", "human", "child"],
                    char: "👩‍👦"
                },
                family_woman_girl: {
                    keywords: ["home", "parent", "people", "human", "child"],
                    char: "👩‍👧"
                },
                family_woman_girl_boy: {
                    keywords: ["home", "parent", "people", "human", "children"],
                    char: "👩‍👧‍👦"
                },
                family_woman_boy_boy: {
                    keywords: ["home", "parent", "people", "human", "children"],
                    char: "👩‍👦‍👦"
                },
                family_woman_girl_girl: {
                    keywords: ["home", "parent", "people", "human", "children"],
                    char: "👩‍👧‍👧"
                },
                family_man_boy: {
                    keywords: ["home", "parent", "people", "human", "child"],
                    char: "👨‍👦"
                },
                family_man_girl: {
                    keywords: ["home", "parent", "people", "human", "child"],
                    char: "👨‍👧"
                },
                family_man_girl_boy: {
                    keywords: ["home", "parent", "people", "human", "children"],
                    char: "👨‍👧‍👦"
                },
                family_man_boy_boy: {
                    keywords: ["home", "parent", "people", "human", "children"],
                    char: "👨‍👦‍👦"
                },
                family_man_girl_girl: {
                    keywords: ["home", "parent", "people", "human", "children"],
                    char: "👨‍👧‍👧"
                },
                yarn: {
                    keywords: ["ball", "crochet", "knit"],
                    char: "🧶"
                },
                thread: {
                    keywords: ["needle", "sewing", "spool", "string"],
                    char: "🧵"
                },
                coat: {
                    keywords: ["jacket"],
                    char: "🧥"
                },
                labcoat: {
                    keywords: ["doctor", "experiment", "scientist", "chemist"],
                    char: "🥼"
                },
                womans_clothes: {
                    keywords: ["fashion", "shopping_bags", "female"],
                    char: "👚"
                },
                tshirt: {
                    keywords: ["fashion", "cloth", "casual", "shirt", "tee"],
                    char: "👕"
                },
                jeans: {
                    keywords: ["fashion", "shopping"],
                    char: "👖"
                },
                necktie: {
                    keywords: [
                        "shirt",
                        "suitup",
                        "formal",
                        "fashion",
                        "cloth",
                        "business"
                    ],
                    char: "👔"
                },
                dress: {
                    keywords: ["clothes", "fashion", "shopping"],
                    char: "👗"
                },
                bikini: {
                    keywords: [
                        "swimming",
                        "female",
                        "woman",
                        "girl",
                        "fashion",
                        "beach",
                        "summer"
                    ],
                    char: "👙"
                },
                kimono: {
                    keywords: ["dress", "fashion", "women", "female", "japanese"],
                    char: "👘"
                },
                lipstick: {
                    keywords: ["female", "girl", "fashion", "woman"],
                    char: "💄"
                },
                kiss: {
                    keywords: ["face", "lips", "love", "like", "affection", "valentines"],
                    char: "💋"
                },
                footprints: {
                    keywords: ["feet", "tracking", "walking", "beach"],
                    char: "👣"
                },
                flat_shoe: {
                    keywords: ["ballet", "slip-on", "slipper"],
                    char: "🥿"
                },
                high_heel: {
                    keywords: ["fashion", "shoes", "female", "pumps", "stiletto"],
                    char: "👠"
                },
                sandal: {
                    keywords: ["shoes", "fashion", "flip flops"],
                    char: "👡"
                },
                boot: {
                    keywords: ["shoes", "fashion"],
                    char: "👢"
                },
                mans_shoe: {
                    keywords: ["fashion", "male"],
                    char: "👞"
                },
                athletic_shoe: {
                    keywords: ["shoes", "sports", "sneakers"],
                    char: "👟"
                },
                hiking_boot: {
                    keywords: ["backpacking", "camping", "hiking"],
                    char: "🥾"
                },
                socks: {
                    keywords: ["stockings", "clothes"],
                    char: "🧦"
                },
                gloves: {
                    keywords: ["hands", "winter", "clothes"],
                    char: "🧤"
                },
                scarf: {
                    keywords: ["neck", "winter", "clothes"],
                    char: "🧣"
                },
                womans_hat: {
                    keywords: ["fashion", "accessories", "female", "lady", "spring"],
                    char: "👒"
                },
                tophat: {
                    keywords: ["magic", "gentleman", "classy", "circus"],
                    char: "🎩"
                },
                billed_hat: {
                    keywords: ["cap", "baseball"],
                    char: "🧢"
                },
                rescue_worker_helmet: {
                    keywords: ["construction", "build"],
                    char: "⛑"
                },
                mortar_board: {
                    keywords: [
                        "school",
                        "college",
                        "degree",
                        "university",
                        "graduation",
                        "cap",
                        "hat",
                        "legal",
                        "learn",
                        "education"
                    ],
                    char: "🎓"
                },
                crown: {
                    keywords: ["king", "kod", "leader", "royalty", "lord"],
                    char: "👑"
                },
                school_satchel: {
                    keywords: ["student", "education", "bag", "backpack"],
                    char: "🎒"
                },
                luggage: {
                    keywords: ["packing", "travel"],
                    char: "🧳"
                },
                pouch: {
                    keywords: ["bag", "accessories", "shopping"],
                    char: "👝"
                },
                purse: {
                    keywords: ["fashion", "accessories", "money", "sales", "shopping"],
                    char: "👛"
                },
                handbag: {
                    keywords: ["fashion", "accessory", "accessories", "shopping"],
                    char: "👜"
                },
                briefcase: {
                    keywords: [
                        "business",
                        "documents",
                        "work",
                        "law",
                        "legal",
                        "job",
                        "career"
                    ],
                    char: "💼"
                },
                eyeglasses: {
                    keywords: [
                        "fashion",
                        "accessories",
                        "eyesight",
                        "nerdy",
                        "dork",
                        "geek"
                    ],
                    char: "👓"
                },
                dark_sunglasses: {
                    keywords: ["face", "cool", "accessories"],
                    char: "🕶"
                },
                goggles: {
                    keywords: ["eyes", "protection", "safety"],
                    char: "🥽"
                },
                ring: {
                    keywords: [
                        "wedding",
                        "propose",
                        "marriage",
                        "valentines",
                        "diamond",
                        "fashion",
                        "jewelry",
                        "gem",
                        "engagement"
                    ],
                    char: "💍"
                },
                closed_umbrella: {
                    keywords: ["weather", "rain", "drizzle"],
                    char: "🌂"
                }
            }
        }
    },
    {
        animals_and_nature: {
            id: "animals_and_nature",
            name: "Animals & Nature",
            symbol: animalsIcon,
            emojis: {
                dog: {
                    keywords: [
                        "animal",
                        "friend",
                        "nature",
                        "woof",
                        "puppy",
                        "pet",
                        "faithful"
                    ],
                    char: "🐶"
                },
                cat: {
                    keywords: ["animal", "meow", "nature", "pet", "kitten"],
                    char: "🐱"
                },
                mouse: {
                    keywords: ["animal", "nature", "cheese_wedge", "rodent"],
                    char: "🐭"
                },
                hamster: {
                    keywords: ["animal", "nature"],
                    char: "🐹"
                },
                rabbit: {
                    keywords: ["animal", "nature", "pet", "spring", "magic", "bunny"],
                    char: "🐰"
                },
                fox_face: {
                    keywords: ["animal", "nature", "face"],
                    char: "🦊"
                },
                bear: {
                    keywords: ["animal", "nature", "wild"],
                    char: "🐻"
                },
                panda_face: {
                    keywords: ["animal", "nature", "panda"],
                    char: "🐼"
                },
                koala: {
                    keywords: ["animal", "nature"],
                    char: "🐨"
                },
                tiger: {
                    keywords: ["animal", "cat", "danger", "wild", "nature", "roar"],
                    char: "🐯"
                },
                lion: {
                    keywords: ["animal", "nature"],
                    char: "🦁"
                },
                cow: {
                    keywords: ["beef", "ox", "animal", "nature", "moo", "milk"],
                    char: "🐮"
                },
                pig: {
                    keywords: ["animal", "oink", "nature"],
                    char: "🐷"
                },
                pig_nose: {
                    keywords: ["animal", "oink"],
                    char: "🐽"
                },
                frog: {
                    keywords: ["animal", "nature", "croak", "toad"],
                    char: "🐸"
                },
                squid: {
                    keywords: ["animal", "nature", "ocean", "sea"],
                    char: "🦑"
                },
                octopus: {
                    keywords: ["animal", "creature", "ocean", "sea", "nature", "beach"],
                    char: "🐙"
                },
                shrimp: {
                    keywords: ["animal", "ocean", "nature", "seafood"],
                    char: "🦐"
                },
                monkey_face: {
                    keywords: ["animal", "nature", "circus"],
                    char: "🐵"
                },
                gorilla: {
                    keywords: ["animal", "nature", "circus"],
                    char: "🦍"
                },
                see_no_evil: {
                    keywords: ["monkey", "animal", "nature", "haha"],
                    char: "🙈"
                },
                hear_no_evil: {
                    keywords: ["animal", "monkey", "nature"],
                    char: "🙉"
                },
                speak_no_evil: {
                    keywords: ["monkey", "animal", "nature", "omg"],
                    char: "🙊"
                },
                monkey: {
                    keywords: ["animal", "nature", "banana", "circus"],
                    char: "🐒"
                },
                chicken: {
                    keywords: ["animal", "cluck", "nature", "bird"],
                    char: "🐔"
                },
                penguin: {
                    keywords: ["animal", "nature"],
                    char: "🐧"
                },
                bird: {
                    keywords: ["animal", "nature", "fly", "tweet", "spring"],
                    char: "🐦"
                },
                baby_chick: {
                    keywords: ["animal", "chicken", "bird"],
                    char: "🐤"
                },
                hatching_chick: {
                    keywords: ["animal", "chicken", "egg", "born", "baby", "bird"],
                    char: "🐣"
                },
                hatched_chick: {
                    keywords: ["animal", "chicken", "baby", "bird"],
                    char: "🐥"
                },
                duck: {
                    keywords: ["animal", "nature", "bird", "mallard"],
                    char: "🦆"
                },
                eagle: {
                    keywords: ["animal", "nature", "bird"],
                    char: "🦅"
                },
                owl: {
                    keywords: ["animal", "nature", "bird", "hoot"],
                    char: "🦉"
                },
                bat: {
                    keywords: ["animal", "nature", "blind", "vampire"],
                    char: "🦇"
                },
                wolf: {
                    keywords: ["animal", "nature", "wild"],
                    char: "🐺"
                },
                boar: {
                    keywords: ["animal", "nature"],
                    char: "🐗"
                },
                horse: {
                    keywords: ["animal", "brown", "nature"],
                    char: "🐴"
                },
                unicorn: {
                    keywords: ["animal", "nature", "mystical"],
                    char: "🦄"
                },
                honeybee: {
                    keywords: ["animal", "insect", "nature", "bug", "spring", "honey"],
                    char: "🐝"
                },
                bug: {
                    keywords: ["animal", "insect", "nature", "worm"],
                    char: "🐛"
                },
                butterfly: {
                    keywords: ["animal", "insect", "nature", "caterpillar"],
                    char: "🦋"
                },
                snail: {
                    keywords: ["slow", "animal", "shell"],
                    char: "🐌"
                },
                beetle: {
                    keywords: ["animal", "insect", "nature", "ladybug"],
                    char: "🐞"
                },
                ant: {
                    keywords: ["animal", "insect", "nature", "bug"],
                    char: "🐜"
                },
                grasshopper: {
                    keywords: ["animal", "cricket", "chirp"],
                    char: "🦗"
                },
                spider: {
                    keywords: ["animal", "arachnid"],
                    char: "🕷"
                },
                scorpion: {
                    keywords: ["animal", "arachnid"],
                    char: "🦂"
                },
                crab: {
                    keywords: ["animal", "crustacean"],
                    char: "🦀"
                },
                snake: {
                    keywords: ["animal", "evil", "nature", "hiss", "python"],
                    char: "🐍"
                },
                lizard: {
                    keywords: ["animal", "nature", "reptile"],
                    char: "🦎"
                },
                "t-rex": {
                    keywords: [
                        "animal",
                        "nature",
                        "dinosaur",
                        "tyrannosaurus",
                        "extinct"
                    ],
                    char: "🦖"
                },
                sauropod: {
                    keywords: [
                        "animal",
                        "nature",
                        "dinosaur",
                        "brachiosaurus",
                        "brontosaurus",
                        "diplodocus",
                        "extinct"
                    ],
                    char: "🦕"
                },
                turtle: {
                    keywords: ["animal", "slow", "nature", "tortoise"],
                    char: "🐢"
                },
                tropical_fish: {
                    keywords: ["animal", "swim", "ocean", "beach", "nemo"],
                    char: "🐠"
                },
                fish: {
                    keywords: ["animal", "food", "nature"],
                    char: "🐟"
                },
                blowfish: {
                    keywords: ["animal", "nature", "food", "sea", "ocean"],
                    char: "🐡"
                },
                dolphin: {
                    keywords: [
                        "animal",
                        "nature",
                        "fish",
                        "sea",
                        "ocean",
                        "flipper",
                        "fins",
                        "beach"
                    ],
                    char: "🐬"
                },
                shark: {
                    keywords: [
                        "animal",
                        "nature",
                        "fish",
                        "sea",
                        "ocean",
                        "jaws",
                        "fins",
                        "beach"
                    ],
                    char: "🦈"
                },
                whale: {
                    keywords: ["animal", "nature", "sea", "ocean"],
                    char: "🐳"
                },
                whale2: {
                    keywords: ["animal", "nature", "sea", "ocean"],
                    char: "🐋"
                },
                crocodile: {
                    keywords: ["animal", "nature", "reptile", "lizard", "alligator"],
                    char: "🐊"
                },
                leopard: {
                    keywords: ["animal", "nature"],
                    char: "🐆"
                },
                zebra: {
                    keywords: ["animal", "nature", "stripes", "safari"],
                    char: "🦓"
                },
                tiger2: {
                    keywords: ["animal", "nature", "roar"],
                    char: "🐅"
                },
                water_buffalo: {
                    keywords: ["animal", "nature", "ox", "cow"],
                    char: "🐃"
                },
                ox: {
                    keywords: ["animal", "cow", "beef"],
                    char: "🐂"
                },
                cow2: {
                    keywords: ["beef", "ox", "animal", "nature", "moo", "milk"],
                    char: "🐄"
                },
                deer: {
                    keywords: ["animal", "nature", "horns", "venison"],
                    char: "🦌"
                },
                dromedary_camel: {
                    keywords: ["animal", "hot", "desert", "hump"],
                    char: "🐪"
                },
                camel: {
                    keywords: ["animal", "nature", "hot", "desert", "hump"],
                    char: "🐫"
                },
                giraffe: {
                    keywords: ["animal", "nature", "spots", "safari"],
                    char: "🦒"
                },
                elephant: {
                    keywords: ["animal", "nature", "nose", "th", "circus"],
                    char: "🐘"
                },
                rhinoceros: {
                    keywords: ["animal", "nature", "horn"],
                    char: "🦏"
                },
                goat: {
                    keywords: ["animal", "nature"],
                    char: "🐐"
                },
                ram: {
                    keywords: ["animal", "sheep", "nature"],
                    char: "🐏"
                },
                sheep: {
                    keywords: ["animal", "nature", "wool", "shipit"],
                    char: "🐑"
                },
                racehorse: {
                    keywords: ["animal", "gamble", "luck"],
                    char: "🐎"
                },
                pig2: {
                    keywords: ["animal", "nature"],
                    char: "🐖"
                },
                rat: {
                    keywords: ["animal", "mouse", "rodent"],
                    char: "🐀"
                },
                mouse2: {
                    keywords: ["animal", "nature", "rodent"],
                    char: "🐁"
                },
                rooster: {
                    keywords: ["animal", "nature", "chicken"],
                    char: "🐓"
                },
                turkey: {
                    keywords: ["animal", "bird"],
                    char: "🦃"
                },
                dove: {
                    keywords: ["animal", "bird"],
                    char: "🕊"
                },
                dog2: {
                    keywords: ["animal", "nature", "friend", "doge", "pet", "faithful"],
                    char: "🐕"
                },
                poodle: {
                    keywords: ["dog", "animal", "101", "nature", "pet"],
                    char: "🐩"
                },
                cat2: {
                    keywords: ["animal", "meow", "pet", "cats"],
                    char: "🐈"
                },
                rabbit2: {
                    keywords: ["animal", "nature", "pet", "magic", "spring"],
                    char: "🐇"
                },
                chipmunk: {
                    keywords: ["animal", "nature", "rodent", "squirrel"],
                    char: "🐿"
                },
                hedgehog: {
                    keywords: ["animal", "nature", "spiny"],
                    char: "🦔"
                },
                raccoon: {
                    keywords: ["animal", "nature"],
                    char: "🦝"
                },
                llama: {
                    keywords: ["animal", "nature", "alpaca"],
                    char: "🦙"
                },
                hippopotamus: {
                    keywords: ["animal", "nature"],
                    char: "🦛"
                },
                kangaroo: {
                    keywords: [
                        "animal",
                        "nature",
                        "australia",
                        "joey",
                        "hop",
                        "marsupial"
                    ],
                    char: "🦘"
                },
                badger: {
                    keywords: ["animal", "nature", "honey"],
                    char: "🦡"
                },
                swan: {
                    keywords: ["animal", "nature", "bird"],
                    char: "🦢"
                },
                peacock: {
                    keywords: ["animal", "nature", "peahen", "bird"],
                    char: "🦚"
                },
                parrot: {
                    keywords: ["animal", "nature", "bird", "pirate", "talk"],
                    char: "🦜"
                },
                lobster: {
                    keywords: ["animal", "nature", "bisque", "claws", "seafood"],
                    char: "🦞"
                },
                mosquito: {
                    keywords: ["animal", "nature", "insect", "malaria"],
                    char: "🦟"
                },
                paw_prints: {
                    keywords: [
                        "animal",
                        "tracking",
                        "footprints",
                        "dog",
                        "cat",
                        "pet",
                        "feet"
                    ],
                    char: "🐾"
                },
                dragon: {
                    keywords: ["animal", "myth", "nature", "chinese", "green"],
                    char: "🐉"
                },
                dragon_face: {
                    keywords: ["animal", "myth", "nature", "chinese", "green"],
                    char: "🐲"
                },
                cactus: {
                    keywords: ["vegetable", "plant", "nature"],
                    char: "🌵"
                },
                christmas_tree: {
                    keywords: ["festival", "vacation", "december", "xmas", "celebration"],
                    char: "🎄"
                },
                evergreen_tree: {
                    keywords: ["plant", "nature"],
                    char: "🌲"
                },
                deciduous_tree: {
                    keywords: ["plant", "nature"],
                    char: "🌳"
                },
                palm_tree: {
                    keywords: [
                        "plant",
                        "vegetable",
                        "nature",
                        "summer",
                        "beach",
                        "mojito",
                        "tropical"
                    ],
                    char: "🌴"
                },
                seedling: {
                    keywords: ["plant", "nature", "grass", "lawn", "spring"],
                    char: "🌱"
                },
                herb: {
                    keywords: ["vegetable", "plant", "medicine", "weed", "grass", "lawn"],
                    char: "🌿"
                },
                shamrock: {
                    keywords: ["vegetable", "plant", "nature", "irish", "clover"],
                    char: "☘"
                },
                four_leaf_clover: {
                    keywords: ["vegetable", "plant", "nature", "lucky", "irish"],
                    char: "🍀"
                },
                bamboo: {
                    keywords: [
                        "plant",
                        "nature",
                        "vegetable",
                        "panda",
                        "pine_decoration"
                    ],
                    char: "🎍"
                },
                tanabata_tree: {
                    keywords: ["plant", "nature", "branch", "summer"],
                    char: "🎋"
                },
                leaves: {
                    keywords: [
                        "nature",
                        "plant",
                        "tree",
                        "vegetable",
                        "grass",
                        "lawn",
                        "spring"
                    ],
                    char: "🍃"
                },
                fallen_leaf: {
                    keywords: ["nature", "plant", "vegetable", "leaves"],
                    char: "🍂"
                },
                maple_leaf: {
                    keywords: ["nature", "plant", "vegetable", "ca", "fall"],
                    char: "🍁"
                },
                ear_of_rice: {
                    keywords: ["nature", "plant"],
                    char: "🌾"
                },
                hibiscus: {
                    keywords: ["plant", "vegetable", "flowers", "beach"],
                    char: "🌺"
                },
                sunflower: {
                    keywords: ["nature", "plant", "fall"],
                    char: "🌻"
                },
                rose: {
                    keywords: ["flowers", "valentines", "love", "spring"],
                    char: "🌹"
                },
                wilted_flower: {
                    keywords: ["plant", "nature", "flower"],
                    char: "🥀"
                },
                tulip: {
                    keywords: ["flowers", "plant", "nature", "summer", "spring"],
                    char: "🌷"
                },
                blossom: {
                    keywords: ["nature", "flowers", "yellow"],
                    char: "🌼"
                },
                cherry_blossom: {
                    keywords: ["nature", "plant", "spring", "flower"],
                    char: "🌸"
                },
                bouquet: {
                    keywords: ["flowers", "nature", "spring"],
                    char: "💐"
                },
                mushroom: {
                    keywords: ["plant", "vegetable"],
                    char: "🍄"
                },
                chestnut: {
                    keywords: ["food", "squirrel"],
                    char: "🌰"
                },
                jack_o_lantern: {
                    keywords: ["halloween", "light", "pumpkin", "creepy", "fall"],
                    char: "🎃"
                },
                shell: {
                    keywords: ["nature", "sea", "beach"],
                    char: "🐚"
                },
                spider_web: {
                    keywords: ["animal", "insect", "arachnid", "silk"],
                    char: "🕸"
                },
                earth_americas: {
                    keywords: ["globe", "world", "USA", "international"],
                    char: "🌎"
                },
                earth_africa: {
                    keywords: ["globe", "world", "international"],
                    char: "🌍"
                },
                earth_asia: {
                    keywords: ["globe", "world", "east", "international"],
                    char: "🌏"
                },
                full_moon: {
                    keywords: [
                        "nature",
                        "yellow",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌕"
                },
                waning_gibbous_moon: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep",
                        "waxing_gibbous_moon"
                    ],
                    char: "🌖"
                },
                last_quarter_moon: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌗"
                },
                waning_crescent_moon: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌘"
                },
                new_moon: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌑"
                },
                waxing_crescent_moon: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌒"
                },
                first_quarter_moon: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌓"
                },
                waxing_gibbous_moon: {
                    keywords: [
                        "nature",
                        "night",
                        "sky",
                        "gray",
                        "twilight",
                        "planet",
                        "space",
                        "evening",
                        "sleep"
                    ],
                    char: "🌔"
                },
                new_moon_with_face: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌚"
                },
                full_moon_with_face: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌝"
                },
                first_quarter_moon_with_face: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌛"
                },
                last_quarter_moon_with_face: {
                    keywords: [
                        "nature",
                        "twilight",
                        "planet",
                        "space",
                        "night",
                        "evening",
                        "sleep"
                    ],
                    char: "🌜"
                },
                sun_with_face: {
                    keywords: ["nature", "morning", "sky"],
                    char: "🌞"
                },
                crescent_moon: {
                    keywords: ["night", "sleep", "sky", "evening", "magic"],
                    char: "🌙"
                },
                star: {
                    keywords: ["night", "yellow"],
                    char: "⭐"
                },
                star2: {
                    keywords: ["night", "sparkle", "awesome", "good", "magic"],
                    char: "🌟"
                },
                dizzy: {
                    keywords: ["star", "sparkle", "shoot", "magic"],
                    char: "💫"
                },
                sparkles: {
                    keywords: [
                        "stars",
                        "shine",
                        "shiny",
                        "cool",
                        "awesome",
                        "good",
                        "magic"
                    ],
                    char: "✨"
                },
                comet: {
                    keywords: ["space"],
                    char: "☄"
                },
                sunny: {
                    keywords: [
                        "weather",
                        "nature",
                        "brightness",
                        "summer",
                        "beach",
                        "spring"
                    ],
                    char: "☀️"
                },
                sun_behind_small_cloud: {
                    keywords: ["weather"],
                    char: "🌤"
                },
                partly_sunny: {
                    keywords: [
                        "weather",
                        "nature",
                        "cloudy",
                        "morning",
                        "fall",
                        "spring"
                    ],
                    char: "⛅"
                },
                sun_behind_large_cloud: {
                    keywords: ["weather"],
                    char: "🌥"
                },
                sun_behind_rain_cloud: {
                    keywords: ["weather"],
                    char: "🌦"
                },
                cloud: {
                    keywords: ["weather", "sky"],
                    char: "☁️"
                },
                cloud_with_rain: {
                    keywords: ["weather"],
                    char: "🌧"
                },
                cloud_with_lightning_and_rain: {
                    keywords: ["weather", "lightning"],
                    char: "⛈"
                },
                cloud_with_lightning: {
                    keywords: ["weather", "thunder"],
                    char: "🌩"
                },
                zap: {
                    keywords: ["thunder", "weather", "lightning bolt", "fast"],
                    char: "⚡"
                },
                fire: {
                    keywords: ["hot", "cook", "flame"],
                    char: "🔥"
                },
                boom: {
                    keywords: ["bomb", "explode", "explosion", "collision", "blown"],
                    char: "💥"
                },
                snowflake: {
                    keywords: [
                        "winter",
                        "season",
                        "cold",
                        "weather",
                        "christmas",
                        "xmas"
                    ],
                    char: "❄️"
                },
                cloud_with_snow: {
                    keywords: ["weather"],
                    char: "🌨"
                },
                snowman: {
                    keywords: [
                        "winter",
                        "season",
                        "cold",
                        "weather",
                        "christmas",
                        "xmas",
                        "frozen",
                        "without_snow"
                    ],
                    char: "⛄"
                },
                snowman_with_snow: {
                    keywords: [
                        "winter",
                        "season",
                        "cold",
                        "weather",
                        "christmas",
                        "xmas",
                        "frozen"
                    ],
                    char: "☃"
                },
                wind_face: {
                    keywords: ["gust", "air"],
                    char: "🌬"
                },
                dash: {
                    keywords: ["wind", "air", "fast", "shoo", "fart", "smoke", "puff"],
                    char: "💨"
                },
                tornado: {
                    keywords: ["weather", "cyclone", "twister"],
                    char: "🌪"
                },
                fog: {
                    keywords: ["weather"],
                    char: "🌫"
                },
                open_umbrella: {
                    keywords: ["weather", "spring"],
                    char: "☂"
                },
                umbrella: {
                    keywords: ["rainy", "weather", "spring"],
                    char: "☔"
                },
                droplet: {
                    keywords: ["water", "drip", "faucet", "spring"],
                    char: "💧"
                },
                sweat_drops: {
                    keywords: ["water", "drip", "oops"],
                    char: "💦"
                },
                ocean: {
                    keywords: ["sea", "water", "wave", "nature", "tsunami", "disaster"],
                    char: "🌊"
                }
            }
        }
    },
    {
        food_and_drink: {
            id: "food_and_drink",
            name: "Food",
            symbol: foodIcon,
            emojis: {
                green_apple: {
                    keywords: ["fruit", "nature"],
                    char: "🍏"
                },
                apple: {
                    keywords: ["fruit", "mac", "school"],
                    char: "🍎"
                },
                pear: {
                    keywords: ["fruit", "nature", "food"],
                    char: "🍐"
                },
                tangerine: {
                    keywords: ["food", "fruit", "nature", "orange"],
                    char: "🍊"
                },
                lemon: {
                    keywords: ["fruit", "nature"],
                    char: "🍋"
                },
                banana: {
                    keywords: ["fruit", "food", "monkey"],
                    char: "🍌"
                },
                watermelon: {
                    keywords: ["fruit", "food", "picnic", "summer"],
                    char: "🍉"
                },
                grapes: {
                    keywords: ["fruit", "food", "wine"],
                    char: "🍇"
                },
                strawberry: {
                    keywords: ["fruit", "food", "nature"],
                    char: "🍓"
                },
                melon: {
                    keywords: ["fruit", "nature", "food"],
                    char: "🍈"
                },
                cherries: {
                    keywords: ["food", "fruit"],
                    char: "🍒"
                },
                peach: {
                    keywords: ["fruit", "nature", "food"],
                    char: "🍑"
                },
                pineapple: {
                    keywords: ["fruit", "nature", "food"],
                    char: "🍍"
                },
                coconut: {
                    keywords: ["fruit", "nature", "food", "palm"],
                    char: "🥥"
                },
                kiwi_fruit: {
                    keywords: ["fruit", "food"],
                    char: "🥝"
                },
                mango: {
                    keywords: ["fruit", "food", "tropical"],
                    char: "🥭"
                },
                avocado: {
                    keywords: ["fruit", "food"],
                    char: "🥑"
                },
                broccoli: {
                    keywords: ["fruit", "food", "vegetable"],
                    char: "🥦"
                },
                tomato: {
                    keywords: ["fruit", "vegetable", "nature", "food"],
                    char: "🍅"
                },
                eggplant: {
                    keywords: ["vegetable", "nature", "food", "aubergine"],
                    char: "🍆"
                },
                cucumber: {
                    keywords: ["fruit", "food", "pickle"],
                    char: "🥒"
                },
                carrot: {
                    keywords: ["vegetable", "food", "orange"],
                    char: "🥕"
                },
                hot_pepper: {
                    keywords: ["food", "spicy", "chilli", "chili"],
                    char: "🌶"
                },
                potato: {
                    keywords: ["food", "tuber", "vegatable", "starch"],
                    char: "🥔"
                },
                corn: {
                    keywords: ["food", "vegetable", "plant"],
                    char: "🌽"
                },
                leafy_greens: {
                    keywords: [
                        "food",
                        "vegetable",
                        "plant",
                        "bok choy",
                        "cabbage",
                        "kale",
                        "lettuce"
                    ],
                    char: "🥬"
                },
                sweet_potato: {
                    keywords: ["food", "nature"],
                    char: "🍠"
                },
                peanuts: {
                    keywords: ["food", "nut"],
                    char: "🥜"
                },
                honey_pot: {
                    keywords: ["bees", "sweet", "kitchen"],
                    char: "🍯"
                },
                croissant: {
                    keywords: ["food", "bread", "french"],
                    char: "🥐"
                },
                bread: {
                    keywords: ["food", "wheat", "breakfast", "toast"],
                    char: "🍞"
                },
                baguette_bread: {
                    keywords: ["food", "bread", "french"],
                    char: "🥖"
                },
                bagel: {
                    keywords: ["food", "bread", "bakery", "schmear"],
                    char: "🥯"
                },
                pretzel: {
                    keywords: ["food", "bread", "twisted"],
                    char: "🥨"
                },
                cheese: {
                    keywords: ["food", "chadder"],
                    char: "🧀"
                },
                egg: {
                    keywords: ["food", "chicken", "breakfast"],
                    char: "🥚"
                },
                bacon: {
                    keywords: ["food", "breakfast", "pork", "pig", "meat"],
                    char: "🥓"
                },
                steak: {
                    keywords: [
                        "food",
                        "cow",
                        "meat",
                        "cut",
                        "chop",
                        "lambchop",
                        "porkchop"
                    ],
                    char: "🥩"
                },
                pancakes: {
                    keywords: ["food", "breakfast", "flapjacks", "hotcakes"],
                    char: "🥞"
                },
                poultry_leg: {
                    keywords: ["food", "meat", "drumstick", "bird", "chicken", "turkey"],
                    char: "🍗"
                },
                meat_on_bone: {
                    keywords: ["good", "food", "drumstick"],
                    char: "🍖"
                },
                bone: {
                    keywords: ["skeleton"],
                    char: "🦴"
                },
                fried_shrimp: {
                    keywords: ["food", "animal", "appetizer", "summer"],
                    char: "🍤"
                },
                fried_egg: {
                    keywords: ["food", "breakfast", "kitchen", "egg"],
                    char: "🍳"
                },
                hamburger: {
                    keywords: [
                        "meat",
                        "fast food",
                        "beef",
                        "cheeseburger",
                        "mcdonalds",
                        "burger king"
                    ],
                    char: "🍔"
                },
                fries: {
                    keywords: ["chips", "snack", "fast food"],
                    char: "🍟"
                },
                stuffed_flatbread: {
                    keywords: ["food", "flatbread", "stuffed", "gyro"],
                    char: "🥙"
                },
                hotdog: {
                    keywords: ["food", "frankfurter"],
                    char: "🌭"
                },
                pizza: {
                    keywords: ["food", "party"],
                    char: "🍕"
                },
                sandwich: {
                    keywords: ["food", "lunch", "bread"],
                    char: "🥪"
                },
                canned_food: {
                    keywords: ["food", "soup"],
                    char: "🥫"
                },
                spaghetti: {
                    keywords: ["food", "italian", "noodle"],
                    char: "🍝"
                },
                taco: {
                    keywords: ["food", "mexican"],
                    char: "🌮"
                },
                burrito: {
                    keywords: ["food", "mexican"],
                    char: "🌯"
                },
                green_salad: {
                    keywords: ["food", "healthy", "lettuce"],
                    char: "🥗"
                },
                shallow_pan_of_food: {
                    keywords: ["food", "cooking", "casserole", "paella"],
                    char: "🥘"
                },
                ramen: {
                    keywords: ["food", "japanese", "noodle", "chopsticks"],
                    char: "🍜"
                },
                stew: {
                    keywords: ["food", "meat", "soup"],
                    char: "🍲"
                },
                fish_cake: {
                    keywords: [
                        "food",
                        "japan",
                        "sea",
                        "beach",
                        "narutomaki",
                        "pink",
                        "swirl",
                        "kamaboko",
                        "surimi",
                        "ramen"
                    ],
                    char: "🍥"
                },
                fortune_cookie: {
                    keywords: ["food", "prophecy"],
                    char: "🥠"
                },
                sushi: {
                    keywords: ["food", "fish", "japanese", "rice"],
                    char: "🍣"
                },
                bento: {
                    keywords: ["food", "japanese", "box"],
                    char: "🍱"
                },
                curry: {
                    keywords: ["food", "spicy", "hot", "indian"],
                    char: "🍛"
                },
                rice_ball: {
                    keywords: ["food", "japanese"],
                    char: "🍙"
                },
                rice: {
                    keywords: ["food", "china", "asian"],
                    char: "🍚"
                },
                rice_cracker: {
                    keywords: ["food", "japanese"],
                    char: "🍘"
                },
                oden: {
                    keywords: ["food", "japanese"],
                    char: "🍢"
                },
                dango: {
                    keywords: [
                        "food",
                        "dessert",
                        "sweet",
                        "japanese",
                        "barbecue",
                        "meat"
                    ],
                    char: "🍡"
                },
                shaved_ice: {
                    keywords: ["hot", "dessert", "summer"],
                    char: "🍧"
                },
                ice_cream: {
                    keywords: ["food", "hot", "dessert"],
                    char: "🍨"
                },
                icecream: {
                    keywords: ["food", "hot", "dessert", "summer"],
                    char: "🍦"
                },
                pie: {
                    keywords: ["food", "dessert", "pastry"],
                    char: "🥧"
                },
                cake: {
                    keywords: ["food", "dessert"],
                    char: "🍰"
                },
                cupcake: {
                    keywords: ["food", "dessert", "bakery", "sweet"],
                    char: "🧁"
                },
                moon_cake: {
                    keywords: ["food", "autumn"],
                    char: "🥮"
                },
                birthday: {
                    keywords: ["food", "dessert", "cake"],
                    char: "🎂"
                },
                custard: {
                    keywords: ["dessert", "food"],
                    char: "🍮"
                },
                candy: {
                    keywords: ["snack", "dessert", "sweet", "lolly"],
                    char: "🍬"
                },
                lollipop: {
                    keywords: ["food", "snack", "candy", "sweet"],
                    char: "🍭"
                },
                chocolate_bar: {
                    keywords: ["food", "snack", "dessert", "sweet"],
                    char: "🍫"
                },
                popcorn: {
                    keywords: ["food", "movie theater", "films", "snack"],
                    char: "🍿"
                },
                dumpling: {
                    keywords: ["food", "empanada", "pierogi", "potsticker"],
                    char: "🥟"
                },
                doughnut: {
                    keywords: ["food", "dessert", "snack", "sweet", "donut"],
                    char: "🍩"
                },
                cookie: {
                    keywords: ["food", "snack", "oreo", "chocolate", "sweet", "dessert"],
                    char: "🍪"
                },
                milk_glass: {
                    keywords: ["beverage", "drink", "cow"],
                    char: "🥛"
                },
                beer: {
                    keywords: [
                        "relax",
                        "beverage",
                        "drink",
                        "drunk",
                        "party",
                        "pub",
                        "summer",
                        "alcohol",
                        "booze"
                    ],
                    char: "🍺"
                },
                beers: {
                    keywords: [
                        "relax",
                        "beverage",
                        "drink",
                        "drunk",
                        "party",
                        "pub",
                        "summer",
                        "alcohol",
                        "booze"
                    ],
                    char: "🍻"
                },
                clinking_glasses: {
                    keywords: [
                        "beverage",
                        "drink",
                        "party",
                        "alcohol",
                        "celebrate",
                        "cheers",
                        "wine",
                        "champagne",
                        "toast"
                    ],
                    char: "🥂"
                },
                wine_glass: {
                    keywords: ["drink", "beverage", "drunk", "alcohol", "booze"],
                    char: "🍷"
                },
                tumbler_glass: {
                    keywords: [
                        "drink",
                        "beverage",
                        "drunk",
                        "alcohol",
                        "liquor",
                        "booze",
                        "bourbon",
                        "scotch",
                        "whisky",
                        "glass",
                        "shot"
                    ],
                    char: "🥃"
                },
                cocktail: {
                    keywords: [
                        "drink",
                        "drunk",
                        "alcohol",
                        "beverage",
                        "booze",
                        "mojito"
                    ],
                    char: "🍸"
                },
                tropical_drink: {
                    keywords: [
                        "beverage",
                        "cocktail",
                        "summer",
                        "beach",
                        "alcohol",
                        "booze",
                        "mojito"
                    ],
                    char: "🍹"
                },
                champagne: {
                    keywords: ["drink", "wine", "bottle", "celebration"],
                    char: "🍾"
                },
                sake: {
                    keywords: [
                        "wine",
                        "drink",
                        "drunk",
                        "beverage",
                        "japanese",
                        "alcohol",
                        "booze"
                    ],
                    char: "🍶"
                },
                tea: {
                    keywords: ["drink", "bowl", "breakfast", "green", "british"],
                    char: "🍵"
                },
                cup_with_straw: {
                    keywords: ["drink", "soda"],
                    char: "🥤"
                },
                coffee: {
                    keywords: ["beverage", "caffeine", "latte", "espresso"],
                    char: "☕"
                },
                baby_bottle: {
                    keywords: ["food", "container", "milk"],
                    char: "🍼"
                },
                salt: {
                    keywords: ["condiment", "shaker"],
                    char: "🧂"
                },
                spoon: {
                    keywords: ["cutlery", "kitchen", "tableware"],
                    char: "🥄"
                },
                fork_and_knife: {
                    keywords: ["cutlery", "kitchen"],
                    char: "🍴"
                },
                plate_with_cutlery: {
                    keywords: ["food", "eat", "meal", "lunch", "dinner", "restaurant"],
                    char: "🍽"
                },
                bowl_with_spoon: {
                    keywords: ["food", "breakfast", "cereal", "oatmeal", "porridge"],
                    char: "🥣"
                },
                takeout_box: {
                    keywords: ["food", "leftovers"],
                    char: "🥡"
                },
                chopsticks: {
                    keywords: ["food"],
                    char: "🥢"
                }
            }
        }
    },
    {
        activity: {
            id: "activity",
            name: "Activity",
            symbol: activityIcon,
            emojis: {
                soccer: {
                    keywords: ["sports", "football"],
                    char: "⚽"
                },
                basketball: {
                    keywords: ["sports", "balls", "NBA"],
                    char: "🏀"
                },
                football: {
                    keywords: ["sports", "balls", "NFL"],
                    char: "🏈"
                },
                baseball: {
                    keywords: ["sports", "balls"],
                    char: "⚾"
                },
                softball: {
                    keywords: ["sports", "balls"],
                    char: "🥎"
                },
                tennis: {
                    keywords: ["sports", "balls", "green"],
                    char: "🎾"
                },
                volleyball: {
                    keywords: ["sports", "balls"],
                    char: "🏐"
                },
                rugby_football: {
                    keywords: ["sports", "team"],
                    char: "🏉"
                },
                flying_disc: {
                    keywords: ["sports", "frisbee", "ultimate"],
                    char: "🥏"
                },
                "8ball": {
                    keywords: ["pool", "hobby", "game", "luck", "magic"],
                    char: "🎱"
                },
                golf: {
                    keywords: ["sports", "business", "flag", "hole", "summer"],
                    char: "⛳"
                },
                golfing_woman: {
                    keywords: ["sports", "business", "woman", "female"],
                    char: "🏌️‍♀️"
                },
                golfing_man: {
                    keywords: ["sports", "business"],
                    char: "🏌",
                    fitzpatrick_scale: true
                },
                ping_pong: {
                    keywords: ["sports", "pingpong"],
                    char: "🏓"
                },
                badminton: {
                    keywords: ["sports"],
                    char: "🏸"
                },
                goal_net: {
                    keywords: ["sports"],
                    char: "🥅"
                },
                ice_hockey: {
                    keywords: ["sports"],
                    char: "🏒"
                },
                field_hockey: {
                    keywords: ["sports"],
                    char: "🏑"
                },
                lacrosse: {
                    keywords: ["sports", "ball", "stick"],
                    char: "🥍"
                },
                cricket: {
                    keywords: ["sports"],
                    char: "🏏"
                },
                ski: {
                    keywords: ["sports", "winter", "cold", "snow"],
                    char: "🎿"
                },
                skier: {
                    keywords: ["sports", "winter", "snow"],
                    char: "⛷"
                },
                snowboarder: {
                    keywords: ["sports", "winter"],
                    char: "🏂",
                    fitzpatrick_scale: true
                },
                person_fencing: {
                    keywords: ["sports", "fencing", "sword"],
                    char: "🤺"
                },
                women_wrestling: {
                    keywords: ["sports", "wrestlers"],
                    char: "🤼‍♀️"
                },
                men_wrestling: {
                    keywords: ["sports", "wrestlers"],
                    char: "🤼‍♂️"
                },
                woman_cartwheeling: {
                    keywords: ["gymnastics"],
                    char: "🤸‍♀️",
                    fitzpatrick_scale: true
                },
                man_cartwheeling: {
                    keywords: ["gymnastics"],
                    char: "🤸‍♂️",
                    fitzpatrick_scale: true
                },
                woman_playing_handball: {
                    keywords: ["sports"],
                    char: "🤾‍♀️",
                    fitzpatrick_scale: true
                },
                man_playing_handball: {
                    keywords: ["sports"],
                    char: "🤾‍♂️",
                    fitzpatrick_scale: true
                },
                ice_skate: {
                    keywords: ["sports"],
                    char: "⛸"
                },
                curling_stone: {
                    keywords: ["sports"],
                    char: "🥌"
                },
                skateboard: {
                    keywords: ["board"],
                    char: "🛹"
                },
                sled: {
                    keywords: ["sleigh", "luge", "toboggan"],
                    char: "🛷"
                },
                bow_and_arrow: {
                    keywords: ["sports"],
                    char: "🏹"
                },
                fishing_pole_and_fish: {
                    keywords: ["food", "hobby", "summer"],
                    char: "🎣"
                },
                boxing_glove: {
                    keywords: ["sports", "fighting"],
                    char: "🥊"
                },
                martial_arts_uniform: {
                    keywords: ["judo", "karate", "taekwondo"],
                    char: "🥋"
                },
                rowing_woman: {
                    keywords: ["sports", "hobby", "water", "ship", "woman", "female"],
                    char: "🚣‍♀️",
                    fitzpatrick_scale: true
                },
                rowing_man: {
                    keywords: ["sports", "hobby", "water", "ship"],
                    char: "🚣",
                    fitzpatrick_scale: true
                },
                climbing_woman: {
                    keywords: ["sports", "hobby", "woman", "female", "rock"],
                    char: "🧗‍♀️",
                    fitzpatrick_scale: true
                },
                climbing_man: {
                    keywords: ["sports", "hobby", "man", "male", "rock"],
                    char: "🧗‍♂️",
                    fitzpatrick_scale: true
                },
                swimming_woman: {
                    keywords: [
                        "sports",
                        "exercise",
                        "human",
                        "athlete",
                        "water",
                        "summer",
                        "woman",
                        "female"
                    ],
                    char: "🏊‍♀️",
                    fitzpatrick_scale: true
                },
                swimming_man: {
                    keywords: [
                        "sports",
                        "exercise",
                        "human",
                        "athlete",
                        "water",
                        "summer"
                    ],
                    char: "🏊",
                    fitzpatrick_scale: true
                },
                woman_playing_water_polo: {
                    keywords: ["sports", "pool"],
                    char: "🤽‍♀️",
                    fitzpatrick_scale: true
                },
                man_playing_water_polo: {
                    keywords: ["sports", "pool"],
                    char: "🤽‍♂️",
                    fitzpatrick_scale: true
                },
                woman_in_lotus_position: {
                    keywords: [
                        "woman",
                        "female",
                        "meditation",
                        "yoga",
                        "serenity",
                        "zen",
                        "mindfulness"
                    ],
                    char: "🧘‍♀️",
                    fitzpatrick_scale: true
                },
                man_in_lotus_position: {
                    keywords: [
                        "man",
                        "male",
                        "meditation",
                        "yoga",
                        "serenity",
                        "zen",
                        "mindfulness"
                    ],
                    char: "🧘‍♂️",
                    fitzpatrick_scale: true
                },
                surfing_woman: {
                    keywords: [
                        "sports",
                        "ocean",
                        "sea",
                        "summer",
                        "beach",
                        "woman",
                        "female"
                    ],
                    char: "🏄‍♀️",
                    fitzpatrick_scale: true
                },
                surfing_man: {
                    keywords: ["sports", "ocean", "sea", "summer", "beach"],
                    char: "🏄",
                    fitzpatrick_scale: true
                },
                bath: {
                    keywords: ["clean", "shower", "bathroom"],
                    char: "🛀",
                    fitzpatrick_scale: true
                },
                basketball_woman: {
                    keywords: ["sports", "human", "woman", "female"],
                    char: "⛹️‍♀️",
                    fitzpatrick_scale: true
                },
                basketball_man: {
                    keywords: ["sports", "human"],
                    char: "⛹",
                    fitzpatrick_scale: true
                },
                weight_lifting_woman: {
                    keywords: ["sports", "training", "exercise", "woman", "female"],
                    char: "🏋️‍♀️",
                    fitzpatrick_scale: true
                },
                weight_lifting_man: {
                    keywords: ["sports", "training", "exercise"],
                    char: "🏋",
                    fitzpatrick_scale: true
                },
                biking_woman: {
                    keywords: [
                        "sports",
                        "bike",
                        "exercise",
                        "hipster",
                        "woman",
                        "female"
                    ],
                    char: "🚴‍♀️",
                    fitzpatrick_scale: true
                },
                biking_man: {
                    keywords: ["sports", "bike", "exercise", "hipster"],
                    char: "🚴",
                    fitzpatrick_scale: true
                },
                mountain_biking_woman: {
                    keywords: [
                        "transportation",
                        "sports",
                        "human",
                        "race",
                        "bike",
                        "woman",
                        "female"
                    ],
                    char: "🚵‍♀️",
                    fitzpatrick_scale: true
                },
                mountain_biking_man: {
                    keywords: ["transportation", "sports", "human", "race", "bike"],
                    char: "🚵",
                    fitzpatrick_scale: true
                },
                horse_racing: {
                    keywords: ["animal", "betting", "competition", "gambling", "luck"],
                    char: "🏇",
                    fitzpatrick_scale: true
                },
                business_suit_levitating: {
                    keywords: ["suit", "business", "levitate", "hover", "jump"],
                    char: "🕴",
                    fitzpatrick_scale: true
                },
                trophy: {
                    keywords: ["win", "award", "contest", "place", "ftw", "ceremony"],
                    char: "🏆"
                },
                running_shirt_with_sash: {
                    keywords: ["play", "pageant"],
                    char: "🎽"
                },
                medal_sports: {
                    keywords: ["award", "winning"],
                    char: "🏅"
                },
                medal_military: {
                    keywords: ["award", "winning", "army"],
                    char: "🎖"
                },
                "1st_place_medal": {
                    keywords: ["award", "winning", "first"],
                    char: "🥇"
                },
                "2nd_place_medal": {
                    keywords: ["award", "second"],
                    char: "🥈"
                },
                "3rd_place_medal": {
                    keywords: ["award", "third"],
                    char: "🥉"
                },
                reminder_ribbon: {
                    keywords: ["sports", "cause", "support", "awareness"],
                    char: "🎗"
                },
                rosette: {
                    keywords: ["flower", "decoration", "military"],
                    char: "🏵"
                },
                ticket: {
                    keywords: ["event", "concert", "pass"],
                    char: "🎫"
                },
                tickets: {
                    keywords: ["sports", "concert", "entrance"],
                    char: "🎟"
                },
                performing_arts: {
                    keywords: ["acting", "theater", "drama"],
                    char: "🎭"
                },
                art: {
                    keywords: ["design", "paint", "draw", "colors"],
                    char: "🎨"
                },
                circus_tent: {
                    keywords: ["festival", "carnival", "party"],
                    char: "🎪"
                },
                woman_juggling: {
                    keywords: ["juggle", "balance", "skill", "multitask"],
                    char: "🤹‍♀️",
                    fitzpatrick_scale: true
                },
                man_juggling: {
                    keywords: ["juggle", "balance", "skill", "multitask"],
                    char: "🤹‍♂️",
                    fitzpatrick_scale: true
                },
                microphone: {
                    keywords: ["sound", "music", "PA", "sing", "talkshow"],
                    char: "🎤"
                },
                headphones: {
                    keywords: ["music", "score", "gadgets"],
                    char: "🎧"
                },
                musical_score: {
                    keywords: ["treble", "clef", "compose"],
                    char: "🎼"
                },
                musical_keyboard: {
                    keywords: ["piano", "instrument", "compose"],
                    char: "🎹"
                },
                drum: {
                    keywords: ["music", "instrument", "drumsticks", "snare"],
                    char: "🥁"
                },
                saxophone: {
                    keywords: ["music", "instrument", "jazz", "blues"],
                    char: "🎷"
                },
                trumpet: {
                    keywords: ["music", "brass"],
                    char: "🎺"
                },
                guitar: {
                    keywords: ["music", "instrument"],
                    char: "🎸"
                },
                violin: {
                    keywords: ["music", "instrument", "orchestra", "symphony"],
                    char: "🎻"
                },
                clapper: {
                    keywords: ["movie", "film", "record"],
                    char: "🎬"
                },
                video_game: {
                    keywords: ["play", "console", "PS4", "controller"],
                    char: "🎮"
                },
                space_invader: {
                    keywords: ["game", "arcade", "play"],
                    char: "👾"
                },
                dart: {
                    keywords: ["game", "play", "bar", "target", "bullseye"],
                    char: "🎯"
                },
                game_die: {
                    keywords: ["dice", "random", "tabletop", "play", "luck"],
                    char: "🎲"
                },
                chess_pawn: {
                    keywords: ["expendable"],
                    char: "♟"
                },
                slot_machine: {
                    keywords: [
                        "bet",
                        "gamble",
                        "vegas",
                        "fruit machine",
                        "luck",
                        "casino"
                    ],
                    char: "🎰"
                },
                jigsaw: {
                    keywords: ["interlocking", "puzzle", "piece"],
                    char: "🧩"
                },
                bowling: {
                    keywords: ["sports", "fun", "play"],
                    char: "🎳"
                }
            }
        }
    },
    {
        travel_and_places: {
            id: "travel_and_places",
            name: "Travel & Places",
            symbol: travelIcon,
            emojis: {
                red_car: {
                    keywords: ["red", "transportation", "vehicle"],
                    char: "🚗"
                },
                taxi: {
                    keywords: ["uber", "vehicle", "cars", "transportation"],
                    char: "🚕"
                },
                blue_car: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚙"
                },
                bus: {
                    keywords: ["car", "vehicle", "transportation"],
                    char: "🚌"
                },
                trolleybus: {
                    keywords: ["bart", "transportation", "vehicle"],
                    char: "🚎"
                },
                racing_car: {
                    keywords: ["sports", "race", "fast", "formula", "f1"],
                    char: "🏎"
                },
                police_car: {
                    keywords: [
                        "vehicle",
                        "cars",
                        "transportation",
                        "law",
                        "legal",
                        "enforcement"
                    ],
                    char: "🚓"
                },
                ambulance: {
                    keywords: ["health", "911", "hospital"],
                    char: "🚑"
                },
                fire_engine: {
                    keywords: ["transportation", "cars", "vehicle"],
                    char: "🚒"
                },
                minibus: {
                    keywords: ["vehicle", "car", "transportation"],
                    char: "🚐"
                },
                truck: {
                    keywords: ["cars", "transportation"],
                    char: "🚚"
                },
                articulated_lorry: {
                    keywords: ["vehicle", "cars", "transportation", "express"],
                    char: "🚛"
                },
                tractor: {
                    keywords: ["vehicle", "car", "farming", "agriculture"],
                    char: "🚜"
                },
                kick_scooter: {
                    keywords: ["vehicle", "kick", "razor"],
                    char: "🛴"
                },
                motorcycle: {
                    keywords: ["race", "sports", "fast"],
                    char: "🏍"
                },
                bike: {
                    keywords: ["sports", "bicycle", "exercise", "hipster"],
                    char: "🚲"
                },
                motor_scooter: {
                    keywords: ["vehicle", "vespa", "sasha"],
                    char: "🛵"
                },
                rotating_light: {
                    keywords: [
                        "police",
                        "ambulance",
                        "911",
                        "emergency",
                        "alert",
                        "error",
                        "pinged",
                        "law",
                        "legal"
                    ],
                    char: "🚨"
                },
                oncoming_police_car: {
                    keywords: ["vehicle", "law", "legal", "enforcement", "911"],
                    char: "🚔"
                },
                oncoming_bus: {
                    keywords: ["vehicle", "transportation"],
                    char: "🚍"
                },
                oncoming_automobile: {
                    keywords: ["car", "vehicle", "transportation"],
                    char: "🚘"
                },
                oncoming_taxi: {
                    keywords: ["vehicle", "cars", "uber"],
                    char: "🚖"
                },
                aerial_tramway: {
                    keywords: ["transportation", "vehicle", "ski"],
                    char: "🚡"
                },
                mountain_cableway: {
                    keywords: ["transportation", "vehicle", "ski"],
                    char: "🚠"
                },
                suspension_railway: {
                    keywords: ["vehicle", "transportation"],
                    char: "🚟"
                },
                railway_car: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚃"
                },
                train: {
                    keywords: [
                        "transportation",
                        "vehicle",
                        "carriage",
                        "public",
                        "travel"
                    ],
                    char: "🚋"
                },
                monorail: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚝"
                },
                bullettrain_side: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚄"
                },
                bullettrain_front: {
                    keywords: [
                        "transportation",
                        "vehicle",
                        "speed",
                        "fast",
                        "public",
                        "travel"
                    ],
                    char: "🚅"
                },
                light_rail: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚈"
                },
                mountain_railway: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚞"
                },
                steam_locomotive: {
                    keywords: ["transportation", "vehicle", "train"],
                    char: "🚂"
                },
                train2: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚆"
                },
                metro: {
                    keywords: [
                        "transportation",
                        "blue-square",
                        "mrt",
                        "underground",
                        "tube"
                    ],
                    char: "🚇"
                },
                tram: {
                    keywords: ["transportation", "vehicle"],
                    char: "🚊"
                },
                station: {
                    keywords: ["transportation", "vehicle", "public"],
                    char: "🚉"
                },
                flying_saucer: {
                    keywords: ["transportation", "vehicle", "ufo"],
                    char: "🛸"
                },
                helicopter: {
                    keywords: ["transportation", "vehicle", "fly"],
                    char: "🚁"
                },
                small_airplane: {
                    keywords: ["flight", "transportation", "fly", "vehicle"],
                    char: "🛩"
                },
                airplane: {
                    keywords: ["vehicle", "transportation", "flight", "fly"],
                    char: "✈️"
                },
                flight_departure: {
                    keywords: ["airport", "flight", "landing"],
                    char: "🛫"
                },
                flight_arrival: {
                    keywords: ["airport", "flight", "boarding"],
                    char: "🛬"
                },
                sailboat: {
                    keywords: ["ship", "summer", "transportation", "water", "sailing"],
                    char: "⛵"
                },
                motor_boat: {
                    keywords: ["ship"],
                    char: "🛥"
                },
                speedboat: {
                    keywords: ["ship", "transportation", "vehicle", "summer"],
                    char: "🚤"
                },
                ferry: {
                    keywords: ["boat", "ship", "yacht"],
                    char: "⛴"
                },
                passenger_ship: {
                    keywords: ["yacht", "cruise", "ferry"],
                    char: "🛳"
                },
                rocket: {
                    keywords: [
                        "launch",
                        "ship",
                        "staffmode",
                        "NASA",
                        "outer space",
                        "outer_space",
                        "fly"
                    ],
                    char: "🚀"
                },
                artificial_satellite: {
                    keywords: [
                        "communication",
                        "gps",
                        "orbit",
                        "spaceflight",
                        "NASA",
                        "ISS"
                    ],
                    char: "🛰"
                },
                seat: {
                    keywords: ["sit", "airplane", "transport", "bus", "flight", "fly"],
                    char: "💺"
                },
                canoe: {
                    keywords: ["boat", "paddle", "water", "ship"],
                    char: "🛶"
                },
                anchor: {
                    keywords: ["ship", "ferry", "sea", "boat"],
                    char: "⚓"
                },
                construction: {
                    keywords: ["wip", "progress", "caution", "warning"],
                    char: "🚧"
                },
                fuelpump: {
                    keywords: ["gas station", "petroleum"],
                    char: "⛽"
                },
                busstop: {
                    keywords: ["transportation", "wait"],
                    char: "🚏"
                },
                vertical_traffic_light: {
                    keywords: ["transportation", "driving"],
                    char: "🚦"
                },
                traffic_light: {
                    keywords: ["transportation", "signal"],
                    char: "🚥"
                },
                checkered_flag: {
                    keywords: ["contest", "finishline", "race", "gokart"],
                    char: "🏁"
                },
                ship: {
                    keywords: ["transportation", "titanic", "deploy"],
                    char: "🚢"
                },
                ferris_wheel: {
                    keywords: ["photo", "carnival", "londoneye"],
                    char: "🎡"
                },
                roller_coaster: {
                    keywords: ["carnival", "playground", "photo", "fun"],
                    char: "🎢"
                },
                carousel_horse: {
                    keywords: ["photo", "carnival"],
                    char: "🎠"
                },
                building_construction: {
                    keywords: ["wip", "working", "progress"],
                    char: "🏗"
                },
                foggy: {
                    keywords: ["photo", "mountain"],
                    char: "🌁"
                },
                tokyo_tower: {
                    keywords: ["photo", "japanese"],
                    char: "🗼"
                },
                factory: {
                    keywords: ["building", "industry", "pollution", "smoke"],
                    char: "🏭"
                },
                fountain: {
                    keywords: ["photo", "summer", "water", "fresh"],
                    char: "⛲"
                },
                rice_scene: {
                    keywords: ["photo", "japan", "asia", "tsukimi"],
                    char: "🎑"
                },
                mountain: {
                    keywords: ["photo", "nature", "environment"],
                    char: "⛰"
                },
                mountain_snow: {
                    keywords: ["photo", "nature", "environment", "winter", "cold"],
                    char: "🏔"
                },
                mount_fuji: {
                    keywords: ["photo", "mountain", "nature", "japanese"],
                    char: "🗻"
                },
                volcano: {
                    keywords: ["photo", "nature", "disaster"],
                    char: "🌋"
                },
                japan: {
                    keywords: ["nation", "country", "japanese", "asia"],
                    char: "🗾"
                },
                camping: {
                    keywords: ["photo", "outdoors", "tent"],
                    char: "🏕"
                },
                tent: {
                    keywords: ["photo", "camping", "outdoors"],
                    char: "⛺"
                },
                national_park: {
                    keywords: ["photo", "environment", "nature"],
                    char: "🏞"
                },
                motorway: {
                    keywords: ["road", "cupertino", "interstate", "highway"],
                    char: "🛣"
                },
                railway_track: {
                    keywords: ["train", "transportation"],
                    char: "🛤"
                },
                sunrise: {
                    keywords: ["morning", "view", "vacation", "photo"],
                    char: "🌅"
                },
                sunrise_over_mountains: {
                    keywords: ["view", "vacation", "photo"],
                    char: "🌄"
                },
                desert: {
                    keywords: ["photo", "warm", "saharah"],
                    char: "🏜"
                },
                beach_umbrella: {
                    keywords: ["weather", "summer", "sunny", "sand", "mojito"],
                    char: "🏖"
                },
                desert_island: {
                    keywords: ["photo", "tropical", "mojito"],
                    char: "🏝"
                },
                city_sunrise: {
                    keywords: ["photo", "good morning", "dawn"],
                    char: "🌇"
                },
                city_sunset: {
                    keywords: ["photo", "evening", "sky", "buildings"],
                    char: "🌆"
                },
                cityscape: {
                    keywords: ["photo", "night life", "urban"],
                    char: "🏙"
                },
                night_with_stars: {
                    keywords: ["evening", "city", "downtown"],
                    char: "🌃"
                },
                bridge_at_night: {
                    keywords: ["photo", "sanfrancisco"],
                    char: "🌉"
                },
                milky_way: {
                    keywords: ["photo", "space", "stars"],
                    char: "🌌"
                },
                stars: {
                    keywords: ["night", "photo"],
                    char: "🌠"
                },
                sparkler: {
                    keywords: ["stars", "night", "shine"],
                    char: "🎇"
                },
                fireworks: {
                    keywords: ["photo", "festival", "carnival", "congratulations"],
                    char: "🎆"
                },
                rainbow: {
                    keywords: [
                        "nature",
                        "happy",
                        "unicorn_face",
                        "photo",
                        "sky",
                        "spring"
                    ],
                    char: "🌈"
                },
                houses: {
                    keywords: ["buildings", "photo"],
                    char: "🏘"
                },
                european_castle: {
                    keywords: ["building", "royalty", "history"],
                    char: "🏰"
                },
                japanese_castle: {
                    keywords: ["photo", "building"],
                    char: "🏯"
                },
                stadium: {
                    keywords: ["photo", "place", "sports", "concert", "venue"],
                    char: "🏟"
                },
                statue_of_liberty: {
                    keywords: ["american", "newyork"],
                    char: "🗽"
                },
                house: {
                    keywords: ["building", "home"],
                    char: "🏠"
                },
                house_with_garden: {
                    keywords: ["home", "plant", "nature"],
                    char: "🏡"
                },
                derelict_house: {
                    keywords: ["abandon", "evict", "broken", "building"],
                    char: "🏚"
                },
                office: {
                    keywords: ["building", "bureau", "work"],
                    char: "🏢"
                },
                department_store: {
                    keywords: ["building", "shopping", "mall"],
                    char: "🏬"
                },
                post_office: {
                    keywords: ["building", "envelope", "communication"],
                    char: "🏣"
                },
                european_post_office: {
                    keywords: ["building", "email"],
                    char: "🏤"
                },
                hospital: {
                    keywords: ["building", "health", "surgery", "doctor"],
                    char: "🏥"
                },
                bank: {
                    keywords: [
                        "building",
                        "money",
                        "sales",
                        "cash",
                        "business",
                        "enterprise"
                    ],
                    char: "🏦"
                },
                hotel: {
                    keywords: ["building", "accomodation", "checkin"],
                    char: "🏨"
                },
                convenience_store: {
                    keywords: ["building", "shopping", "groceries"],
                    char: "🏪"
                },
                school: {
                    keywords: ["building", "student", "education", "learn", "teach"],
                    char: "🏫"
                },
                love_hotel: {
                    keywords: ["like", "affection", "dating"],
                    char: "🏩"
                },
                wedding: {
                    keywords: [
                        "love",
                        "like",
                        "affection",
                        "couple",
                        "marriage",
                        "bride",
                        "groom"
                    ],
                    char: "💒"
                },
                classical_building: {
                    keywords: ["art", "culture", "history"],
                    char: "🏛"
                },
                church: {
                    keywords: ["building", "religion", "christ"],
                    char: "⛪"
                },
                mosque: {
                    keywords: ["islam", "worship", "minaret"],
                    char: "🕌"
                },
                synagogue: {
                    keywords: ["judaism", "worship", "temple", "jewish"],
                    char: "🕍"
                },
                kaaba: {
                    keywords: ["mecca", "mosque", "islam"],
                    char: "🕋"
                },
                shinto_shrine: {
                    keywords: ["temple", "japan", "kyoto"],
                    char: "⛩"
                }
            }
        }
    },
    {
        objects: {
            id: "objects",
            name: "Objects",
            symbol: objectsIcon,
            emojis: {
                watch: {
                    keywords: ["time", "accessories"],
                    char: "⌚"
                },
                iphone: {
                    keywords: ["technology", "apple", "gadgets", "dial"],
                    char: "📱"
                },
                calling: {
                    keywords: ["iphone", "incoming"],
                    char: "📲"
                },
                computer: {
                    keywords: ["technology", "laptop", "screen", "display", "monitor"],
                    char: "💻"
                },
                keyboard: {
                    keywords: ["technology", "computer", "type", "input", "text"],
                    char: "⌨"
                },
                desktop_computer: {
                    keywords: ["technology", "computing", "screen"],
                    char: "🖥"
                },
                printer: {
                    keywords: ["paper", "ink"],
                    char: "🖨"
                },
                computer_mouse: {
                    keywords: ["click"],
                    char: "🖱"
                },
                trackball: {
                    keywords: ["technology", "trackpad"],
                    char: "🖲"
                },
                joystick: {
                    keywords: ["game", "play"],
                    char: "🕹"
                },
                clamp: {
                    keywords: ["tool"],
                    char: "🗜"
                },
                minidisc: {
                    keywords: ["technology", "record", "emojis", "disk", "90s"],
                    char: "💽"
                },
                floppy_disk: {
                    keywords: ["oldschool", "technology", "save", "90s", "80s"],
                    char: "💾"
                },
                cd: {
                    keywords: ["technology", "dvd", "disk", "disc", "90s"],
                    char: "💿"
                },
                dvd: {
                    keywords: ["cd", "disk", "disc"],
                    char: "📀"
                },
                vhs: {
                    keywords: ["record", "video", "oldschool", "90s", "80s"],
                    char: "📼"
                },
                camera: {
                    keywords: ["gadgets", "photography"],
                    char: "📷"
                },
                camera_flash: {
                    keywords: ["photography", "gadgets"],
                    char: "📸"
                },
                video_camera: {
                    keywords: ["film", "record"],
                    char: "📹"
                },
                movie_camera: {
                    keywords: ["film", "record"],
                    char: "🎥"
                },
                film_projector: {
                    keywords: ["video", "tape", "record", "movie"],
                    char: "📽"
                },
                film_strip: {
                    keywords: ["movie"],
                    char: "🎞"
                },
                telephone_receiver: {
                    keywords: ["technology", "communication", "dial"],
                    char: "📞"
                },
                phone: {
                    keywords: ["technology", "communication", "dial", "telephone"],
                    char: "☎️"
                },
                pager: {
                    keywords: ["bbcall", "oldschool", "90s"],
                    char: "📟"
                },
                fax: {
                    keywords: ["communication", "technology"],
                    char: "📠"
                },
                tv: {
                    keywords: [
                        "technology",
                        "program",
                        "oldschool",
                        "show",
                        "television"
                    ],
                    char: "📺"
                },
                radio: {
                    keywords: ["communication", "music", "podcast", "program"],
                    char: "📻"
                },
                studio_microphone: {
                    keywords: ["sing", "recording", "artist", "talkshow"],
                    char: "🎙"
                },
                level_slider: {
                    keywords: ["scale"],
                    char: "🎚"
                },
                control_knobs: {
                    keywords: ["dial"],
                    char: "🎛"
                },
                compass: {
                    keywords: ["magnetic", "navigation", "orienteering"],
                    char: "🧭"
                },
                stopwatch: {
                    keywords: ["time", "deadline"],
                    char: "⏱"
                },
                timer_clock: {
                    keywords: ["alarm"],
                    char: "⏲"
                },
                alarm_clock: {
                    keywords: ["time", "wake"],
                    char: "⏰"
                },
                mantelpiece_clock: {
                    keywords: ["time"],
                    char: "🕰"
                },
                hourglass_flowing_sand: {
                    keywords: ["oldschool", "time", "countdown"],
                    char: "⏳"
                },
                hourglass: {
                    keywords: [
                        "time",
                        "clock",
                        "oldschool",
                        "limit",
                        "exam",
                        "quiz",
                        "test"
                    ],
                    char: "⌛"
                },
                satellite: {
                    keywords: ["communication", "future", "radio", "space"],
                    char: "📡"
                },
                battery: {
                    keywords: ["power", "energy", "sustain"],
                    char: "🔋"
                },
                electric_plug: {
                    keywords: ["charger", "power"],
                    char: "🔌"
                },
                bulb: {
                    keywords: ["light", "electricity", "idea"],
                    char: "💡"
                },
                flashlight: {
                    keywords: ["dark", "camping", "sight", "night"],
                    char: "🔦"
                },
                candle: {
                    keywords: ["fire", "wax"],
                    char: "🕯"
                },
                fire_extinguisher: {
                    keywords: ["quench"],
                    char: "🧯"
                },
                wastebasket: {
                    keywords: ["bin", "trash", "rubbish", "garbage", "toss"],
                    char: "🗑"
                },
                oil_drum: {
                    keywords: ["barrell"],
                    char: "🛢"
                },
                money_with_wings: {
                    keywords: ["dollar", "bills", "payment", "sale"],
                    char: "💸"
                },
                dollar: {
                    keywords: ["money", "sales", "bill", "currency"],
                    char: "💵"
                },
                yen: {
                    keywords: ["money", "sales", "japanese", "dollar", "currency"],
                    char: "💴"
                },
                euro: {
                    keywords: ["money", "sales", "dollar", "currency"],
                    char: "💶"
                },
                pound: {
                    keywords: [
                        "british",
                        "sterling",
                        "money",
                        "sales",
                        "bills",
                        "uk",
                        "england",
                        "currency"
                    ],
                    char: "💷"
                },
                moneybag: {
                    keywords: ["dollar", "payment", "coins", "sale"],
                    char: "💰"
                },
                credit_card: {
                    keywords: ["money", "sales", "dollar", "bill", "payment", "shopping"],
                    char: "💳"
                },
                gem: {
                    keywords: ["blue", "ruby", "diamond", "jewelry"],
                    char: "💎"
                },
                balance_scale: {
                    keywords: ["law", "fairness", "weight"],
                    char: "⚖"
                },
                toolbox: {
                    keywords: ["tools", "diy", "fix", "maintainer", "mechanic"],
                    char: "🧰"
                },
                wrench: {
                    keywords: ["tools", "diy", "ikea", "fix", "maintainer"],
                    char: "🔧"
                },
                hammer: {
                    keywords: ["tools", "build", "create"],
                    char: "🔨"
                },
                hammer_and_pick: {
                    keywords: ["tools", "build", "create"],
                    char: "⚒"
                },
                hammer_and_wrench: {
                    keywords: ["tools", "build", "create"],
                    char: "🛠"
                },
                pick: {
                    keywords: ["tools", "dig"],
                    char: "⛏"
                },
                nut_and_bolt: {
                    keywords: ["handy", "tools", "fix"],
                    char: "🔩"
                },
                gear: {
                    keywords: ["cog"],
                    char: "⚙"
                },
                brick: {
                    keywords: ["bricks"],
                    char: "🧱"
                },
                chains: {
                    keywords: ["lock", "arrest"],
                    char: "⛓"
                },
                magnet: {
                    keywords: ["attraction", "magnetic"],
                    char: "🧲"
                },
                gun: {
                    keywords: ["violence", "weapon", "pistol", "revolver"],
                    char: "🔫"
                },
                bomb: {
                    keywords: ["boom", "explode", "explosion", "terrorism"],
                    char: "💣"
                },
                firecracker: {
                    keywords: ["dynamite", "boom", "explode", "explosion", "explosive"],
                    char: "🧨"
                },
                hocho: {
                    keywords: ["knife", "blade", "cutlery", "kitchen", "weapon"],
                    char: "🔪"
                },
                dagger: {
                    keywords: ["weapon"],
                    char: "🗡"
                },
                crossed_swords: {
                    keywords: ["weapon"],
                    char: "⚔"
                },
                shield: {
                    keywords: ["protection", "security"],
                    char: "🛡"
                },
                smoking: {
                    keywords: ["kills", "tobacco", "cigarette", "joint", "smoke"],
                    char: "🚬"
                },
                skull_and_crossbones: {
                    keywords: [
                        "poison",
                        "danger",
                        "deadly",
                        "scary",
                        "death",
                        "pirate",
                        "evil"
                    ],
                    char: "☠"
                },
                coffin: {
                    keywords: [
                        "vampire",
                        "dead",
                        "die",
                        "death",
                        "rip",
                        "graveyard",
                        "cemetery",
                        "casket",
                        "funeral",
                        "box"
                    ],
                    char: "⚰"
                },
                funeral_urn: {
                    keywords: ["dead", "die", "death", "rip", "ashes"],
                    char: "⚱"
                },
                amphora: {
                    keywords: ["vase", "jar"],
                    char: "🏺"
                },
                crystal_ball: {
                    keywords: ["disco", "party", "magic", "circus", "fortune_teller"],
                    char: "🔮"
                },
                prayer_beads: {
                    keywords: ["dhikr", "religious"],
                    char: "📿"
                },
                nazar_amulet: {
                    keywords: ["bead", "charm"],
                    char: "🧿"
                },
                barber: {
                    keywords: ["hair", "salon", "style"],
                    char: "💈"
                },
                alembic: {
                    keywords: ["distilling", "science", "experiment", "chemistry"],
                    char: "⚗"
                },
                telescope: {
                    keywords: ["stars", "space", "zoom", "science", "astronomy"],
                    char: "🔭"
                },
                microscope: {
                    keywords: ["laboratory", "experiment", "zoomin", "science", "study"],
                    char: "🔬"
                },
                hole: {
                    keywords: ["embarrassing"],
                    char: "🕳"
                },
                pill: {
                    keywords: ["health", "medicine", "doctor", "pharmacy", "drug"],
                    char: "💊"
                },
                syringe: {
                    keywords: [
                        "health",
                        "hospital",
                        "drugs",
                        "blood",
                        "medicine",
                        "needle",
                        "doctor",
                        "nurse"
                    ],
                    char: "💉"
                },
                dna: {
                    keywords: ["biologist", "genetics", "life"],
                    char: "🧬"
                },
                microbe: {
                    keywords: ["amoeba", "bacteria", "germs"],
                    char: "🦠"
                },
                petri_dish: {
                    keywords: ["bacteria", "biology", "culture", "lab"],
                    char: "🧫"
                },
                test_tube: {
                    keywords: ["chemistry", "experiment", "lab", "science"],
                    char: "🧪"
                },
                thermometer: {
                    keywords: ["weather", "temperature", "hot", "cold"],
                    char: "🌡"
                },
                broom: {
                    keywords: ["cleaning", "sweeping", "witch"],
                    char: "🧹"
                },
                basket: {
                    keywords: ["laundry"],
                    char: "🧺"
                },
                toilet_paper: {
                    keywords: ["roll"],
                    char: "🧻"
                },
                label: {
                    keywords: ["sale", "tag"],
                    char: "🏷"
                },
                bookmark: {
                    keywords: ["favorite", "label", "save"],
                    char: "🔖"
                },
                toilet: {
                    keywords: ["restroom", "wc", "washroom", "bathroom", "potty"],
                    char: "🚽"
                },
                shower: {
                    keywords: ["clean", "water", "bathroom"],
                    char: "🚿"
                },
                bathtub: {
                    keywords: ["clean", "shower", "bathroom"],
                    char: "🛁"
                },
                soap: {
                    keywords: ["bar", "bathing", "cleaning", "lather"],
                    char: "🧼"
                },
                sponge: {
                    keywords: ["absorbing", "cleaning", "porous"],
                    char: "🧽"
                },
                lotion_bottle: {
                    keywords: ["moisturizer", "sunscreen"],
                    char: "🧴"
                },
                key: {
                    keywords: ["lock", "door", "password"],
                    char: "🔑"
                },
                old_key: {
                    keywords: ["lock", "door", "password"],
                    char: "🗝"
                },
                couch_and_lamp: {
                    keywords: ["read", "chill"],
                    char: "🛋"
                },
                sleeping_bed: {
                    keywords: ["bed", "rest"],
                    char: "🛌",
                    fitzpatrick_scale: true
                },
                bed: {
                    keywords: ["sleep", "rest"],
                    char: "🛏"
                },
                door: {
                    keywords: ["house", "entry", "exit"],
                    char: "🚪"
                },
                bellhop_bell: {
                    keywords: ["service"],
                    char: "🛎"
                },
                teddy_bear: {
                    keywords: ["plush", "stuffed"],
                    char: "🧸"
                },
                framed_picture: {
                    keywords: ["photography"],
                    char: "🖼"
                },
                world_map: {
                    keywords: ["location", "direction"],
                    char: "🗺"
                },
                parasol_on_ground: {
                    keywords: ["weather", "summer"],
                    char: "⛱"
                },
                moyai: {
                    keywords: ["rock", "easter island", "moai"],
                    char: "🗿"
                },
                shopping: {
                    keywords: ["mall", "buy", "purchase"],
                    char: "🛍"
                },
                shopping_cart: {
                    keywords: ["trolley"],
                    char: "🛒"
                },
                balloon: {
                    keywords: ["party", "celebration", "birthday", "circus"],
                    char: "🎈"
                },
                flags: {
                    keywords: ["fish", "japanese", "koinobori", "carp", "banner"],
                    char: "🎏"
                },
                ribbon: {
                    keywords: ["decoration", "pink", "girl", "bowtie"],
                    char: "🎀"
                },
                gift: {
                    keywords: ["present", "birthday", "christmas", "xmas"],
                    char: "🎁"
                },
                confetti_ball: {
                    keywords: ["festival", "party", "birthday", "circus"],
                    char: "🎊"
                },
                tada: {
                    keywords: [
                        "party",
                        "congratulations",
                        "birthday",
                        "magic",
                        "circus",
                        "celebration"
                    ],
                    char: "🎉"
                },
                dolls: {
                    keywords: ["japanese", "toy", "kimono"],
                    char: "🎎"
                },
                wind_chime: {
                    keywords: ["nature", "ding", "spring", "bell"],
                    char: "🎐"
                },
                crossed_flags: {
                    keywords: ["japanese", "nation", "country", "border"],
                    char: "🎌"
                },
                izakaya_lantern: {
                    keywords: ["light", "paper", "halloween", "spooky"],
                    char: "🏮"
                },
                red_envelope: {
                    keywords: ["gift"],
                    char: "🧧"
                },
                email: {
                    keywords: ["letter", "postal", "inbox", "communication"],
                    char: "✉️"
                },
                envelope_with_arrow: {
                    keywords: ["email", "communication"],
                    char: "📩"
                },
                incoming_envelope: {
                    keywords: ["email", "inbox"],
                    char: "📨"
                },
                "e-mail": {
                    keywords: ["communication", "inbox"],
                    char: "📧"
                },
                love_letter: {
                    keywords: ["email", "like", "affection", "envelope", "valentines"],
                    char: "💌"
                },
                postbox: {
                    keywords: ["email", "letter", "envelope"],
                    char: "📮"
                },
                mailbox_closed: {
                    keywords: ["email", "communication", "inbox"],
                    char: "📪"
                },
                mailbox: {
                    keywords: ["email", "inbox", "communication"],
                    char: "📫"
                },
                mailbox_with_mail: {
                    keywords: ["email", "inbox", "communication"],
                    char: "📬"
                },
                mailbox_with_no_mail: {
                    keywords: ["email", "inbox"],
                    char: "📭"
                },
                package: {
                    keywords: ["mail", "gift", "cardboard", "box", "moving"],
                    char: "📦"
                },
                postal_horn: {
                    keywords: ["instrument", "music"],
                    char: "📯"
                },
                inbox_tray: {
                    keywords: ["email", "documents"],
                    char: "📥"
                },
                outbox_tray: {
                    keywords: ["inbox", "email"],
                    char: "📤"
                },
                scroll: {
                    keywords: ["documents", "ancient", "history", "paper"],
                    char: "📜"
                },
                page_with_curl: {
                    keywords: ["documents", "office", "paper"],
                    char: "📃"
                },
                bookmark_tabs: {
                    keywords: ["favorite", "save", "order", "tidy"],
                    char: "📑"
                },
                receipt: {
                    keywords: ["accounting", "expenses"],
                    char: "🧾"
                },
                bar_chart: {
                    keywords: ["graph", "presentation", "stats"],
                    char: "📊"
                },
                chart_with_upwards_trend: {
                    keywords: [
                        "graph",
                        "presentation",
                        "stats",
                        "recovery",
                        "business",
                        "economics",
                        "money",
                        "sales",
                        "good",
                        "success"
                    ],
                    char: "📈"
                },
                chart_with_downwards_trend: {
                    keywords: [
                        "graph",
                        "presentation",
                        "stats",
                        "recession",
                        "business",
                        "economics",
                        "money",
                        "sales",
                        "bad",
                        "failure"
                    ],
                    char: "📉"
                },
                page_facing_up: {
                    keywords: ["documents", "office", "paper", "information"],
                    char: "📄"
                },
                date: {
                    keywords: ["calendar", "schedule"],
                    char: "📅"
                },
                calendar: {
                    keywords: ["schedule", "date", "planning"],
                    char: "📆"
                },
                spiral_calendar: {
                    keywords: ["date", "schedule", "planning"],
                    char: "🗓"
                },
                card_index: {
                    keywords: ["business", "stationery"],
                    char: "📇"
                },
                card_file_box: {
                    keywords: ["business", "stationery"],
                    char: "🗃"
                },
                ballot_box: {
                    keywords: ["election", "vote"],
                    char: "🗳"
                },
                file_cabinet: {
                    keywords: ["filing", "organizing"],
                    char: "🗄"
                },
                clipboard: {
                    keywords: ["stationery", "documents"],
                    char: "📋"
                },
                spiral_notepad: {
                    keywords: ["memo", "stationery"],
                    char: "🗒"
                },
                file_folder: {
                    keywords: ["documents", "business", "office"],
                    char: "📁"
                },
                open_file_folder: {
                    keywords: ["documents", "load"],
                    char: "📂"
                },
                card_index_dividers: {
                    keywords: ["organizing", "business", "stationery"],
                    char: "🗂"
                },
                newspaper_roll: {
                    keywords: ["press", "headline"],
                    char: "🗞"
                },
                newspaper: {
                    keywords: ["press", "headline"],
                    char: "📰"
                },
                notebook: {
                    keywords: ["stationery", "record", "notes", "paper", "study"],
                    char: "📓"
                },
                closed_book: {
                    keywords: ["read", "library", "knowledge", "textbook", "learn"],
                    char: "📕"
                },
                green_book: {
                    keywords: ["read", "library", "knowledge", "study"],
                    char: "📗"
                },
                blue_book: {
                    keywords: ["read", "library", "knowledge", "learn", "study"],
                    char: "📘"
                },
                orange_book: {
                    keywords: ["read", "library", "knowledge", "textbook", "study"],
                    char: "📙"
                },
                notebook_with_decorative_cover: {
                    keywords: ["classroom", "notes", "record", "paper", "study"],
                    char: "📔"
                },
                ledger: {
                    keywords: ["notes", "paper"],
                    char: "📒"
                },
                books: {
                    keywords: ["literature", "library", "study"],
                    char: "📚"
                },
                open_book: {
                    keywords: [
                        "book",
                        "read",
                        "library",
                        "knowledge",
                        "literature",
                        "learn",
                        "study"
                    ],
                    char: "📖"
                },
                safety_pin: {
                    keywords: ["diaper"],
                    char: "🧷"
                },
                link: {
                    keywords: ["rings", "url"],
                    char: "🔗"
                },
                paperclip: {
                    keywords: ["documents", "stationery"],
                    char: "📎"
                },
                paperclips: {
                    keywords: ["documents", "stationery"],
                    char: "🖇"
                },
                scissors: {
                    keywords: ["stationery", "cut"],
                    char: "✂️"
                },
                triangular_ruler: {
                    keywords: ["stationery", "math", "architect", "sketch"],
                    char: "📐"
                },
                straight_ruler: {
                    keywords: [
                        "stationery",
                        "calculate",
                        "length",
                        "math",
                        "school",
                        "drawing",
                        "architect",
                        "sketch"
                    ],
                    char: "📏"
                },
                abacus: {
                    keywords: ["calculation"],
                    char: "🧮"
                },
                pushpin: {
                    keywords: ["stationery", "mark", "here"],
                    char: "📌"
                },
                round_pushpin: {
                    keywords: ["stationery", "location", "map", "here"],
                    char: "📍"
                },
                triangular_flag_on_post: {
                    keywords: ["mark", "milestone", "place"],
                    char: "🚩"
                },
                white_flag: {
                    keywords: ["losing", "loser", "lost", "surrender", "give up", "fail"],
                    char: "🏳"
                },
                black_flag: {
                    keywords: ["pirate"],
                    char: "🏴"
                },
                rainbow_flag: {
                    keywords: [
                        "flag",
                        "rainbow",
                        "pride",
                        "gay",
                        "lgbt",
                        "glbt",
                        "queer",
                        "homosexual",
                        "lesbian",
                        "bisexual",
                        "transgender"
                    ],
                    char: "🏳️‍🌈"
                },
                closed_lock_with_key: {
                    keywords: ["security", "privacy"],
                    char: "🔐"
                },
                lock: {
                    keywords: ["security", "password", "padlock"],
                    char: "🔒"
                },
                unlock: {
                    keywords: ["privacy", "security"],
                    char: "🔓"
                },
                lock_with_ink_pen: {
                    keywords: ["security", "secret"],
                    char: "🔏"
                },
                pen: {
                    keywords: ["stationery", "writing", "write"],
                    char: "🖊"
                },
                fountain_pen: {
                    keywords: ["stationery", "writing", "write"],
                    char: "🖋"
                },
                black_nib: {
                    keywords: ["pen", "stationery", "writing", "write"],
                    char: "✒️"
                },
                memo: {
                    keywords: [
                        "write",
                        "documents",
                        "stationery",
                        "pencil",
                        "paper",
                        "writing",
                        "legal",
                        "exam",
                        "quiz",
                        "test",
                        "study",
                        "compose"
                    ],
                    char: "📝"
                },
                pencil2: {
                    keywords: [
                        "stationery",
                        "write",
                        "paper",
                        "writing",
                        "school",
                        "study"
                    ],
                    char: "✏️"
                },
                crayon: {
                    keywords: ["drawing", "creativity"],
                    char: "🖍"
                },
                paintbrush: {
                    keywords: ["drawing", "creativity", "art"],
                    char: "🖌"
                },
                mag: {
                    keywords: ["search", "zoom", "find", "detective"],
                    char: "🔍"
                },
                mag_right: {
                    keywords: ["search", "zoom", "find", "detective"],
                    char: "🔎"
                }
            }
        }
    },
    {
        symbols: {
            id: "symbols",
            name: "Symbols",
            symbol: symbolsIcon,
            emojis: {
                heart: {
                    keywords: ["love", "like", "valentines"],
                    char: "❤️"
                },
                orange_heart: {
                    keywords: ["love", "like", "affection", "valentines"],
                    char: "🧡"
                },
                yellow_heart: {
                    keywords: ["love", "like", "affection", "valentines"],
                    char: "💛"
                },
                green_heart: {
                    keywords: ["love", "like", "affection", "valentines"],
                    char: "💚"
                },
                blue_heart: {
                    keywords: ["love", "like", "affection", "valentines"],
                    char: "💙"
                },
                purple_heart: {
                    keywords: ["love", "like", "affection", "valentines"],
                    char: "💜"
                },
                black_heart: {
                    keywords: ["evil"],
                    char: "🖤"
                },
                broken_heart: {
                    keywords: ["sad", "sorry", "break", "heart", "heartbreak"],
                    char: "💔"
                },
                heavy_heart_exclamation: {
                    keywords: ["decoration", "love"],
                    char: "❣"
                },
                two_hearts: {
                    keywords: ["love", "like", "affection", "valentines", "heart"],
                    char: "💕"
                },
                revolving_hearts: {
                    keywords: ["love", "like", "affection", "valentines"],
                    char: "💞"
                },
                heartbeat: {
                    keywords: [
                        "love",
                        "like",
                        "affection",
                        "valentines",
                        "pink",
                        "heart"
                    ],
                    char: "💓"
                },
                heartpulse: {
                    keywords: ["like", "love", "affection", "valentines", "pink"],
                    char: "💗"
                },
                sparkling_heart: {
                    keywords: ["love", "like", "affection", "valentines"],
                    char: "💖"
                },
                cupid: {
                    keywords: ["love", "like", "heart", "affection", "valentines"],
                    char: "💘"
                },
                gift_heart: {
                    keywords: ["love", "valentines"],
                    char: "💝"
                },
                heart_decoration: {
                    keywords: ["purple-square", "love", "like"],
                    char: "💟"
                },
                peace_symbol: {
                    keywords: ["hippie"],
                    char: "☮"
                },
                latin_cross: {
                    keywords: ["christianity"],
                    char: "✝"
                },
                star_and_crescent: {
                    keywords: ["islam"],
                    char: "☪"
                },
                om: {
                    keywords: ["hinduism", "buddhism", "sikhism", "jainism"],
                    char: "🕉"
                },
                wheel_of_dharma: {
                    keywords: ["hinduism", "buddhism", "sikhism", "jainism"],
                    char: "☸"
                },
                star_of_david: {
                    keywords: ["judaism"],
                    char: "✡"
                },
                six_pointed_star: {
                    keywords: ["purple-square", "religion", "jewish", "hexagram"],
                    char: "🔯"
                },
                menorah: {
                    keywords: ["hanukkah", "candles", "jewish"],
                    char: "🕎"
                },
                yin_yang: {
                    keywords: ["balance"],
                    char: "☯"
                },
                orthodox_cross: {
                    keywords: ["suppedaneum", "religion"],
                    char: "☦"
                },
                place_of_worship: {
                    keywords: ["religion", "church", "temple", "prayer"],
                    char: "🛐"
                },
                ophiuchus: {
                    keywords: ["sign", "purple-square", "constellation", "astrology"],
                    char: "⛎"
                },
                aries: {
                    keywords: ["sign", "purple-square", "zodiac", "astrology"],
                    char: "♈"
                },
                taurus: {
                    keywords: ["purple-square", "sign", "zodiac", "astrology"],
                    char: "♉"
                },
                gemini: {
                    keywords: ["sign", "zodiac", "purple-square", "astrology"],
                    char: "♊"
                },
                cancer: {
                    keywords: ["sign", "zodiac", "purple-square", "astrology"],
                    char: "♋"
                },
                leo: {
                    keywords: ["sign", "purple-square", "zodiac", "astrology"],
                    char: "♌"
                },
                virgo: {
                    keywords: ["sign", "zodiac", "purple-square", "astrology"],
                    char: "♍"
                },
                libra: {
                    keywords: ["sign", "purple-square", "zodiac", "astrology"],
                    char: "♎"
                },
                scorpius: {
                    keywords: ["sign", "zodiac", "purple-square", "astrology", "scorpio"],
                    char: "♏"
                },
                sagittarius: {
                    keywords: ["sign", "zodiac", "purple-square", "astrology"],
                    char: "♐"
                },
                capricorn: {
                    keywords: ["sign", "zodiac", "purple-square", "astrology"],
                    char: "♑"
                },
                aquarius: {
                    keywords: ["sign", "purple-square", "zodiac", "astrology"],
                    char: "♒"
                },
                pisces: {
                    keywords: ["purple-square", "sign", "zodiac", "astrology"],
                    char: "♓"
                },
                id: {
                    keywords: ["purple-square", "words"],
                    char: "🆔"
                },
                atom_symbol: {
                    keywords: ["science", "physics", "chemistry"],
                    char: "⚛"
                },
                u7a7a: {
                    keywords: [
                        "kanji",
                        "japanese",
                        "chinese",
                        "empty",
                        "sky",
                        "blue-square"
                    ],
                    char: "🈳"
                },
                u5272: {
                    keywords: ["cut", "divide", "chinese", "kanji", "pink-square"],
                    char: "🈹"
                },
                radioactive: {
                    keywords: ["nuclear", "danger"],
                    char: "☢"
                },
                biohazard: {
                    keywords: ["danger"],
                    char: "☣"
                },
                mobile_phone_off: {
                    keywords: ["mute", "orange-square", "silence", "quiet"],
                    char: "📴"
                },
                vibration_mode: {
                    keywords: ["orange-square", "phone"],
                    char: "📳"
                },
                u6709: {
                    keywords: ["orange-square", "chinese", "have", "kanji"],
                    char: "🈶"
                },
                u7121: {
                    keywords: [
                        "nothing",
                        "chinese",
                        "kanji",
                        "japanese",
                        "orange-square"
                    ],
                    char: "🈚"
                },
                u7533: {
                    keywords: ["chinese", "japanese", "kanji", "orange-square"],
                    char: "🈸"
                },
                u55b6: {
                    keywords: ["japanese", "opening hours", "orange-square"],
                    char: "🈺"
                },
                u6708: {
                    keywords: [
                        "chinese",
                        "month",
                        "moon",
                        "japanese",
                        "orange-square",
                        "kanji"
                    ],
                    char: "🈷️"
                },
                eight_pointed_black_star: {
                    keywords: ["orange-square", "shape", "polygon"],
                    char: "✴️"
                },
                vs: {
                    keywords: ["words", "orange-square"],
                    char: "🆚"
                },
                accept: {
                    keywords: [
                        "ok",
                        "good",
                        "chinese",
                        "kanji",
                        "agree",
                        "yes",
                        "orange-circle"
                    ],
                    char: "🉑"
                },
                white_flower: {
                    keywords: ["japanese", "spring"],
                    char: "💮"
                },
                ideograph_advantage: {
                    keywords: ["chinese", "kanji", "obtain", "get", "circle"],
                    char: "🉐"
                },
                secret: {
                    keywords: ["privacy", "chinese", "sshh", "kanji", "red-circle"],
                    char: "㊙️"
                },
                congratulations: {
                    keywords: ["chinese", "kanji", "japanese", "red-circle"],
                    char: "㊗️"
                },
                u5408: {
                    keywords: ["japanese", "chinese", "join", "kanji", "red-square"],
                    char: "🈴"
                },
                u6e80: {
                    keywords: ["full", "chinese", "japanese", "red-square", "kanji"],
                    char: "🈵"
                },
                u7981: {
                    keywords: [
                        "kanji",
                        "japanese",
                        "chinese",
                        "forbidden",
                        "limit",
                        "restricted",
                        "red-square"
                    ],
                    char: "🈲"
                },
                a: {
                    keywords: ["red-square", "alphabet", "letter"],
                    char: "🅰️"
                },
                b: {
                    keywords: ["red-square", "alphabet", "letter"],
                    char: "🅱️"
                },
                ab: {
                    keywords: ["red-square", "alphabet"],
                    char: "🆎"
                },
                cl: {
                    keywords: ["alphabet", "words", "red-square"],
                    char: "🆑"
                },
                o2: {
                    keywords: ["alphabet", "red-square", "letter"],
                    char: "🅾️"
                },
                sos: {
                    keywords: ["help", "red-square", "words", "emergency", "911"],
                    char: "🆘"
                },
                no_entry: {
                    keywords: [
                        "limit",
                        "security",
                        "privacy",
                        "bad",
                        "denied",
                        "stop",
                        "circle"
                    ],
                    char: "⛔"
                },
                name_badge: {
                    keywords: ["fire", "forbid"],
                    char: "📛"
                },
                no_entry_sign: {
                    keywords: ["forbid", "stop", "limit", "denied", "disallow", "circle"],
                    char: "🚫"
                },
                x: {
                    keywords: ["no", "delete", "remove", "cancel", "red"],
                    char: "❌"
                },
                o: {
                    keywords: ["circle", "round"],
                    char: "⭕"
                },
                stop_sign: {
                    keywords: ["stop"],
                    char: "🛑"
                },
                anger: {
                    keywords: ["angry", "mad"],
                    char: "💢"
                },
                hotsprings: {
                    keywords: ["bath", "warm", "relax"],
                    char: "♨️"
                },
                no_pedestrians: {
                    keywords: ["rules", "crossing", "walking", "circle"],
                    char: "🚷"
                },
                do_not_litter: {
                    keywords: ["trash", "bin", "garbage", "circle"],
                    char: "🚯"
                },
                no_bicycles: {
                    keywords: ["cyclist", "prohibited", "circle"],
                    char: "🚳"
                },
                "non-potable_water": {
                    keywords: ["drink", "faucet", "tap", "circle"],
                    char: "🚱"
                },
                underage: {
                    keywords: ["18", "drink", "pub", "night", "minor", "circle"],
                    char: "🔞"
                },
                no_mobile_phones: {
                    keywords: ["iphone", "mute", "circle"],
                    char: "📵"
                },
                exclamation: {
                    keywords: [
                        "heavy_exclamation_mark",
                        "danger",
                        "surprise",
                        "punctuation",
                        "wow",
                        "warning"
                    ],
                    char: "❗"
                },
                grey_exclamation: {
                    keywords: ["surprise", "punctuation", "gray", "wow", "warning"],
                    char: "❕"
                },
                question: {
                    keywords: ["doubt", "confused"],
                    char: "❓"
                },
                grey_question: {
                    keywords: ["doubts", "gray", "huh", "confused"],
                    char: "❔"
                },
                bangbang: {
                    keywords: ["exclamation", "surprise"],
                    char: "‼️"
                },
                interrobang: {
                    keywords: ["wat", "punctuation", "surprise"],
                    char: "⁉️"
                },
                "100": {
                    keywords: [
                        "score",
                        "perfect",
                        "numbers",
                        "century",
                        "exam",
                        "quiz",
                        "test",
                        "pass",
                        "hundred"
                    ],
                    char: "💯"
                },
                low_brightness: {
                    keywords: ["sun", "afternoon", "warm", "summer"],
                    char: "🔅"
                },
                high_brightness: {
                    keywords: ["sun", "light"],
                    char: "🔆"
                },
                trident: {
                    keywords: ["weapon", "spear"],
                    char: "🔱"
                },
                fleur_de_lis: {
                    keywords: ["decorative", "scout"],
                    char: "⚜"
                },
                part_alternation_mark: {
                    keywords: [
                        "graph",
                        "presentation",
                        "stats",
                        "business",
                        "economics",
                        "bad"
                    ],
                    char: "〽️"
                },
                warning: {
                    keywords: [
                        "exclamation",
                        "wip",
                        "alert",
                        "error",
                        "problem",
                        "issue"
                    ],
                    char: "⚠️"
                },
                children_crossing: {
                    keywords: [
                        "school",
                        "warning",
                        "danger",
                        "sign",
                        "driving",
                        "yellow-diamond"
                    ],
                    char: "🚸"
                },
                beginner: {
                    keywords: ["badge", "shield"],
                    char: "🔰"
                },
                recycle: {
                    keywords: ["arrow", "environment", "garbage", "trash"],
                    char: "♻️"
                },
                u6307: {
                    keywords: ["chinese", "point", "green-square", "kanji"],
                    char: "🈯"
                },
                chart: {
                    keywords: ["green-square", "graph", "presentation", "stats"],
                    char: "💹"
                },
                sparkle: {
                    keywords: ["stars", "green-square", "awesome", "good", "fireworks"],
                    char: "❇️"
                },
                eight_spoked_asterisk: {
                    keywords: ["star", "sparkle", "green-square"],
                    char: "✳️"
                },
                negative_squared_cross_mark: {
                    keywords: ["x", "green-square", "no", "deny"],
                    char: "❎"
                },
                white_check_mark: {
                    keywords: [
                        "green-square",
                        "ok",
                        "agree",
                        "vote",
                        "election",
                        "answer",
                        "tick"
                    ],
                    char: "✅"
                },
                diamond_shape_with_a_dot_inside: {
                    keywords: ["jewel", "blue", "gem", "crystal", "fancy"],
                    char: "💠"
                },
                cyclone: {
                    keywords: [
                        "weather",
                        "swirl",
                        "blue",
                        "cloud",
                        "vortex",
                        "spiral",
                        "whirlpool",
                        "spin",
                        "tornado",
                        "hurricane",
                        "typhoon"
                    ],
                    char: "🌀"
                },
                loop: {
                    keywords: ["tape", "cassette"],
                    char: "➿"
                },
                globe_with_meridians: {
                    keywords: [
                        "earth",
                        "international",
                        "world",
                        "internet",
                        "interweb",
                        "i18n"
                    ],
                    char: "🌐"
                },
                m: {
                    keywords: ["alphabet", "blue-circle", "letter"],
                    char: "Ⓜ️"
                },
                atm: {
                    keywords: [
                        "money",
                        "sales",
                        "cash",
                        "blue-square",
                        "payment",
                        "bank"
                    ],
                    char: "🏧"
                },
                sa: {
                    keywords: ["japanese", "blue-square", "katakana"],
                    char: "🈂️"
                },
                passport_control: {
                    keywords: ["custom", "blue-square"],
                    char: "🛂"
                },
                customs: {
                    keywords: ["passport", "border", "blue-square"],
                    char: "🛃"
                },
                baggage_claim: {
                    keywords: ["blue-square", "airport", "transport"],
                    char: "🛄"
                },
                left_luggage: {
                    keywords: ["blue-square", "travel"],
                    char: "🛅"
                },
                wheelchair: {
                    keywords: ["blue-square", "disabled", "a11y", "accessibility"],
                    char: "♿"
                },
                no_smoking: {
                    keywords: ["cigarette", "blue-square", "smell", "smoke"],
                    char: "🚭"
                },
                wc: {
                    keywords: ["toilet", "restroom", "blue-square"],
                    char: "🚾"
                },
                parking: {
                    keywords: ["cars", "blue-square", "alphabet", "letter"],
                    char: "🅿️"
                },
                potable_water: {
                    keywords: ["blue-square", "liquid", "restroom", "cleaning", "faucet"],
                    char: "🚰"
                },
                mens: {
                    keywords: [
                        "toilet",
                        "restroom",
                        "wc",
                        "blue-square",
                        "gender",
                        "male"
                    ],
                    char: "🚹"
                },
                womens: {
                    keywords: [
                        "purple-square",
                        "woman",
                        "female",
                        "toilet",
                        "loo",
                        "restroom",
                        "gender"
                    ],
                    char: "🚺"
                },
                baby_symbol: {
                    keywords: ["orange-square", "child"],
                    char: "🚼"
                },
                restroom: {
                    keywords: ["blue-square", "toilet", "refresh", "wc", "gender"],
                    char: "🚻"
                },
                put_litter_in_its_place: {
                    keywords: ["blue-square", "sign", "human", "info"],
                    char: "🚮"
                },
                cinema: {
                    keywords: [
                        "blue-square",
                        "record",
                        "film",
                        "movie",
                        "curtain",
                        "stage",
                        "theater"
                    ],
                    char: "🎦"
                },
                signal_strength: {
                    keywords: [
                        "blue-square",
                        "reception",
                        "phone",
                        "internet",
                        "connection",
                        "wifi",
                        "bluetooth",
                        "bars"
                    ],
                    char: "📶"
                },
                koko: {
                    keywords: [
                        "blue-square",
                        "here",
                        "katakana",
                        "japanese",
                        "destination"
                    ],
                    char: "🈁"
                },
                ng: {
                    keywords: ["blue-square", "words", "shape", "icon"],
                    char: "🆖"
                },
                ok: {
                    keywords: ["good", "agree", "yes", "blue-square"],
                    char: "🆗"
                },
                up: {
                    keywords: ["blue-square", "above", "high"],
                    char: "🆙"
                },
                cool: {
                    keywords: ["words", "blue-square"],
                    char: "🆒"
                },
                new: {
                    keywords: ["blue-square", "words", "start"],
                    char: "🆕"
                },
                free: {
                    keywords: ["blue-square", "words"],
                    char: "🆓"
                },
                zero: {
                    keywords: ["0", "numbers", "blue-square", "null"],
                    char: "0️⃣"
                },
                one: {
                    keywords: ["blue-square", "numbers", "1"],
                    char: "1️⃣"
                },
                two: {
                    keywords: ["numbers", "2", "prime", "blue-square"],
                    char: "2️⃣"
                },
                three: {
                    keywords: ["3", "numbers", "prime", "blue-square"],
                    char: "3️⃣"
                },
                four: {
                    keywords: ["4", "numbers", "blue-square"],
                    char: "4️⃣"
                },
                five: {
                    keywords: ["5", "numbers", "blue-square", "prime"],
                    char: "5️⃣"
                },
                six: {
                    keywords: ["6", "numbers", "blue-square"],
                    char: "6️⃣"
                },
                seven: {
                    keywords: ["7", "numbers", "blue-square", "prime"],
                    char: "7️⃣"
                },
                eight: {
                    keywords: ["8", "blue-square", "numbers"],
                    char: "8️⃣"
                },
                nine: {
                    keywords: ["blue-square", "numbers", "9"],
                    char: "9️⃣"
                },
                keycap_ten: {
                    keywords: ["numbers", "10", "blue-square"],
                    char: "🔟"
                },
                asterisk: {
                    keywords: ["star", "keycap"],
                    char: "*⃣"
                },
                "1234": {
                    keywords: ["numbers", "blue-square"],
                    char: "🔢"
                },
                eject_button: {
                    keywords: ["blue-square"],
                    char: "⏏️"
                },
                arrow_forward: {
                    keywords: ["blue-square", "right", "direction", "play"],
                    char: "▶️"
                },
                pause_button: {
                    keywords: ["pause", "blue-square"],
                    char: "⏸"
                },
                next_track_button: {
                    keywords: ["forward", "next", "blue-square"],
                    char: "⏭"
                },
                stop_button: {
                    keywords: ["blue-square"],
                    char: "⏹"
                },
                record_button: {
                    keywords: ["blue-square"],
                    char: "⏺"
                },
                play_or_pause_button: {
                    keywords: ["blue-square", "play", "pause"],
                    char: "⏯"
                },
                previous_track_button: {
                    keywords: ["backward"],
                    char: "⏮"
                },
                fast_forward: {
                    keywords: ["blue-square", "play", "speed", "continue"],
                    char: "⏩"
                },
                rewind: {
                    keywords: ["play", "blue-square"],
                    char: "⏪"
                },
                twisted_rightwards_arrows: {
                    keywords: ["blue-square", "shuffle", "music", "random"],
                    char: "🔀"
                },
                repeat: {
                    keywords: ["loop", "record"],
                    char: "🔁"
                },
                repeat_one: {
                    keywords: ["blue-square", "loop"],
                    char: "🔂"
                },
                arrow_backward: {
                    keywords: ["blue-square", "left", "direction"],
                    char: "◀️"
                },
                arrow_up_small: {
                    keywords: [
                        "blue-square",
                        "triangle",
                        "direction",
                        "point",
                        "forward",
                        "top"
                    ],
                    char: "🔼"
                },
                arrow_down_small: {
                    keywords: ["blue-square", "direction", "bottom"],
                    char: "🔽"
                },
                arrow_double_up: {
                    keywords: ["blue-square", "direction", "top"],
                    char: "⏫"
                },
                arrow_double_down: {
                    keywords: ["blue-square", "direction", "bottom"],
                    char: "⏬"
                },
                arrow_right: {
                    keywords: ["blue-square", "next"],
                    char: "➡️"
                },
                arrow_left: {
                    keywords: ["blue-square", "previous", "back"],
                    char: "⬅️"
                },
                arrow_up: {
                    keywords: ["blue-square", "continue", "top", "direction"],
                    char: "⬆️"
                },
                arrow_down: {
                    keywords: ["blue-square", "direction", "bottom"],
                    char: "⬇️"
                },
                arrow_upper_right: {
                    keywords: [
                        "blue-square",
                        "point",
                        "direction",
                        "diagonal",
                        "northeast"
                    ],
                    char: "↗️"
                },
                arrow_lower_right: {
                    keywords: ["blue-square", "direction", "diagonal", "southeast"],
                    char: "↘️"
                },
                arrow_lower_left: {
                    keywords: ["blue-square", "direction", "diagonal", "southwest"],
                    char: "↙️"
                },
                arrow_upper_left: {
                    keywords: [
                        "blue-square",
                        "point",
                        "direction",
                        "diagonal",
                        "northwest"
                    ],
                    char: "↖️"
                },
                arrow_up_down: {
                    keywords: ["blue-square", "direction", "way", "vertical"],
                    char: "↕️"
                },
                left_right_arrow: {
                    keywords: ["shape", "direction", "horizontal", "sideways"],
                    char: "↔️"
                },
                arrows_counterclockwise: {
                    keywords: ["blue-square", "sync", "cycle"],
                    char: "🔄"
                },
                arrow_right_hook: {
                    keywords: ["blue-square", "return", "rotate", "direction"],
                    char: "↪️"
                },
                leftwards_arrow_with_hook: {
                    keywords: ["back", "return", "blue-square", "undo", "enter"],
                    char: "↩️"
                },
                arrow_heading_up: {
                    keywords: ["blue-square", "direction", "top"],
                    char: "⤴️"
                },
                arrow_heading_down: {
                    keywords: ["blue-square", "direction", "bottom"],
                    char: "⤵️"
                },
                hash: {
                    keywords: ["symbol", "blue-square", "twitter"],
                    char: "#️⃣"
                },
                information_source: {
                    keywords: ["blue-square", "alphabet", "letter"],
                    char: "ℹ️"
                },
                abc: {
                    keywords: ["blue-square", "alphabet"],
                    char: "🔤"
                },
                abcd: {
                    keywords: ["blue-square", "alphabet"],
                    char: "🔡"
                },
                capital_abcd: {
                    keywords: ["alphabet", "words", "blue-square"],
                    char: "🔠"
                },
                symbols: {
                    keywords: [
                        "blue-square",
                        "music",
                        "note",
                        "ampersand",
                        "percent",
                        "glyphs",
                        "characters"
                    ],
                    char: "🔣"
                },
                musical_note: {
                    keywords: ["score", "tone", "sound"],
                    char: "🎵"
                },
                notes: {
                    keywords: ["music", "score"],
                    char: "🎶"
                },
                wavy_dash: {
                    keywords: [
                        "draw",
                        "line",
                        "moustache",
                        "mustache",
                        "squiggle",
                        "scribble"
                    ],
                    char: "〰️"
                },
                curly_loop: {
                    keywords: ["scribble", "draw", "shape", "squiggle"],
                    char: "➰"
                },
                heavy_check_mark: {
                    keywords: ["ok", "nike", "answer", "yes", "tick"],
                    char: "✔️"
                },
                arrows_clockwise: {
                    keywords: ["sync", "cycle", "round", "repeat"],
                    char: "🔃"
                },
                heavy_plus_sign: {
                    keywords: ["math", "calculation", "addition", "more", "increase"],
                    char: "➕"
                },
                heavy_minus_sign: {
                    keywords: ["math", "calculation", "subtract", "less"],
                    char: "➖"
                },
                heavy_division_sign: {
                    keywords: ["divide", "math", "calculation"],
                    char: "➗"
                },
                heavy_multiplication_x: {
                    keywords: ["math", "calculation"],
                    char: "✖️"
                },
                infinity: {
                    keywords: ["forever"],
                    char: "♾"
                },
                heavy_dollar_sign: {
                    keywords: ["money", "sales", "payment", "currency", "buck"],
                    char: "💲"
                },
                currency_exchange: {
                    keywords: ["money", "sales", "dollar", "travel"],
                    char: "💱"
                },
                copyright: {
                    keywords: ["ip", "license", "circle", "law", "legal"],
                    char: "©️"
                },
                registered: {
                    keywords: ["alphabet", "circle"],
                    char: "®️"
                },
                tm: {
                    keywords: ["trademark", "brand", "law", "legal"],
                    char: "™️"
                },
                end: {
                    keywords: ["words", "arrow"],
                    char: "🔚"
                },
                back: {
                    keywords: ["arrow", "words", "return"],
                    char: "🔙"
                },
                on: {
                    keywords: ["arrow", "words"],
                    char: "🔛"
                },
                top: {
                    keywords: ["words", "blue-square"],
                    char: "🔝"
                },
                soon: {
                    keywords: ["arrow", "words"],
                    char: "🔜"
                },
                ballot_box_with_check: {
                    keywords: [
                        "ok",
                        "agree",
                        "confirm",
                        "black-square",
                        "vote",
                        "election",
                        "yes",
                        "tick"
                    ],
                    char: "☑️"
                },
                radio_button: {
                    keywords: ["input", "old", "music", "circle"],
                    char: "🔘"
                },
                white_circle: {
                    keywords: ["shape", "round"],
                    char: "⚪"
                },
                black_circle: {
                    keywords: ["shape", "button", "round"],
                    char: "⚫"
                },
                red_circle: {
                    keywords: ["shape", "error", "danger"],
                    char: "🔴"
                },
                large_blue_circle: {
                    keywords: ["shape", "icon", "button"],
                    char: "🔵"
                },
                small_orange_diamond: {
                    keywords: ["shape", "jewel", "gem"],
                    char: "🔸"
                },
                small_blue_diamond: {
                    keywords: ["shape", "jewel", "gem"],
                    char: "🔹"
                },
                large_orange_diamond: {
                    keywords: ["shape", "jewel", "gem"],
                    char: "🔶"
                },
                large_blue_diamond: {
                    keywords: ["shape", "jewel", "gem"],
                    char: "🔷"
                },
                small_red_triangle: {
                    keywords: ["shape", "direction", "up", "top"],
                    char: "🔺"
                },
                black_small_square: {
                    keywords: ["shape", "icon"],
                    char: "▪️"
                },
                white_small_square: {
                    keywords: ["shape", "icon"],
                    char: "▫️"
                },
                black_large_square: {
                    keywords: ["shape", "icon", "button"],
                    char: "⬛"
                },
                white_large_square: {
                    keywords: ["shape", "icon", "stone", "button"],
                    char: "⬜"
                },
                small_red_triangle_down: {
                    keywords: ["shape", "direction", "bottom"],
                    char: "🔻"
                },
                black_medium_square: {
                    keywords: ["shape", "button", "icon"],
                    char: "◼️"
                },
                white_medium_square: {
                    keywords: ["shape", "stone", "icon"],
                    char: "◻️"
                },
                black_medium_small_square: {
                    keywords: ["icon", "shape", "button"],
                    char: "◾"
                },
                white_medium_small_square: {
                    keywords: ["shape", "stone", "icon", "button"],
                    char: "◽"
                },
                black_square_button: {
                    keywords: ["shape", "input", "frame"],
                    char: "🔲"
                },
                white_square_button: {
                    keywords: ["shape", "input"],
                    char: "🔳"
                },
                speaker: {
                    keywords: ["sound", "volume", "silence", "broadcast"],
                    char: "🔈"
                },
                sound: {
                    keywords: ["volume", "speaker", "broadcast"],
                    char: "🔉"
                },
                loud_sound: {
                    keywords: ["volume", "noise", "noisy", "speaker", "broadcast"],
                    char: "🔊"
                },
                mute: {
                    keywords: ["sound", "volume", "silence", "quiet"],
                    char: "🔇"
                },
                mega: {
                    keywords: ["sound", "speaker", "volume"],
                    char: "📣"
                },
                loudspeaker: {
                    keywords: ["volume", "sound"],
                    char: "📢"
                },
                bell: {
                    keywords: ["sound", "notification", "christmas", "xmas", "chime"],
                    char: "🔔"
                },
                no_bell: {
                    keywords: ["sound", "volume", "mute", "quiet", "silent"],
                    char: "🔕"
                },
                black_joker: {
                    keywords: ["poker", "cards", "game", "play", "magic"],
                    char: "🃏"
                },
                mahjong: {
                    keywords: ["game", "play", "chinese", "kanji"],
                    char: "🀄"
                },
                spades: {
                    keywords: ["poker", "cards", "suits", "magic"],
                    char: "♠️"
                },
                clubs: {
                    keywords: ["poker", "cards", "magic", "suits"],
                    char: "♣️"
                },
                hearts: {
                    keywords: ["poker", "cards", "magic", "suits"],
                    char: "♥️"
                },
                diamonds: {
                    keywords: ["poker", "cards", "magic", "suits"],
                    char: "♦️"
                },
                flower_playing_cards: {
                    keywords: ["game", "sunset", "red"],
                    char: "🎴"
                },
                thought_balloon: {
                    keywords: ["bubble", "cloud", "speech", "thinking", "dream"],
                    char: "💭"
                },
                right_anger_bubble: {
                    keywords: ["caption", "speech", "thinking", "mad"],
                    char: "🗯"
                },
                speech_balloon: {
                    keywords: ["bubble", "words", "message", "talk", "chatting"],
                    char: "💬"
                },
                left_speech_bubble: {
                    keywords: ["words", "message", "talk", "chatting"],
                    char: "🗨"
                },
                clock1: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕐"
                },
                clock2: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕑"
                },
                clock3: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕒"
                },
                clock4: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕓"
                },
                clock5: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕔"
                },
                clock6: {
                    keywords: ["time", "late", "early", "schedule", "dawn", "dusk"],
                    char: "🕕"
                },
                clock7: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕖"
                },
                clock8: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕗"
                },
                clock9: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕘"
                },
                clock10: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕙"
                },
                clock11: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕚"
                },
                clock12: {
                    keywords: [
                        "time",
                        "noon",
                        "midnight",
                        "midday",
                        "late",
                        "early",
                        "schedule"
                    ],
                    char: "🕛"
                },
                clock130: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕜"
                },
                clock230: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕝"
                },
                clock330: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕞"
                },
                clock430: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕟"
                },
                clock530: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕠"
                },
                clock630: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕡"
                },
                clock730: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕢"
                },
                clock830: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕣"
                },
                clock930: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕤"
                },
                clock1030: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕥"
                },
                clock1130: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕦"
                },
                clock1230: {
                    keywords: ["time", "late", "early", "schedule"],
                    char: "🕧"
                }
            }
        }
    },
    {
        flags: {
            id: "flags",
            name: "Flags",
            symbol: flagsIcon,
            emojis: {
                afghanistan: {
                    keywords: ["af", "flag", "nation", "country", "banner"],
                    char: "🇦🇫"
                },
                aland_islands: {
                    keywords: ["Åland", "islands", "flag", "nation", "country", "banner"],
                    char: "🇦🇽"
                },
                albania: {
                    keywords: ["al", "flag", "nation", "country", "banner"],
                    char: "🇦🇱"
                },
                algeria: {
                    keywords: ["dz", "flag", "nation", "country", "banner"],
                    char: "🇩🇿"
                },
                american_samoa: {
                    keywords: ["american", "ws", "flag", "nation", "country", "banner"],
                    char: "🇦🇸"
                },
                andorra: {
                    keywords: ["ad", "flag", "nation", "country", "banner"],
                    char: "🇦🇩"
                },
                angola: {
                    keywords: ["ao", "flag", "nation", "country", "banner"],
                    char: "🇦🇴"
                },
                anguilla: {
                    keywords: ["ai", "flag", "nation", "country", "banner"],
                    char: "🇦🇮"
                },
                antarctica: {
                    keywords: ["aq", "flag", "nation", "country", "banner"],
                    char: "🇦🇶"
                },
                antigua_barbuda: {
                    keywords: [
                        "antigua",
                        "barbuda",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇦🇬"
                },
                argentina: {
                    keywords: ["ar", "flag", "nation", "country", "banner"],
                    char: "🇦🇷"
                },
                armenia: {
                    keywords: ["am", "flag", "nation", "country", "banner"],
                    char: "🇦🇲"
                },
                aruba: {
                    keywords: ["aw", "flag", "nation", "country", "banner"],
                    char: "🇦🇼"
                },
                australia: {
                    keywords: ["au", "flag", "nation", "country", "banner"],
                    char: "🇦🇺"
                },
                austria: {
                    keywords: ["at", "flag", "nation", "country", "banner"],
                    char: "🇦🇹"
                },
                azerbaijan: {
                    keywords: ["az", "flag", "nation", "country", "banner"],
                    char: "🇦🇿"
                },
                bahamas: {
                    keywords: ["bs", "flag", "nation", "country", "banner"],
                    char: "🇧🇸"
                },
                bahrain: {
                    keywords: ["bh", "flag", "nation", "country", "banner"],
                    char: "🇧🇭"
                },
                bangladesh: {
                    keywords: ["bd", "flag", "nation", "country", "banner"],
                    char: "🇧🇩"
                },
                barbados: {
                    keywords: ["bb", "flag", "nation", "country", "banner"],
                    char: "🇧🇧"
                },
                belarus: {
                    keywords: ["by", "flag", "nation", "country", "banner"],
                    char: "🇧🇾"
                },
                belgium: {
                    keywords: ["be", "flag", "nation", "country", "banner"],
                    char: "🇧🇪"
                },
                belize: {
                    keywords: ["bz", "flag", "nation", "country", "banner"],
                    char: "🇧🇿"
                },
                benin: {
                    keywords: ["bj", "flag", "nation", "country", "banner"],
                    char: "🇧🇯"
                },
                bermuda: {
                    keywords: ["bm", "flag", "nation", "country", "banner"],
                    char: "🇧🇲"
                },
                bhutan: {
                    keywords: ["bt", "flag", "nation", "country", "banner"],
                    char: "🇧🇹"
                },
                bolivia: {
                    keywords: ["bo", "flag", "nation", "country", "banner"],
                    char: "🇧🇴"
                },
                caribbean_netherlands: {
                    keywords: ["bonaire", "flag", "nation", "country", "banner"],
                    char: "🇧🇶"
                },
                bosnia_herzegovina: {
                    keywords: [
                        "bosnia",
                        "herzegovina",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇧🇦"
                },
                botswana: {
                    keywords: ["bw", "flag", "nation", "country", "banner"],
                    char: "🇧🇼"
                },
                brazil: {
                    keywords: ["br", "flag", "nation", "country", "banner"],
                    char: "🇧🇷"
                },
                british_indian_ocean_territory: {
                    keywords: [
                        "british",
                        "indian",
                        "ocean",
                        "territory",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇮🇴"
                },
                british_virgin_islands: {
                    keywords: [
                        "british",
                        "virgin",
                        "islands",
                        "bvi",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇻🇬"
                },
                brunei: {
                    keywords: ["bn", "darussalam", "flag", "nation", "country", "banner"],
                    char: "🇧🇳"
                },
                bulgaria: {
                    keywords: ["bg", "flag", "nation", "country", "banner"],
                    char: "🇧🇬"
                },
                burkina_faso: {
                    keywords: ["burkina", "faso", "flag", "nation", "country", "banner"],
                    char: "🇧🇫"
                },
                burundi: {
                    keywords: ["bi", "flag", "nation", "country", "banner"],
                    char: "🇧🇮"
                },
                cape_verde: {
                    keywords: ["cabo", "verde", "flag", "nation", "country", "banner"],
                    char: "🇨🇻"
                },
                cambodia: {
                    keywords: ["kh", "flag", "nation", "country", "banner"],
                    char: "🇰🇭"
                },
                cameroon: {
                    keywords: ["cm", "flag", "nation", "country", "banner"],
                    char: "🇨🇲"
                },
                canada: {
                    keywords: ["ca", "flag", "nation", "country", "banner"],
                    char: "🇨🇦"
                },
                canary_islands: {
                    keywords: [
                        "canary",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇮🇨"
                },
                cayman_islands: {
                    keywords: [
                        "cayman",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇰🇾"
                },
                central_african_republic: {
                    keywords: [
                        "central",
                        "african",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇨🇫"
                },
                chad: {
                    keywords: ["td", "flag", "nation", "country", "banner"],
                    char: "🇹🇩"
                },
                chile: {
                    keywords: ["flag", "nation", "country", "banner"],
                    char: "🇨🇱"
                },
                cn: {
                    keywords: [
                        "china",
                        "chinese",
                        "prc",
                        "flag",
                        "country",
                        "nation",
                        "banner"
                    ],
                    char: "🇨🇳"
                },
                christmas_island: {
                    keywords: [
                        "christmas",
                        "island",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇨🇽"
                },
                cocos_islands: {
                    keywords: [
                        "cocos",
                        "keeling",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇨🇨"
                },
                colombia: {
                    keywords: ["co", "flag", "nation", "country", "banner"],
                    char: "🇨🇴"
                },
                comoros: {
                    keywords: ["km", "flag", "nation", "country", "banner"],
                    char: "🇰🇲"
                },
                congo_brazzaville: {
                    keywords: ["congo", "flag", "nation", "country", "banner"],
                    char: "🇨🇬"
                },
                congo_kinshasa: {
                    keywords: [
                        "congo",
                        "democratic",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇨🇩"
                },
                cook_islands: {
                    keywords: ["cook", "islands", "flag", "nation", "country", "banner"],
                    char: "🇨🇰"
                },
                costa_rica: {
                    keywords: ["costa", "rica", "flag", "nation", "country", "banner"],
                    char: "🇨🇷"
                },
                croatia: {
                    keywords: ["hr", "flag", "nation", "country", "banner"],
                    char: "🇭🇷"
                },
                cuba: {
                    keywords: ["cu", "flag", "nation", "country", "banner"],
                    char: "🇨🇺"
                },
                curacao: {
                    keywords: ["curaçao", "flag", "nation", "country", "banner"],
                    char: "🇨🇼"
                },
                cyprus: {
                    keywords: ["cy", "flag", "nation", "country", "banner"],
                    char: "🇨🇾"
                },
                czech_republic: {
                    keywords: ["cz", "flag", "nation", "country", "banner"],
                    char: "🇨🇿"
                },
                denmark: {
                    keywords: ["dk", "flag", "nation", "country", "banner"],
                    char: "🇩🇰"
                },
                djibouti: {
                    keywords: ["dj", "flag", "nation", "country", "banner"],
                    char: "🇩🇯"
                },
                dominica: {
                    keywords: ["dm", "flag", "nation", "country", "banner"],
                    char: "🇩🇲"
                },
                dominican_republic: {
                    keywords: [
                        "dominican",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇩🇴"
                },
                ecuador: {
                    keywords: ["ec", "flag", "nation", "country", "banner"],
                    char: "🇪🇨"
                },
                egypt: {
                    keywords: ["eg", "flag", "nation", "country", "banner"],
                    char: "🇪🇬"
                },
                el_salvador: {
                    keywords: ["el", "salvador", "flag", "nation", "country", "banner"],
                    char: "🇸🇻"
                },
                equatorial_guinea: {
                    keywords: ["equatorial", "gn", "flag", "nation", "country", "banner"],
                    char: "🇬🇶"
                },
                eritrea: {
                    keywords: ["er", "flag", "nation", "country", "banner"],
                    char: "🇪🇷"
                },
                estonia: {
                    keywords: ["ee", "flag", "nation", "country", "banner"],
                    char: "🇪🇪"
                },
                ethiopia: {
                    keywords: ["et", "flag", "nation", "country", "banner"],
                    char: "🇪🇹"
                },
                eu: {
                    keywords: ["european", "union", "flag", "banner"],
                    char: "🇪🇺"
                },
                falkland_islands: {
                    keywords: [
                        "falkland",
                        "islands",
                        "malvinas",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇫🇰"
                },
                faroe_islands: {
                    keywords: ["faroe", "islands", "flag", "nation", "country", "banner"],
                    char: "🇫🇴"
                },
                fiji: {
                    keywords: ["fj", "flag", "nation", "country", "banner"],
                    char: "🇫🇯"
                },
                finland: {
                    keywords: ["fi", "flag", "nation", "country", "banner"],
                    char: "🇫🇮"
                },
                fr: {
                    keywords: ["banner", "flag", "nation", "france", "french", "country"],
                    char: "🇫🇷"
                },
                french_guiana: {
                    keywords: ["french", "guiana", "flag", "nation", "country", "banner"],
                    char: "🇬🇫"
                },
                french_polynesia: {
                    keywords: [
                        "french",
                        "polynesia",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇵🇫"
                },
                french_southern_territories: {
                    keywords: [
                        "french",
                        "southern",
                        "territories",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇹🇫"
                },
                gabon: {
                    keywords: ["ga", "flag", "nation", "country", "banner"],
                    char: "🇬🇦"
                },
                gambia: {
                    keywords: ["gm", "flag", "nation", "country", "banner"],
                    char: "🇬🇲"
                },
                georgia: {
                    keywords: ["ge", "flag", "nation", "country", "banner"],
                    char: "🇬🇪"
                },
                de: {
                    keywords: ["german", "nation", "flag", "country", "banner"],
                    char: "🇩🇪"
                },
                ghana: {
                    keywords: ["gh", "flag", "nation", "country", "banner"],
                    char: "🇬🇭"
                },
                gibraltar: {
                    keywords: ["gi", "flag", "nation", "country", "banner"],
                    char: "🇬🇮"
                },
                greece: {
                    keywords: ["gr", "flag", "nation", "country", "banner"],
                    char: "🇬🇷"
                },
                greenland: {
                    keywords: ["gl", "flag", "nation", "country", "banner"],
                    char: "🇬🇱"
                },
                grenada: {
                    keywords: ["gd", "flag", "nation", "country", "banner"],
                    char: "🇬🇩"
                },
                guadeloupe: {
                    keywords: ["gp", "flag", "nation", "country", "banner"],
                    char: "🇬🇵"
                },
                guam: {
                    keywords: ["gu", "flag", "nation", "country", "banner"],
                    char: "🇬🇺"
                },
                guatemala: {
                    keywords: ["gt", "flag", "nation", "country", "banner"],
                    char: "🇬🇹"
                },
                guernsey: {
                    keywords: ["gg", "flag", "nation", "country", "banner"],
                    char: "🇬🇬"
                },
                guinea: {
                    keywords: ["gn", "flag", "nation", "country", "banner"],
                    char: "🇬🇳"
                },
                guinea_bissau: {
                    keywords: ["gw", "bissau", "flag", "nation", "country", "banner"],
                    char: "🇬🇼"
                },
                guyana: {
                    keywords: ["gy", "flag", "nation", "country", "banner"],
                    char: "🇬🇾"
                },
                haiti: {
                    keywords: ["ht", "flag", "nation", "country", "banner"],
                    char: "🇭🇹"
                },
                honduras: {
                    keywords: ["hn", "flag", "nation", "country", "banner"],
                    char: "🇭🇳"
                },
                hong_kong: {
                    keywords: ["hong", "kong", "flag", "nation", "country", "banner"],
                    char: "🇭🇰"
                },
                hungary: {
                    keywords: ["hu", "flag", "nation", "country", "banner"],
                    char: "🇭🇺"
                },
                iceland: {
                    keywords: ["is", "flag", "nation", "country", "banner"],
                    char: "🇮🇸"
                },
                india: {
                    keywords: ["in", "flag", "nation", "country", "banner"],
                    char: "🇮🇳"
                },
                indonesia: {
                    keywords: ["flag", "nation", "country", "banner"],
                    char: "🇮🇩"
                },
                iran: {
                    keywords: [
                        "iran,",
                        "islamic",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇮🇷"
                },
                iraq: {
                    keywords: ["iq", "flag", "nation", "country", "banner"],
                    char: "🇮🇶"
                },
                ireland: {
                    keywords: ["ie", "flag", "nation", "country", "banner"],
                    char: "🇮🇪"
                },
                isle_of_man: {
                    keywords: ["isle", "man", "flag", "nation", "country", "banner"],
                    char: "🇮🇲"
                },
                israel: {
                    keywords: ["il", "flag", "nation", "country", "banner"],
                    char: "🇮🇱"
                },
                it: {
                    keywords: ["italy", "flag", "nation", "country", "banner"],
                    char: "🇮🇹"
                },
                cote_divoire: {
                    keywords: ["ivory", "coast", "flag", "nation", "country", "banner"],
                    char: "🇨🇮"
                },
                jamaica: {
                    keywords: ["jm", "flag", "nation", "country", "banner"],
                    char: "🇯🇲"
                },
                jp: {
                    keywords: ["japanese", "nation", "flag", "country", "banner"],
                    char: "🇯🇵"
                },
                jersey: {
                    keywords: ["je", "flag", "nation", "country", "banner"],
                    char: "🇯🇪"
                },
                jordan: {
                    keywords: ["jo", "flag", "nation", "country", "banner"],
                    char: "🇯🇴"
                },
                kazakhstan: {
                    keywords: ["kz", "flag", "nation", "country", "banner"],
                    char: "🇰🇿"
                },
                kenya: {
                    keywords: ["ke", "flag", "nation", "country", "banner"],
                    char: "🇰🇪"
                },
                kiribati: {
                    keywords: ["ki", "flag", "nation", "country", "banner"],
                    char: "🇰🇮"
                },
                kosovo: {
                    keywords: ["xk", "flag", "nation", "country", "banner"],
                    char: "🇽🇰"
                },
                kuwait: {
                    keywords: ["kw", "flag", "nation", "country", "banner"],
                    char: "🇰🇼"
                },
                kyrgyzstan: {
                    keywords: ["kg", "flag", "nation", "country", "banner"],
                    char: "🇰🇬"
                },
                laos: {
                    keywords: [
                        "lao",
                        "democratic",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇱🇦"
                },
                latvia: {
                    keywords: ["lv", "flag", "nation", "country", "banner"],
                    char: "🇱🇻"
                },
                lebanon: {
                    keywords: ["lb", "flag", "nation", "country", "banner"],
                    char: "🇱🇧"
                },
                lesotho: {
                    keywords: ["ls", "flag", "nation", "country", "banner"],
                    char: "🇱🇸"
                },
                liberia: {
                    keywords: ["lr", "flag", "nation", "country", "banner"],
                    char: "🇱🇷"
                },
                libya: {
                    keywords: ["ly", "flag", "nation", "country", "banner"],
                    char: "🇱🇾"
                },
                liechtenstein: {
                    keywords: ["li", "flag", "nation", "country", "banner"],
                    char: "🇱🇮"
                },
                lithuania: {
                    keywords: ["lt", "flag", "nation", "country", "banner"],
                    char: "🇱🇹"
                },
                luxembourg: {
                    keywords: ["lu", "flag", "nation", "country", "banner"],
                    char: "🇱🇺"
                },
                macau: {
                    keywords: ["macao", "flag", "nation", "country", "banner"],
                    char: "🇲🇴"
                },
                macedonia: {
                    keywords: ["macedonia,", "flag", "nation", "country", "banner"],
                    char: "🇲🇰"
                },
                madagascar: {
                    keywords: ["mg", "flag", "nation", "country", "banner"],
                    char: "🇲🇬"
                },
                malawi: {
                    keywords: ["mw", "flag", "nation", "country", "banner"],
                    char: "🇲🇼"
                },
                malaysia: {
                    keywords: ["my", "flag", "nation", "country", "banner"],
                    char: "🇲🇾"
                },
                maldives: {
                    keywords: ["mv", "flag", "nation", "country", "banner"],
                    char: "🇲🇻"
                },
                mali: {
                    keywords: ["ml", "flag", "nation", "country", "banner"],
                    char: "🇲🇱"
                },
                malta: {
                    keywords: ["mt", "flag", "nation", "country", "banner"],
                    char: "🇲🇹"
                },
                marshall_islands: {
                    keywords: [
                        "marshall",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇲🇭"
                },
                martinique: {
                    keywords: ["mq", "flag", "nation", "country", "banner"],
                    char: "🇲🇶"
                },
                mauritania: {
                    keywords: ["mr", "flag", "nation", "country", "banner"],
                    char: "🇲🇷"
                },
                mauritius: {
                    keywords: ["mu", "flag", "nation", "country", "banner"],
                    char: "🇲🇺"
                },
                mayotte: {
                    keywords: ["yt", "flag", "nation", "country", "banner"],
                    char: "🇾🇹"
                },
                mexico: {
                    keywords: ["mx", "flag", "nation", "country", "banner"],
                    char: "🇲🇽"
                },
                micronesia: {
                    keywords: [
                        "micronesia,",
                        "federated",
                        "states",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇫🇲"
                },
                moldova: {
                    keywords: [
                        "moldova,",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇲🇩"
                },
                monaco: {
                    keywords: ["mc", "flag", "nation", "country", "banner"],
                    char: "🇲🇨"
                },
                mongolia: {
                    keywords: ["mn", "flag", "nation", "country", "banner"],
                    char: "🇲🇳"
                },
                montenegro: {
                    keywords: ["me", "flag", "nation", "country", "banner"],
                    char: "🇲🇪"
                },
                montserrat: {
                    keywords: ["ms", "flag", "nation", "country", "banner"],
                    char: "🇲🇸"
                },
                morocco: {
                    keywords: ["ma", "flag", "nation", "country", "banner"],
                    char: "🇲🇦"
                },
                mozambique: {
                    keywords: ["mz", "flag", "nation", "country", "banner"],
                    char: "🇲🇿"
                },
                myanmar: {
                    keywords: ["mm", "flag", "nation", "country", "banner"],
                    char: "🇲🇲"
                },
                namibia: {
                    keywords: ["na", "flag", "nation", "country", "banner"],
                    char: "🇳🇦"
                },
                nauru: {
                    keywords: ["nr", "flag", "nation", "country", "banner"],
                    char: "🇳🇷"
                },
                nepal: {
                    keywords: ["np", "flag", "nation", "country", "banner"],
                    char: "🇳🇵"
                },
                netherlands: {
                    keywords: ["nl", "flag", "nation", "country", "banner"],
                    char: "🇳🇱"
                },
                new_caledonia: {
                    keywords: ["new", "caledonia", "flag", "nation", "country", "banner"],
                    char: "🇳🇨"
                },
                new_zealand: {
                    keywords: ["new", "zealand", "flag", "nation", "country", "banner"],
                    char: "🇳🇿"
                },
                nicaragua: {
                    keywords: ["ni", "flag", "nation", "country", "banner"],
                    char: "🇳🇮"
                },
                niger: {
                    keywords: ["ne", "flag", "nation", "country", "banner"],
                    char: "🇳🇪"
                },
                nigeria: {
                    keywords: ["flag", "nation", "country", "banner"],
                    char: "🇳🇬"
                },
                niue: {
                    keywords: ["nu", "flag", "nation", "country", "banner"],
                    char: "🇳🇺"
                },
                norfolk_island: {
                    keywords: [
                        "norfolk",
                        "island",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇳🇫"
                },
                northern_mariana_islands: {
                    keywords: [
                        "northern",
                        "mariana",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇲🇵"
                },
                north_korea: {
                    keywords: ["north", "korea", "nation", "flag", "country", "banner"],
                    char: "🇰🇵"
                },
                norway: {
                    keywords: ["no", "flag", "nation", "country", "banner"],
                    char: "🇳🇴"
                },
                oman: {
                    keywords: ["om_symbol", "flag", "nation", "country", "banner"],
                    char: "🇴🇲"
                },
                pakistan: {
                    keywords: ["pk", "flag", "nation", "country", "banner"],
                    char: "🇵🇰"
                },
                palau: {
                    keywords: ["pw", "flag", "nation", "country", "banner"],
                    char: "🇵🇼"
                },
                palestinian_territories: {
                    keywords: [
                        "palestine",
                        "palestinian",
                        "territories",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇵🇸"
                },
                panama: {
                    keywords: ["pa", "flag", "nation", "country", "banner"],
                    char: "🇵🇦"
                },
                papua_new_guinea: {
                    keywords: [
                        "papua",
                        "new",
                        "guinea",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇵🇬"
                },
                paraguay: {
                    keywords: ["py", "flag", "nation", "country", "banner"],
                    char: "🇵🇾"
                },
                peru: {
                    keywords: ["pe", "flag", "nation", "country", "banner"],
                    char: "🇵🇪"
                },
                philippines: {
                    keywords: ["ph", "flag", "nation", "country", "banner"],
                    char: "🇵🇭"
                },
                pitcairn_islands: {
                    keywords: ["pitcairn", "flag", "nation", "country", "banner"],
                    char: "🇵🇳"
                },
                poland: {
                    keywords: ["pl", "flag", "nation", "country", "banner"],
                    char: "🇵🇱"
                },
                portugal: {
                    keywords: ["pt", "flag", "nation", "country", "banner"],
                    char: "🇵🇹"
                },
                puerto_rico: {
                    keywords: ["puerto", "rico", "flag", "nation", "country", "banner"],
                    char: "🇵🇷"
                },
                qatar: {
                    keywords: ["qa", "flag", "nation", "country", "banner"],
                    char: "🇶🇦"
                },
                reunion: {
                    keywords: ["réunion", "flag", "nation", "country", "banner"],
                    char: "🇷🇪"
                },
                romania: {
                    keywords: ["ro", "flag", "nation", "country", "banner"],
                    char: "🇷🇴"
                },
                ru: {
                    keywords: [
                        "russian",
                        "federation",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇷🇺"
                },
                rwanda: {
                    keywords: ["rw", "flag", "nation", "country", "banner"],
                    char: "🇷🇼"
                },
                st_barthelemy: {
                    keywords: [
                        "saint",
                        "barthélemy",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇧🇱"
                },
                st_helena: {
                    keywords: [
                        "saint",
                        "helena",
                        "ascension",
                        "tristan",
                        "cunha",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇸🇭"
                },
                st_kitts_nevis: {
                    keywords: [
                        "saint",
                        "kitts",
                        "nevis",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇰🇳"
                },
                st_lucia: {
                    keywords: ["saint", "lucia", "flag", "nation", "country", "banner"],
                    char: "🇱🇨"
                },
                st_pierre_miquelon: {
                    keywords: [
                        "saint",
                        "pierre",
                        "miquelon",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇵🇲"
                },
                st_vincent_grenadines: {
                    keywords: [
                        "saint",
                        "vincent",
                        "grenadines",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇻🇨"
                },
                samoa: {
                    keywords: ["ws", "flag", "nation", "country", "banner"],
                    char: "🇼🇸"
                },
                san_marino: {
                    keywords: ["san", "marino", "flag", "nation", "country", "banner"],
                    char: "🇸🇲"
                },
                sao_tome_principe: {
                    keywords: [
                        "sao",
                        "tome",
                        "principe",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇸🇹"
                },
                saudi_arabia: {
                    keywords: ["flag", "nation", "country", "banner"],
                    char: "🇸🇦"
                },
                senegal: {
                    keywords: ["sn", "flag", "nation", "country", "banner"],
                    char: "🇸🇳"
                },
                serbia: {
                    keywords: ["rs", "flag", "nation", "country", "banner"],
                    char: "🇷🇸"
                },
                seychelles: {
                    keywords: ["sc", "flag", "nation", "country", "banner"],
                    char: "🇸🇨"
                },
                sierra_leone: {
                    keywords: ["sierra", "leone", "flag", "nation", "country", "banner"],
                    char: "🇸🇱"
                },
                singapore: {
                    keywords: ["sg", "flag", "nation", "country", "banner"],
                    char: "🇸🇬"
                },
                sint_maarten: {
                    keywords: [
                        "sint",
                        "maarten",
                        "dutch",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇸🇽"
                },
                slovakia: {
                    keywords: ["sk", "flag", "nation", "country", "banner"],
                    char: "🇸🇰"
                },
                slovenia: {
                    keywords: ["si", "flag", "nation", "country", "banner"],
                    char: "🇸🇮"
                },
                solomon_islands: {
                    keywords: [
                        "solomon",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇸🇧"
                },
                somalia: {
                    keywords: ["so", "flag", "nation", "country", "banner"],
                    char: "🇸🇴"
                },
                south_africa: {
                    keywords: ["south", "africa", "flag", "nation", "country", "banner"],
                    char: "🇿🇦"
                },
                south_georgia_south_sandwich_islands: {
                    keywords: [
                        "south",
                        "georgia",
                        "sandwich",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇬🇸"
                },
                kr: {
                    keywords: ["south", "korea", "nation", "flag", "country", "banner"],
                    char: "🇰🇷"
                },
                south_sudan: {
                    keywords: ["south", "sd", "flag", "nation", "country", "banner"],
                    char: "🇸🇸"
                },
                es: {
                    keywords: ["spain", "flag", "nation", "country", "banner"],
                    char: "🇪🇸"
                },
                sri_lanka: {
                    keywords: ["sri", "lanka", "flag", "nation", "country", "banner"],
                    char: "🇱🇰"
                },
                sudan: {
                    keywords: ["sd", "flag", "nation", "country", "banner"],
                    char: "🇸🇩"
                },
                suriname: {
                    keywords: ["sr", "flag", "nation", "country", "banner"],
                    char: "🇸🇷"
                },
                swaziland: {
                    keywords: ["sz", "flag", "nation", "country", "banner"],
                    char: "🇸🇿"
                },
                sweden: {
                    keywords: ["se", "flag", "nation", "country", "banner"],
                    char: "🇸🇪"
                },
                switzerland: {
                    keywords: ["ch", "flag", "nation", "country", "banner"],
                    char: "🇨🇭"
                },
                syria: {
                    keywords: [
                        "syrian",
                        "arab",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇸🇾"
                },
                taiwan: {
                    keywords: ["tw", "flag", "nation", "country", "banner"],
                    char: "🇹🇼"
                },
                tajikistan: {
                    keywords: ["tj", "flag", "nation", "country", "banner"],
                    char: "🇹🇯"
                },
                tanzania: {
                    keywords: [
                        "tanzania,",
                        "united",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇹🇿"
                },
                thailand: {
                    keywords: ["th", "flag", "nation", "country", "banner"],
                    char: "🇹🇭"
                },
                timor_leste: {
                    keywords: ["timor", "leste", "flag", "nation", "country", "banner"],
                    char: "🇹🇱"
                },
                togo: {
                    keywords: ["tg", "flag", "nation", "country", "banner"],
                    char: "🇹🇬"
                },
                tokelau: {
                    keywords: ["tk", "flag", "nation", "country", "banner"],
                    char: "🇹🇰"
                },
                tonga: {
                    keywords: ["to", "flag", "nation", "country", "banner"],
                    char: "🇹🇴"
                },
                trinidad_tobago: {
                    keywords: [
                        "trinidad",
                        "tobago",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇹🇹"
                },
                tunisia: {
                    keywords: ["tn", "flag", "nation", "country", "banner"],
                    char: "🇹🇳"
                },
                tr: {
                    keywords: ["turkey", "flag", "nation", "country", "banner"],
                    char: "🇹🇷"
                },
                turkmenistan: {
                    keywords: ["flag", "nation", "country", "banner"],
                    char: "🇹🇲"
                },
                turks_caicos_islands: {
                    keywords: [
                        "turks",
                        "caicos",
                        "islands",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇹🇨"
                },
                tuvalu: {
                    keywords: ["flag", "nation", "country", "banner"],
                    char: "🇹🇻"
                },
                uganda: {
                    keywords: ["ug", "flag", "nation", "country", "banner"],
                    char: "🇺🇬"
                },
                ukraine: {
                    keywords: ["ua", "flag", "nation", "country", "banner"],
                    char: "🇺🇦"
                },
                united_arab_emirates: {
                    keywords: [
                        "united",
                        "arab",
                        "emirates",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇦🇪"
                },
                uk: {
                    keywords: [
                        "united",
                        "kingdom",
                        "great",
                        "britain",
                        "northern",
                        "ireland",
                        "flag",
                        "nation",
                        "country",
                        "banner",
                        "british",
                        "UK",
                        "english",
                        "england",
                        "union jack"
                    ],
                    char: "🇬🇧"
                },
                england: {
                    keywords: ["flag", "english"],
                    char: "🏴󠁧󠁢󠁥󠁮󠁧󠁿"
                },
                scotland: {
                    keywords: ["flag", "scottish"],
                    char: "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
                },
                wales: {
                    keywords: ["flag", "welsh"],
                    char: "🏴󠁧󠁢󠁷󠁬󠁳󠁿"
                },
                us: {
                    keywords: [
                        "united",
                        "states",
                        "america",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇺🇸"
                },
                us_virgin_islands: {
                    keywords: [
                        "virgin",
                        "islands",
                        "us",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇻🇮"
                },
                uruguay: {
                    keywords: ["uy", "flag", "nation", "country", "banner"],
                    char: "🇺🇾"
                },
                uzbekistan: {
                    keywords: ["uz", "flag", "nation", "country", "banner"],
                    char: "🇺🇿"
                },
                vanuatu: {
                    keywords: ["vu", "flag", "nation", "country", "banner"],
                    char: "🇻🇺"
                },
                vatican_city: {
                    keywords: ["vatican", "city", "flag", "nation", "country", "banner"],
                    char: "🇻🇦"
                },
                venezuela: {
                    keywords: [
                        "ve",
                        "bolivarian",
                        "republic",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇻🇪"
                },
                vietnam: {
                    keywords: ["viet", "nam", "flag", "nation", "country", "banner"],
                    char: "🇻🇳"
                },
                wallis_futuna: {
                    keywords: ["wallis", "futuna", "flag", "nation", "country", "banner"],
                    char: "🇼🇫"
                },
                western_sahara: {
                    keywords: [
                        "western",
                        "sahara",
                        "flag",
                        "nation",
                        "country",
                        "banner"
                    ],
                    char: "🇪🇭"
                },
                yemen: {
                    keywords: ["ye", "flag", "nation", "country", "banner"],
                    char: "🇾🇪"
                },
                zambia: {
                    keywords: ["zm", "flag", "nation", "country", "banner"],
                    char: "🇿🇲"
                },
                zimbabwe: {
                    keywords: ["zw", "flag", "nation", "country", "banner"],
                    char: "🇿🇼"
                },
                united_nations: {
                    keywords: ["un", "flag", "banner"],
                    char: "🇺🇳"
                },
                pirate_flag: {
                    keywords: ["skull", "crossbones", "flag", "banner"],
                    char: "🏴‍☠️"
                }
            }
        }
    }
];

/**
* @class CometChatEmojiCategory
* @description CometChatEmojiCategory class is used for defining the emoji categories.
*
* @param {String} id
* @param {String} symbolURL
* @param {String} name
* @param {null | object[]} emojies
*/
class CometChatEmojiCategory {
    constructor({ id = "", symbolURL = "", name = "", emojies = null, }) {
        this.id = id;
        this.symbolURL = symbolURL;
        this.name = name;
        this.emojies = emojies;
    }
}

/**
 * @class CometChatEmoji
 * @description CometChatEmoji class is used for defining the emoji.
 *
 * @param {String} char
 * @param {[]} keywords
 */
class CometChatEmoji {
    constructor({ char = "", keywords = [] }) {
        this.char = "";
        this.keywords = [];
        this.char = char;
        this.keywords = keywords;
    }
}

exports.CometChatEmojiKeyboard = class CometChatEmojiKeyboard extends lit.LitElement {
    constructor() {
        var _a, _b;
        super(...arguments);
        this.hideSearch = true;
        this.emojiKeyboardStyle = {
            width: "100%",
            height: "100%",
            border: "none",
            textFont: "500 12px Inter, sans-serif",
            textColor: "",
            background: "",
            borderRadius: "12px",
            activeIconTint: "#2196ec",
            iconTint: "grey"
        };
        this.emojiData = [];
        /**
   * Properties for internal use
   */
        this.iconStyle = {
            buttonIconTint: "grey",
            background: "transparent",
            border: "none",
        };
        this.activeIconStyle = {
            buttonIconTint: "#2196ec",
            background: "transparent",
            border: "none",
        };
        this.objectKeys = Object.keys;
        this.activeCategory = "people";
        this.buttonStyle = {
            background: "transparent",
            border: "none",
            buttonTextColor: ((_a = this.emojiKeyboardStyle) === null || _a === void 0 ? void 0 : _a.textColor) || "grey",
            buttonTextFont: ((_b = this.emojiKeyboardStyle) === null || _b === void 0 ? void 0 : _b.textFont) || "500 15px Inter, sans-serif"
        };
        this.emojiStyle = {
            background: "transparent",
            border: "none",
            borderRadius: "0",
            fontSize: "22px"
        };
        /**
         * @param  {CometChatEmoji} emoji
         */
        this.onEmojiClick = (emoji) => {
            this.dispatchEvent(new CustomEvent('cc-emoji-clicked', {
                bubbles: true,
                composed: true,
                detail: { id: emoji.char }
            }));
        };
        /**
          * Props dependent styles for the CometChatEmojiKeyboard.
          *
          */
        this.emojiContainerStyle = () => {
            var _a, _b, _c, _d;
            return {
                width: (_a = this.emojiKeyboardStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.emojiKeyboardStyle) === null || _b === void 0 ? void 0 : _b.height,
                background: ((_c = this.emojiKeyboardStyle) === null || _c === void 0 ? void 0 : _c.background) ||
                    "white",
                borderRadius: (_d = this.emojiKeyboardStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                border: this.emojiKeyboardStyle.border
            };
        };
        this.emojiCategoryWrapper = () => {
            var _a;
            return {
                background: ((_a = this.emojiKeyboardStyle) === null || _a === void 0 ? void 0 : _a.background) || "white"
            };
        };
        this.emojiCategoryTitle = () => {
            var _a, _b;
            return {
                font: (_a = this.emojiKeyboardStyle) === null || _a === void 0 ? void 0 : _a.textFont,
                color: ((_b = this.emojiKeyboardStyle) === null || _b === void 0 ? void 0 : _b.textColor) || "grey",
            };
        };
    }
    connectedCallback() {
        var _a, _b;
        this.activeIconStyle.buttonIconTint = (_a = this.emojiKeyboardStyle) === null || _a === void 0 ? void 0 : _a.activeIconTint;
        this.iconStyle.iconTint = (_b = this.emojiKeyboardStyle) === null || _b === void 0 ? void 0 : _b.activeIconTint;
        this.getEmojiCategory();
        super.connectedCallback();
    }
    render() {
        return lit.html `<div class="cc__emojikeyboard" style=${styleMap_js.styleMap(this.emojiContainerStyle())}><div class="cc__emojikeyboard__emojis">
         ${this.emojiData.map((emoji) => lit.html `<div class="cc__emojikeyboard__main"  id=${emoji.id}>
        <div class="cc__emojikeyboard__section"  style=${styleMap_js.styleMap(this.emojiCategoryTitle())}> <cometchat-button .buttonStyle=${this.buttonStyle} .hoverText=${emoji.name} .text=${emoji.name} ></cometchat-button></div>
       <div class="cc__emojikeyboard__emojilist">
       ${this.objectKeys(emoji.emojies).map((item) => lit.html `
       <div class="cc__emojikeyboard__emoji" @click=${() => { this.onEmojiClick(emoji.emojies[item]); }} >
           <cometchat-button .buttonStyle=${this.emojiStyle}   .text=${this.getEmojiData(emoji.emojies[item])} .hoverText=${item} ></cometchat-button>
         </div>
       `)}
       </div>
     </div>`)}
      </div><div class="cc__category__list" style=${styleMap_js.styleMap(this.emojiCategoryWrapper())}>
      ${this.emojiData.map((emoji) => lit.html `
      <div class="cc__emojikeyboard__category"   @click=${() => { this.scrollToElement(emoji.id); }} title=${emoji.name}>
        <cometchat-button .hoverText=${emoji.name} .iconURL=${emoji.symbolURL} .buttonStyle=${this.activeCategory == emoji.id ? this.activeIconStyle : this.iconStyle} ></cometchat-button>
      </div>`)}
      </div>
    </div>
    `;
    }
    /**
 * @param  {CometChatEmoji} emojiData
 */
    getEmojiData(emojiData) {
        const emojiInstance = new CometChatEmoji({
            char: emojiData.char,
            keywords: emojiData.keywords
        });
        return emojiInstance.char;
    }
    getEmojiCategory() {
        var _a;
        if (this.emojiData && ((_a = this.emojiData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return this.emojiData.category;
        }
        else {
            this.emojiData = Emojis.map((el) => {
                const vals = Object.values(el)[0];
                const emojiCategory = new CometChatEmojiCategory({
                    id: vals.id,
                    name: vals.name,
                    symbolURL: vals.symbol,
                    emojies: vals.emojis,
                });
                return emojiCategory;
            });
        }
    }
    /**
     * @param  {string} id
     */
    scrollToElement(id) {
        var _a, _b;
        this.activeCategory = id;
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(id)) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
        this.requestUpdate("activeCategory");
    }
};
exports.CometChatEmojiKeyboard.styles = [
    lit.css `
      .cc__category__list{
    width: 100%;
    display:  flex;
    flex-wrap:  wrap;
    border:  none;
    align-items: center;
    background: white;
    justify-content: center;
    align-items: center;
    gap:10px;
    padding:12px 0;
}
.cc__emojikeyboard__emojilist{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.cc__emojikeyboard__emoji{
    width: 35px;
    height: 35px;
    border-radius: 3px;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
}
.cc__emojikeyboard__section{
    margin: 5px 0 0 5px;
    text-align: left;
}
.cc__emojikeyboard__category{
    padding: 1px;
}
  .cc__emojikeyboard {
    padding:0px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-top:5px;
  }
  .cc__emojikeyboard__emojis::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .cc__emojikeyboard__emojis::-webkit-scrollbar-thumb {
    background: rgb(232, 229, 229);
    border-radius: 8px;
  }
  .cc__emojikeyboard__emojis{
    overflow-y:scroll;
  }
      `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatEmojiKeyboard.prototype, "hideSearch", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatEmojiKeyboard.prototype, "emojiKeyboardStyle", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatEmojiKeyboard.prototype, "emojiData", void 0);
exports.CometChatEmojiKeyboard = __decorate([
    decorators_js.customElement('cometchat-emoji-keyboard')
], exports.CometChatEmojiKeyboard);

/**
 * EmojiKeyboardStyle class defines the style properties for emoji keyboard
 *
 * @property {string} textFont - The font style for the text.
 * @property {string} textColor - The text color for the text.
 *
 * @extends {BaseStyle}
 */
class EmojiKeyboardStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "400 13px Inter, sans-serif";
        this.textColor = "RGBA(20, 20, 20, 0.58)";
        this.activeIconTint = "#2196ec";
        this.iconTint = "grey";
        Object.assign(this, props);
    }
}

exports.auxiliaryButtonAlignmentEnum = void 0;
(function (auxiliaryButtonAlignmentEnum) {
    auxiliaryButtonAlignmentEnum[auxiliaryButtonAlignmentEnum["left"] = 0] = "left";
    auxiliaryButtonAlignmentEnum[auxiliaryButtonAlignmentEnum["right"] = 1] = "right";
})(exports.auxiliaryButtonAlignmentEnum || (exports.auxiliaryButtonAlignmentEnum = {}));
exports.CometChatMessageInput = class CometChatMessageInput extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.text = "";
        this.disabled = false;
        this.placeholderText = "Send a message...";
        this.auxiliaryButtonAlignment = exports.auxiliaryButtonAlignmentEnum.right;
        this.dir = "auto";
        this.messageInputStyle = {
            height: "100%",
            width: "",
            maxHeight: "100px",
            border: "1px solid #efefef",
            borderRadius: "",
            background: "",
            placeholderTextFont: "",
            placeholderTextColor: "",
            textFont: "",
            textColor: "",
            dividerColor: "#efefef",
            inputBorder: "none",
            inputBorderRadius: "0",
            inputBackground: "transparent",
        };
        this.textFormatters = [];
        this.reRenderCounter = 1;
        this.inputText = "";
        this.onKeyDown = (event) => {
            var _a, _b, _c;
            var contenteditable = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]");
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                if ((_b = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.textContent) === null || _b === void 0 ? void 0 : _b.trim()) {
                    let textToDispatch = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.innerHTML;
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            textToDispatch =
                                this.textFormatters[i].getOriginalText(textToDispatch);
                        }
                    }
                    this.dispatchEvent(new CustomEvent("cc-message-input-entered", {
                        bubbles: true,
                        composed: true,
                        detail: { value: textToDispatch },
                    }));
                }
                return;
            }
            if (this.textFormatters && this.textFormatters.length) {
                this.updateSelection();
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference((_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("[contenteditable]"));
                    this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                    this.textFormatters[i].onKeyDown(event);
                }
            }
        };
        /**
         * On Every KeyUp Event, pass the event to registered text formatters in order to track characters
         * and format the text in real time.
         */
        this.onKeyUp = (event) => {
            var _a;
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                return;
            }
            if (this.textFormatters && this.textFormatters.length) {
                this.updateSelection();
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]"));
                    this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                    this.textFormatters[i].onKeyUp(event);
                }
            }
        };
        this.hasAllSlotsAssigned = false;
        this.emptyInputField = () => {
            var _a;
            let contenteditable = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]");
            contenteditable.textContent = "";
            contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.focus();
        };
        this.dispatchChangedEVent = (event) => {
            var _a;
            var contenteditable = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]");
            let textToDispatch = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.innerHTML;
            if (textToDispatch) {
                if (this.textFormatters && this.textFormatters.length) {
                    for (let i = 0; i < this.textFormatters.length; i++) {
                        textToDispatch =
                            this.textFormatters[i].getOriginalText(textToDispatch);
                    }
                }
            }
            this.dispatchEvent(new CustomEvent("cc-message-input-changed", {
                bubbles: true,
                composed: true,
                detail: { value: textToDispatch },
            }));
            this.updateSelection();
        };
        this.messageInputStyles = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.messageInputStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.messageInputStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.messageInputStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.messageInputStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.messageInputStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
        this.inputStyle = () => {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
                font: (_a = this.messageInputStyle) === null || _a === void 0 ? void 0 : _a.textFont,
                color: (_b = this.messageInputStyle) === null || _b === void 0 ? void 0 : _b.textColor,
                height: "100%",
                width: "100%",
                maxHeight: (_c = this.messageInputStyle) === null || _c === void 0 ? void 0 : _c.maxHeight,
                border: (_d = this.messageInputStyle) === null || _d === void 0 ? void 0 : _d.inputBorder,
                borderRadius: (_e = this.messageInputStyle) === null || _e === void 0 ? void 0 : _e.inputBorderRadius,
                background: (_f = this.messageInputStyle) === null || _f === void 0 ? void 0 : _f.inputBackground,
                padding: ((_g = this.messageInputStyle) === null || _g === void 0 ? void 0 : _g.inputPadding) || "7px 12px",
            };
        };
        this.auxiliaryStyles = () => {
            return {
                display: "flex",
                justifyContent: this.auxiliaryButtonAlignment == exports.auxiliaryButtonAlignmentEnum.left
                    ? "flex-start"
                    : "flex-end",
            };
        };
        this.dividerStyle = () => {
            var _a;
            return {
                height: "1px",
                width: "100%",
                background: (_a = this.messageInputStyle) === null || _a === void 0 ? void 0 : _a.dividerColor,
            };
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener("slotchange", (event) => { });
    }
    /**
     * Updates the current cursor position to be sent to formatters on every change
     */
    updateSelection() {
        try {
            if (this.shadowRoot.getSelection) {
                this.sel = this.shadowRoot.getSelection();
                this.currentSelectionForRegex = this.sel;
                if (this.sel.getRangeAt && this.sel.rangeCount) {
                    this.range = this.sel.getRangeAt(0);
                    this.currentSelectionForRegexRange = this.sel.getRangeAt(0);
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                        }
                    }
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    reRender() {
        this.requestUpdate("reRenderCounter");
    }
    pasteHtmlAtCaret(html) {
        var _a, _b;
        try {
            if (this.sel && this.range) {
                this.range.deleteContents();
                let el = document.createElement("div");
                el.innerHTML = html;
                let frag = document.createDocumentFragment(), node, lastNode;
                let i = 0;
                while ((node = el.firstChild)) {
                    if (node instanceof HTMLElement) {
                        if (this.textFormatters && this.textFormatters.length) {
                            for (let i = 0; i < this.textFormatters.length; i++) {
                                node = this.textFormatters[i].registerEventListeners(node, node.classList);
                            }
                        }
                        lastNode = frag.appendChild(el.removeChild(node));
                    }
                    else if (node instanceof Text) {
                        lastNode = frag.appendChild(el.removeChild(node));
                    }
                }
                this.range.insertNode(frag);
                if (lastNode) {
                    this.range = this.range.cloneRange();
                    this.range.setStartAfter(lastNode);
                    this.range.collapse(true);
                    this.sel.removeAllRanges();
                    this.sel.addRange(this.range);
                    var contenteditable = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]");
                    let textToDispatch = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.innerHTML;
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            textToDispatch =
                                this.textFormatters[i].getOriginalText(textToDispatch);
                        }
                    }
                    this.dispatchEvent(new CustomEvent("cc-message-input-changed", {
                        bubbles: true,
                        composed: true,
                        detail: { value: textToDispatch },
                    }));
                }
            }
            else if (this.shadowRoot.selection &&
                this.shadowRoot.selection.type != "Control") {
                this.shadowRoot.selection.createRange().pasteHTML(html);
            }
            else {
                let contenteditable = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("[contenteditable]");
                contenteditable.textContent = this.text;
                contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.focus();
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    updated(_changedProperties) {
        var _a, _b, _c, _d;
        var contenteditable = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]");
        //use this to avoid double formatting in case of edit text when themessage input receives both text and formatters
        let skipFormattersChangedCheck = false;
        if (_changedProperties.has("text") && this.text && this.text != "") {
            let finalText = this.text;
            if (this.textFormatters && this.textFormatters.length) {
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("[contenteditable]"));
                    this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                    if (typeof finalText == "string") {
                        finalText = this.textFormatters[i].getFormattedText(finalText, {
                            mentionsTargetElement: uikitResources.MentionsTargetElement.textinput,
                        });
                    }
                }
            }
            if (finalText !== this.text) {
                skipFormattersChangedCheck = true;
            }
            if (!((_c = contenteditable.innerHTML) === null || _c === void 0 ? void 0 : _c.trim())) {
                contenteditable.focus();
            }
            this.pasteHtmlAtCaret(finalText);
        }
        if ((_changedProperties.has("textFormatters") ||
            _changedProperties.has("reRenderCounter")) &&
            !skipFormattersChangedCheck) {
            if (this.textFormatters && this.textFormatters.length) {
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference((_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("[contenteditable]"));
                    this.textFormatters[i].setReRender(this.reRender.bind(this));
                }
            }
            if (this.currentSelectionForRegex &&
                this.textFormatters &&
                this.textFormatters.length) {
                if (this.textFormatters && this.textFormatters.length) {
                    for (let i = 0; i < this.textFormatters.length; i++) {
                        this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                        this.textFormatters[i].getFormattedText(null, {
                            mentionsTargetElement: uikitResources.MentionsTargetElement.textinput,
                        });
                    }
                }
                let textToDispatch = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.innerHTML;
                if (textToDispatch) {
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            textToDispatch =
                                this.textFormatters[i].getOriginalText(textToDispatch);
                        }
                    }
                }
                this.dispatchEvent(new CustomEvent("cc-message-input-changed", {
                    bubbles: true,
                    composed: true,
                    detail: { value: textToDispatch },
                }));
            }
        }
    }
    preventPaste(e) {
        e.preventDefault();
        let clipboardData = e === null || e === void 0 ? void 0 : e.clipboardData.getData("text/plain");
        if (clipboardData) {
            clipboardData = clipboardData.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        }
        if (clipboardData) {
            this.updateSelection();
            this.text = clipboardData;
        }
        this.requestUpdate("text");
    }
    firstUpdated(_changedProperties) {
        var _a, _b, _c, _d;
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]")) === null || _b === void 0 ? void 0 : _b.addEventListener("paste", this.preventPaste.bind(this));
        if ((_c = this.text) === null || _c === void 0 ? void 0 : _c.trim()) {
            var contenteditable = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("[contenteditable]");
            contenteditable.focus();
            this.updateSelection();
        }
        this.hasAllSlotsAssigned = this.checkIfAllSlotsAreAssigned();
        this.requestUpdate("hasAllSlotsAssigned");
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]")) === null || _b === void 0 ? void 0 : _b.removeEventListener("paste", this.preventPaste);
    }
    checkIfAllSlotsAreAssigned() {
        var _a, _b, _c;
        const primarySlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="primaryView"]');
        const secondarySlot = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('slot[name="secondaryView"]');
        const auxilarySlot = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('slot[name="auxilaryView"]');
        if (primarySlot && secondarySlot && auxilarySlot) {
            if (primarySlot.assignedElements().length > 0 ||
                secondarySlot.assignedElements().length > 0 ||
                auxilarySlot.assignedElements().length > 0) {
                return true;
            }
        }
        return false;
    }
    render() {
        var _a;
        if (this.textFormatters && this.textFormatters.length) {
            for (let i = 0; i < this.textFormatters.length; i++) {
                this.textFormatters[i].setInputElementReference((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("[contenteditable]"));
                this.textFormatters[i].setReRender(this.reRender.bind(this));
            }
        }
        return lit.html `
      <div
        class="cc__messageinput"
        style=${styleMap_js.styleMap(this.messageInputStyles())}
      >
        <div
          dir=${this.dir}
          @keyup=${this.onKeyUp}
          @keydown=${this.onKeyDown}
          @focus=${() => {
            this.updateSelection();
        }}
          @blur=${() => {
            this.updateSelection();
        }}
          contenteditable=${this.disabled ? false : true}
          @input=${(event) => {
            this.dispatchChangedEVent(event);
        }}
          style=${styleMap_js.styleMap(this.inputStyle())}
          class="cc__messageinput-input"
          data-placeholder=${this.placeholderText}
        ></div>
        <cometchat-divider
          .dividerStyle=${this.dividerStyle()}
        ></cometchat-divider>
        <div
          class="cc__messageinput__sticky"
          style=${styleMap_js.styleMap({
            display: this.hasAllSlotsAssigned ? "flex" : "none",
        })}
        >
          <div class="cc__messageinput__secondaryactions">
            <slot name="secondaryView"></slot>
          </div>
          <div
            class="cc__messageinput__auxiliaryactions"
            style=${styleMap_js.styleMap(this.auxiliaryStyles())}
          >
            <slot name="auxilaryView"></slot>
          </div>
          <div class="cc__messageinput__primaryactions">
            <slot name="primaryView"></slot>
          </div>
        </div>
      </div>
    `;
    }
};
exports.CometChatMessageInput.styles = [
    lit.css `
      * {
        box-sizing: border-box;
      }
      .cc__messageinput {
        border: 1px solid grey;
        width: 400px;
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
      .cc__messageinput-input {
        border: none;
        width: 100%;
        outline: none;
        border-radius: 0;
        background: transparent;
        overflow-y: auto;
        min-height: 28px;
        padding: 7px 12px;
        user-select: text;
        white-space: pre-wrap;
        overflow-wrap: break-word;
        text-align: left;
      }
      .cc__messageinput-input::-webkit-scrollbar {
        background: transparent;
        width: 8px;
      }
      .cc__messageinput-input::-webkit-scrollbar-thumb {
        background: rgb(232, 229, 229);
        border-radius: 8px;
      }
      .cc__messageinput-input:empty:before {
        content: attr(data-placeholder);
        color: rgba(119, 119, 119, 0.58);
        font: 400 13px sans-serif, Inter;
      }
      .cc__messageinput__sticky {
        display: flex;
        padding: 4px 8px;
        width: 100%;
      }
      .cc__messageinput__primaryactions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex: 1;
      }
      .cc__messageinput__auxiliaryactions {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        flex: 0 1 100%;
        align-items: center;
      }
      .cc__messageinput__secondaryactions {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex: 0 1 8%;
      }
    `,
];
__decorate([
    decorators_js.property()
], exports.CometChatMessageInput.prototype, "text", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatMessageInput.prototype, "disabled", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMessageInput.prototype, "placeholderText", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatMessageInput.prototype, "auxiliaryButtonAlignment", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMessageInput.prototype, "dir", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatMessageInput.prototype, "messageInputStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMessageInput.prototype, "textFormatters", void 0);
exports.CometChatMessageInput = __decorate([
    decorators_js.customElement("cometchat-message-input")
], exports.CometChatMessageInput);

/**
 * MessageInputStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class MessageInputStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.placeholderTextFont = "";
        this.placeholderTextColor = "";
        this.textFont = "";
        this.textColor = "";
        this.dividerColor = "#efefef";
        this.inputBorder = "none";
        this.inputBorderRadius = "0";
        this.inputBackground = "transparent";
        this.maxHeight = "100px";
        this.inputPadding = "";
        Object.assign(this, props);
    }
}

var dropdownIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2220%22%20viewBox%3D%220%200%2018%2020%22%20fill%3D%22none%22%3E%20%20%3Cg%20clip-path%3D%22url%28%23clip0_306_15838%29%22%3E%20%20%20%20%3Cpath%20d%3D%22M4.59912%207.5L8.9033%2012.5L13.2075%207.5%22%20stroke%3D%22%236B7280%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%3C%2Fg%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip0_306_15838%22%3E%20%20%20%20%20%20%3Crect%20width%3D%2217.2167%22%20height%3D%2220%22%20fill%3D%22white%22%20transform%3D%22translate%280.294922%29%22%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%3C%2Fsvg%3E";

exports.CometChatDropdown = class CometChatDropdown extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.arrowIconURL = dropdownIcon;
        this.dropdownStyle = {
            height: "40px",
            width: "150px",
            background: "white",
            border: "1px solid #e2e2e2",
            borderRadius: "12px",
            activeTextFont: "400 15px Inter",
            activeTextColor: "#141414",
            arrowIconTint: "grey",
            textFont: "400 15px Inter",
            textColor: "#141414",
            optionBackground: "white",
            optionBorder: "1px solid #e2e2e2",
            hoverTextFont: "400 15px Inter",
            hoverTextColor: "#141414",
            hoverTextBackground: "red",
        };
        this.options = [];
        this.isHovering = false;
        this.hoveredOption = "";
        this.onMouseHover = (event, option) => {
            if ((event === null || event === void 0 ? void 0 : event.type) == "mouseenter") {
                this.isHovering = true;
                this.hoveredOption = option;
            }
            else {
                this.isHovering = false;
                this.hoveredOption = "";
            }
            this.requestUpdate("isHovering");
        };
        this.onButtonClick = (event) => {
            event.preventDefault();
            this.toggleHidden();
        };
        this.onOptionClick = (selectedOption) => {
            this.selectedOption = selectedOption;
            this.dispatchEvent(new CustomEvent("cc-dropdown-changed", {
                bubbles: true,
                composed: true,
                detail: { value: this.selectedOption },
            }));
            this.requestUpdate("selectedOption");
            this.toggleHidden();
        };
        this.selectedOptionStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                border: (_a = this.dropdownStyle) === null || _a === void 0 ? void 0 : _a.border,
                borderRadius: (_b = this.dropdownStyle) === null || _b === void 0 ? void 0 : _b.borderRadius,
                background: (_c = this.dropdownStyle) === null || _c === void 0 ? void 0 : _c.background,
                width: (_d = this.dropdownStyle) === null || _d === void 0 ? void 0 : _d.width,
                height: (_e = this.dropdownStyle) === null || _e === void 0 ? void 0 : _e.height,
            };
        };
        this.selectedOptionTextStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.dropdownStyle) === null || _a === void 0 ? void 0 : _a.activeTextFont,
                textColor: (_b = this.dropdownStyle) === null || _b === void 0 ? void 0 : _b.activeTextColor,
            };
        };
        this.optionTextStyle = (option) => {
            let style = {};
            if (this.isHovering && this.hoveredOption == option) {
                style = {
                    textFont: this.dropdownStyle.hoverTextFont,
                    textColor: this.dropdownStyle.hoverTextColor,
                };
            }
            else {
                style = {
                    textFont: this.dropdownStyle.textFont,
                    textColor: this.dropdownStyle.textColor,
                };
            }
            return style;
        };
        this.optionStyle = (option) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let style = {};
            if (this.isHovering && this.hoveredOption == option) {
                style = {
                    height: (_a = this.dropdownStyle) === null || _a === void 0 ? void 0 : _a.height,
                    border: (_b = this.dropdownStyle) === null || _b === void 0 ? void 0 : _b.optionHoverBorder,
                    borderRadius: (_c = this.dropdownStyle) === null || _c === void 0 ? void 0 : _c.optionHoverBorderRadius,
                    background: (_d = this.dropdownStyle) === null || _d === void 0 ? void 0 : _d.hoverTextBackground,
                };
            }
            else {
                style = {
                    height: (_e = this.dropdownStyle) === null || _e === void 0 ? void 0 : _e.height,
                    border: (_f = this.dropdownStyle) === null || _f === void 0 ? void 0 : _f.optionBorder,
                    borderRadius: (_g = this.dropdownStyle) === null || _g === void 0 ? void 0 : _g.optionBorderRadius,
                    background: (_h = this.dropdownStyle) === null || _h === void 0 ? void 0 : _h.optionBackground,
                };
            }
            return style;
        };
        this.arowIconStyle = () => {
            var _a;
            return {
                WebkitMask: `url(${this.arrowIconURL})  center center no-repeat`,
                background: ((_a = this.dropdownStyle) === null || _a === void 0 ? void 0 : _a.arrowIconTint) || "grey",
            };
        };
        this.optionWrapperStyle = () => {
            var _a, _b;
            return {
                width: (_a = this.dropdownStyle) === null || _a === void 0 ? void 0 : _a.width,
                background: (_b = this.dropdownStyle) === null || _b === void 0 ? void 0 : _b.optionBackground,
            };
        };
    }
    render() {
        if (!this.selectedOption) {
            this.selectedOption = this.options[0];
        }
        return lit.html `
      <div class="cc__dropdown">
        <button
          name="button"
          style=${styleMap_js.styleMap(this.selectedOptionStyle())}
          class="cc__dropdown__button"
          @click=${this.onButtonClick}
        >
          <cometchat-label
            text=${this.selectedOption}
            .labelStyle=${this.selectedOptionTextStyle()}
          ></cometchat-label>
          <div
            class="cc__dropdown__arrow"
            style=${styleMap_js.styleMap(this.arowIconStyle())}
          ></div>
        </button>
        <div class="cc__dropdown__options hidden" style=${styleMap_js.styleMap(this.optionWrapperStyle())} name="dropdown">
          ${this.options.map((option) => lit.html ` <div
              class="cc__dropdown__option"
              @click=${() => {
            this.onOptionClick(option);
        }}
              @mouseenter=${(event) => {
            this.onMouseHover(event, option);
        }}
              @mouseleave=${(event) => {
            this.onMouseHover(event, option);
        }}
              style=${styleMap_js.styleMap(this.optionStyle(option))}
            >
              <cometchat-label
                .labelStyle=${this.optionTextStyle(option)}
                .text=${option}
              >
              </cometchat-label>
            </div>`)}
        </div>
      </div>
    `;
    }
    toggleHidden() {
        let select = this.shadowRoot.querySelector("div[name='dropdown']");
        select.classList.toggle("hidden");
    }
};
exports.CometChatDropdown.styles = [
    lit.css `
    .cc__dropdown {
      position: relative;
    }

      label {
        display: block;
        font-weight: 500;
        padding: 2rem 0 0.5rem;
      }
      .cc__dropdown__button {
        display: flex;
        align-items: center;
        padding: 1rem;
        justify-content: space-between;
        border-radius: 0.3rem;
        height: 3.2rem;
        width: 100%;
        background-color: white;
        position: relative;
        border: 1px solid #d9d9d9;
        background: #efefef;
      }
      .cc__dropdown__arrow {
        height: 24px;
        width: 24px;
      }
      .cc__dropdown__options {
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        border-radius:8px;
        overflow: hidden;
        background: white;
        z-index: 99;
      }
      .cc__dropdown__option {
        display: flex;
        align-items: center;
        padding-left: 1rem;
        font-weight: 400;
        cursor: pointer;
        color: black;
        box-sizing: border-box;
      }
      .cc__dropdown__options.hidden {
        display: none;
      }
    `,
];
__decorate([
    decorators_js.property()
], exports.CometChatDropdown.prototype, "arrowIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatDropdown.prototype, "dropdownStyle", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatDropdown.prototype, "options", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatDropdown.prototype, "selectedOption", void 0);
exports.CometChatDropdown = __decorate([
    decorators_js.customElement("cometchat-dropdown")
], exports.CometChatDropdown);

/**
 * DropdownStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class DropdownStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.activeTextFont = "400 15px Inter";
        this.activeTextColor = "#141414";
        this.arrowIconTint = "grey";
        this.textFont = "400 15px Inter";
        this.textColor = "#141414";
        this.optionBackground = "white";
        this.hoverTextFont = "400 15px Inter";
        this.hoverTextColor = "#141414";
        this.hoverTextBackground = "red";
        this.optionHoverBorder = "";
        this.optionHoverBorderRadius = "";
        this.optionBorder = "";
        this.optionBorderRadius = "";
        Object.assign(this, props);
    }
}

var arrowIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20%3F%3E%3C!DOCTYPE%20svg%20%20PUBLIC%20%5Ci-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%5Ci%20%20%5Cihttp%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%5Ci%3E%3Csvg%20enable-background%3D%22new%200%200%2032%2032%22%20%20id%3D%22%D0%A1%D0%BB%D0%BE%D0%B9_1%22%20version%3D%221.1%22%20viewBox%3D%220%200%2032%2032%22%20%20xml%3Aspace%3D%22preserve%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cpath%20d%3D%22M24.285%2C11.284L16%2C19.571l-8.285-8.288c-0.395-0.395-1.034-0.395-1.429%2C0%20%20c-0.394%2C0.395-0.394%2C1.035%2C0%2C1.43l8.999%2C9.002l0%2C0l0%2C0c0.394%2C0.395%2C1.034%2C0.395%2C1.428%2C0l8.999-9.002%20%20c0.394-0.395%2C0.394-1.036%2C0-1.431C25.319%2C10.889%2C24.679%2C10.889%2C24.285%2C11.284z%22%20fill%3D%22%23121313%22%20id%3D%22Expand_More%22%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3C%2Fsvg%3E";

var closeIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FClose%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FClose%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%285.000000%2C%205.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%20transform%3D%22translate%287.000000%2C%207.000000%29%20scale%28-1%2C%201%29%20translate%28-7.000000%2C%20-7.000000%29%20%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.CometChatChangeScope = class CometChatChangeScope extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = uikitResources.localize("CHANGE_SCOPE");
        this.buttonText = "Save";
        this.arrowIconURL = arrowIcon;
        this.closeIconURL = closeIcon;
        this.changeScopeStyle = {
            height: "100%",
            width: "100%",
            background: "transparent",
            border: "",
            borderRadius: "",
            titleTextFont: "700 22px Inter",
            titleTextColor: "#141414",
            activeTextFont: "400 15px Inter",
            activeTextColor: "#141414",
            activeTextBackground: "#efefef",
            arrowIconTint: "grey",
            textFont: "400 15px Inter",
            textColor: "#141414",
            optionBackground: "white",
            optionBorder: "none",
            optionBorderRadius: "0",
            hoverTextFont: "400 15px Inter",
            hoverTextColor: "#141414",
            hoverTextBackground: "#efefef",
            buttonTextFont: "600 15px Inter",
            buttonTextColor: "white",
            buttonBackground: "#3399FF",
            closeIconTint: "#3399FF"
        };
        this.selectedOption = "";
        this.options = [];
        this.dropdownStyle = {
            height: "50px",
            width: "100%",
            background: "#efefef",
            border: "1px solid #e2e2e2",
            borderRadius: "12px",
            activeTextFont: "400 15px Inter",
            activeTextColor: "#141414",
            arrowIconTint: "grey",
            textFont: "400 15px Inter",
            textColor: "#141414",
            optionBackground: "white",
            hoverTextFont: "400 15px Inter",
            hoverTextColor: "#141414",
            hoverTextBackground: "#efefef",
        };
        this.onCloseClick = () => {
            this.dispatchEvent(new CustomEvent('cc-changescope-close-clicked', {
                bubbles: true,
                composed: true,
            }));
        };
        this.dowpdownChanged = (event) => {
            this.selectedOption = event.detail.value;
        };
        this.dispatchScope = () => {
            this.dispatchEvent(new CustomEvent('cc-changescope-changed', {
                bubbles: true,
                composed: true,
                detail: { value: this.selectedOption }
            }));
        };
        this.titleStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.changeScopeStyle) === null || _a === void 0 ? void 0 : _a.titleTextFont,
                textColor: (_b = this.changeScopeStyle) === null || _b === void 0 ? void 0 : _b.titleTextColor
            };
        };
        this.closeIconStyle = () => {
            var _a;
            return {
                height: "24px",
                width: "24px",
                buttonIconTint: (_a = this.changeScopeStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint,
                border: "none",
                borderRadius: "0",
                background: "transparent"
            };
        };
        this.buttonStyle = () => {
            var _a, _b, _c;
            return {
                height: "100%",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                buttonTextFont: (_a = this.changeScopeStyle) === null || _a === void 0 ? void 0 : _a.buttonTextFont,
                buttonTextColor: (_b = this.changeScopeStyle) === null || _b === void 0 ? void 0 : _b.buttonTextColor,
                background: (_c = this.changeScopeStyle) === null || _c === void 0 ? void 0 : _c.buttonBackground,
                border: "none",
                borderRadius: "8px"
            };
        };
        this.changeScopeStyles = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.changeScopeStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.changeScopeStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.changeScopeStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.changeScopeStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.changeScopeStyle) === null || _e === void 0 ? void 0 : _e.background
            };
        };
    }
    setStyling() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.dropdownStyle.activeTextFont = (_a = this.changeScopeStyle) === null || _a === void 0 ? void 0 : _a.activeTextFont;
        this.dropdownStyle.arrowIconTint = (_b = this.changeScopeStyle) === null || _b === void 0 ? void 0 : _b.arrowIconTint;
        this.dropdownStyle.textFont = (_c = this.changeScopeStyle) === null || _c === void 0 ? void 0 : _c.textFont;
        this.dropdownStyle.textColor = (_d = this.changeScopeStyle) === null || _d === void 0 ? void 0 : _d.textColor;
        this.dropdownStyle.optionBackground = (_e = this.changeScopeStyle) === null || _e === void 0 ? void 0 : _e.optionBackground;
        this.dropdownStyle.hoverTextFont = (_f = this.changeScopeStyle) === null || _f === void 0 ? void 0 : _f.hoverTextFont;
        this.dropdownStyle.hoverTextColor = (_g = this.changeScopeStyle) === null || _g === void 0 ? void 0 : _g.hoverTextColor;
        this.dropdownStyle.hoverTextBackground = (_h = this.changeScopeStyle) === null || _h === void 0 ? void 0 : _h.hoverTextBackground;
    }
    render() {
        this.setStyling();
        if (!this.selectedOption) {
            this.selectedOption = this.options[0];
        }
        return lit.html `
      <div class="cc__changescope" style=${styleMap_js.styleMap(this.changeScopeStyles())}>
          <div class="cc__changescope__title" > <cometchat-label .text=${this.title} .labelStyle=${this.titleStyle()}></cometchat-label>
          <div class="cc__changescope__close" @click=${this.onCloseClick}> <cometchat-button .iconURL=${this.closeIconURL} .buttonStyle=${this.closeIconStyle()}>
          </cometchat-button> </div>
        </div>
<cometchat-dropdown @cc-dropdown-changed=${this.dowpdownChanged} .arrowIconURL=${this.arrowIconURL} .options=${this.options} .dropdownStyle=${this.dropdownStyle}></cometchat-dropdown>
<div class="cc__changescope__button">
<cometchat-button .text=${this.buttonText} .buttonStyle=${this.buttonStyle()}   @click=${this.dispatchScope}></cometchat-button>
</div>
      </div>
    `;
    }
};
exports.CometChatChangeScope.styles = [
    lit.css `
*{
    box-sizing:border-box;
}
.cc__changescope {
    position: relative;
    background: wheat;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 0px 12px;
    height:100%;
    width:100%;
}
.cc__changescope__title{
  display: flex;
    justify-content: center;
    align-items: center;
}
.cc__changescope__button{
    width:100%;
    height:46px;
}
.cc__changescope__close{
  position: absolute;
    right: 18px;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatChangeScope.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatChangeScope.prototype, "buttonText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatChangeScope.prototype, "arrowIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatChangeScope.prototype, "closeIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatChangeScope.prototype, "changeScopeStyle", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatChangeScope.prototype, "options", void 0);
exports.CometChatChangeScope = __decorate([
    decorators_js.customElement('cometchat-change-scope')
], exports.CometChatChangeScope);

/**

ChangeScopeStyle class represents the styling properties for the Confirm Dialog component.
@property {string} titleTextFont - The font and size of the title text.
@property {string} titleTextColor - The color of the title text.
@property {string} selectedOptionTextFont - The font and size of the selected option text.
@property {string} selectedOptionTextColor - The color of the selected option text.
@property {string} selectedOptionBackground - The background color of the selected option.
@property {string} selectedOptionBorder - The border of the selected option.
@property {string} selectedOptionBorderRadius - The border radius of the selected option.
@property {string} arrowIconTint - The tint color of the arrow icon.
@property {string} optionTextFont - The font and size of the option text.
@property {string} optionTextColor - The color of the option text.
@property {string} optionBackground - The background color of the option.
@property {string} optionBorder - The border of the option.
@property {string} optionBorderRadius - The border radius of the option.
@property {string} buttonTextFont - The font and size of the button text.
@property {string} buttonTextColor - The color of the button text.
@property {string} buttonBackground - The background color of the button.
@property {string} scopeTextFont - The font and size of the scope text.
@property {string} scopeTextColor - The color of the scope text.
*/
class ChangeScopeStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter";
        this.titleTextColor = "#141414";
        this.activeTextFont = "400 15px Inter";
        this.activeTextColor = "#141414";
        this.activeTextBackground = "#efefef";
        this.arrowIconTint = "grey";
        this.textFont = "400 15px Inter";
        this.textColor = "#141414";
        this.optionBackground = "white";
        this.optionBorder = "none";
        this.optionBorderRadius = "0";
        this.hoverTextFont = "400 15px Inter";
        this.hoverTextColor = "#141414";
        this.hoverTextBackground = "#efefef";
        this.buttonTextFont = "600 15px Inter";
        this.buttonTextColor = "white";
        this.buttonBackground = "#3399FF";
        this.closeIconTint = "#3399FF";
        this.border = '';
        this.borderRadius = '8px';
        this.height = '200px';
        this.width = '280px';
        Object.assign(this, props);
    }
}

var CloseIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FClose%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FClose%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%285.000000%2C%205.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%20transform%3D%22translate%287.000000%2C%207.000000%29%20scale%28-1%2C%201%29%20translate%28-7.000000%2C%20-7.000000%29%20%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.CometChatPreview = class CometChatPreview extends lit.LitElement {
    constructor() {
        super();
        this.previewTitle = "Edit Message";
        this.previewSubtitle = "";
        this.closeButtonIconURL = CloseIcon;
        this.previewStyle = {
            height: "100%",
            width: "100%",
            border: "none",
            background: "",
            previewTitleFont: "500 12px Inter, sans-serif",
            previewTitleColor: "grey",
            previewSubtitleColor: "grey",
            previewSubtitleFont: "400 13px Inter, sans-serif",
            closeButtonIconTint: "grey",
        };
        this.closePreview = () => {
            this.dispatchEvent(new CustomEvent('cc-preview-close-clicked', {
                bubbles: true,
                composed: true,
            }));
        };
        this.closeBtnIconStyle = () => {
            var _a;
            return {
                buttonIconTint: (_a = this.previewStyle) === null || _a === void 0 ? void 0 : _a.closeButtonIconTint,
                height: "14px",
                width: "14px",
                border: "none",
                borderRadius: "0",
                background: "transparent",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            };
        };
        this.subtitleStyle = () => {
            var _a, _b;
            return {
                font: (_a = this.previewStyle) === null || _a === void 0 ? void 0 : _a.previewSubtitleFont,
                color: (_b = this.previewStyle) === null || _b === void 0 ? void 0 : _b.previewSubtitleColor
            };
        };
        this.titleStyle = () => {
            var _a, _b;
            return {
                font: (_a = this.previewStyle) === null || _a === void 0 ? void 0 : _a.previewTitleFont,
                color: (_b = this.previewStyle) === null || _b === void 0 ? void 0 : _b.previewTitleColor
            };
        };
        this.previewWrapperStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                background: (_a = this.previewStyle) === null || _a === void 0 ? void 0 : _a.background,
                border: (_b = this.previewStyle) === null || _b === void 0 ? void 0 : _b.border,
                height: (_c = this.previewStyle) === null || _c === void 0 ? void 0 : _c.height,
                width: (_d = this.previewStyle) === null || _d === void 0 ? void 0 : _d.width,
                borderRadius: (_e = this.previewStyle) === null || _e === void 0 ? void 0 : _e.borderRadius
            };
        };
    }
    render() {
        return lit.html `
    <div class="cc__preview"  style=${styleMap_js.styleMap(this.previewWrapperStyle())}>
  <div class="cc__preview__content">
      <p class="cc__preview__title" style= ${styleMap_js.styleMap(this.titleStyle())} >${this.previewTitle}</p>
      <p class="cc__preview__subtitle" style= ${styleMap_js.styleMap(this.subtitleStyle())} >${this.previewSubtitle}</p>
  </div>
  <div class="cc__preview__close" @click=${this.closePreview}>
    <cometchat-button .buttonStyle= ${this.closeBtnIconStyle()} .iconURL=${this.closeButtonIconURL}></cometchat-button>
  </div>
</div>
`;
    }
};
exports.CometChatPreview.styles = [
    lit.css `
      *{
        box-sizing:border-box;
    }
 .cc__preview {
  padding: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  min-height: 30px;
}
.cc__preview__content {
  padding: 0 12px;

}
.cc__preview__content > p {
    margin: 0;
  }
  .cc__preview__content > .cc__preview__title {
    margin-bottom: 2px;
  }
.cc__preview__close {
  width: 14px;
  height: 14px;
  display: inline-block;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatPreview.prototype, "previewTitle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatPreview.prototype, "previewSubtitle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatPreview.prototype, "closeButtonIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatPreview.prototype, "previewStyle", void 0);
exports.CometChatPreview = __decorate([
    decorators_js.customElement('cometchat-preview')
], exports.CometChatPreview);

/**
 * PreviewStyle class represents the styles for preview. It extends BaseStyle.
 *
 * @property {string} previewTitleFont - Font for preview title.
 * @property {string} previewTitleColor - Color for preview title.
 * @property {string} previewSubtitleColor - Color for preview subtitle.
 * @property {string} previewSubtitleFont - Font for preview subtitle.
 * @property {string} closeButtonIconTint - Tint color for close button icon.
 */
class PreviewStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.previewTitleFont = "500 12px Inter, sans-serif";
        this.previewTitleColor = "grey";
        this.previewSubtitleColor = "grey";
        this.previewSubtitleFont = "400 13px Inter, sans-serif";
        this.closeButtonIconTint = "grey";
        Object.assign(this, props);
    }
}

var layoutIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024.0%2024.0%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cg%20transform%3D%22translate%282.0%202.0%29%22%3E%3Cpath%20d%3D%22M1.36046512%2C0%20L7.01162791%2C0%20C7.76299204%2C-3.60067958e-16%208.37209302%2C0.60910098%208.37209302%2C1.36046512%20L8.37209302%2C7.01162791%20C8.37209302%2C7.76299204%207.76299204%2C8.37209302%207.01162791%2C8.37209302%20L1.36046512%2C8.37209302%20C0.60910098%2C8.37209302%20-3.52073641e-16%2C7.76299204%200%2C7.01162791%20L0%2C1.36046512%20C-3.14060173e-16%2C0.60910098%200.60910098%2C-3.06065857e-16%201.36046512%2C0%20Z%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%20fill%3D%22none%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C%2Fpath%3E%3Cg%20transform%3D%22translate%280.0%2011.62790697674419%29%22%3E%3Cpath%20d%3D%22M1.36046512%2C0%20L7.01162791%2C0%20C7.76299204%2C-3.60067958e-16%208.37209302%2C0.60910098%208.37209302%2C1.36046512%20L8.37209302%2C7.01162791%20C8.37209302%2C7.76299204%207.76299204%2C8.37209302%207.01162791%2C8.37209302%20L1.36046512%2C8.37209302%20C0.60910098%2C8.37209302%20-3.52073641e-16%2C7.76299204%200%2C7.01162791%20L0%2C1.36046512%20C-3.14060173e-16%2C0.60910098%200.60910098%2C-3.06065857e-16%201.36046512%2C0%20Z%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%20fill%3D%22none%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3Cg%20transform%3D%22translate%2811.62790697674419%200.0%29%22%3E%3Cpath%20d%3D%22M1.36046512%2C0%20L7.01162791%2C0%20C7.76299204%2C-3.60067958e-16%208.37209302%2C0.60910098%208.37209302%2C1.36046512%20L8.37209302%2C7.01162791%20C8.37209302%2C7.76299204%207.76299204%2C8.37209302%207.01162791%2C8.37209302%20L1.36046512%2C8.37209302%20C0.60910098%2C8.37209302%20-3.52073641e-16%2C7.76299204%200%2C7.01162791%20L0%2C1.36046512%20C-3.14060173e-16%2C0.60910098%200.60910098%2C-3.06065857e-16%201.36046512%2C0%20Z%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%20fill%3D%22none%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3Cg%20transform%3D%22translate%2811.62790697674419%2011.62790697674419%29%22%3E%3Cpath%20d%3D%22M1.36046512%2C0%20L7.01162791%2C0%20C7.76299204%2C-3.60067958e-16%208.37209302%2C0.60910098%208.37209302%2C1.36046512%20L8.37209302%2C7.01162791%20C8.37209302%2C7.76299204%207.76299204%2C8.37209302%207.01162791%2C8.37209302%20L1.36046512%2C8.37209302%20C0.60910098%2C8.37209302%20-3.52073641e-16%2C7.76299204%200%2C7.01162791%20L0%2C1.36046512%20C-3.14060173e-16%2C0.60910098%200.60910098%2C-3.06065857e-16%201.36046512%2C0%20Z%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%20fill%3D%22none%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

exports.CometChatActionSheet = class CometChatActionSheet extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.hideLayoutMode = false;
        this.title = "Add to chat";
        this.layoutModeIconURL = layoutIcon;
        this.actionsheetbuttonstyle = {
            height: "48px",
            width: "100%",
            border: "none",
            borderRadius: "0",
            background: "#f1f1f1",
            buttonIconTint: "grey",
            buttonTextFont: "400 13px Inter",
            buttonTextColor: "black",
            gap: "13px",
            padding: "4px 8px"
        };
        this.layoutMode = layoutType.list;
        this.actionSheetStyle = {
            layoutModeIconTint: "#3399FF",
            borderRadius: "inherit",
            background: "rgb(255,255,255)",
            border: "none",
            width: "100%",
            height: "100%",
            titleFont: "700 22px Inter, sans-serif",
            titleColor: "#141414",
            listItemBackground: "",
            ActionSheetSeparatorTint: "#dddddd"
        };
        this.toggleLayoutMode = () => {
            this.layoutMode = this.layoutMode == layoutType.list ? layoutType.grid : this.layoutMode = layoutType.list;
            this.requestUpdate("layoutMode");
        };
        this.actionSheetTitleStyle = () => {
            return {
                color: this.actionSheetStyle.titleColor,
                font: this.actionSheetStyle.titleFont,
            };
        };
        this.sheetItemListStyle = () => {
            let style = {};
            if (this.layoutMode === layoutType.list) {
                style = {
                    display: "block",
                };
            }
            else {
                style = {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    flexWrap: "wrap",
                };
            }
            return style;
        };
        this.actionSheetWrapperStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.actionSheetStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.actionSheetStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.actionSheetStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.actionSheetStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.actionSheetStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
        this.setStyle = (action, index) => {
            var _a;
            let style = {};
            if (this.layoutMode == layoutType.list) {
                style = {
                    height: "54px",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    buttonTextFont: action.titleFont,
                    buttonTextColor: action.titleColor,
                    buttonIconTint: action.iconTint,
                    borderRadius: index == 0
                        ? "8px 8px 0 0"
                        : index == ((_a = this.actions) === null || _a === void 0 ? void 0 : _a.length) - 1
                            ? "0 0 8px 8px"
                            : "0",
                    borderBottom: `1px solid ${this.actionSheetStyle.ActionSheetSeparatorTint}`,
                    background: this.actionSheetStyle.listItemBackground || action.background,
                    gap: "13px",
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    padding: "4px 8px"
                };
            }
            else {
                style = {
                    width: "115px",
                    height: "90px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    border: "none",
                    borderRadius: action.borderRadius || "8px",
                    buttonTextFont: action.titleFont,
                    buttonTextColor: action.titleColor,
                    buttonIconTint: action.iconTint,
                    background: this.actionSheetStyle.listItemBackground || action.background,
                    borderBottom: `1px solid ${this.actionSheetStyle.ActionSheetSeparatorTint}`,
                    gap: "0",
                    padding: "4px 8px",
                    margin: "4px"
                };
            }
            return style;
        };
        this.getButtonStyle = () => {
            return {
                height: "24px",
                width: "24px",
                border: "none",
                borderRadius: "0",
                background: "transparent",
                buttonIconTint: this.actionSheetStyle.layoutModeIconTint || "#3399FF",
            };
        };
    }
    render() {
        var _a;
        return lit.html ` <div class="cc__actionsheet__wrapper" style=${styleMap_js.styleMap(this.actionSheetWrapperStyle())}>
      ${(this.title && !this.hideLayoutMode) ? lit.html `
      <div class="cc__actionsheet__header">
        <span class="cc__actionsheet__title" style=${styleMap_js.styleMap(this.actionSheetTitleStyle())}>${this.title}</span>
        ${!this.hideLayoutMode ? lit.html `
        <div class="cc__actionsheet__layoutbutton">
          <cometchat-button  .iconURL=${this.layoutModeIconURL} .buttonStyle=${this.getButtonStyle()} @cc-button-clicked=${this.toggleLayoutMode}>
        </cometchat-button>
      </div>` : lit.nothing}
      </div>` : lit.nothing}
      <div class="cc__actionsheet" style=${styleMap_js.styleMap(this.sheetItemListStyle())}>
     ${(_a = this.actions) === null || _a === void 0 ? void 0 : _a.map((action, i) => {
            return lit.html `<cometchat-button
     .iconURL=${action.iconURL}
     .text=${action.title}
    .buttonStyle=${this.setStyle(action, i)}
     @cc-button-clicked=${() => { this.onActionItemClick(action); }}
     ></cometchat-button>`;
        })}
      </div>
    </div>
    `;
    }
    onActionItemClick(action) {
        this.dispatchEvent(new CustomEvent('cc-actionsheet-clicked', {
            bubbles: true,
            composed: true,
            detail: { action: action }
        }));
    }
};
exports.CometChatActionSheet.styles = [
    lit.css `
    *{
        box-sizing:border-box;
    }
.cc__actionsheet__wrapper{
  display: flex;
  padding:8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.cc__actionsheet__header{
  height: 45px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 4px 8px;
}
.cc__actionsheet__title{
  display: flex;
    align-items: center;
  line-height: 22px;
  width: calc(100% - 24px);
}
.cc__actionsheet{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.cc__actionsheet__layoutbutton{
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius:15px;
}
.cc__actionsheet::-webkit-scrollbar {
  background: transparent;
  width: 8px;
}
.cc__actionsheet::-webkit-scrollbar-thumb {
  background: rgb(232, 229, 229);
  border-radius: 8px;
}
    `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatActionSheet.prototype, "hideLayoutMode", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatActionSheet.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatActionSheet.prototype, "layoutModeIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatActionSheet.prototype, "layoutMode", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatActionSheet.prototype, "actions", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatActionSheet.prototype, "actionSheetStyle", void 0);
exports.CometChatActionSheet = __decorate([
    decorators_js.customElement('cometchat-action-sheet')
], exports.CometChatActionSheet);
const layoutType = Object.freeze({
    list: "list",
    grid: "grid"
});
class CometChatActionItem {
    constructor(props) {
        this.id = "";
        this.iconURL = "";
        this.title = "";
        this.iconTint = "";
        this.titleFont = "";
        this.titleColor = "";
        this.background = "";
        this.borderRadius = ""; //create actionItem datamodel in web component
        this.onClick = null;
        Object.assign(this, props);
    }
}

class ActionSheetStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.layoutModeIconTint = "#3399FF";
        this.titleFont = "700 22px Inter, sans-serif";
        this.titleColor = "#141414";
        this.listItemBackground = "";
        this.ActionSheetSeparatorTint = "1px solid RGBA(20, 20, 20, 0.08)";
        this.listItemIconTint = "RGBA(20, 20, 20, 0.69)";
        this.listItemIconBackground = "transparent";
        this.listItemIconBorderRadius = "0";
        Object.assign(this, props);
    }
}

var heartIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAFAAAAAAnxZisAAACpElEQVQ4Ea1VzUsVURQ/5868UrEg/AMy0NTMRQRBJfIQszKxgh5ByzbVIooiiDbZBwUtXAWJtGgRJW0MQsxnxfhRIbgpsqcQtajoA8uITGfu3Hs6Z+zJU3pq+n4wc+fee87vd+bcM2cQ5mB0Z+0WMuERQNiNgO+UgtYAgs7K7uffM01fVlevyc9391iAo5bsOkT1gPdvlvd4Q5l2mJ68bahdG2rTwvMmB9HV1gKP0WWA3oSWzlc86rsj9qm6mkOuwgsKsMQSgeErxpEYS5oQOpSLp0u7vA9iGwmkdsWLlaGuPKXKJw3TyU4GYizEYG+OFglXAt7gOWomzoRY5TsO+Na+8pEaqpJ97/FeIuFUjX++X+C4jb+ZPBsUi3C0Wvb5OSaRZ0MBi0xY01GxvfYApuprtjkE/ZZAZXeZpkrnczF2Ek9oaKtCi2c4ogXJRUKIFyJP2zmolHLUSZeAGjWXQq4RcpHwMTVxIeCwVEuuIWfGSPGIl/9OcqohnA7QVWUCeMg1PyJ1nCsIl7ZmVIcqqSo97xen6aK8UC4SleZB5VwS7ijs8p7e9sDQLflIlos8R4FPdLs9Gb8rXJEAq5K7YurEpLHeckTEd8rYp77G483QHNXmTOJLuwZ/ukof9I0dWIqI+PjWDFqHEps870c6EzMCslCSfPYVQtzvG9MpDos5E7GZJrc9gfX3buju/5Qml3GWgCyUed7YtwmdYJHrLqqom8r6vyDfT0whsG3bqrzV+6oeD36ZazdvkCN1NYe5nq8xSRHndpYvd14Igca5dZxdn+xtm7WZMZlXQOxe18c3ukQtLLJDc0cUSPsOiJ6AMqfKugdeRItZbgsKiN/Q5s2xwqLCYw7hOWl3/FO5oj+OtVYODwdZeJe2LD+mVDxe/D/efwCuAQs2cnkFkQAAAABJRU5ErkJggg==";

exports.CometChatLiveReaction = class CometChatLiveReaction extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.reactionIconURL = heartIcon;
        this.liveReactionStyle = {
            height: "20px",
            width: "25px",
            background: "red"
        };
        this.items = [];
    }
    firstUpdated(_changedProperties) {
        try {
            this.counter = 0;
            this.verticalSpeed = 5;
            this.horizontalSpeed = 2;
            this.items = [];
            this.before = Date.now();
            this.setItems();
            this.requestAnimation();
        }
        catch (error) {
        }
    }
    render() {
        return lit.html `
  <div class="cc__livereaction">
    ${Array(5).fill(0).map(() => {
            return lit.html `<span class="cc__livereaction__icon" id="reaction">
     <cometchat-icon  .URL=${this.reactionIconURL} .name="reaction" .iconStyle=${this.liveReactionStyles()}></cometchat-icon>
      </span>`;
        })}

</div>

  `;
    }
    /**
     * Sets height width speed for animation
     */
    setItems() {
        var _a, _b;
        try {
            const width = this.shadowRoot.querySelector("#reaction").parentElement.offsetWidth;
            const height = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#reaction").parentElement.offsetHeight;
            const elements = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("#reaction").parentElement.querySelectorAll(".cc__livereaction__icon");
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i], elementWidth = element.offsetWidth, elementHeight = element.offsetHeight;
                const item = {
                    element: element,
                    elementHeight: elementHeight,
                    elementWidth: elementWidth,
                    ySpeed: -this.verticalSpeed,
                    omega: (2 * Math.PI * this.horizontalSpeed) / (width * 60),
                    random: (Math.random() / 2 + 0.5) * i * 10000,
                    x: function (time) {
                        return (((Math.sin(this.omega * (time + this.random)) + 1) / 2) *
                            (width - elementWidth));
                    },
                    y: height + (Math.random() + 0.2) * i * elementHeight,
                };
                this.items.push(item);
            }
        }
        catch (error) {
        }
    }
    requestAnimation() {
        try {
            this.timer = setTimeout(() => {
                this.animateReaction();
            }, 1000 / 60);
        }
        catch (error) {
        }
    }
    /**
     * Animates the reactions
     */
    animateReaction() {
        var _a;
        try {
            if (!((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#reaction").parentElement)) {
                return false;
            }
            const time = +new Date(); //little trick, gives unix time in ms
            for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i];
                const transformString = "translate3d(" + item.x(time) + "px, " + item.y + "px, 0px)";
                item.element.style.transform = transformString;
                item.element.style.visibility = "visible";
                item.y += item.ySpeed;
            }
            this.requestAnimation();
        }
        catch (error) {
        }
        return true;
    }
    liveReactionStyles() {
        var _a, _b, _c;
        return {
            height: ((_a = this.liveReactionStyle) === null || _a === void 0 ? void 0 : _a.height) || "24px",
            width: ((_b = this.liveReactionStyle) === null || _b === void 0 ? void 0 : _b.width) || "24px",
            iconTint: (_c = this.liveReactionStyle) === null || _c === void 0 ? void 0 : _c.background,
        };
    }
};
exports.CometChatLiveReaction.styles = [
    lit.css `
.cc__livereaction{
  width: 100px;
  height: calc(100% - 120px);
  overflow: hidden;
  top: 70px;
  float: right;
  display: block;
  z-index: 10;
  position: absolute;
  right: 2px;
}

.cc__livereaction__icon {
  position: absolute;
  z-index: 10;
  visibility: hidden;
  width: 25px;
  height: 20px;
}
.cc__livereaction {
    animation: fade 2s ease-in-out;
}


@keyframes fade {
  100% { opacity: 0;}
  0% { opacity: 1 }
}

  `
];
__decorate([
    decorators_js.property()
], exports.CometChatLiveReaction.prototype, "reactionIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatLiveReaction.prototype, "liveReactionStyle", void 0);
exports.CometChatLiveReaction = __decorate([
    decorators_js.customElement('cometchat-live-reaction')
], exports.CometChatLiveReaction);

exports.CometChatJoinGroup = class CometChatJoinGroup extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = uikitResources.localize("ENTER_GROUP_PASSWORD");
        this.passwordInputPlaceholderText = uikitResources.localize("ENTER_YOUR_PASSWORD");
        this.joinButtonText = uikitResources.localize("CONTINUE");
        this.joinGroupStyle = {
            width: "100%",
            boxShadow: "none",
            height: "100%",
            background: "rgb(255, 255, 255)",
            border: "none",
            borderRadius: "none",
            titleTextFont: "700 22px Inter",
            titleTextColor: "rgba(20, 20, 20, 0.69)",
            errorTextFont: "500 15px Inter",
            errorTextColor: "red",
            passwordInputTextFont: "400 15px Inter",
            passwordInputTextColor: "rgb(142 130 130)",
            passwordInputPlaceholderTextFont: "400 15px Inter",
            passwordInputPlaceholderTextColor: "rgba(20, 20, 20, 0.6)",
            passwordInputBackground: "rgba(20, 20, 20, 0.04)",
            passwordInputBorder: "none",
            passwordInputBorderRadius: "8px",
            passwordInputBoxShadow: "rgba(20, 20, 20, 0.04) 0px 0px 0px 1px",
            joinButtonTextFont: "600 15px Inter",
            joinButtonTextColor: "rgb(255, 255, 255)",
            joinButtonBackground: "rgb(51, 153, 255)",
            joinButtonBorderRadius: "8px",
            joinButtonBorder: "none"
        };
        this.hasError = false;
        this.errorText = uikitResources.localize("SOMETHING_WRONG");
        this.joinClick = null;
        this.errorCallback = null;
        this.loggedInUser = null;
        this.password = "";
        /**
         * Props dependent styles of CometChatJoinGroup
         */
        this.wrapperStyle = () => {
            return {
                height: this.joinGroupStyle.height,
                width: this.joinGroupStyle.width,
                border: this.joinGroupStyle.border,
                borderRadius: this.joinGroupStyle.borderRadius,
                boxShadow: this.joinGroupStyle.boxShadow,
                background: this.joinGroupStyle.background
            };
        };
        this.titleStyle = () => {
            return {
                font: this.joinGroupStyle.titleTextFont,
                color: this.joinGroupStyle.titleTextColor
            };
        };
        this.placeholderStyle = () => {
            return {
                placeholderTextFont: this.joinGroupStyle.passwordInputPlaceholderTextFont,
                placeholderTextColor: this.joinGroupStyle.passwordInputPlaceholderTextColor,
                textFont: this.joinGroupStyle.passwordInputTextFont,
                textColor: this.joinGroupStyle.passwordInputTextColor,
                background: this.joinGroupStyle.passwordInputBackground,
                border: this.joinGroupStyle.passwordInputBorder,
                boxShadow: this.joinGroupStyle.passwordInputBoxShadow,
                borderRadius: this.joinGroupStyle.passwordInputBorderRadius,
                window: "100%",
                padding: "8px"
            };
        };
        this.buttonStyle = () => {
            var _a;
            return {
                buttonTextFont: this.joinGroupStyle.joinButtonTextFont,
                buttonTextColor: this.joinGroupStyle.joinButtonTextColor,
                background: this.joinGroupStyle.joinButtonBackground,
                borderRadius: this.joinGroupStyle.joinButtonBorderRadius,
                border: (_a = this.joinGroupStyle) === null || _a === void 0 ? void 0 : _a.joinButtonBorder,
                width: "100%",
                height: "38px",
                display: "flex",
                justifyContent: "center"
            };
        };
        this.errorTextStyle = () => {
            return {
                textFont: this.joinGroupStyle.errorTextFont,
                textColor: this.joinGroupStyle.errorTextColor
            };
        };
    }
    updated(_changedProperties) {
    }
    render() {
        chatSdkJavascript.CometChat.getLoggedinUser().then((user) => {
            this.loggedInUser = user;
        });
        return lit.html `
      <div class="cc__joingroup" style=${styleMap_js.styleMap(this.wrapperStyle())}>
     <div class="cc__joingroup__headerview">    <slot name="headerView"></slot></div>
        <div class=" cc__joingroup__container" >
          <div class="cc__joingroup__title" style=${styleMap_js.styleMap(this.titleStyle())} > ${this.title} </div>
        ${this.hasError ? lit.html `  <div class="cc__joingroup__error" >
            <cometchat-label .text=${this.errorText} .labelStyle=${this.errorTextStyle()}>
            </cometchat-label>
            </div>` : lit.nothing}
          <div class="cc__joingroup__input--password">
          <cometchat-input type=${"password"} @cc-message-input-entered=${() => { this.hasError = false; this.requestUpdate("hasError"); }}   .placeholderText=${this.passwordInputPlaceholderText} @cc-input-changed=${(event) => { var _a; this.password = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value; }} .inputStyle=${this.placeholderStyle()}></cometchat-input>
          </div>
            <cometchat-button class="cc__joingroup__button--join" .buttonStyle=${this.buttonStyle()} @click=${this.joinGroup} .text=${this.joinButtonText}>  </cometchat-button>
        </div>
      </div>`;
    }
    joinGroup() {
        var _a, _b, _c, _d;
        let guid = this.group instanceof chatSdkJavascript.CometChat.Group ? (_a = this.group) === null || _a === void 0 ? void 0 : _a.getGuid() : (_b = this.group) === null || _b === void 0 ? void 0 : _b.guid;
        let type = this.group instanceof chatSdkJavascript.CometChat.Group ? (_c = this.group) === null || _c === void 0 ? void 0 : _c.getType() : (_d = this.group) === null || _d === void 0 ? void 0 : _d.type;
        let password = this.password;
        if (this.joinClick) {
            this.joinClick(this.group, password);
            return;
        }
        try {
            chatSdkJavascript.CometChat.joinGroup(guid, type, password)
                .then((response) => {
                this.hasError = false;
                this.requestUpdate("hasError");
                uikitResources.CometChatGroupEvents.ccGroupMemberJoined.next({
                    joinedGroup: response,
                    joinedUser: this.loggedInUser
                });
            })
                .catch((error) => {
                if (this.errorCallback) {
                    this.errorCallback(error);
                }
                this.hasError = true;
                this.requestUpdate("hasError");
                this.errorText = error.message;
            });
        }
        catch (error) {
            this.hasError = true;
            this.requestUpdate("hasError");
            if (this.errorCallback) {
                this.errorCallback(error);
            }
        }
    }
};
exports.CometChatJoinGroup.styles = [
    lit.css `
    .cc__joingroup__container{
  margin: auto;
  width: 343px;
  height: 100%;
  border-radius: 8px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cc__joingroup {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}
.cc__joingroup__title{
  padding: 16px;
}
.cc__joingroup__input--password{
  width: 100%;
  padding: 8px 0;
  input{
    outline: none;
    width: 100%;
    height: 46px;
    text-align: left;
    padding-left: 16px;
    border: none;
  }
}
.cc__joingroup__button--join{
  width: 100%;
  height: 46px;
  border: none;
  text-align: center;
  margin: 8px;
}
.cc__joingroup__error{
  text-align: left;
  padding-bottom: 18px;
}

    `
];
__decorate([
    decorators_js.property()
], exports.CometChatJoinGroup.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatJoinGroup.prototype, "passwordInputPlaceholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatJoinGroup.prototype, "joinButtonText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatJoinGroup.prototype, "joinGroupStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatJoinGroup.prototype, "errorText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatJoinGroup.prototype, "group", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatJoinGroup.prototype, "joinClick", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatJoinGroup.prototype, "errorCallback", void 0);
exports.CometChatJoinGroup = __decorate([
    decorators_js.customElement('cometchat-join-group')
], exports.CometChatJoinGroup);

/**
 * JoinGroupStyle class defines the style for a join group component.
 *
 * @property {string} boxShadow - The box shadow for the component.
 * @property {string} titleTextFont - The font for the title text.
 * @property {string} titleTextColor - The color for the title text.
 * @property {string} errorTextFont - The font for the error text.
 * @property {string} errorTextColor - The color for the error text.
 * @property {string} passwordInputTextFont - The font for the password input text.
 * @property {string} passwordInputTextColor - The color for the password input text.
 * @property {string} passwordInputPlaceholderTextFont - The font for the password input placeholder text.
 * @property {string} passwordInputPlaceholderTextColor - The color for the password input placeholder text.
 * @property {string} passwordInputBackground - The background color for the password input.
 * @property {string} passwordInputBorder - The border color for the password input.
 * @property {string} passwordInputBorderRadius - The border radius for the password input.
 * @property {string} passwordInputBoxShadow - The box shadow for the password input.
 * @property {string} joinButtonTextFont - The font for the join button text.
 * @property {string} joinButtonTextColor - The color for the join button text.
 * @property {string} joinButtonBackground - The background color for the join button.
 * @property {string} joinButtonBorderRadius - The border radius for the join button.
 * @property {string} joinButtonBorder - The border color for the join button.
 *
 * @extends {BaseStyle}
 */
class JoinGroupStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.boxShadow = "rgb(20 20 20 / 20%) 0px 0px 32px";
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "RGBA(20, 20, 20, 0.46)";
        this.errorTextFont = "400 13px Inter";
        this.errorTextColor = "red";
        this.passwordInputTextFont = "400 15px Inter, sans-serif";
        this.passwordInputTextColor = "black";
        this.passwordInputPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.passwordInputPlaceholderTextColor = "RGBA(20, 20, 20, 0.6)";
        this.passwordInputBackground = "RGBA(20, 20, 20, 0.04)";
        this.passwordInputBorder = "1px solid rgba(20, 20, 20, 0.04)";
        this.passwordInputBorderRadius = "8px";
        this.passwordInputBoxShadow = "rgba(20, 20, 20, 0.04) 0 0 0 1px";
        this.joinButtonTextFont = "600 15px Inter, sans-serif";
        this.joinButtonTextColor = "white";
        this.joinButtonBackground = "RGB(51, 153, 255)";
        this.joinButtonBorderRadius = "8px";
        this.joinButtonBorder = "none";
        Object.assign(this, props);
    }
}

exports.CometChatCreateGroup = class CometChatCreateGroup extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = uikitResources.localize("NEW__GROUP");
        this.createGroupButtonText = uikitResources.localize("CREATE_GROUP");
        this.nameInputPlaceholderText = uikitResources.localize("NAME");
        this.passwordInputPlaceholderText = uikitResources.localize("PASSWORD");
        this.closeButtonIconURL = closeIcon;
        this.hideCloseButton = false;
        this.errorStateText = "";
        this.createGroupStyle = {
            width: "340px",
            height: "500px",
            background: "rgb(255, 255, 255)",
            border: "none",
            borderRadius: "8px",
            boxShadow: "rgba(20, 20, 20, 0.2) 0px 16px 32px 0px",
            groupTypeTextFont: "500 13px Inter",
            groupTypeBorder: "1px solid rgb(178 178 178 / 60%)",
            groupTypeBorderRadius: "0",
            groupTypeTextColor: "black",
            groupTypeTextBackground: "transparent",
            groupTypeBackground: "rgba(20, 20, 20, 0.08)",
            groupTypeBoxShadow: "",
            activeGroupTypeTextFont: "500 13px Inter",
            activeGroupTypeTextColor: "black",
            activeGroupTypeBackground: "rgb(255, 255, 255)",
            activeGroupTypeBoxShadow: "rgba(20, 20, 20, 0.12) 0 3px 8px 0",
            activeGroupTypeBorderRadius: "8px",
            activeGroupTypeBorder: "none",
            groupTypeTextBoxShadow: "none",
            groupTypeTextBorderRadius: "0",
            closeIconTint: "rgb(51, 153, 255)",
            titleTextFont: "700 22px Inter",
            titleTextColor: "rgb(20, 20, 20)",
            errorTextFont: "500 15px Inter",
            errorTextBackground: "rgba(255, 59, 48, 0.1)",
            errorTextBorderRadius: "8px",
            errorTextBorder: "none",
            errorTextColor: "rgb(255, 59, 48)",
            nameInputPlaceholderTextFont: "400 15 Inter",
            nameInputPlaceholderTextColor: "rgba(20, 20, 20, 0.6)",
            nameInputBackground: "rgba(20, 20, 20, 0.04)",
            nameInputTextFont: "400 15 Inter",
            nameInputTextColor: "rgb(20, 20, 20)",
            nameInputBorder: "none",
            nameInputBorderRadius: "8px",
            nameInputBoxShadow: "rgba(20, 20, 20, 0.04) 0 0 0 1px",
            passwordInputPlaceholderTextFont: "400 15 Inter",
            passwordInputPlaceholderTextColor: "rgba(20, 20, 20, 0.6)",
            passwordInputBackground: "rgba(20, 20, 20, 0.04)",
            passwordInputBorder: "none",
            passwordInputBorderRadius: "8px",
            passwordInputBoxShadow: "rgba(20, 20, 20, 0.04) 0 0 0 1px",
            passwordInputTextFont: "400 15 Inter",
            passwordInputTextColor: "rgb(20, 20, 20)",
            createGroupButtonTextFont: "600 15px Inter",
            createGroupButtonTextColor: "rgb(255, 255, 255)",
            createGroupButtonBackground: "rgb(51, 153, 255)",
            createGroupButtonBorderRadius: "8px",
            createGroupButtonBorder: "none"
        };
        this.errorCallback = null;
        this.closeCallback = null;
        this.createClick = null;
        this.hasError = false;
        this.objectKeys = Object.keys;
        this.groupTypes = {
            public: uikitResources.CometChatUIKitConstants.GroupTypes.public,
            private: uikitResources.CometChatUIKitConstants.GroupTypes.private,
            password: uikitResources.CometChatUIKitConstants.GroupTypes.password,
        };
        this.activeTab = "public";
        this.passwordInput = false;
        this.groupName = "";
        this.groupPassword = "";
        this.type = "";
        this.buttonGroup = [
            {
                buttonText: "Public",
                id: "public"
            },
            {
                buttonText: "Private",
                id: "private"
            },
            {
                buttonText: "Password",
                id: "password"
            }
        ];
        this.buttonGroupStyle = {};
        /**
       * Props dependent styles of CometChatCreateGroup
       */
        this.closeIconStyle = () => {
            var _a;
            return {
                buttonIconTint: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint,
                height: "24px",
                width: "24px",
                border: "none",
                borderRadius: "0",
                background: "transparent"
            };
        };
        this.createButtonStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                buttonTextFont: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.createGroupButtonTextFont,
                buttonTextColor: (_b = this.createGroupStyle) === null || _b === void 0 ? void 0 : _b.createGroupButtonTextColor,
                background: (_c = this.createGroupStyle) === null || _c === void 0 ? void 0 : _c.createGroupButtonBackground,
                borderRadius: (_d = this.createGroupStyle) === null || _d === void 0 ? void 0 : _d.createGroupButtonBorderRadius,
                border: (_e = this.createGroupStyle) === null || _e === void 0 ? void 0 : _e.createGroupButtonBorder,
                width: "100%",
                height: "40px",
                display: "flex",
                justifyContent: "center"
            };
        };
        this.passwordInputStyle = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return {
                textColor: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.passwordInputTextColor,
                textFont: (_b = this.createGroupStyle) === null || _b === void 0 ? void 0 : _b.passwordInputTextFont,
                placeholderTextColor: (_c = this.createGroupStyle) === null || _c === void 0 ? void 0 : _c.passwordInputPlaceholderTextColor,
                placeholderTextFont: (_d = this.createGroupStyle) === null || _d === void 0 ? void 0 : _d.passwordInputPlaceholderTextFont,
                boxShadow: (_e = this.createGroupStyle) === null || _e === void 0 ? void 0 : _e.passwordInputBoxShadow,
                background: (_f = this.createGroupStyle) === null || _f === void 0 ? void 0 : _f.passwordInputBackground,
                border: (_g = this.createGroupStyle) === null || _g === void 0 ? void 0 : _g.passwordInputBorder,
                borderRadius: (_h = this.createGroupStyle) === null || _h === void 0 ? void 0 : _h.passwordInputBorderRadius,
                width: "100%",
                padding: "12px"
            };
        };
        this.nameInputStyle = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return {
                textColor: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.nameInputTextColor,
                textFont: (_b = this.createGroupStyle) === null || _b === void 0 ? void 0 : _b.nameInputTextFont,
                placeholderTextColor: (_c = this.createGroupStyle) === null || _c === void 0 ? void 0 : _c.nameInputPlaceholderTextColor,
                placeholderTextFont: (_d = this.createGroupStyle) === null || _d === void 0 ? void 0 : _d.nameInputPlaceholderTextFont,
                boxShadow: (_e = this.createGroupStyle) === null || _e === void 0 ? void 0 : _e.nameInputBoxShadow,
                background: (_f = this.createGroupStyle) === null || _f === void 0 ? void 0 : _f.nameInputBackground,
                border: (_g = this.createGroupStyle) === null || _g === void 0 ? void 0 : _g.nameInputBorder,
                borderRadius: (_h = this.createGroupStyle) === null || _h === void 0 ? void 0 : _h.nameInputBorderRadius,
                width: `100%`,
                padding: "12px"
            };
        };
        this.titleStyle = () => {
            var _a, _b;
            return {
                textColor: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.titleTextColor,
                textFont: (_b = this.createGroupStyle) === null || _b === void 0 ? void 0 : _b.titleTextFont,
            };
        };
        this.wrapperStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                border: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.border,
                borderRadius: (_b = this.createGroupStyle) === null || _b === void 0 ? void 0 : _b.borderRadius,
                height: (_c = this.createGroupStyle) === null || _c === void 0 ? void 0 : _c.height,
                width: (_d = this.createGroupStyle) === null || _d === void 0 ? void 0 : _d.width,
                background: (_e = this.createGroupStyle) === null || _e === void 0 ? void 0 : _e.background,
                boxShadow: (_f = this.createGroupStyle) === null || _f === void 0 ? void 0 : _f.boxShadow
            };
        };
        this.errorTextStyle = () => {
            var _a, _b, _c;
            return {
                textFont: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.errorTextFont,
                textColor: (_b = this.createGroupStyle) === null || _b === void 0 ? void 0 : _b.errorTextColor,
                background: (_c = this.createGroupStyle) === null || _c === void 0 ? void 0 : _c.errorTextBackground,
            };
        };
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        this.buttonGroupStyle = {
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "8px",
            background: (_a = this.createGroupStyle) === null || _a === void 0 ? void 0 : _a.groupTypeBackground,
            buttonTextFont: (_b = this.createGroupStyle) === null || _b === void 0 ? void 0 : _b.groupTypeTextFont,
            buttonTextColor: (_c = this.createGroupStyle) === null || _c === void 0 ? void 0 : _c.groupTypeTextColor,
            buttonBackground: (_d = this.createGroupStyle) === null || _d === void 0 ? void 0 : _d.groupTypeTextBackground,
            activeButtonBackground: (_e = this.createGroupStyle) === null || _e === void 0 ? void 0 : _e.activeGroupTypeBackground,
            activeButtonBorder: (_f = this.createGroupStyle) === null || _f === void 0 ? void 0 : _f.activeGroupTypeBorder,
            activeButtonBorderRadius: (_g = this.createGroupStyle) === null || _g === void 0 ? void 0 : _g.activeGroupTypeBorderRadius,
            activeButtonTextFont: (_h = this.createGroupStyle) === null || _h === void 0 ? void 0 : _h.activeGroupTypeTextFont,
            activeButtonTextColor: (_j = this.createGroupStyle) === null || _j === void 0 ? void 0 : _j.activeGroupTypeTextColor,
            buttonSeparatorColor: (_k = this.createGroupStyle) === null || _k === void 0 ? void 0 : _k.groupTypeBorder,
            buttonBorder: (_l = this.createGroupStyle) === null || _l === void 0 ? void 0 : _l.groupTypeBorderRadius,
            activeButtonBoxShadow: (_m = this.createGroupStyle) === null || _m === void 0 ? void 0 : _m.activeGroupTypeBoxShadow,
            buttonBorderRadius: "4px",
            boxShadow: (_o = this.createGroupStyle) === null || _o === void 0 ? void 0 : _o.groupTypeBoxShadow
        };
        return lit.html `
      <div class="cc__creategroup__wrapper" style=${styleMap_js.styleMap(this.wrapperStyle())}>
      ${!this.hideCloseButton ? lit.html `   <span class="cc__creategroup__close">
  <cometchat-button .buttonStyle=${this.closeIconStyle()}  .iconURL=${this.closeButtonIconURL} @cc-button-clicked=${() => { this.closeCreateGroupView(); }}>
  </cometchat-button>
    </span>` : lit.nothing}
  <div class="cc__creategroup__body">
    <cometchat-label class="cc__creategroup__title"  .text=${this.title} .labelStyle=${this.titleStyle()}></cometchat-label>
    <div class="cc__tabs__container">
      <cometchat-button-group .data=${this.buttonGroup} class="cc__tab__list" .buttonGroupStyle=${this.buttonGroupStyle} @cc-button-group-clicked = ${this.setActiveTab}> </cometchat-button-group>
    </div>
    <div class="cc__creategroup__input">
      <div class="cc__creategroup__input--name">
          <cometchat-input class="cc__input" @cc-message-input-entered=${() => { this.hasError = false; this.requestUpdate("hasError"); }}  .placeholderText=${this.nameInputPlaceholderText} .type=${'text'} .inputStyle=${this.nameInputStyle()}  @cc-input-changed=${(event) => { var _a; this.groupName = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value; }} ></cometchat-input>
      </div>
      ${this.passwordInput ? lit.html `<div  class="cc__creategroup__input--password">
       <cometchat-input class="cc__input" @cc-message-input-entered=${() => { this.hasError = false; this.requestUpdate("hasError"); }}   .placeholderText=${this.passwordInputPlaceholderText} .type=${'password'}   .inputStyle=${this.passwordInputStyle()} @cc-input-changed=${(event) => { var _a; this.groupPassword = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value; }} ></cometchat-input>
       </div>` : lit.nothing}
      <div>
       ${this.hasError ? lit.html ` <div class="cc__creategroup__error" >
          <cometchat-label  .text=${this.errorStateText} .labelStyle=${this.errorTextStyle()}>
          </cometchat-label>
          </div>` : lit.nothing}
      </div>
    </div>
    <div class="cc__creategroup__button">
      <cometchat-button  @click=${this.createGroup} .buttonStyle=${this.createButtonStyle()} .text=${this.createGroupButtonText}>
      </cometchat-button>
    </div>
  </div>
</div>
      `;
    }
    /**
   * @param  {string} type
   */
    setActiveTab(event) {
        var _a;
        let type = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.id;
        this.activeTab = type;
        if (type == "password") {
            this.passwordInput = true;
            this.requestUpdate("passwordInput");
        }
        else {
            this.passwordInput = false;
            this.requestUpdate("passwordInput");
        }
    }
    /**
    * If the Group Data is successfully validated , below function creates the group
    * @param
    */
    createGroup() {
        var _a;
        let password = this.groupPassword;
        let guid = "group__" + new Date().getTime();
        let name = this.groupName.trim();
        let type = this.activeTab || ((_a = this.groupTypes) === null || _a === void 0 ? void 0 : _a.public);
        let group = new chatSdkJavascript.CometChat.Group(guid, name, type, password);
        if (this.createClick) {
            this.createClick(group);
            return;
        }
        chatSdkJavascript.CometChat.createGroup(group)
            .then((group) => {
            this.hasError = false;
            this.requestUpdate("hasError");
            uikitResources.CometChatGroupEvents.ccGroupCreated.next(group);
        })
            .catch((error) => {
            this.hasError = true;
            this.requestUpdate("hasError");
            if (this.errorCallback) {
                this.errorCallback(error);
            }
        });
    }
    closeCreateGroupView() {
        this.resetGroupData();
        if (this.closeCallback) {
            this.closeCallback();
        }
        this.dispatchEvent(new CustomEvent('cc-creategroup-close-clicked', {
            bubbles: true,
            composed: true,
        }));
    }
    /**
     * Resets all the Group creation form data to initial values
     * @param
     */
    resetGroupData() {
        try {
            this.passwordInput = false;
            this.groupName = "";
            this.type = "";
            this.groupPassword = "";
            this.activeTab = "";
            this.requestUpdate();
        }
        catch (error) {
        }
    }
};
exports.CometChatCreateGroup.styles = [
    lit.css `
    .cc__creategroup__wrapper {
  display: block;
  overflow: hidden;
  padding:16px;
  box-sizing: border-box;
}
.cc__creategroup__close {
  display:block;
  width: 24px;
  height: 24px;
  float: right;
  border-radius: 8px;
  cursor: pointer;
  position:relative;
  z-index:5;
}
.cc__creategroup__body {
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
}
.cc__creategroup__error {
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  height: 45px;
  width: 100%;
  padding: 0 12px;
}
.cc__creategroup__button{
  text-align: center;
  border: none;
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.cc__input{
  display: block;
  width: 100%;
  border: 0;
  border-radius: 8px;

}

.cc__tab{
  text-transform: capitalize ;
}
.cc__creategroup__input{
  padding: 16px 0 ;
}
.cc__creategroup__input--name {
  margin-bottom: 12px;
}
.cc__creategroup__title{
  display: flex;
  margin-bottom: 15px;
  text-align: left;
  justify-content: center;
}
.cc__tabs__container{
  border-radius: 8px;
  width: 100%;
  height: 32px;
  margin: auto;
}
.cc__tabs__container > .cc__tab__list{
    padding: 0 !important;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    padding: 0;
    height: inherit;
    width: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
  }
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatCreateGroup.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCreateGroup.prototype, "createGroupButtonText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCreateGroup.prototype, "nameInputPlaceholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCreateGroup.prototype, "passwordInputPlaceholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCreateGroup.prototype, "closeButtonIconURL", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatCreateGroup.prototype, "hideCloseButton", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCreateGroup.prototype, "errorStateText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCreateGroup.prototype, "createGroupStyle", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatCreateGroup.prototype, "errorCallback", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatCreateGroup.prototype, "closeCallback", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CometChatCreateGroup.prototype, "createClick", void 0);
exports.CometChatCreateGroup = __decorate([
    decorators_js.customElement('cometchat-create-group')
], exports.CometChatCreateGroup);

/**
 * @property {string} boxShadow - Box shadow of the group container
 * @property {string} groupTypeTextFont - Font of the group type text
 * @property {string} groupTypeBorder - Border of the group type container
 * @property {string} groupTypeBorderRadius - Border radius of the group type container
 * @property {string} groupTypeTextColor - Color of the group type text
 * @property {string} groupTypeTextBackground - Background color of the group type container
 * @property {string} groupTypeBackground - Background color of the group type container
 * @property {string} groupTypeBoxShadow - Box shadow of the group type container
 * @property {string} activeGroupTypeTextFont - Font of the active group type text
 * @property {string} activeGroupTypeTextColor - Color of the active group type text
 * @property {string} activeGroupTypeBackground - Background color of the active group type container
 * @property {string} activeGroupTypeBoxShadow - Box shadow of the active group type container
 * @property {string} activeGroupTypeBorderRadius - Border radius of the active group type container
 * @property {string} activeGroupTypeBorder - Border of the active group type container
 * @property {string} groupTypeTextBoxShadow - Box shadow of the group type text
 * @property {string} groupTypeTextBorderRadius - Border radius of the group type text
 * @property {string} closeIconTint - Tint color of the close icon
 * @property {string} titleTextFont - Font of the title text
 * @property {string} titleTextColor - Color of the title text
 * @property {string} errorTextFont - Font of the error text
 * @property {string} errorTextBackground - Background color of the error container
 * @property {string} errorTextBorderRadius - Border radius of the error container
 * @property {string} errorTextBorder - Border of the error container
 * @property {string} errorTextColor - Color of the error text
 * @property {string} nameInputPlaceholderTextFont - Font of the name input placeholder text
 * @property {string} nameInputPlaceholderTextColor - Color of the name input placeholder text
 * @property {string} nameInputBackground - Background color of the name input container
 * @property {string} nameInputTextFont - Font of the name input text
 * @property {string} nameInputTextColor - Color of the name input text
 * @property {string} nameInputBorder - Border of the name input container
 * @property {string} nameInputBorderRadius - Border radius of the name input container
 * @property {string} nameInputBoxShadow - Box shadow of the name input container
 * @property {string} passwordInputPlaceholderTextFont - Font of the password input placeholder text
 * @property {string} passwordInputPlaceholderTextColor - Color of the password input placeholder text
 * @property {string} passwordInputBackground - Background color of the password input container
 * @property {string} passwordInputBorder - Border of the password input container
 * @property {string} passwordInputBorderRadius - Border radius of the password input container
 * @property {string} passwordInputBoxShadow - Box shadow of the password input container
 * @property {string} passwordInputTextFont - The font style for the password input text. Default is "400 15 Inter".
 * @property {string} passwordInputTextColor - The text color for the password input text. Default is "rgb(20, 20, 20)".
 * @property {string} createGroupButtonTextFont - The font style for the create group button text. Default is "600 15px Inter".
 * @property {string} createGroupButtonTextColor - The text color for the create group button text. Default is "rgb(255, 255, 255)".
 * @property {string} createGroupButtonBackground - The background color for the create group button. Default is "rgb(51, 153, 255)".
 * @property {string} createGroupButtonBorderRadius - The border radius for the create group button. Default is "8px".
 * @property {string} createGroupButtonBorder - The border for the create group button. Default is "none".
 */
class CreateGroupStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.boxShadow = "rgba(20, 20, 20, 0.2) 0px 16px 32px 0px";
        this.groupTypeTextFont = "500 13px Inter, sans-serif";
        this.groupTypeBorder = "1px solid rgb(178 178 178 / 60%)";
        this.groupTypeBorderRadius = "0";
        this.groupTypeTextColor = "black";
        this.groupTypeTextBackground = "transparent";
        this.groupTypeBackground = "rgba(20, 20, 20, 0.08)";
        this.groupTypeBoxShadow = "";
        this.activeGroupTypeTextFont = "500 13px Inter, sans-serif";
        this.activeGroupTypeTextColor = "black";
        this.activeGroupTypeBackground = "rgb(255, 255, 255)";
        this.activeGroupTypeBoxShadow = "rgba(20, 20, 20, 0.12) 0 3px 8px 0";
        this.activeGroupTypeBorderRadius = "8px";
        this.activeGroupTypeBorder = "none";
        this.groupTypeTextBoxShadow = "none";
        this.groupTypeTextBorderRadius = "0";
        this.closeIconTint = "rgb(51, 153, 255)";
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "rgb(20, 20, 20)";
        this.errorTextFont = "500 15px Inter, sans-serif";
        this.errorTextBackground = "rgba(255, 59, 48, 0.1)";
        this.errorTextBorderRadius = "8px";
        this.errorTextBorder = "none";
        this.errorTextColor = "rgb(255, 59, 48)";
        this.nameInputPlaceholderTextFont = "400 15 Inter, sans-serif";
        this.nameInputPlaceholderTextColor = "rgba(20, 20, 20, 0.6)";
        this.nameInputBackground = "rgba(20, 20, 20, 0.04)";
        this.nameInputTextFont = "400 15 Inter, sans-serif";
        this.nameInputTextColor = "rgb(20, 20, 20)";
        this.nameInputBorder = "none";
        this.nameInputBorderRadius = "8px";
        this.nameInputBoxShadow = "rgba(20, 20, 20, 0.04) 0 0 0 1px";
        this.passwordInputPlaceholderTextFont = "400 15 Inter, sans-serif";
        this.passwordInputPlaceholderTextColor = "rgba(20, 20, 20, 0.6)";
        this.passwordInputBackground = "rgba(20, 20, 20, 0.04)";
        this.passwordInputBorder = "none";
        this.passwordInputBorderRadius = "8px";
        this.passwordInputBoxShadow = "rgba(20, 20, 20, 0.04) 0 0 0 1px";
        this.passwordInputTextFont = "400 15 Inter, sans-serif";
        this.passwordInputTextColor = "rgb(20, 20, 20)";
        this.createGroupButtonTextFont = "600 15px Inter, sans-serif";
        this.createGroupButtonTextColor = "rgb(255, 255, 255)";
        this.createGroupButtonBackground = "rgb(51, 153, 255)";
        this.createGroupButtonBorderRadius = "8px";
        this.createGroupButtonBorder = "none";
        Object.assign(this, props);
    }
}

exports.CometChatDocumentBubble = class CometChatDocumentBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.iconURL = "";
        this.title = "";
        this.URL = "";
        this.subtitle = "";
        this.buttonText = "";
        this.documentStyle = {
            width: "250px",
            height: "fit-content",
            border: "none",
            background: "RGBA(20, 20, 20, 0.04)",
            borderRadius: "8px",
            titleFont: "600 15px Inter, sans-serif",
            titleColor: "rgb(20, 20, 20)",
            subtitleFont: "400 13px Inter, sans-serif",
            subtitleColor: "rgba(20, 20, 20, 0.58)",
            iconTint: "RGBA(20, 20, 20, 0.69)",
            buttonTextFont: "600 15px Inter",
            buttonTextColor: "#11bbf4d4",
            buttonBackground: "transparent",
            separatorColor: "RGBA(20, 20, 20, 0.1)"
        };
        this.hideSeparator = false;
        this.iconAlignment = uikitResources.DocumentIconAlignment.left;
        this.dividerStyle = {
            height: "1px",
            width: "100%",
            background: "#e6e6e6"
        };
        this.iconStyle = {
            height: "24px",
            width: "24px",
            iconTint: "grey"
        };
        this.bubbleStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                width: (_a = this.documentStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.documentStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.documentStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.documentStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.documentStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
        this.bubbleTitleStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.documentStyle) === null || _a === void 0 ? void 0 : _a.titleFont,
                textColor: (_b = this.documentStyle) === null || _b === void 0 ? void 0 : _b.titleColor,
            };
        };
        this.bubbleSubtitleStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.documentStyle) === null || _a === void 0 ? void 0 : _a.subtitleFont,
                textColor: (_b = this.documentStyle) === null || _b === void 0 ? void 0 : _b.subtitleColor,
            };
        };
        this.bubbleButtonStyle = () => {
            var _a, _b, _c;
            return {
                border: "none",
                borderRadius: "8px",
                background: (_a = this.documentStyle) === null || _a === void 0 ? void 0 : _a.buttonBackground,
                buttonTextFont: (_b = this.documentStyle) === null || _b === void 0 ? void 0 : _b.buttonTextFont,
                buttonTextColor: (_c = this.documentStyle) === null || _c === void 0 ? void 0 : _c.buttonTextColor,
                height: this.hideSeparator ? "28px" : "22px",
                display: "flex",
                width: "100%",
                justifyContent: "center",
                marginTop: this.hideSeparator ? "8px" : "0"
            };
        };
    }
    buttonClicked() {
        if (this.ccClicked) {
            this.ccClicked(this.URL);
        }
    }
    ;
    render() {
        var _a, _b, _c, _d;
        this.iconStyle.iconTint = ((_a = this.documentStyle) === null || _a === void 0 ? void 0 : _a.iconTint) || "grey";
        this.dividerStyle.background = ((_b = this.documentStyle) === null || _b === void 0 ? void 0 : _b.separatorColor) || "#e6e6e6";
        return lit.html `
<div style=${styleMap_js.styleMap(this.bubbleStyle())} class="cc__documentbubble__wrapper">
<div class="cc__documentbubble"  style=${styleMap_js.styleMap(this.bubbleAlignment())}>
<div class="cc__documentbubble__details">
    <div class="cc__documentbubble__title">
      <cometchat-label .labelStyle=${this.bubbleTitleStyle()} .text=${this.title}></cometchat-label>
    </div>
    ${((_c = this.subtitle) === null || _c === void 0 ? void 0 : _c.trim()) && ((_d = this.subtitle.trim()) === null || _d === void 0 ? void 0 : _d.length) > 0 ? lit.html `
 <div  class="cc__documentbubble__subtitle">
    <cometchat-label .labelStyle=${this.bubbleSubtitleStyle()} .text=${this.subtitle}></cometchat-label>
   </div>` : lit.nothing}
  </div>
  <div class="cc__documentbubble__icon">
  <cometchat-icon .URL=${this.iconURL} .iconStyle=${this.iconStyle}> </cometchat-icon>
  </div>
</div>
${this.hideSeparator ? lit.nothing : lit.html `
<div class="cc__documentbubble__separator" >
<cometchat-divider .dividerStyle=${this.dividerStyle}></cometchat-divider>
</div>
`}
  <div class="cc__documentbubble__button">
<cometchat-button .text=${this.buttonText} .buttonStyle=${this.bubbleButtonStyle()} @cc-button-clicked=${this.buttonClicked}></cometchat-button>
  </div>
</div>
      `;
    }
    bubbleAlignment() {
        return {
            display: "flex",
            flexDirection: this.iconAlignment == uikitResources.DocumentIconAlignment.left ? "row-reverse" : "row",
            justifyContent: "space-between",
            alignItems: this.iconAlignment == uikitResources.DocumentIconAlignment.left ? "center" : "flex-start"
        };
    }
};
exports.CometChatDocumentBubble.styles = [
    lit.css `
.cc__documentbubble {
  background: transparent;
  display: flex;
  gap:4px;
  padding: 8px;
}
.cc__documentbubble__wrapper{
  padding:8px;
  max-width: 100%;
  min-width: 190px;
  box-sizing: border-box;
  
}
.cc__documentbubble__details {
  text-align: left;
}
.cc__documentbubble__icon {
  width: 24px;
}

.cc__documentbubble__separator{
  
}
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatDocumentBubble.prototype, "iconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatDocumentBubble.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatDocumentBubble.prototype, "URL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatDocumentBubble.prototype, "subtitle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatDocumentBubble.prototype, "buttonText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatDocumentBubble.prototype, "documentStyle", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatDocumentBubble.prototype, "hideSeparator", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatDocumentBubble.prototype, "iconAlignment", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatDocumentBubble.prototype, "ccClicked", void 0);
exports.CometChatDocumentBubble = __decorate([
    decorators_js.customElement('cometchat-document-bubble')
], exports.CometChatDocumentBubble);

exports.CometChatCard = class CometChatCard extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.id = "";
        this.avatarURL = "";
        this.avatarName = "";
        this.title = "hello";
        this.cardStyle = {
            height: "400px",
            width: "400px",
            border: "",
            borderRadius: "",
            background: "",
            titleFont: "",
            titleColor: "",
        };
        this.avatarStyle = {
            borderRadius: "50%",
            width: "150px",
            height: "150px",
            border: "1px solid rgb(238 238 238)",
            backgroundColor: "lightgrey",
            nameTextColor: "rgb(20,20,20)",
            backgroundSize: "cover",
            nameTextFont: "700 22px Inter",
        };
        this.cardViewStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                background: (_a = this.cardStyle) === null || _a === void 0 ? void 0 : _a.background,
                width: (_b = this.cardStyle) === null || _b === void 0 ? void 0 : _b.width,
                height: (_c = this.cardStyle) === null || _c === void 0 ? void 0 : _c.height,
                border: (_d = this.cardStyle) === null || _d === void 0 ? void 0 : _d.border,
                borderRadius: (_e = this.cardStyle) === null || _e === void 0 ? void 0 : _e.borderRadius,
            };
        };
    }
    render() {
        return lit.html `
       <div class="cc-card" style=${styleMap_js.styleMap(this.cardViewStyle())}>
       <div class="cc-card__details">
       <cometchat-label class="cc-card__title" .labelStyle=${this.titleStyle()} .text=${this.title}></cometchat-label>
    <div class="cc-card__subtitle-view"><slot name="subtitleView"></slot></div>
       </div>
    <div class="cc-card__image">
        <cometchat-avatar .avatarStyle=${this.avatarStyle} .name=${this.avatarName} .image=${this.avatarURL}>

        </cometchat-avatar>
    </div>
    <div class="cc-card__bottom-view">
    <slot name="bottomView"></slot>
    </div>
  </div>
      `;
    }
    titleStyle() {
        var _a, _b;
        return {
            textFont: (_a = this.cardStyle) === null || _a === void 0 ? void 0 : _a.titleFont,
            textColor: (_b = this.cardStyle) === null || _b === void 0 ? void 0 : _b.titleColor
        };
    }
};
exports.CometChatCard.styles = [
    lit.css `
        *{
          box-sizing: border-box;
        }
  .cc-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 8px;
      justify-content: space-between;
      height: 100%;
    width: 100%;

    }
 .cc-card__details{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
 }


    .cc-card__subtitle-view {
      margin-bottom: 20px;
    }

    .cc-card__image {
      height: fit-content;
    width: fit-content;
      margin-bottom: 20px;
      display: flex;
    align-items: center;
    justify-content: center;
    }

    .cc-card__bottom-view {
      cursor: pointer;
      display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    }
    `
];
__decorate([
    decorators_js.property()
], exports.CometChatCard.prototype, "id", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCard.prototype, "avatarURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCard.prototype, "avatarName", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCard.prototype, "title", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCard.prototype, "cardStyle", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCard.prototype, "avatarStyle", void 0);
exports.CometChatCard = __decorate([
    decorators_js.customElement('cometchat-card')
], exports.CometChatCard);

class CardStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        Object.assign(this, props);
    }
}

class DocumentBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "600 15px Inter, sans-serif";
        this.titleColor = "rgb(20, 20, 20)";
        this.subtitleFont = "400 13px Inter, sans-serif";
        this.subtitleColor = "rgba(20, 20, 20, 0.58)";
        this.iconTint = "RGBA(20, 20, 20, 0.69)";
        this.buttonTextFont = "600 15px Inter";
        this.buttonTextColor = "#11bbf4d4";
        this.buttonBackground = "transparent";
        this.separatorColor = "RGBA(20, 20, 20, 0.1)";
        Object.assign(this, props);
    }
}

exports.CometChatFullScreenViewer = class CometChatFullScreenViewer extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.URL = "";
        this.closeIconURL = "";
        this.fullScreenViewerStyle = {
            closeIconTint: "",
            height: "100%",
            width: "100%"
        };
        this.placeholderImage = placeholderIcon;
        this.timer = null;
        this.image = "";
        this.dispatchClickEvent = (event) => {
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
            this.dispatchEvent(new CustomEvent('cc-close-clicked', {
                bubbles: true,
                composed: true,
            }));
        };
        this.viewerStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.fullScreenViewerStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.fullScreenViewerStyle) === null || _b === void 0 ? void 0 : _b.width,
                background: (_c = this.fullScreenViewerStyle) === null || _c === void 0 ? void 0 : _c.background,
                border: (_d = this.fullScreenViewerStyle) === null || _d === void 0 ? void 0 : _d.border,
                borderRadius: (_e = this.fullScreenViewerStyle) === null || _e === void 0 ? void 0 : _e.borderRadius,
            };
        };
        this.closeIconStyle = () => {
            var _a;
            return {
                height: "24px",
                width: "24px",
                iconTint: (_a = this.fullScreenViewerStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint
            };
        };
    }
    firstUpdated(_changedProperties) {
        if (_changedProperties && (_changedProperties.has("URL") || _changedProperties.has("placeholderImage"))) {
            this.updateImage();
        }
    }
    downloadImage(imgUrl, attemptCount = 0) {
        const maxAttempts = 5;
        const promise = new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", imgUrl, true);
            xhr.responseType = "blob";
            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        clearTimeout(this.timer); // Clear the timer if the download is successful
                        resolve(xhr.response);
                    }
                    else if (xhr.status === 403 && attemptCount < maxAttempts) {
                        this.timer = setTimeout(() => {
                            this.downloadImage(imgUrl, attemptCount + 1)
                                .then((response) => resolve(response))
                                .catch((error) => reject(error));
                        }, 800);
                    }
                    else {
                        reject(xhr.statusText);
                    }
                }
            };
            xhr.onerror = (event) => reject(new Error("There was a network error."));
            xhr.ontimeout = (event) => reject(new Error("There was a timeout error."));
            xhr.send();
        });
        return promise;
    }
    updateImage() {
        this.image = this.placeholderImage;
        this.downloadImage(this.URL)
            .then((response) => {
            let img = new Image();
            img.src = this.URL;
            img.onload = () => {
                this.image = img.src;
                this.requestUpdate("image");
            };
        })
            .catch((error) => {
            if (this.URL) {
                this.image = this.URL;
            }
            else {
                this.image = this.placeholderImage;
            }
            this.requestUpdate("image");
        });
        this.requestUpdate("image");
    }
    render() {
        return lit.html `
 <img src=${this.image}  style=${styleMap_js.styleMap(this.viewerStyle())}/>
    <div class="cc__imageviewer__close-button" @click=${this.dispatchClickEvent}>
    <cometchat-icon .URL=${this.closeIconURL} .iconStyle=${this.closeIconStyle()}></cometchat-icon></div>
  `;
    }
};
exports.CometChatFullScreenViewer.styles = [
    lit.css `
      :host {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        max-width: 100%;
        max-height: 100%;
      }
      .cc__imageviewer__close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }

    `
];
__decorate([
    decorators_js.property()
], exports.CometChatFullScreenViewer.prototype, "URL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatFullScreenViewer.prototype, "closeIconURL", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatFullScreenViewer.prototype, "fullScreenViewerStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatFullScreenViewer.prototype, "placeholderImage", void 0);
exports.CometChatFullScreenViewer = __decorate([
    decorators_js.customElement('cometchat-full-screen-viewer')
], exports.CometChatFullScreenViewer);

class FullScreenViewerStyle extends BaseStyle {
    constructor() {
        super(...arguments);
        this.closeIconTint = "";
    }
}

exports.CometChatIconButton = class CometChatIconButton extends lit.LitElement {
    constructor() {
        super();
        this.disabled = false;
        this.text = "";
        this.iconURL = "";
        this.hoverText = "";
        this.buttonStyle = {
            height: "fit-content",
            width: "fit-content",
            buttonTextFont: "",
            buttonTextColor: "",
            borderRadius: "8px",
            border: "none",
            buttonIconTint: "",
            background: "",
            iconBackground: "",
            iconHeight: "",
            iconWidth: ""
        };
        this.mirrorIcon = false;
        this.iconStyle = {};
        this.dispatchClickEvent = (event) => {
            this.dispatchEvent(new CustomEvent('cc-button-clicked', {
                bubbles: true,
                composed: true,
                detail: { event: event }
            }));
        };
    }
    render() {
        var _a, _b, _c, _d, _e;
        this.iconStyle = Object.assign({}, {
            height: ((_a = this.buttonStyle) === null || _a === void 0 ? void 0 : _a.iconHeight) ? (_b = this.buttonStyle) === null || _b === void 0 ? void 0 : _b.iconHeight : "24px",
            width: ((_c = this.buttonStyle) === null || _c === void 0 ? void 0 : _c.iconWidth) ? (_d = this.buttonStyle) === null || _d === void 0 ? void 0 : _d.iconWidth : "24px",
            iconTint: (_e = this.buttonStyle) === null || _e === void 0 ? void 0 : _e.buttonIconTint
        });
        return lit.html `<button @mouseup=${(event) => event === null || event === void 0 ? void 0 : event.stopPropagation()} @mousedown=${(event) => event === null || event === void 0 ? void 0 : event.stopPropagation()}  class="cc__iconbutton" title=${this.hoverText} @click=${this.dispatchClickEvent} style= ${styleMap_js.styleMap(this.buttonStyles())}  ?disabled=${this.disabled} >
    ${this.iconURL ? lit.html `<div class="cc__iconbutton-icon" style= ${styleMap_js.styleMap(this.iconBackgroundStyles())}><cometchat-icon .URL=${this.iconURL} .name=${this.hoverText} .iconStyle=${this.iconStyle}></cometchat-icon></div>` : lit.nothing} <span class="cc_icon-button_content" ><cometchat-label .text= ${this.text} .labelStyle=${this.titleStyle()}>
    </cometchat-label>
    <slot name="buttonView"> </slot></span>
    </button>`;
    }
    iconBackgroundStyles() {
        var _a, _b, _c, _d, _e, _f;
        let iconPadding = ((_a = this.buttonStyle) === null || _a === void 0 ? void 0 : _a.flexDirection) && ((_b = this.buttonStyle) === null || _b === void 0 ? void 0 : _b.padding) && (((_c = this.buttonStyle) === null || _c === void 0 ? void 0 : _c.flexDirection) == "column" || ((_d = this.buttonStyle) === null || _d === void 0 ? void 0 : _d.flexDirection) == "column-reverse") ? (_e = this.buttonStyle) === null || _e === void 0 ? void 0 : _e.padding : "0px";
        return {
            background: ((_f = this.buttonStyle) === null || _f === void 0 ? void 0 : _f.iconBackground) || "transparent",
            borderRadius: "50%",
            height: "fit-content",
            width: "fit-content",
            padding: iconPadding,
            transform: this.mirrorIcon ? "scaleX(-1)" : "scaleX(1)"
        };
    }
    titleStyle() {
        var _a, _b;
        return {
            textFont: (_a = this.buttonStyle) === null || _a === void 0 ? void 0 : _a.buttonTextFont,
            textColor: (_b = this.buttonStyle) === null || _b === void 0 ? void 0 : _b.buttonTextColor,
            background: "transparent"
        };
    }
    buttonStyles() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let iconPadding = !((_a = this.buttonStyle) === null || _a === void 0 ? void 0 : _a.flexDirection) || (((_b = this.buttonStyle) === null || _b === void 0 ? void 0 : _b.flexDirection) && ((_c = this.buttonStyle) === null || _c === void 0 ? void 0 : _c.padding) && (((_d = this.buttonStyle) === null || _d === void 0 ? void 0 : _d.flexDirection) != "column" || ((_e = this.buttonStyle) === null || _e === void 0 ? void 0 : _e.flexDirection) != "column-reverse")) ? (_f = this.buttonStyle) === null || _f === void 0 ? void 0 : _f.padding : "0px";
        let contentAlignment = this.iconURL && this.iconURL != "" && this.text && this.text != "" ? {} : { justifyContent: "center" };
        return {
            display: "flex",
            flexDirection: this.alignment,
            height: (_g = this.buttonStyle) === null || _g === void 0 ? void 0 : _g.height,
            width: (_h = this.buttonStyle) === null || _h === void 0 ? void 0 : _h.width,
            border: (_j = this.buttonStyle) === null || _j === void 0 ? void 0 : _j.border,
            borderRadius: (_k = this.buttonStyle) === null || _k === void 0 ? void 0 : _k.borderRadius,
            background: (_l = this.buttonStyle) === null || _l === void 0 ? void 0 : _l.background,
            ...this.buttonStyle,
            padding: iconPadding,
            ...contentAlignment
        };
    }
};
exports.CometChatIconButton.styles = [
    lit.css `
    .cc__iconbutton {
      display:flex;
      flex-direction:row;
      justify-content: flex-start;
      align-items: center;
      cursor:pointer;
      border: none;
      background: transparent;
    }
    label {
      cursor: pointer;
    }

    .cc_icon-button_content {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    `
];
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatIconButton.prototype, "disabled", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatIconButton.prototype, "text", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatIconButton.prototype, "iconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatIconButton.prototype, "hoverText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatIconButton.prototype, "buttonStyle", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatIconButton.prototype, "alignment", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatIconButton.prototype, "mirrorIcon", void 0);
exports.CometChatIconButton = __decorate([
    decorators_js.customElement('cometchat-icon-button')
], exports.CometChatIconButton);

exports.CometChatDraggable = class CometChatDraggable extends lit.LitElement {
    constructor() {
        super();
        this.draggableStyle = {
            height: "fit-content",
            width: "fit-content",
            background: "transparent",
            border: "none",
            borderRadius: "0"
        };
        this.state = {
            x: null,
            y: null,
            dragging: false,
            rel: {}
        };
        this.enableDragging = (e) => {
            e.preventDefault();
            this.state.dragging = true;
            this.state.rel = { x: e.pageX - this.state.x,
                y: e.pageY - this.state.y };
            window.document.onmousemove = (e) => this.startDragging(e);
            window.document.onmouseup = (e) => this.disableDragging(e);
        };
        this.startDragging = (e) => {
            this.draggableElement.style.position = "fixed";
            if (!this.state.dragging)
                return;
            e = e || window.event;
            const elem = this.draggableElement;
            const dialogWidth = elem.clientWidth;
            const dialogHeight = elem.clientHeight;
            const x = Math.min(Math.max(0, e.pageX - this.state.rel.x), window.innerWidth - dialogWidth - 20);
            const y = Math.min(Math.max(0, e.pageY - this.state.rel.y), window.innerHeight - dialogHeight - 20);
            this.state.x = x;
            this.state.y = y;
            this.requestUpdate("state");
            e.stopPropagation();
            e.preventDefault();
        };
        this.disableDragging = (e) => {
            window.document.onmousemove = null;
            window.document.onmouseup = null;
            this.state.dragging = false;
        };
        this.draggableWrapperStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                width: (_c = (_b = (_a = this.draggableElement) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : this.draggableStyle.width,
                height: (_f = (_e = (_d = this.draggableElement) === null || _d === void 0 ? void 0 : _d.style) === null || _e === void 0 ? void 0 : _e.height) !== null && _f !== void 0 ? _f : this.draggableStyle.height,
                top: `${this.state.y}px`,
                left: `${this.state.x}px`,
                overflow: "hidden",
                border: this.draggableStyle.border,
                borderRadius: this.draggableStyle.borderRadius,
                background: this.draggableStyle.background
            };
        };
    }
    firstUpdated(_changedProperties) {
        var _a;
        this.draggableElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".cc__draggable");
        const rect = this.getBoundingClientRect();
        this.state.x = rect === null || rect === void 0 ? void 0 : rect.left;
        this.state.y = rect === null || rect === void 0 ? void 0 : rect.top;
        this.requestUpdate("state");
    }
    render() {
        return lit.html `
       <div class="cc__draggable" style=${styleMap_js.styleMap((this.draggableWrapperStyle()))} @mousedown=${this.enableDragging}>
	<slot></slot>
	   </div>
    `;
    }
};
exports.CometChatDraggable.styles = [
    lit.css `
.cc__draggable{
	background:transparent;
	height:fit-content;
	width:fit-content;
	border-radius:0;
	border:none;
	cursor:grabbing;
	padding:4px;
	position:initial;
	z-index:10;
	box-sizing:border-box;
}`
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatDraggable.prototype, "draggableStyle", void 0);
exports.CometChatDraggable = __decorate([
    decorators_js.customElement('cometchat-draggable')
], exports.CometChatDraggable);

exports.CometChatContextMenu = class CometChatContextMenu extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.menuListStyle = {
            width: "",
            height: "",
            border: "1px solid #e8e8e8",
            borderRadius: "8px",
            background: "white",
            submenuWidth: "100%",
            submenuHeight: "100%",
            submenuBorder: "1px solid #e8e8e8",
            submenuBorderRadius: "8px",
            submenuBackground: "white",
            moreIconTint: "grey"
        }; //CSS properties
        this.childView = lit.html `<cometchat-button .text=${'lalalala'}></cometchat-button>`;
        this.data = [];
        this.moreIconURL = moreIcon; //Image URL for more icon
        this.topMenuSize = 2;
        this.buttonStyle = {
            buttonTextFont: "",
            buttonTextColor: "",
            iconTint: "",
            background: "",
            border: "",
            borderRadius: "",
        };
        // subMenuList: any = null;
        this.mainMenuList = [];
        this.subMenuList = [];
        this.isShown = false; // hidden by defaul
        this.showSubMenu = false;
        this.isIconArray = false;
        this.openSubMenu = () => {
            this.showSubMenu = !this.showSubMenu;
            this.requestUpdate("showSubMenu");
        };
    }
    onMenuItemClick(item, event) {
        this.dispatchEvent(new CustomEvent('cc-menu-clicked', {
            bubbles: true,
            composed: true,
            detail: { data: item, event: event }
        }));
        this.isShown = false;
        this.showSubMenu = false;
        this.requestUpdate("isShown");
        this.requestUpdate("showSubMenu");
    }
    getMenuStyle(option, isMainMenu = true) {
        return {
            background: (option === null || option === void 0 ? void 0 : option.backgroundColor) || "transparent",
            border: "none",
            borderRadius: "0",
            buttonIconTint: option === null || option === void 0 ? void 0 : option.iconTint,
            buttonTextFont: option === null || option === void 0 ? void 0 : option.titleFont,
            buttonTextColor: option === null || option === void 0 ? void 0 : option.titleColor,
            gap: !isMainMenu && option.title && option.iconURL ? "10px" : "0"
        };
    }
    moreIconStyle() {
        return {
            background: this.menuListStyle.background
        };
    }
    /**
     * hide show submenu on click of more icon
     * @param  {any} e
     */
    render() {
        var _a, _b, _c;
        if (this.data) {
            if (this.data.every((item) => item instanceof uikitResources.CometChatActionsIcon)) {
                this.isIconArray = true;
            }
            else {
                this.isIconArray = false;
            }
        }
        this.mainMenuList = this.mainMenuItems();
        this.subMenuList = this.subMenuItems();
        this.buttonStyle = {
            background: "transparent",
            border: "none",
            borderRadius: "0",
            buttonIconTint: (_a = this.menuListStyle) === null || _a === void 0 ? void 0 : _a.moreIconTint,
        };
        return lit.html `
    <div>${this.childView}</div>
    <div>${lit.html `${this.childView}`}</div>
    <div class="cc__menulist" style=${styleMap_js.styleMap(this.mainMenuStyles())}>
    <ul class="cc__menuitem__wrapper">
          ${this.mainMenuList.map((button) => lit.html `
              ${this.isIconArray ? lit.html `
              <cometchat-button .buttonStyle=${this.getMenuStyle(button, true)} hoverText=${button.title} iconURL=${button.iconURL}
           @click=${(event) => { this.onMenuItemClick(button, event); }} class="cc__menu__item" ></cometchat-button>
              ` : lit.html `  <cometchat-popover> <div></div> </cometchat-popover>
              `}
          `)}
    </ul>
    <div class="cc__menulist__moreicon">
      ${this.data && ((_b = this.data) === null || _b === void 0 ? void 0 : _b.length) > this.topMenuSize ? lit.html `
            <cometchat-button
            .buttonStyle=${this.buttonStyle} hoverText="more" iconURL=${this.moreIconURL} @click=${this.openSubMenu}
            ></cometchat-button>
      ` : ""}
    </div>
</div>
<div class="cc__menulist__submenu
 ">
${this.showSubMenu ? lit.html `
         <ul class="cc__menuitem__wrapper cc__submenu__wrapper "  style=${styleMap_js.styleMap(this.subMenuStyle())}>
         ${(_c = this.subMenuList) === null || _c === void 0 ? void 0 : _c.map((button) => lit.html `
         <cometchat-button  hoverText=${button.title} .buttonStyle=${this.getMenuStyle(button, false)}   class="cc__menu__item"
            iconURL=${button.iconURL}  text=${button.title} @click=${(event) => { this.onMenuItemClick(button, event); }}>
        </cometchat-button>`)}
    </ul>` : lit.nothing}
</div>
    `;
    }
    // filtering main menu options from list
    mainMenuItems() {
        var menuData = this.data;
        const defaultNumber = this.topMenuSize - 1;
        return menuData === null || menuData === void 0 ? void 0 : menuData.filter((item, i) => {
            return i <= defaultNumber;
        });
    }
    // filtering submenu options from list
    subMenuItems() {
        var menuData = this.data;
        const defaultNumber = this.topMenuSize - 1;
        return menuData === null || menuData === void 0 ? void 0 : menuData.filter((item, i) => {
            return i > defaultNumber;
        });
    }
    // mainmenu style
    mainMenuStyles() {
        var _a, _b, _c;
        return {
            background: (_a = this.menuListStyle) === null || _a === void 0 ? void 0 : _a.background,
            borderRadius: (_b = this.menuListStyle) === null || _b === void 0 ? void 0 : _b.borderRadius,
            border: (_c = this.menuListStyle) === null || _c === void 0 ? void 0 : _c.border
        };
    }
    subMenuStyle() {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            background: (_a = this.menuListStyle) === null || _a === void 0 ? void 0 : _a.submenuBackground,
            borderRadius: (_b = this.menuListStyle) === null || _b === void 0 ? void 0 : _b.submenuBorderRadius,
            border: (_c = this.menuListStyle) === null || _c === void 0 ? void 0 : _c.submenuBorder,
            height: (_d = this.menuListStyle) === null || _d === void 0 ? void 0 : _d.submenuHeight,
            width: (_e = this.menuListStyle) === null || _e === void 0 ? void 0 : _e.submenuWidth,
            minWidth: ((_f = this.mainMenuList) === null || _f === void 0 ? void 0 : _f.length) > 0 ? ((_g = this.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector(".cc__menulist").offsetWidth) + "px" : "110px"
        };
    }
};
exports.CometChatContextMenu.styles = [
    lit.css `
    .cc__menuitem__wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin: 0;
    padding-left: 0px;
    border-radius: inherit;
}
.cc__menulist {
    display: flex;
    align-items: center;
}
.cc__submenu__wrapper {
  display: flex;
    flex-direction: column;
    position: relative;
    height: max-content;
    width: max-content;
    min-height: 50px;
    z-index: 10;
    border-radius: 8px;
    overflow: visible;
    align-self: flex-end;
    margin-top: 2px;
    padding:4px;
    align-items: flex-start;
    justify-content: flex-start;
}
.cc__menu__item{
    border-radius: inherit;
}
.cc__menulist__submenu
{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
    right: 0;
}
.cc__menulist__moreicon{
    border-radius: inherit;
    background:"transparent"
}
    `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatContextMenu.prototype, "menuListStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatContextMenu.prototype, "childView", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatContextMenu.prototype, "data", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatContextMenu.prototype, "moreIconURL", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatContextMenu.prototype, "topMenuSize", void 0);
exports.CometChatContextMenu = __decorate([
    decorators_js.customElement('cometchat-context-menu')
], exports.CometChatContextMenu);

/**
 * ContextMenuStyle class defines the style for a menu list component.
 *
 * @property {string} textFont - The font for the menu list text.
 * @property {string} textColor - The color for the menu list text.
 * @property {string} iconTint - The tint color for the menu list icons.
 * @property {string} iconBackground - The background color for the menu list icons.
 * @property {string} iconBorder - The border color for the menu list icons.
 * @property {string} iconBorderRadius - The border radius for the menu list icons.
 * @property {string} submenuWidth - The width of the submenu.
 * @property {string} submenuHeight - The height of the submenu.
 * @property {string} submenuBorder - The border color for the submenu.
 * @property {string} submenuBorderRadius - The border radius for the submenu.
 * @property {string} submenuBackground - The background color for the submenu.
 * @extends {BaseStyle}
 */
class ContextMenuStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.moreIconTint = "RGB(20, 20, 20)";
        this.submenuWidth = "100%";
        this.submenuHeight = "100%";
        this.submenuBorder = "1px solid #e8e8e8";
        this.submenuBorderRadius = "8px";
        this.submenuBackground = "white";
        Object.assign(this, props);
    }
}

var WORKER_ENABLED;

if (!window.global) {
  window.global = window;
  WORKER_ENABLED = !!(
    global === global.window &&
    global.URL &&
    global.Blob &&
    global.Worker
  );
}else {
  WORKER_ENABLED = !!(
    global === global.window &&
    global.URL &&
    global.Blob &&
    global.Worker
  );
}

function InlineWorker(func, self) {
  var _this = this;
  var functionBody;

  self = self || {};

  if (WORKER_ENABLED) {
    functionBody = func
      .toString()
      .trim()
      .match(/^function\s*\w*\s*\([\w\s,]*\)\s*{([\w\W]*?)}$/)[1];

    return new global.Worker(
      global.URL.createObjectURL(
        new global.Blob([functionBody], { type: "text/javascript" })
      )
    );
  }

  function postMessage(data) {
    setTimeout(function () {
      _this.onmessage({ data: data });
    }, 0);
  }

  this.self = self;
  this.self.postMessage = postMessage;

  setTimeout(func.bind(self, self), 0);
}

InlineWorker.prototype.postMessage = function postMessage(data) {
  var _this = this;

  setTimeout(function () {
    _this.self.onmessage({ data: data });
  }, 0);
};

const defaultConfig$1 = {
  bufferLen: 4096,
  numChannels: 2,
  mimeType: 'audio/wav',
};

class Microphone {
  constructor(source, config) {
    this.config = Object.assign({}, defaultConfig$1, config);

    this.recording = false;

    this.callbacks = {
      getBuffer: [],
      exportWAV: []
    };

    this.context = source.context;
    this.node = (this.context.createScriptProcessor ||
    this.context.createJavaScriptNode).call(this.context,
      this.config.bufferLen, this.config.numChannels, this.config.numChannels);

    this.node.onaudioprocess = (e) => {
      if (!this.recording) return;

      var buffer = [];
      for (var channel = 0; channel < this.config.numChannels; channel++) {
        buffer.push(e.inputBuffer.getChannelData(channel));
      }
      this.worker.postMessage({
        command: 'record',
        buffer: buffer
      });
    };

    source.connect(this.node);
    this.node.connect(this.context.destination);    //this should not be necessary

    let self = {};
    this.worker = new InlineWorker(function () {
      let recLength = 0,
        recBuffers = [],
        sampleRate,
        numChannels;

      this.onmessage = function (e) {
        switch (e.data.command) {
          case 'init':
            init(e.data.config);
            break;
          case 'record':
            record(e.data.buffer);
            break;
          case 'exportWAV':
            exportWAV(e.data.type);
            break;
          case 'getBuffer':
            getBuffer();
            break;
          case 'clear':
            clear();
            break;
        }
      };

      function init(config) {
        sampleRate = config.sampleRate;
        numChannels = config.numChannels;
        initBuffers();
      }

      function record(inputBuffer) {
        for (var channel = 0; channel < numChannels; channel++) {
          recBuffers[channel].push(inputBuffer[channel]);
        }
        recLength += inputBuffer[0].length;
      }

      function exportWAV(type) {
        let buffers = [];
        for (let channel = 0; channel < numChannels; channel++) {
          buffers.push(mergeBuffers(recBuffers[channel], recLength));
        }
        let interleaved;
        if (numChannels === 2) {
          interleaved = interleave(buffers[0], buffers[1]);
        } else {
          interleaved = buffers[0];
        }
        let dataview = encodeWAV(interleaved);
        let audioBlob = new Blob([dataview], {type: type});

        this.postMessage({command: 'exportWAV', data: audioBlob});
      }

      function getBuffer() {
        let buffers = [];
        for (let channel = 0; channel < numChannels; channel++) {
          buffers.push(mergeBuffers(recBuffers[channel], recLength));
        }
        this.postMessage({command: 'getBuffer', data: buffers});
      }

      function clear() {
        recLength = 0;
        recBuffers = [];
        initBuffers();
      }

      function initBuffers() {
        for (let channel = 0; channel < numChannels; channel++) {
          recBuffers[channel] = [];
        }
      }

      function mergeBuffers(recBuffers, recLength) {
        let result = new Float32Array(recLength);
        let offset = 0;
        for (let i = 0; i < recBuffers.length; i++) {
          result.set(recBuffers[i], offset);
          offset += recBuffers[i].length;
        }
        return result;
      }

      function interleave(inputL, inputR) {
        let length = inputL.length + inputR.length;
        let result = new Float32Array(length);

        let index = 0,
          inputIndex = 0;

        while (index < length) {
          result[index++] = inputL[inputIndex];
          result[index++] = inputR[inputIndex];
          inputIndex++;
        }
        return result;
      }

      function floatTo16BitPCM(output, offset, input) {
        for (let i = 0; i < input.length; i++, offset += 2) {
          let s = Math.max(-1, Math.min(1, input[i]));
          output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
      }

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i += 1) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }

      function encodeWAV(samples) {
        const buffer = new ArrayBuffer(44 + (samples.length * 2));
        const view = new DataView(buffer);

        /* RIFF identifier */
        writeString(view, 0, 'RIFF');
        /* RIFF chunk length */
        view.setUint32(4, 36 + (samples.length * 2), true);
        /* RIFF type */
        writeString(view, 8, 'WAVE');
        /* format chunk identifier */
        writeString(view, 12, 'fmt ');
        /* format chunk length */
        view.setUint32(16, 16, true);
        /* sample format (raw) */
        view.setUint16(20, 1, true);
        /* channel count */
        view.setUint16(22, numChannels, true);
        /* sample rate */
        view.setUint32(24, sampleRate, true);
        /* byte rate (sample rate * block align) */
        view.setUint32(28, sampleRate * 4, true);
        /* block align (channel count * bytes per sample) */
        view.setUint16(32, numChannels * 2, true);
        /* bits per sample */
        view.setUint16(34, 16, true);
        /* data chunk identifier */
        writeString(view, 36, 'data');
        /* data chunk length */
        view.setUint32(40, samples.length * 2, true);

        floatTo16BitPCM(view, 44, samples);

        return view;
      }
    }, self);

    this.worker.postMessage({
      command: 'init',
      config: {
        sampleRate: this.context.sampleRate,
        numChannels: this.config.numChannels,
      },
    });

    this.worker.onmessage = (e) => {
      const cb = this.callbacks[e.data.command].pop();
      if (typeof cb === 'function') {
        cb(e.data.data);
      }
    };
  }


  record() {
    this.recording = true;
  }

  stop() {
    this.recording = false;
  }

  clear() {
    this.worker.postMessage({command: 'clear'});
  }

  getBuffer(cb) {
    cb = cb || this.config.callback;

    if (!cb) throw new Error('Callback not set');

    this.callbacks.getBuffer.push(cb);

    this.worker.postMessage({command: 'getBuffer'});
  }

  exportWAV(cb, mimeType) {
    mimeType = mimeType || this.config.mimeType;
    cb = cb || this.config.callback;

    if (!cb) throw new Error('Callback not set');

    this.callbacks.exportWAV.push(cb);

    this.worker.postMessage({
      command: 'exportWAV',
      type: mimeType,
    });
  }
}

Microphone.forceDownload = function forceDownload(blob, filename) {
    const a = document.createElement('a');

    a.style = 'display: none';
    document.body.appendChild(a);

    var url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);

    document.body.removeChild(a);
};

const defaultConfig = {
  nFrequencyBars: 255,
  onAnalysed: null,
};

const microphoneConfigOptions = ['bufferLen', 'numChannels', 'mimeType'];

class Recorder {
  constructor(audioContext, config = {}) {
    this.config = Object.assign({}, defaultConfig, config);

    this.audioContext = audioContext;
    this.audioInput = null;
    this.realAudioInput = null;
    this.inputPoint = null;
    this.audioRecorder = null;
    this.rafID = null;
    this.analyserContext = null;
    this.recIndex = 0;
    this.stream = null;

    this.microphoneConfig = microphoneConfigOptions.reduce((a, c) => {
      if (config[c]) {
        a[c] = config[c];
      }
      return a;
    }, {});

    this.updateAnalysers = this.updateAnalysers.bind(this);
  }

  init(stream) {
    return new Promise((resolve) => {
      this.inputPoint = this.audioContext.createGain();

      this.stream = stream;

      this.realAudioInput = this.audioContext.createMediaStreamSource(stream);
      this.audioInput = this.realAudioInput;
      this.audioInput.connect(this.inputPoint);

      this.analyserNode = this.audioContext.createAnalyser();
      this.analyserNode.fftSize = 2048;
      this.inputPoint.connect(this.analyserNode);

      this.audioRecorder = new Microphone(this.inputPoint, this.microphoneConfig);

      const zeroGain = this.audioContext.createGain();
      zeroGain.gain.value = 0.0;

      this.inputPoint.connect(zeroGain);
      zeroGain.connect(this.audioContext.destination);

      this.updateAnalysers();

      resolve();
    });
  }

  start() {
    return new Promise((resolve, reject) => {
      if (!this.audioRecorder) {
        reject('Not currently recording');
        return;
      }

      this.audioRecorder.clear();
      this.audioRecorder.record();

      resolve(this.stream);
    });
  }

  stop() {
    return new Promise((resolve) => {
      this.audioRecorder.stop();

      this.audioRecorder.getBuffer((buffer) => {
        this.audioRecorder.exportWAV(blob => resolve({buffer, blob}));
      });
    });
  }

  updateAnalysers() {
    if (this.config.onAnalysed) {
      requestAnimationFrame(this.updateAnalysers);

      const freqByteData = new Uint8Array(this.analyserNode.frequencyBinCount);

      this.analyserNode.getByteFrequencyData(freqByteData);

      const data = new Array(255);
      let lastNonZero = 0;
      let datum;

      for (let idx = 0; idx < 255; idx += 1) {
        datum = Math.floor(freqByteData[idx]) - (Math.floor(freqByteData[idx]) % 5);

        if (datum !== 0) {
          lastNonZero = idx;
        }

        data[idx] = datum;
      }

      this.config.onAnalysed({data, lineTo: lastNonZero});
    }
  }

  setOnAnalysed(handler) {
    this.config.onAnalysed = handler;
  }
}

Recorder.download = function download(blob, filename = 'audio') {
  Microphone.forceDownload(blob, `${filename}.wav`);
};

var RecordingType;
(function (RecordingType) {
    RecordingType[RecordingType["audio"] = 0] = "audio";
    RecordingType[RecordingType["video"] = 1] = "video";
})(RecordingType || (RecordingType = {}));
exports.CometChatMediaRecorder = class CometChatMediaRecorder extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.closeIconURL = CloseIcon;
        this.startIconText = "Start";
        this.stopIconText = "Stop";
        this.submitButtonIconText = "Submit";
        this.autoRecording = false;
        this.recordingType = RecordingType.audio;
        this.mediaPlayerStyle = {
            closeIconTint: "grey",
            submitIconTint: "grey",
            startIconTint: "grey",
            stopIconTint: "grey",
        };
        this.recordedChunks = [];
        this.isRecording = false;
        this.manualStop = false;
        this.counter = 0;
        this.mediaRecorderButton = {
            cursor: "pointer",
            background: "none",
            border: "none",
            height: "fit-object",
            width: "fit-object",
        };
        // handlePauseRecording() {
        //     if (this.mediaRecorder?.state === 'recording') {
        //         this.mediaRecorder.pause();
        //         this.isPaused = true;
        //         this.stopTimer();
        //     }
        // }
        // handleResumeRecording() {
        //     if (this.mediaRecorder?.state === 'paused') {
        //         this.mediaRecorder.resume();
        //         this.isPaused = false;
        //         this.startTimer();
        //     }
        // }
    }
    render() {
        return lit.html `
      <div
        class="cc__media_recorder_body"
        style=${styleMap_js.styleMap(this.getBodyStyle())}
      >
        <div class="cc__media_recorder__body-preview">
          ${this.mediaPreviewUrl
            ? lit.html `
                <cometchat-button
                  .buttonStyle=${this.getMediaRecorderButtonStyle(this.mediaPlayerStyle.closeIconTint)}
                  .iconURL=${this.closeIconURL}
                  @cc-button-clicked=${this.handleCloseRecording}
                ></cometchat-button>
                ${this.recordingType === RecordingType.video
                ? lit.html `<video
                      controls
                      controlsList="nodownload"
                      src=${this.mediaPreviewUrl}
                    ></video>`
                : lit.html `<audio
                      controls
                      controlsList="nodownload"
                      src=${this.mediaPreviewUrl}
                    ></audio>`}
                <cometchat-button
                  .buttonStyle=${this.getMediaRecorderButtonStyle(this.mediaPlayerStyle.submitIconTint)}
                  .text=${this.submitButtonIconText}
                  .iconURL=${this.submitButtonIconURL}
                  @cc-button-clicked=${this.handleSubmit}
                ></cometchat-button>
              `
            : lit.html `
                <div class="cc-media_recorder-recording_timer">
                  ${this.isRecording
                ? lit.html `<div class="cc-media_recorder-record_button"></div>`
                : lit.html ``}
                  <div style=${styleMap_js.styleMap(this.getTextStyle())}>
                    ${this.formatTime(this.counter)}
                  </div>
                </div>
              `}
        </div>
        <div class="cc__media_recorder__body-control">
          ${this.isRecording
            ? lit.html `
                <cometchat-button
                  .buttonStyle=${this.getMediaRecorderButtonStyle(this.mediaPlayerStyle.closeIconTint)}
                  .iconURL=${this.closeIconURL}
                  @cc-button-clicked=${this.handleCloseRecording}
                ></cometchat-button>
                <cometchat-button
                  .buttonStyle=${this.getMediaRecorderButtonStyle(this.mediaPlayerStyle.stopIconTint)}
                  .text=${this.stopIconText}
                  .iconURL=${this.stopIconURL}
                  @cc-button-clicked=${this.handleStopRecording}
                ></cometchat-button>
              `
            : lit.html `
                <cometchat-button
                  .buttonStyle=${this.getMediaRecorderButtonStyle(this.mediaPlayerStyle.startIconTint)}
                  .text=${this.startIconText}
                  .iconURL=${this.startIconURL}
                  @cc-button-clicked=${this.handleStartRecording}
                ></cometchat-button>
              `}
        </div>
      </div>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.autoRecording) {
            this.handleStartRecording();
        }
    }
    formatTime(timeInSeconds) {
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`;
    }
    async initMediaRecorder() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: this.recordingType === RecordingType.video ? true : false,
            });
            if (this.recordingType === RecordingType.video) {
                this.mediaRecorder = new MediaRecorder(this.stream);
                this.mediaRecorder.ondataavailable = (e) => {
                    if (e.data.size > 0) {
                        this.recordedChunks.push(e.data);
                    }
                };
                this.mediaRecorder.onstop = () => {
                    this.stopTimer();
                    this.isRecording = false;
                    if (!this.manualStop) {
                        const blob = new Blob(this.recordedChunks, {
                            type: this.recordedChunks[0].type,
                        });
                        this.blob = blob;
                        this.mediaPreviewUrl = URL.createObjectURL(blob);
                    }
                    else {
                        this.recordedChunks = [];
                    }
                };
            }
            else {
                const audioContext = new AudioContext();
                this.mediaRecorder = new Recorder(audioContext);
                this.mediaRecorder.init(this.stream);
            }
        }
        catch (error) {
            throw error;
        }
    }
    handleStartRecording() {
        this.reset();
        this.initMediaRecorder().then(() => {
            var _a, _b;
            if (this.recordingType === RecordingType.video) {
                (_a = this.mediaRecorder) === null || _a === void 0 ? void 0 : _a.start(1000);
            }
            else {
                (_b = this.mediaRecorder) === null || _b === void 0 ? void 0 : _b.start();
            }
            this.counter = 0;
            this.startTimer();
            this.isRecording = true;
        })
            .catch((error) => {
            console.log((error === null || error === void 0 ? void 0 : error.message) || error);
        });
    }
    handleStopRecording() {
        var _a, _b;
        if (this.recordingType === RecordingType.video) {
            (_a = this.mediaRecorder) === null || _a === void 0 ? void 0 : _a.stop();
            this.stopTimer();
            this.clearStream();
        }
        else {
            ((_b = this.mediaRecorder) === null || _b === void 0 ? void 0 : _b.stop()).then((blob) => {
                this.blob = blob.blob;
                this.isRecording = false;
                this.mediaPreviewUrl = URL.createObjectURL(this.blob);
                this.stopTimer();
                this.clearStream();
            });
        }
    }
    handleSubmit(event) {
        if (event && event.detail && event.detail.stopPropagation) {
            event.detail.stopPropagation();
        }
        if (this.blob) {
            this.dispatchEvent(new CustomEvent("cc-media-recorder-submitted", {
                bubbles: true,
                composed: true,
                detail: { file: this.blob },
            }));
            this.requestUpdate();
        }
    }
    handleCloseRecording(event) {
        if (event && event.detail && event.detail.stopPropagation) {
            event.detail.stopPropagation();
        }
        this.dispatchEvent(new CustomEvent("cc-media-recorder-closed", {
            bubbles: true,
            composed: true,
            detail: {},
        }));
        this.requestUpdate();
    }
    startTimer() {
        this.timerInterval = window.setInterval(() => {
            this.counter++;
            this.requestUpdate();
        }, 1000);
    }
    stopTimer() {
        clearInterval(this.timerInterval);
        this.counter = 0;
        this.timerInterval = undefined;
        this.requestUpdate();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.mediaRecorder) {
            this.mediaRecorder.stop();
            this.clearStream();
            this.stopTimer();
            this.reset();
        }
    }
    reset() {
        this.mediaRecorder = undefined;
        this.manualStop = false;
        // this.isPaused = false;
        this.mediaPreviewUrl = undefined;
        this.isRecording = false;
        this.recordedChunks = [];
    }
    clearStream() {
        if (this.stream) {
            this.stream.getTracks().forEach((track) => track.stop());
        }
    }
    getMediaRecorderButtonStyle(tint) {
        if (tint) {
            return {
                ...this.mediaRecorderButton,
                buttonIconTint: tint,
            };
        }
        return this.mediaRecorderButton;
    }
    getBodyStyle() {
        return {
            height: this.mediaPlayerStyle.height || "100%",
            width: this.mediaPlayerStyle.width || "100%",
            border: this.mediaPlayerStyle.border || "1px solid black",
            borderRadius: this.mediaPlayerStyle.borderRadius || "5px",
            background: this.mediaPlayerStyle.background || "white",
        };
    }
    getTextStyle() {
        return {
            font: this.mediaPlayerStyle.timerTextFont || "400 13px Inter, sans-serif",
            color: this.mediaPlayerStyle.timerTextColor || "RGBA(20, 20, 20, 0.6)",
        };
    }
};
// private startTime = 0;
// private isPaused = false;
exports.CometChatMediaRecorder.styles = lit.css `
    .cc__media_recorder_body {
      display: flex;
      flex-direction: column;
      padding: 5px;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
    }

    .cc__media_recorder__body-preview {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding: 5px 0px;
      box-sizing: border-box;
    }

    .cc__media_recorder__body-control {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      display: flex;
      padding: 10px;
      box-sizing: border-box;
    }

    .cc-media_recorder-button {
      cursor: pointer;
      background: none;
      border: none;
    }

    .cc-media_recorder-recording_timer {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .cc-media_recorder-record_button {
      width: 3px;
      height: 3px;
      border: 3px solid #ff3b30;
      border-radius: 50%;
      background-color: #ff3b30;
      box-shadow: 0 0 10px rgba(255, 0, 0, 0.6);
      animation: blinkAnimation 1s infinite;
    }

    @keyframes blinkAnimation {
      0%,
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0.6;
      }
    }
  `;
__decorate([
    decorators_js.property()
], exports.CometChatMediaRecorder.prototype, "startIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMediaRecorder.prototype, "closeIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMediaRecorder.prototype, "stopIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMediaRecorder.prototype, "submitButtonIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMediaRecorder.prototype, "startIconText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMediaRecorder.prototype, "stopIconText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatMediaRecorder.prototype, "submitButtonIconText", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatMediaRecorder.prototype, "autoRecording", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatMediaRecorder.prototype, "recordingType", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatMediaRecorder.prototype, "mediaPlayerStyle", void 0);
exports.CometChatMediaRecorder = __decorate([
    decorators_js.customElement("cometchat-media-recorder")
], exports.CometChatMediaRecorder);

class MediaRecorderStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.closeIconTint = "";
        this.timerTextFont = "";
        this.timerTextColor = "";
        this.submitIconTint = "";
        this.startIconTint = "";
        this.stopIconTint = "";
        Object.assign(this, props);
    }
}

/**
 * CallscreenStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} maxHeight - maximum height of the component.
 * @property {string} maxWidth - maximum width of the component.
 * @property {string} minHeight - minimum height of the component.
 * @property {string} minWidth - minimum height of the component.
* @property {string} headerBackground - background color of header.
 * @property {string} minimizeIconTint - minimize icon color.
 * @property {string} maximizeIconTint - maximize icon color.
 * @property {string} border - border color of component.
 * @property {string} borderRadius - borderRadius of component
 * @property {string} background - background color of component.
 */
class CallscreenStyle {
    constructor(props) {
        this.maxHeight = "100%";
        this.maxWidth = "100%";
        this.minHeight = "400px";
        this.minWidth = "400px";
        this.minimizeIconTint = "";
        this.maximizeIconTint = "";
        this.border = "";
        this.borderRadius = "";
        this.background = "";
        Object.assign(this, props);
    }
}

var ReduceSizeIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M21%203L13.8%2010.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2%2019.2V13.8H4.80005%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.8%204.8V10.2H19.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2%2013.8L3%2021%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var IncreaseSizeIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10.2%2013.8L3%2021%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M21%208.4V3H15.6%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3%2015.6V21H8.4%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M21%203L13.8%2010.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

exports.CometChatCallscreenWrapper = class CometChatCallscreenWrapper extends lit.LitElement {
    constructor() {
        super();
        this.callscreenStyle = {
            maxHeight: "100%",
            maxWidth: "100%",
            border: "none",
            borderRadius: "0",
            background: "grey",
            minHeight: "400px",
            minWidth: "400px",
            minimizeIconTint: "white",
            maximizeIconTint: "white",
        };
        this.resizeIconHoverText = uikitResources.localize("RESIZE");
        this.minimizeIconURL = ReduceSizeIcon;
        this.maximizeIconURL = IncreaseSizeIcon;
        this.minHeight = 400;
        this.minWidth = 400;
        this.state = {
            x: 0,
            y: 0,
            dragging: false,
            maximized: true,
            rel: {}
        };
        this.showResizerIcon = false;
        this.enableDragging = (e) => {
            e.preventDefault();
            if (this.checkIfCallScreenIsMaximized() === true) {
                return false;
            }
            this.state.dragging = true;
            this.state.rel = { x: e.pageX - this.state.x,
                y: e.pageY - this.state.y };
            this.toggleCallScreenBackground(true);
            this.toggleCallScreenInnerBackground(true);
            if (window === null || window === void 0 ? void 0 : window.document) {
                window.document.onmousemove = (e) => this.startDragging(e);
                window.document.onmouseup = (e) => this.disableDragging(e);
            }
        };
        this.checkIfCallScreenIsMaximized = () => {
            const elem = this.callScreenEl;
            const dialogWidth = elem.clientWidth;
            const dialogHeight = elem.clientHeight;
            const windowWidth = window === null || window === void 0 ? void 0 : window.innerWidth;
            const windowHeight = window === null || window === void 0 ? void 0 : window.innerHeight;
            if (dialogWidth === windowWidth && dialogHeight === windowHeight) {
                return true;
            }
            return false;
        };
        this.checkIfCallScreenIsMinimized = () => {
            const elem = this.callScreenEl;
            const dialogWidth = elem.clientWidth;
            const dialogHeight = elem.clientHeight;
            const minimumWidth = this.minWidth;
            const minimumHeight = this.minHeight;
            if (dialogWidth === minimumWidth && dialogHeight === minimumHeight) {
                return true;
            }
            return false;
        };
        this.startDragging = (e) => {
            if (!this.state.dragging)
                return;
            e = e || (window === null || window === void 0 ? void 0 : window.event);
            const elem = this.callScreenEl;
            const dialogWidth = elem.clientWidth;
            const dialogHeight = elem.clientHeight;
            const x = Math.min(Math.max(0, e.pageX - this.state.rel.x), (window === null || window === void 0 ? void 0 : window.innerWidth) - dialogWidth - 20);
            const y = Math.min(Math.max(0, e.pageY - this.state.rel.y), (window === null || window === void 0 ? void 0 : window.innerHeight) - dialogHeight - 20);
            this.state.x = x;
            this.state.y = y;
            this.requestUpdate("state");
            e.stopPropagation();
            e.preventDefault();
        };
        this.disableDragging = (e) => {
            if (window === null || window === void 0 ? void 0 : window.document) {
                window.document.onmousemove = null;
                window.document.onmouseup = null;
            }
            this.state.dragging = false;
            this.toggleCallScreenBackground(false);
            this.toggleCallScreenInnerBackground(false);
        };
        this.initResize = (e) => {
            e.preventDefault();
            if (this.checkIfCallScreenIsMaximized() === true) {
                return false;
            }
            const element = this.callScreenEl;
            this.startX = e.pageX;
            this.startY = e.pageY;
            this.startWidth = parseFloat(getComputedStyle(element, null)
                .getPropertyValue("width")
                .replace("px", ""));
            this.startHeight = parseInt(getComputedStyle(element, null)
                .getPropertyValue("height")
                .replace("px", ""));
            if (window === null || window === void 0 ? void 0 : window.document) {
                window.document.onmousemove = (e) => this.startResize(e);
                window.document.onmouseup = (e) => this.stopResize();
            }
        };
        this.startResize = (e) => {
            var _a, _b;
            let width = this.startWidth + (e.pageX - this.startX);
            let height = this.startHeight + (e.pageY - this.startY);
            if (width < this.minWidth) {
                width = this.minWidth;
            }
            if (width > (window === null || window === void 0 ? void 0 : window.innerWidth)) {
                width = Number((_a = this.callscreenStyle.maxWidth) === null || _a === void 0 ? void 0 : _a.replace("px", ""));
            }
            if (height < this.minHeight) {
                height = this.minHeight;
            }
            if (height > (window === null || window === void 0 ? void 0 : window.innerHeight)) {
                height = Number((_b = this.callscreenStyle.maxHeight) === null || _b === void 0 ? void 0 : _b.replace("px", ""));
            }
            this.callScreenEl.style.width = width + "px";
            this.callScreenEl.style.height = height + "px";
            this.setDimensionOfCallScreenInnerBackground({
                width: width + "px",
                height: height + "px",
            });
            this.toggleCallScreenBackground(true);
            this.toggleCallScreenInnerBackground(true);
        };
        this.stopResize = () => {
            if (window === null || window === void 0 ? void 0 : window.document) {
                window.document.onmousemove = null;
                window.document.onmouseup = null;
            }
            this.toggleCallScreenBackground(false);
            this.toggleCallScreenInnerBackground(false);
            if (this.checkIfCallScreenIsMaximized() === true) {
                this.state.maximized = true;
            }
            if (this.checkIfCallScreenIsMinimized() === true) {
                this.state.maximized = false;
            }
        };
        this.toggleCallScreenBackground = (flag) => {
            if (this.callScreenBackgroundEl) {
                this.callScreenBackgroundEl.style.display = flag ? "block" : "none";
            }
        };
        this.toggleCallScreenInnerBackground = (flag) => {
            if (this.callScreenInnerBackgroundEl) {
                this.callScreenInnerBackgroundEl.style.display = flag ? "block" : "none";
            }
        };
        this.setDimensionOfCallScreenInnerBackground = (props) => {
            this.callScreenInnerBackgroundEl.style.width = props.width;
            this.callScreenInnerBackgroundEl.style.height = props.height;
        };
        this.setPositionOfCallScreenInnerBackground = (props) => {
            this.callScreenInnerBackgroundEl.style.top = props.y;
            this.callScreenInnerBackgroundEl.style.left = props.x;
        };
        this.minimize = () => {
            if (!this.callScreenEl || !this.callScreenEl) {
                return false;
            }
            const width = this.minWidth + "px";
            const height = this.minHeight + "px";
            this.state.maximized = false;
            this.showResizerIcon = true;
            this.setSizingAndPostionOfCallScreen({ width: width, height: height });
            this.setDimensionOfCallScreenInnerBackground({
                width: width,
                height: height,
            });
            this.setPositionOfCallScreenInnerBackground({ x: "0px", y: "0px" });
            this.requestUpdate("showResizerIcon");
        };
        this.maximize = () => {
            if (!this.callScreenEl || !this.callScreenEl) {
                return false;
            }
            const width = this.callscreenStyle.maxWidth;
            const height = this.callscreenStyle.maxHeight;
            this.showResizerIcon = false;
            this.state.maximized = true;
            this.requestUpdate("showResizerIcon");
            this.setSizingAndPostionOfCallScreen({ width: width, height: height });
            this.setDimensionOfCallScreenInnerBackground({
                width: width,
                height: height,
            });
            this.setPositionOfCallScreenInnerBackground({ x: "0px", y: "0px" });
        };
        this.setSizingAndPostionOfCallScreen = (props) => {
            this.callScreenEl.style.width = props.width;
            this.callScreenEl.style.height = props.height;
            this.callScreenEl.style.top = "0px";
            this.callScreenEl.style.left = "0px";
        };
        this.toggle = (e) => {
            this.state.x = 0;
            this.state.y = 0;
            if (this.state.maximized) {
                this.minimize();
            }
            else {
                this.maximize();
            }
            e.stopPropagation();
            e.preventDefault();
        };
        this.callScreenWrapperStyle = () => {
            var _a;
            return {
                backgroundColor: ((_a = this.callscreenStyle) === null || _a === void 0 ? void 0 : _a.background) || "grey",
            };
        };
        this.callScreenBackgroundStyle = () => {
            return {
                display: "none",
                width: "100vw",
                height: "100vh",
                position: "fixed",
                top: "0",
                left: "0",
                bottom: "0",
                right: "0",
                zIndex: "2147483001",
            };
        };
        this.callScreenContainerStyle = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return {
                width: (_c = (_b = (_a = this.callScreenEl) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : this.callscreenStyle.maxWidth,
                height: (_f = (_e = (_d = this.callScreenEl) === null || _d === void 0 ? void 0 : _d.style) === null || _e === void 0 ? void 0 : _e.height) !== null && _f !== void 0 ? _f : this.callscreenStyle.maxHeight,
                position: "fixed",
                overflow: "hidden",
                zIndex: "1000",
                top: `${this.state.y}px`,
                left: `${this.state.x}px`,
                border: (_g = this.callscreenStyle) === null || _g === void 0 ? void 0 : _g.border,
                borderRadius: (_h = this.callscreenStyle) === null || _h === void 0 ? void 0 : _h.borderRadius,
            };
        };
        this.callScreenHeaderStyle = () => {
            var _a;
            return {
                backgroundColor: (_a = this.callscreenStyle) === null || _a === void 0 ? void 0 : _a.background,
                cursor: this.state.maximized ? "" : "grabbing"
            };
        };
        this.headerStyle = () => {
            return {
                width: "calc(100% - 55px)",
                padding: "16px",
            };
        };
        this.callScreenResizerStyle = () => {
            const backgroundStyle = this.state.maximized
                ? {
                    display: "none",
                }
                : {
                    cursor: "nwse-resize",
                    clipPath: "polygon(100% 0,100% 100%,0 100%)",
                    background: "repeating-linear-gradient(135deg,hsla(0,0%,100%,.5),hsla(0,0%,100%,.5) 2px,#000 0,#000 4px)",
                };
            return {
                width: "35px",
                height: "35px",
                position: "absolute",
                right: "0",
                bottom: "0",
                zIndex: "2147483004",
                ...backgroundStyle,
            };
        };
        this.iconStyle = () => {
            var _a, _b, _c;
            return {
                width: "24px",
                height: "24px",
                buttonIconTint: ((_a = this === null || this === void 0 ? void 0 : this.state) === null || _a === void 0 ? void 0 : _a.maximized) ? (_b = this.callscreenStyle) === null || _b === void 0 ? void 0 : _b.minimizeIconTint : (_c = this.callscreenStyle) === null || _c === void 0 ? void 0 : _c.maximizeIconTint,
                border: "none",
                borderRadius: "0",
                background: "transparent"
            };
        };
    }
    firstUpdated(_changedProperties) {
        var _a, _b, _c, _d;
        this.callScreenEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".cc__callscreen__container");
        this.callScreenBackgroundEl = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(".cc__callscreen__background");
        this.callScreenInnerBackgroundEl = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(".cc__callscreen");
        this.callScreenFrame = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(".cc__callscreen__wrapper");
    }
    updated(_changedProperties) {
        var _a;
        this.callScreenFrame = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".cc__callscreen__wrapper");
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        var _a, _b, _c, _d;
        this.minHeight = ((_a = this.callscreenStyle) === null || _a === void 0 ? void 0 : _a.minHeight) ? Number((_b = this.callscreenStyle) === null || _b === void 0 ? void 0 : _b.minHeight.replace("px", "")) : 400;
        this.minWidth = ((_c = this.callscreenStyle) === null || _c === void 0 ? void 0 : _c.minWidth) ? Number((_d = this.callscreenStyle) === null || _d === void 0 ? void 0 : _d.minWidth.replace("px", "")) : 400;
        return lit.html `
	<div
	  class="cc__callscreen__background"
        style=${styleMap_js.styleMap(this.callScreenBackgroundStyle())}
      ></div>
      <div
        class="cc__callscreen__container"
        style=${styleMap_js.styleMap(this.callScreenContainerStyle())}
      >
	  <div
		  class="cc__callscreen"
        ></div>
        <div
          style=${styleMap_js.styleMap(this.callScreenHeaderStyle())}
          class="cc__callscreen__header"
          @mousedown=${this.enableDragging}
        >
          <div style=${styleMap_js.styleMap(this.headerStyle())}>&nbsp;</div>
          <div
            class="cc__callscreen__resize"

          >
            <cometchat-button
			@cc-button-clicked=${this.toggle}
            @mousedown=${(e) => e.stopPropagation()}
			class="cc__callscreen__resize-button"  .hoverText=${this.resizeIconHoverText} .iconURL=${this.state.maximized ? this.minimizeIconURL : this.maximizeIconURL} .buttonStyle=${this.iconStyle()}></cometchat-button>
          </div>
        </div>
        <div
          style=${styleMap_js.styleMap(this.callScreenWrapperStyle())}
          class="cc__callscreen__wrapper"
        >
    <slot></slot>
    </div>
       ${this.showResizerIcon ? lit.html `
	   <div
          style=${styleMap_js.styleMap(this.callScreenResizerStyle())}
          class="cc__callscreen__resizer-both"
          @mousedown=${this.initResize}
        ></div>` : lit.nothing}
      </div>
    `;
    }
};
exports.CometChatCallscreenWrapper.styles = [
    lit.css `
	.cc__callscreen__resize-button{
		border:none;
			background:transparent;
			cursor:pointer;
			outline:none;
			display:flex;
			flex-direction:row;
			justify-content:center;
			align-items:center;
			width:100%;
			padding:0px;
			user-select:none;
	}
	.callscreen__resize{
		width:55px;
		padding:16px;
		display:flex;
		justify-content:center;
		align-items:center;
	}
    .cc__callscreen__wrapper{
		width:100%;
		height:calc(100% - 50px);
		position:absolute;
		top:50px;
		right:0;
		bottom:0;
		left:0;
		z-index:999;
		color:white;
		text-align:center;
		box-sizing:border-box;
		animation: my-animation  250ms ease;
		iframe: {
			border:none;
		}
	}
	.cc__callscreen__header{
		display:flex;
		flex-direction:row;
		align-items:center;
		justify-content:flex-end;
		width:100%;
		height:50px;
		position:absolute;
		top:0;
		right:0;
		bottom:0;
		left:0;
		z-index:1000;
	}
	.cc__callscreen{
		display: none;
		position:absolute;
		top:0;
		left:0;
		bottom:0;
		right:0;
		z-index:1000;
	}
	.cc__callscreen__resize{
		padding:16px
	}
	@keyframes my-animation {
		from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCallscreenWrapper.prototype, "callscreenStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCallscreenWrapper.prototype, "resizeIconHoverText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCallscreenWrapper.prototype, "minimizeIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatCallscreenWrapper.prototype, "maximizeIconURL", void 0);
exports.CometChatCallscreenWrapper = __decorate([
    decorators_js.customElement('cometchat-callscreen-wrapper')
], exports.CometChatCallscreenWrapper);

class BackdropStyle extends BaseStyle {
    constructor(props) {
        super({
            background: 'rgba(0, 0, 0, 0.5)'
        });
        this.position = "";
        Object.assign(this, props);
    }
}

exports.CometChatQuickView = class CometChatQuickView extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = "";
        this.subtitle = "";
        this.closeIconURL = closeIcon;
        this.hideCloseIcon = true;
        this.quickViewStyle = {
            background: "#efefef",
            height: "fit-content",
            width: "100%",
            titleFont: "600 13px Inter, sans-serif",
            titleColor: "grey",
            subtitleFont: "400 13px Inter, sans-serif",
            subtitleColor: "grey",
            closeIconTint: "black",
            leadingBarTint: "black",
            leadingBarWidth: "4px",
            borderRadius: "8px",
        };
        this.closeQuickView = () => {
            this.dispatchEvent(new CustomEvent("cc-close-clicked", {
                bubbles: true,
                composed: true,
            }));
        };
    }
    render() {
        const { title, subtitle } = this;
        return lit.html `
      <div
        class="cc-quick_view-container"
        style=${styleMap_js.styleMap(this.getContainerStyle())}
      >
        <div style="display: flex; align-items: center;">
          <div
            class="cc-quick_view-bar"
            style=${styleMap_js.styleMap(this.getBarStyle())}
          ></div>
          <div style=${styleMap_js.styleMap(this.getTextContainerStyle())}>
            <p
              class="cc-quick_view-title"
              style=${styleMap_js.styleMap(this.getTitleStyle())}
            >
              ${title}
            </p>
            <p
              class="cc-quick_view-subtitle"
              style=${styleMap_js.styleMap(this.getSubtitleStyle())}
            >
              ${subtitle}
            </p>
          </div>
        </div>
        ${!this.hideCloseIcon
            ? lit.html `
              <cometchat-icon-button
                class="cc-quick_view-button"
                text=""
                iconURL=${this.closeIconURL}
                buttonStyle=${JSON.stringify(this.getbuttonStyle())}
                @cc-button-clicked=${this.closeQuickView}
              ></cometchat-icon-button>
            `
            : lit.nothing}
      </div>
    `;
    }
    getContainerStyle() {
        const { background, height, width, borderRadius } = this.quickViewStyle;
        return {
            background,
            height,
            width,
            borderRadius,
        };
    }
    getBarStyle() {
        const { leadingBarTint, leadingBarWidth } = this.quickViewStyle;
        return {
            width: leadingBarWidth,
            background: leadingBarTint,
        };
    }
    getTextContainerStyle() {
        return {
            marginLeft: `calc(${this.quickViewStyle.leadingBarWidth} + 10px)`,
        };
    }
    getTitleStyle() {
        const { titleFont, titleColor } = this.quickViewStyle;
        return {
            font: titleFont,
            color: titleColor,
        };
    }
    getSubtitleStyle() {
        const { subtitleFont, subtitleColor } = this.quickViewStyle;
        return {
            font: subtitleFont,
            color: subtitleColor,
        };
    }
    getbuttonStyle() {
        var _a;
        return {
            height: "16px",
            width: "16px",
            iconHeight: "16px",
            iconWidth: "16px",
            border: "none",
            borderRadius: "0",
            background: "transparent",
            buttonIconTint: (_a = this.quickViewStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint,
        };
    }
};
exports.CometChatQuickView.styles = [
    lit.css `
      .cc-quick_view-container {
        position: relative;
        min-width: 190px;
        padding: 5px;
        box-sizing: border-box;
      }

      .cc-quick_view-button {
        position: absolute;
        top: 2px;
        right: 4px;
      }

      .cc-quick_view-bar {
        position: absolute;
        height: 90%;
        top: 5%;
        left: 5px;
        border-radius: 5px;
      }

      .cc-quick_view-title {
        margin-top: 5px;
        margin-bottom: 10px;
        padding: 0px;
      }
      .cc-quick_view-subtitle {
        margin-top: 5px;
        margin-bottom: 5px;
        padding: 0px;
        text-align: left;

      }

      /* Add other static CSS styles here */
    `,
];
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatQuickView.prototype, "title", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatQuickView.prototype, "subtitle", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatQuickView.prototype, "closeIconURL", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatQuickView.prototype, "hideCloseIcon", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatQuickView.prototype, "quickViewStyle", void 0);
exports.CometChatQuickView = __decorate([
    decorators_js.customElement("cometchat-quick-view")
], exports.CometChatQuickView);

class QuickViewStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.subtitleFont = "";
        this.subtitleColor = "";
        this.closeIconTint = "";
        this.leadingBarTint = "";
        this.leadingBarWidth = "";
        Object.assign(this, props);
    }
}

exports.CometChatSingleSelect = class CometChatSingleSelect extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.name = "";
        this.options = [];
        this.selectedOption = "";
        this.selectStyle = {
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "6px",
            background: "transparent",
            textFont: "400 14px Inter",
            textColor: "grey",
            optionBackground: "white",
            optionBorder: "1px solid #dedede",
            optionBorderRadius: "2px",
            hoverTextFont: "400 14px Inter",
            hoverTextColor: "black",
            hoverTextBackground: "#efefef",
            activeTextFont: "400 14px Inter",
            activeTextColor: "#141414",
            activeTextBackground: "#efefef",
        };
        this.isHovering = false;
        this.hoveredOption = "";
        this.onMouseHover = (event, option) => {
            if ((event === null || event === void 0 ? void 0 : event.type) == "mouseenter") {
                this.isHovering = true;
                this.hoveredOption = option;
            }
            else {
                this.isHovering = false;
                this.hoveredOption = "";
            }
            this.requestUpdate("isHovering");
        };
    }
    render() {
        return lit.html `
    <div style=${styleMap_js.styleMap(this.containerStyle())}>
        ${this.options.map((option, index) => lit.html `
            <div
            class="cc-single_select-option"
            style=${styleMap_js.styleMap(this.optionStyle(option, index))}
            @mouseenter=${(event) => {
            this.onMouseHover(event, option);
        }}
            @mouseleave=${(event) => {
            this.onMouseHover(event, option);
        }}
            @click="${() => this.selectOption(option)}"
            >
            ${option}
            </div>
        `)}
    </div>
    `;
    }
    selectOption(option) {
        this.selectedOption = option;
        this.requestUpdate("selectedOption");
        this.dispatchEvent(new CustomEvent("cc-single-select-changed", {
            bubbles: true,
            composed: true,
            detail: {
                value: this.selectedOption
            }
        }));
    }
    containerStyle() {
        const direction = this.options.length > 2 ? "column" : "row";
        const gap = this.options.length > 2 ? "10px" : "0px";
        const { height, width, border, borderRadius } = this.selectStyle;
        return {
            height: height,
            width: width,
            display: "flex",
            flexDirection: direction,
            gap: gap,
            justifyContent: "center",
            alignItems: "center",
            border: border,
            borderRadius: borderRadius,
        };
    }
    optionStyle(option, index) {
        var _a;
        const { textFont, textColor, optionBackground, hoverTextFont, hoverTextColor, hoverTextBackground, activeTextBackground, activeTextColor, activeTextFont, optionBorder, optionBorderRadius, } = this.selectStyle;
        const flex = this.options.length > 2 ? "0 0 100%" : "0 0 50%";
        let optionBR = optionBorderRadius;
        if ((index % 2 != 0 || index == 0) && (index + 1 < ((_a = this.options) === null || _a === void 0 ? void 0 : _a.length))) {
            optionBR = `${optionBorderRadius} 0 0 ${optionBorderRadius}`;
        }
        const style = {
            flex: flex,
            border: optionBorder,
            borderRadius: optionBR,
            width: "100%",
        };
        if (this.isHovering && this.hoveredOption === option) {
            return {
                ...style,
                background: hoverTextBackground,
                color: hoverTextColor,
                font: hoverTextFont,
            };
        }
        else if (this.selectedOption === option) {
            return {
                ...style,
                background: activeTextBackground,
                color: activeTextColor,
                font: activeTextFont,
            };
        }
        else {
            return {
                ...style,
                background: optionBackground,
                color: textColor,
                font: textFont,
            };
        }
    }
};
exports.CometChatSingleSelect.styles = lit.css `
    :host {
    width: 100%;
    text-align: center;
    }

    .cc-single_select-option {
    border: 1px solid #000;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    min-height: 20px;
    min-width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    }
`;
__decorate([
    decorators_js.property()
], exports.CometChatSingleSelect.prototype, "name", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.CometChatSingleSelect.prototype, "options", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatSingleSelect.prototype, "selectedOption", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatSingleSelect.prototype, "selectStyle", void 0);
exports.CometChatSingleSelect = __decorate([
    decorators_js.customElement("cometchat-single-select")
], exports.CometChatSingleSelect);

class SingleSelectStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "";
        this.textColor = "";
        this.optionBackground = "";
        this.optionBorder = "";
        this.optionBorderRadius = "";
        this.hoverTextFont = "";
        this.hoverTextColor = "";
        this.hoverTextBackground = "";
        this.activeTextBackground = "";
        this.activeTextColor = "";
        this.activeTextFont = "";
        Object.assign(this, props);
    }
}

class PanelStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.closeIconTint = "";
        this.boxShadow = "";
        this.textFont = "";
        this.textColor = "";
        Object.assign(this, props);
    }
}

exports.CometChatPanel = class CometChatPanel extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = "";
        this.text = "";
        this.closeIconUrl = closeIcon;
        this.hideCloseButton = false;
        this.panelStyle = new PanelStyle({
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "8px",
            background: "white",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            titleFont: "400 16px inter",
            titleColor: "#323232",
            closeIconTint: "black",
            textFont: "400 14px inter",
            textColor: "#6f6f6f",
        });
    }
    render() {
        return lit.html `
      <div class="cc_panel_container" style=${this.containerStyle()}>
        <div class="cc_panel__header">
          <div class="cc_panel__title"
            style=${this.titleStyle()}
          >${this.title}</div>
          ${!this.hideCloseButton
            ? lit.html `
            <cometchat-icon-button
              class="cc_panel_button"
              text=""
              iconURL=${this.closeIconUrl}
              buttonStyle=${JSON.stringify(this.getbuttonStyle())}
              @cc-button-clicked=${this.handleCloseClick}
            ></cometchat-icon-button>
          `
            : lit.nothing}
        </div>
        <div class="cc_panel__body">
          <div class="cc_panel__text"
          style=${this.textStyle()}
          >${this.text}</div>
        </div>
      </div>
    `;
    }
    handleCloseClick() {
        this.dispatchEvent(new CustomEvent("cc-close-clicked", {
            bubbles: true,
            composed: true,
        }));
    }
    containerStyle() {
        var _a, _b, _c, _d, _e, _f;
        return styleMap_js.styleMap({
            height: (_a = this.panelStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.panelStyle) === null || _b === void 0 ? void 0 : _b.width,
            border: (_c = this.panelStyle) === null || _c === void 0 ? void 0 : _c.border,
            borderRadius: (_d = this.panelStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
            background: (_e = this.panelStyle) === null || _e === void 0 ? void 0 : _e.background,
            boxShadow: (_f = this.panelStyle) === null || _f === void 0 ? void 0 : _f.boxShadow,
        });
    }
    titleStyle() {
        var _a, _b;
        return styleMap_js.styleMap({
            font: (_a = this.panelStyle) === null || _a === void 0 ? void 0 : _a.titleFont,
            color: (_b = this.panelStyle) === null || _b === void 0 ? void 0 : _b.titleColor,
        });
    }
    textStyle() {
        var _a, _b;
        return styleMap_js.styleMap({
            font: (_a = this.panelStyle) === null || _a === void 0 ? void 0 : _a.textFont,
            color: (_b = this.panelStyle) === null || _b === void 0 ? void 0 : _b.textColor,
        });
    }
    getbuttonStyle() {
        var _a;
        return {
            height: "16px",
            width: "16px",
            iconHeight: "16px",
            iconWidth: "16px",
            border: "none",
            borderRadius: "0",
            background: "transparent",
            buttonIconTint: ((_a = this.panelStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint) || "black",
        };
    }
};
exports.CometChatPanel.styles = [
    lit.css `
      .cc_panel_container {
        position: relative;
        height: 100%;
        width: 100%;
        border: none;
        border-radius: 0;
        padding: 10px;
        box-sizing: border-box;
      }
      .cc_panel__header {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0px;
        box-sizing: border-box;
      }

      .cc_panel_button{
        position: absolute;
        right: 0;
        top: 8px;
      }
    `,
];
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatPanel.prototype, "title", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatPanel.prototype, "text", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.CometChatPanel.prototype, "closeIconUrl", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatPanel.prototype, "hideCloseButton", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatPanel.prototype, "panelStyle", void 0);
exports.CometChatPanel = __decorate([
    decorators_js.customElement("cometchat-panel")
], exports.CometChatPanel);

var CometChatTextInput_1;
var auxiliaryButtonAlignmentEnum;
(function (auxiliaryButtonAlignmentEnum) {
    auxiliaryButtonAlignmentEnum[auxiliaryButtonAlignmentEnum["left"] = 0] = "left";
    auxiliaryButtonAlignmentEnum[auxiliaryButtonAlignmentEnum["right"] = 1] = "right";
})(auxiliaryButtonAlignmentEnum || (auxiliaryButtonAlignmentEnum = {}));
exports.CometChatTextInput = CometChatTextInput_1 = class CometChatTextInput extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.text = "";
        this.disabled = false;
        this.placeholderText = "Send a message...";
        this.auxiliaryButtonAlignment = auxiliaryButtonAlignmentEnum.right;
        this.dir = "auto";
        this.textInputStyle = {
            height: "100%",
            width: "",
            maxHeight: "100px",
            border: "1px solid #efefef",
            borderRadius: "",
            background: "",
            placeholderTextFont: "",
            placeholderTextColor: "",
            textFont: "",
            textColor: "",
            dividerColor: "#efefef",
            inputBorder: "none",
            inputBorderRadius: "0",
            inputBackground: "transparent",
        };
        this.textFormatters = [];
        this.reRenderCounter = 1;
        this.inputText = "";
        this.componentID = ``;
        this.onKeyDown = (event) => {
            var _a, _b, _c;
            var contenteditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                if ((_a = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.textContent) === null || _a === void 0 ? void 0 : _a.trim()) {
                    let textToDispatch = ((_b = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.innerHTML) === null || _b === void 0 ? void 0 : _b.trim()) == "<br>" ? undefined : contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.innerHTML;
                    if (((_c = contenteditable === null || contenteditable === void 0 ? void 0 : contenteditable.innerHTML) === null || _c === void 0 ? void 0 : _c.trim()) == "<br>") {
                        contenteditable.innerHTML = "";
                    }
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            textToDispatch =
                                this.textFormatters[i].getOriginalText(textToDispatch);
                        }
                    }
                    this.dispatchEvent(new CustomEvent("cc-text-input-entered", {
                        bubbles: true,
                        composed: true,
                        detail: { value: textToDispatch },
                    }));
                }
                return;
            }
            if (this.textFormatters && this.textFormatters.length) {
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference(document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`));
                    this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                    this.textFormatters[i].onKeyDown(event);
                }
            }
        };
        /**
         * On Every KeyUp Event, pass the event to registered text formatters in order to track characters
         * and format the text in real time.
         */
        this.onKeyUp = (event) => {
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                return;
            }
            if (this.textFormatters && this.textFormatters.length) {
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference(document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`));
                    this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                    this.textFormatters[i].onKeyUp(event);
                }
            }
        };
        this.hasAllSlotsAssigned = false;
        this.emptyInputField = () => {
            let contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
            contentEditable.textContent = "";
            contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.focus();
        };
        this.emptyInputFieldWithoutFocus = () => {
            let contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
            contentEditable.textContent = "";
        };
        this.dispatchChangedEVent = (event) => {
            var _a, _b;
            const contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
            let textToDispatch = ((_a = contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML) === null || _a === void 0 ? void 0 : _a.trim()) == "<br>" ? undefined : contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML;
            if (((_b = contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML) === null || _b === void 0 ? void 0 : _b.trim()) == "<br>") {
                contentEditable.innerHTML = "";
            }
            if (textToDispatch) {
                if (this.textFormatters && this.textFormatters.length) {
                    for (let i = 0; i < this.textFormatters.length; i++) {
                        textToDispatch =
                            this.textFormatters[i].getOriginalText(textToDispatch);
                    }
                }
            }
            this.dispatchEvent(new CustomEvent("cc-text-input-changed", {
                bubbles: true,
                composed: true,
                detail: { value: textToDispatch },
            }));
        };
        this.messageInputStyles = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.textInputStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.textInputStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.textInputStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.textInputStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.textInputStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
        this.inputStyle = () => {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
                font: (_a = this.textInputStyle) === null || _a === void 0 ? void 0 : _a.textFont,
                color: (_b = this.textInputStyle) === null || _b === void 0 ? void 0 : _b.textColor,
                height: "100%",
                width: "100%",
                maxHeight: (_c = this.textInputStyle) === null || _c === void 0 ? void 0 : _c.maxHeight,
                border: (_d = this.textInputStyle) === null || _d === void 0 ? void 0 : _d.inputBorder,
                borderRadius: (_e = this.textInputStyle) === null || _e === void 0 ? void 0 : _e.inputBorderRadius,
                background: (_f = this.textInputStyle) === null || _f === void 0 ? void 0 : _f.inputBackground,
                padding: ((_g = this.textInputStyle) === null || _g === void 0 ? void 0 : _g.inputPadding) || "7px 12px",
            };
        };
        this.auxiliaryStyles = () => {
            return {
                display: "flex",
                justifyContent: this.auxiliaryButtonAlignment == auxiliaryButtonAlignmentEnum.left
                    ? "flex-start"
                    : "flex-end",
            };
        };
        this.dividerStyle = () => {
            var _a;
            return {
                height: "1px",
                width: "100%",
                background: (_a = this.textInputStyle) === null || _a === void 0 ? void 0 : _a.dividerColor,
            };
        };
    }
    connectedCallback() {
        this.componentID = `message-input-${Math.random()
            .toString(36)
            .substring(7)}`;
        super.connectedCallback();
        this.addStyles();
    }
    setSelection(sel) {
        if (sel && sel.rangeCount) {
            if (this.isDescendant(sel)) {
                this.sel = sel;
                this.range = this.sel.getRangeAt(0);
                this.currentSelectionForRegex = this.sel;
                if (this.sel.getRangeAt && this.sel.rangeCount) {
                    this.range = this.sel.getRangeAt(0);
                    this.currentSelectionForRegexRange = this.sel.getRangeAt(0);
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                        }
                        this.onKeyUp(new Event("mention_keyup_event"));
                    }
                }
            }
        }
    }
    addStyles() {
        // Prevent adding the styles multiple times
        if (!CometChatTextInput_1.stylesAdded) {
            CometChatTextInput_1.stylesAdded = true;
            const style = document.createElement("style");
            style.textContent = CometChatTextInput_1.style;
            document.head.appendChild(style);
        }
    }
    isDescendant(sel) {
        if (sel.rangeCount > 0) {
            let range = sel.getRangeAt(0);
            let elm = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
            let parentElm = range.commonAncestorContainer.parentNode;
            if ((parentElm === null || parentElm === void 0 ? void 0 : parentElm.nodeName) === "SPAN") {
                return false;
            }
            if ((elm === null || elm === void 0 ? void 0 : elm.contains(range.startContainer)) &&
                (elm === null || elm === void 0 ? void 0 : elm.contains(range.endContainer))) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    reRender() {
        this.requestUpdate("reRenderCounter");
    }
    pasteHtmlAtCaret(html) {
        var _a, _b;
        try {
            if (this.sel && this.range) {
                this.range.deleteContents();
                let el = document.createElement("div");
                el.innerHTML = html;
                let frag = document.createDocumentFragment(), node, lastNode;
                while ((node = el.firstChild)) {
                    if (node instanceof HTMLElement) {
                        if (this.textFormatters && this.textFormatters.length) {
                            for (let i = 0; i < this.textFormatters.length; i++) {
                                node = this.textFormatters[i].registerEventListeners(node, node.classList);
                            }
                        }
                        lastNode = frag.appendChild(el.removeChild(node));
                    }
                    else if (node instanceof Text) {
                        lastNode = frag.appendChild(el.removeChild(node));
                    }
                }
                this.range.insertNode(frag);
                if (lastNode) {
                    this.range = this.range.cloneRange();
                    this.range.setStartAfter(lastNode);
                    this.range.collapse(true);
                    this.sel.removeAllRanges();
                    this.sel.addRange(this.range);
                    const contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
                    let textToDispatch = ((_a = contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML) === null || _a === void 0 ? void 0 : _a.trim()) == "<br>" ? undefined : contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML;
                    if (((_b = contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML) === null || _b === void 0 ? void 0 : _b.trim()) == "<br>") {
                        contentEditable.innerHTML = "";
                    }
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            textToDispatch =
                                this.textFormatters[i].getOriginalText(textToDispatch);
                        }
                    }
                    this.dispatchEvent(new CustomEvent("cc-text-input-changed", {
                        bubbles: true,
                        composed: true,
                        detail: { value: textToDispatch },
                    }));
                }
            }
            else if (this.sel && this.sel.type != "Control") {
                this.sel.createRange().pasteHTML(html);
            }
            else {
                const contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
                contentEditable.textContent = this.text;
            }
        }
        catch (error) {
            console.log("Error pasting html to caret", error);
        }
    }
    updatePlaceholderTextStyle() {
        var _a, _b, _c;
        const color = ((_a = this.textInputStyle) === null || _a === void 0 ? void 0 : _a.placeholderTextColor) || 'rgba(119, 119, 119, 0.58)';
        const font = ((_b = this.textInputStyle) === null || _b === void 0 ? void 0 : _b.placeholderTextFont) || '400 13px sans-serif, Inter';
        const selector = `#${this.componentID} > .messageinput-input:empty::before`;
        let existingRule;
        for (const sheet of document.styleSheets) {
            for (const rule of sheet.cssRules) {
                if ((rule === null || rule === void 0 ? void 0 : rule.selectorText) === selector) {
                    existingRule = rule;
                    break;
                }
            }
            if (existingRule)
                break;
        }
        if (existingRule) {
            existingRule.style.color = color;
            existingRule.style.font = font;
        }
        else {
            const style = document.createElement('style');
            document.head.appendChild(style);
            const ruleText = `#${this.componentID} > .messageinput-input:empty::before {
            content: attr(data-placeholder);
            color: ${color};
            font: ${font};
        }`;
            (_c = style.sheet) === null || _c === void 0 ? void 0 : _c.insertRule(ruleText, 0);
        }
    }
    updated(_changedProperties) {
        var _a, _b;
        const contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
        // this.updatePlaceholderTextStyle();
        let skipFormattersChangedCheck = false;
        if (_changedProperties.has("text") && this.text && this.text != "") {
            const sel = window === null || window === void 0 ? void 0 : window.getSelection();
            this.setSelection(sel);
            let finalText = this.text;
            if (this.textFormatters && this.textFormatters.length) {
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference(document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`));
                    this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                    if (typeof finalText == "string") {
                        finalText = this.textFormatters[i].getFormattedText(finalText, uikitResources.MentionsTargetElement.textinput);
                    }
                }
            }
            if (finalText !== this.text) {
                skipFormattersChangedCheck = true;
            }
            this.pasteHtmlAtCaret(finalText);
        }
        if ((_changedProperties.has("textFormatters") ||
            _changedProperties.has("reRenderCounter")) &&
            !skipFormattersChangedCheck) {
            if (this.textFormatters && this.textFormatters.length) {
                for (let i = 0; i < this.textFormatters.length; i++) {
                    this.textFormatters[i].setInputElementReference(document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`));
                    this.textFormatters[i].setReRender(this.reRender.bind(this));
                }
            }
            if (this.currentSelectionForRegex &&
                this.textFormatters &&
                this.textFormatters.length) {
                if (this.textFormatters && this.textFormatters.length) {
                    for (let i = 0; i < this.textFormatters.length; i++) {
                        this.textFormatters[i].setCaretPositionAndRange(this.currentSelectionForRegex, this.currentSelectionForRegexRange);
                        this.textFormatters[i].getFormattedText(null, uikitResources.MentionsTargetElement.textinput);
                    }
                }
                let textToDispatch = ((_a = contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML) === null || _a === void 0 ? void 0 : _a.trim()) == "<br>" ? undefined : contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML;
                if (((_b = contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.innerHTML) === null || _b === void 0 ? void 0 : _b.trim()) == "<br>") {
                    contentEditable.innerHTML = "";
                }
                if (textToDispatch) {
                    if (this.textFormatters && this.textFormatters.length) {
                        for (let i = 0; i < this.textFormatters.length; i++) {
                            textToDispatch =
                                this.textFormatters[i].getOriginalText(textToDispatch);
                        }
                    }
                }
                this.dispatchEvent(new CustomEvent("cc-text-input-changed", {
                    bubbles: true,
                    composed: true,
                    detail: { value: textToDispatch },
                }));
            }
        }
    }
    preventPaste(e) {
        e.preventDefault();
        let clipboardData = e === null || e === void 0 ? void 0 : e.clipboardData.getData("text/plain");
        if (clipboardData) {
            clipboardData = clipboardData.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        }
        if (clipboardData) {
            this.text = clipboardData;
        }
        this.requestUpdate("text");
    }
    firstUpdated(_changedProperties) {
        const contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
        contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.addEventListener("paste", this.preventPaste.bind(this));
        document === null || document === void 0 ? void 0 : document.addEventListener("selectionchange", this.triggerSelection.bind(this));
        if (!isMobileDevice()) {
            contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.focus();
        }
        this.distributeChildren();
        this.requestUpdate("hasAllSlotsAssigned");
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        const contentEditable = document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`);
        contentEditable === null || contentEditable === void 0 ? void 0 : contentEditable.removeEventListener("paste", this.preventPaste);
        document === null || document === void 0 ? void 0 : document.removeEventListener("selectionchange", this.triggerSelection);
    }
    triggerSelection() {
        let sel = window === null || window === void 0 ? void 0 : window.getSelection();
        this.setSelection(sel);
    }
    distributeChildren() {
        // Get all children with a 'data-slot' attribute
        const children = this.querySelectorAll(`[data-slot]`);
        if (children.length == 0) {
            this.hasAllSlotsAssigned = false;
            return;
        }
        this.hasAllSlotsAssigned = true;
        children.forEach((child) => {
            // Get the destination ID from the child's 'data-slot' attribute
            const destinationId = child.getAttribute("data-slot");
            // Find the target div within the component with the corresponding ID
            const targetDiv = this.querySelector(`#${destinationId}`);
            if (targetDiv) {
                // Move the child to the target div
                targetDiv.appendChild(child);
            }
        });
    }
    checkPlainTextAvailability(disabled) {
        try {
            const temp = document.createElement('div');
            temp.contentEditable = 'plaintext-only';
            const value = temp.contentEditable === 'plaintext-only';
            if (!disabled && value) {
                return 'plaintext-only';
            }
            else {
                return false;
            }
        }
        catch (error) {
            return !disabled;
        }
    }
    render() {
        if (this.textFormatters && this.textFormatters.length) {
            for (let i = 0; i < this.textFormatters.length; i++) {
                this.textFormatters[i].setInputElementReference(document === null || document === void 0 ? void 0 : document.querySelector(`#${this.componentID} > .messageinput-input`));
                this.textFormatters[i].setReRender(this.reRender.bind(this));
            }
        }
        return lit.html `
      <div
        id=${this.componentID}
        class="messageinput"
        style=${styleMap_js.styleMap(this.messageInputStyles())}
      >
        <div
          dir=${this.dir}
          @keyup=${this.onKeyUp}
          @keydown=${this.onKeyDown}
          contenteditable=${this.checkPlainTextAvailability(this.disabled)}
          @input=${(event) => {
            this.dispatchChangedEVent(event);
        }}
          style=${styleMap_js.styleMap(this.inputStyle())}
          class="messageinput-input"
          data-placeholder=${this.placeholderText}
        ></div>
        <cometchat-divider
          .dividerStyle=${this.dividerStyle()}
        ></cometchat-divider>
        <div
          class="messageinput__sticky"
          style=${styleMap_js.styleMap({
            display: this.hasAllSlotsAssigned ? "flex" : "none",
        })}
        >
          <div id="secondaryView" class="messageinput__secondaryactions"></div>
          <div
            id="auxilaryView"
            class="messageinput__auxiliaryactions"
            style=${styleMap_js.styleMap(this.auxiliaryStyles())}
          ></div>
          <div id="primaryView" class="messageinput__primaryactions"></div>
        </div>
      </div>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
exports.CometChatTextInput.style = `
    .messageinput > *{
      box-sizing:border-box;
    }

.messageinput{
    border:1px solid grey;
    // padding:4px 8px;
    width:400px;
    border-radius:12px;
    overflow:hidden;
    display: flex;
    flex-direction: column;
}
.messageinput-input{
  border:none;
    width:100%;
    outline:none;
    border-radius:0;
    background:transparent;
    overflow-y:auto;
    min-height: 28px;
    padding: 7px 12px;
    user-select: text;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    text-align: left;
    box-sizing:border-box;
  }
.messageinput-input::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .messageinput-input::-webkit-scrollbar-thumb {
    background: rgb(232, 229, 229);
    border-radius: 8px;
  }

.messageinput__sticky{
   display: flex;
  padding: 4px 8px;
  width:100%;
}
.messageinput__primaryactions{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}
.messageinput__auxiliaryactions{
    display: flex;
    justify-content: flex-end;
    width: 100%;
    flex: 0 1 100%;
    align-items: center;
}
.messageinput__secondaryactions{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 0 1 8%;
}

.messageinput-input:empty:before{
  content:attr(data-placeholder);
  color: rgba(119, 119, 119, 0.58);
  font: 400 13px sans-serif, Inter;
}
        `;
exports.CometChatTextInput.stylesAdded = false;
__decorate([
    decorators_js.property()
], exports.CometChatTextInput.prototype, "text", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatTextInput.prototype, "disabled", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatTextInput.prototype, "placeholderText", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CometChatTextInput.prototype, "auxiliaryButtonAlignment", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatTextInput.prototype, "dir", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatTextInput.prototype, "textInputStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatTextInput.prototype, "textFormatters", void 0);
exports.CometChatTextInput = CometChatTextInput_1 = __decorate([
    decorators_js.customElement("cometchat-text-input")
], exports.CometChatTextInput);

/**
 * TextInputStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class TextInputStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.placeholderTextFont = "";
        this.placeholderTextColor = "";
        this.textFont = "";
        this.textColor = "";
        this.dividerColor = "#efefef";
        this.inputBorder = "none";
        this.inputBorderRadius = "0";
        this.inputBackground = "transparent";
        this.maxHeight = "100px";
        this.inputPadding = "";
        Object.assign(this, props);
    }
}

exports.ActionSheetStyle = ActionSheetStyle;
exports.AvatarStyle = AvatarStyle;
exports.BackdropStyle = BackdropStyle;
exports.BadgeStyle = BadgeStyle;
exports.BaseStyle = BaseStyle;
exports.ButtonGroupStyle = ButtonGroupStyle;
exports.CallscreenStyle = CallscreenStyle;
exports.CardStyle = CardStyle;
exports.ChangeScopeStyle = ChangeScopeStyle;
exports.CheckboxStyle = CheckboxStyle;
exports.CometChatActionItem = CometChatActionItem;
exports.CometChatEmoji = CometChatEmoji;
exports.ConfirmDialogStyle = ConfirmDialogStyle;
exports.ContextMenuStyle = ContextMenuStyle;
exports.CreateGroupStyle = CreateGroupStyle;
exports.DateStyle = DateStyle;
exports.DocumentBubbleStyle = DocumentBubbleStyle;
exports.DropdownStyle = DropdownStyle;
exports.EmojiKeyboardStyle = EmojiKeyboardStyle;
exports.Emojis = Emojis;
exports.FileBubbleStyle = FileBubbleStyle;
exports.FullScreenViewerStyle = FullScreenViewerStyle;
exports.IconStyle = IconStyle;
exports.ImageBubbleStyle = ImageBubbleStyle;
exports.InputStyle = InputStyle;
exports.JoinGroupStyle = JoinGroupStyle;
exports.LabelStyle = LabelStyle;
exports.ListItemStyle = ListItemStyle;
exports.LoaderStyle = LoaderStyle;
exports.MediaRecorderStyle = MediaRecorderStyle;
exports.MenuListStyle = MenuListStyle;
exports.MessageInputStyle = MessageInputStyle;
exports.ModalStyle = ModalStyle;
exports.PanelStyle = PanelStyle;
exports.PopoverStyle = PopoverStyle;
exports.PreviewStyle = PreviewStyle;
exports.QuickViewStyle = QuickViewStyle;
exports.RadioButtonStyle = RadioButtonStyle;
exports.ReceiptStyle = ReceiptStyle;
exports.SearchInputStyle = SearchInputStyle;
exports.SingleSelectStyle = SingleSelectStyle;
exports.TextBubbleStyle = TextBubbleStyle;
exports.TextInputStyle = TextInputStyle;
exports.debounce = debounce;
exports.getClosestScrollableAncestor = getClosestScrollableAncestor;
exports.isElementVisibleWithScrollableAncestor = isElementVisibleWithScrollableAncestor;
exports.isMobileDevice = isMobileDevice;
exports.isScrollable = isScrollable;
exports.layoutType = layoutType;
exports.sanitizeHtml = sanitizeHtml;
